/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** @default "EMBEDDING_STORAGE_NOT_SET" */
export enum AppEmbeddingsStorage {
  EMBEDDING_STORAGE_NOT_SET = 'EMBEDDING_STORAGE_NOT_SET',
  POSTGRES = 'POSTGRES',
  QDRANT = 'QDRANT',
}

/** @default "unknown" */
export enum BookmarkOriginBookmarkType {
  Unknown = 'unknown',
  Model = 'model',
  Workflow = 'workflow',
  Dataset = 'dataset',
  Module = 'module',
}

/** @default "TYPE_NOT_SET" */
export enum CommitmentValueCommitmentType {
  TYPE_NOT_SET = 'TYPE_NOT_SET',
  MONTHLY = 'MONTHLY',
  ANNUAL = 'ANNUAL',
}

/**
 * In some scenarios it may not be obvous how we should schedule a resource to underlying nodes
 * within the nodepool(s) above. The SchedulerChoice allows us to specify how to decide which
 * nodepool to use when there are multiple nodepools and how to decide which type of node
 * within a nodepool if there are multiple types.
 * If here are multiple nondepools then a decision on which to use comes into play
 * if it is not specified in the prediction request.
 * Even with a single nodepool a choice may come up such as when a resource that needs scheduling
 * has not specified the accelerator types it supports and the nodepool has multiple types.
 *
 *  - FAIL: fail if there is any ambiguity.
 *  - RANDOM: randomly pick amongst the nodepools/nodes to assign.
 *  - PRICE: choose the compute that is cheaper
 *  - PERFORMANCE: schedule to the fastest known iption.
 *  - NETWORK: optimize based on network latency.
 *  - UTILIZATION: send to the least used nodepool based on it's capacity.
 *  - PREFER_SPOT: choose spot instances over on-demand
 *  - PREFER_ONDEMAND: choose on-demand instances over spot.
 * @default "UNKNOWN_SCHEDULING_CHOICE"
 */
export enum DeploymentSchedulingChoice {
  UNKNOWN_SCHEDULING_CHOICE = 'UNKNOWN_SCHEDULING_CHOICE',
  FAIL = 'FAIL',
  RANDOM = 'RANDOM',
  PRICE = 'PRICE',
  PERFORMANCE = 'PERFORMANCE',
  NETWORK = 'NETWORK',
  UTILIZATION = 'UTILIZATION',
  PREFER_SPOT = 'PREFER_SPOT',
  PREFER_ONDEMAND = 'PREFER_ONDEMAND',
}

/**
 * Store matrix of uint64s values.
 * It is recommended to store the matrix as a 1D array
 * because it produces less bytes during serialization than a 2D array.
 * The matrix does store the number of columns, but it does not store the number of rows.
 * The number of rows can automatically be calculated as length(data)/n_cols.
 */
export interface MatrixUint64 {
  /**
   * Number of columns
   * @format uint64
   */
  n_cols?: string;
  /**
   * Matrix data stored as an array.
   * In order to access matrix element at row i & column j, use data[i*n_cols+j].
   */
  data?: string[];
}

/** @default "Unknown" */
export enum ModelBillingType {
  Unknown = 'Unknown',
  Tokens = 'Tokens',
  Ops = 'Ops',
}

/**
 * Source of Model
 * @default "UNKNOWN_SOURCE"
 */
export enum ModelSource {
  UNKNOWN_SOURCE = 'UNKNOWN_SOURCE',
  HOSTED = 'HOSTED',
  WRAPPED = 'WRAPPED',
}

/**
 * These are various types of fields that we have UIs for.
 *
 *  - ARRAY_OF_CONCEPTS: For auto-completing to concepts in the app. This goes into an data.concepts field.
 *  - ARRAY_OF_CONCEPTS_WITH_THRESHOLD: For auto-completing to concepts in the app. This goes into an data.concepts field.
 *  - RANGE: A range for a float value.
 *  - ENUM: If ENUM is used then the "enum_options" field should also be filled in with the respective ID and description
 * for the different ENUM options.
 *  - COLLABORATORS: For listing collaborators of the app. The field is a string of the collaborator's user_id.
 *  - JSON: For arbitrary json object: "{...}"
 *  - ARRAY_OF_NUMBERS: Such as [1.0, 2.0, 3.5]
 *  - WORKFLOW_EMBED_MODELS: For selecting the embed_model_version_id for context based models.
 *  - ARRAY_OF_STRINGS: Such as ['a', 'b', 'cantaloupe']
 *  - RECURSIVE_ENUM: If RECURSIVE_ENUM is used then the "enum_options" field should also be filled in with the respective ID and
 * description for the different RECURSIVE_ENUM options, as well as model_type_fields for each enum choice.
 *  - PYTHON_CODE: For blocks of code that need to be specified by the user for setup or execution during workflow runs.
 *  - DATASET_ID: For selecting a dataset id in model parameters. String in API request.
 *  - DATASET_VERSION_ID: For selecting a dataset version id. String.
 *  - ARRAY_OF_MODEL_CONCEPTS: For auto-completing to concepts in the model.
 *  - DATASET: For selecting a dataset
 *  - DATASET_VERSION: For selecting a dataset version
 *  - ENCRYPTED_STRING: To pass a string downstream, that is encrypted in the DB and API.
 *  - CHECKPOINT_MODEL: For selecting a model version of the same model type to resume training from.
 * @default "INVALID_MODEL_TYPE_FIELD_TYPE"
 */
export enum ModelTypeFieldModelTypeFieldType {
  INVALID_MODEL_TYPE_FIELD_TYPE = 'INVALID_MODEL_TYPE_FIELD_TYPE',
  BOOLEAN = 'BOOLEAN',
  STRING = 'STRING',
  NUMBER = 'NUMBER',
  ARRAY_OF_CONCEPTS = 'ARRAY_OF_CONCEPTS',
  ARRAY_OF_CONCEPTS_WITH_THRESHOLD = 'ARRAY_OF_CONCEPTS_WITH_THRESHOLD',
  RANGE = 'RANGE',
  ENUM = 'ENUM',
  COLLABORATORS = 'COLLABORATORS',
  JSON = 'JSON',
  ARRAY_OF_NUMBERS = 'ARRAY_OF_NUMBERS',
  WORKFLOW_EMBED_MODELS = 'WORKFLOW_EMBED_MODELS',
  ARRAY_OF_STRINGS = 'ARRAY_OF_STRINGS',
  RECURSIVE_ENUM = 'RECURSIVE_ENUM',
  PYTHON_CODE = 'PYTHON_CODE',
  DATASET_ID = 'DATASET_ID',
  DATASET_VERSION_ID = 'DATASET_VERSION_ID',
  ARRAY_OF_MODEL_CONCEPTS = 'ARRAY_OF_MODEL_CONCEPTS',
  DATASET = 'DATASET',
  DATASET_VERSION = 'DATASET_VERSION',
  ENCRYPTED_STRING = 'ENCRYPTED_STRING',
  CHECKPOINT_MODEL = 'CHECKPOINT_MODEL',
}

export interface ModuleVersionModuleNav {
  /**
   * This is the left side title for this module and for browser tab title of the module.
   * We have this in the version so that users can change those settings
   * when releasing a new version of their module.
   */
  title?: string;
  /** A list of subnav elements to put under the module title. */
  module_sub_navs?: ModuleVersionModuleSubNav[];
}

export interface ModuleVersionModuleSubNav {
  /**
   * This is the display title for a navbar element to link to a specific page.
   * The name for this subnav element to show in the sidebar.
   */
  title?: string;
  /** The query param name */
  query_key?: string;
  /** The query param value */
  query_value?: string;
}

/** @default "UKNOWN_CAPACITY_TYPE" */
export enum NodeCapacityTypeCapacityType {
  UKNOWN_CAPACITY_TYPE = 'UKNOWN_CAPACITY_TYPE',
  ON_DEMAND_TYPE = 'ON_DEMAND_TYPE',
  SPOT_TYPE = 'SPOT_TYPE',
}

/**
 * Metric used for search. Can be EUCLIDEAN_DISTANCE (default) or COSINE_DISTANCE.
 * Currently only brute force search supports non-eudlicean metrics.
 * @default "METRIC_NOT_SET"
 */
export enum SearchMetric {
  METRIC_NOT_SET = 'METRIC_NOT_SET',
  EUCLIDEAN_DISTANCE = 'EUCLIDEAN_DISTANCE',
  COSINE_DISTANCE = 'COSINE_DISTANCE',
}

/**
 * - RANDOM_PERCENTAGE_SPLIT: We will randomly split inputs into the datasets
 * @default "NOT_SET"
 */
export enum SplitIntoDatasetsDatasetSplitMethod {
  NOT_SET = 'NOT_SET',
  RANDOM_PERCENTAGE_SPLIT = 'RANDOM_PERCENTAGE_SPLIT',
}

/**
 *  - ALL_INPUTS: Use all inputs in the app.
 *  - SAVED_SEARCH: Use the inputs from a saved search.
 *  - DATASET: Inputs from a dataset.
 * @default "INPUT_SOURCE_TYPE_NOT_SET"
 */
export enum TaskInputSourceTaskInputSourceType {
  INPUT_SOURCE_TYPE_NOT_SET = 'INPUT_SOURCE_TYPE_NOT_SET',
  ALL_INPUTS = 'ALL_INPUTS',
  SAVED_SEARCH = 'SAVED_SEARCH',
  DATASET = 'DATASET',
}

/**
 *  - NONE: No review is needed.
 * When a labeler labels an input, the annotations are immediately approved.
 *  - MANUAL: Human reviewers will review the work done by labelers.
 *  - CONSENSUS: Automatically approve inputs when labelers reach consensus.
 * If consensus is not reached, then it will fallback to human reviewers.
 * @default "TASK_REVIEW_STRATEGY_NOT_SET"
 */
export enum TaskReviewTaskReviewStrategy {
  TASK_REVIEW_STRATEGY_NOT_SET = 'TASK_REVIEW_STRATEGY_NOT_SET',
  NONE = 'NONE',
  MANUAL = 'MANUAL',
  CONSENSUS = 'CONSENSUS',
}

/** @default "TASK_PRIORITY_NOT_SET" */
export enum TaskTaskPriority {
  TASK_PRIORITY_NOT_SET = 'TASK_PRIORITY_NOT_SET',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
}

/**
 *  - EVENLY: Each worker will label (approximately) the same number of inputs.
 *  - WEIGHTED: Each worker will have an assigned weight.
 * See weights field for more details.
 * @default "PARTITIONED_WORKER_STRATEGY_NOT_SET"
 */
export enum TaskWorkerPartitionedStrategyInfoTaskWorkerPartitionedStrategy {
  PARTITIONED_WORKER_STRATEGY_NOT_SET = 'PARTITIONED_WORKER_STRATEGY_NOT_SET',
  EVENLY = 'EVENLY',
  WEIGHTED = 'WEIGHTED',
}

/**
 *  - PARTITIONED: The inputs will be partitioned in several partitions.
 * Each worker will label one or more input partitions.
 * All inputs are assigned at task creation.
 *  - FULL: Each worker will label all inputs from input source.
 * All inputs are assigned at task creation.
 *  - DYNAMIC: Each worker will dynamically get 10 inputs assigned at a time.
 * No inputs are assigned at task creation.
 * @default "WORKER_STRATEGY_NOT_SET"
 */
export enum TaskWorkerTaskWorkerStrategy {
  WORKER_STRATEGY_NOT_SET = 'WORKER_STRATEGY_NOT_SET',
  PARTITIONED = 'PARTITIONED',
  FULL = 'FULL',
  DYNAMIC = 'DYNAMIC',
}

/**
 * - WORKER_TYPE_NOT_SET: for backward compatibility when task is not setting any type and only sets workers
 *  - WORKER_HUMAN: only human workers
 *  - WORKER_AUTO: auto-annotation tasks. Task must set worker as model or workflow
 * @default "WORKER_TYPE_NOT_SET"
 */
export enum TaskWorkerWorkerType {
  WORKER_TYPE_NOT_SET = 'WORKER_TYPE_NOT_SET',
  WORKER_HUMAN = 'WORKER_HUMAN',
  WORKER_AUTO = 'WORKER_AUTO',
}

/** Cancel a list of bulk operation ids */
export interface V2CancelBulkOperationsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  /** List of bulk operation ids to be cancelled */
  ids?: string[];
}

export interface V2CancelInputsAddJobBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
}

/** Cancel a list of extraction job ids */
export interface V2CancelInputsExtractionJobsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  /** List of extraction job ids to be cancelled */
  ids?: string[];
}

/** Request to delete several annotation filters by list of ids. */
export interface V2DeleteAnnotationFiltersBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  /** Specify which filters to delete. */
  annotation_filter_ids?: string[];
}

/**
 * Request to delete the terminated bulk operations by ID
 * Only operations in terminated state can be deleted.
 */
export interface V2DeleteBulkOperationsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  /** List of bulk operation ids to be deleted */
  ids?: string[];
}

/** DeleteCollaboratorsRequest */
export interface V2DeleteCollaboratorsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  collaborator_ids?: string[];
  user_emails?: string[];
}

/** Request to delete several things by the list of ids. */
export interface V2DeleteCollectorsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  ids?: string[];
  delete_all?: boolean;
}

export interface V2DeleteComputeClustersBody {
  /**
   * Only the user_id is used from this.
   * Only the user_id is used from this.
   */
  user_app_id?: {
    app_id?: string;
  };
  /** List of compute cluster ids to be deleted */
  ids?: string[];
}

/** DELETE concept relations */
export interface V2DeleteConceptRelationsBody {
  /**
   * The user_id and app_id information.
   * The user_id and app_id information.
   */
  user_app_id?: object;
  /** The concept relationship ids to delete. */
  ids?: string[];
}

/** Request to delete several dataset inputs by list of ids. */
export interface V2DeleteDatasetInputsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  /** Specify which inputs to delete from dataset. */
  input_ids?: string[];
}

/** Request to delete several dataset versions by list of ids. */
export interface V2DeleteDatasetVersionsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  dataset_version_ids?: string[];
}

/** Request to delete several datasets by list of ids. */
export interface V2DeleteDatasetsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  dataset_ids?: string[];
}

export interface V2DeleteDeploymentsBody {
  /**
   * Only the user_id is used from this.
   * Only the user_id is used from this.
   */
  user_app_id?: {
    app_id?: string;
  };
  /** List of deployment ids to be deleted */
  ids?: string[];
}

/** Request to delete several things by the list of ids. */
export interface V2DeleteInputsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  ids?: string[];
}

/** Request to delete several installed module versions by the list of ids. */
export interface V2DeleteInstalledModuleVersionsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  ids?: string[];
}

/** Request to delete a list of label orders. */
export interface V2DeleteLabelOrdersBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  ids?: string[];
}

/** Request to delete several things by the list of ids. */
export interface V2DeleteModelsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  ids?: string[];
  delete_all?: boolean;
}

/** Request to delete several module versions by the list of ids. */
export interface V2DeleteModuleVersionsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  ids?: string[];
}

/** Request to delete several things by the list of ids. */
export interface V2DeleteModulesBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  ids?: string[];
}

export interface V2DeleteNodepoolsBody {
  /**
   * Only the user_id is used from this.
   * Only the user_id is used from this.
   */
  user_app_id?: {
    app_id?: string;
  };
  /** List of nodepool ids to be deleted */
  ids?: string[];
}

/** Request to delete several things by the list of ids. */
export interface V2DeleteRunnersBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: {
    app_id?: string;
  };
  ids?: string[];
}

/** Request to delete a list of tasks. */
export interface V2DeleteTasksBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  ids?: string[];
}

/** Stops or deletes multipart upload */
export interface V2DeleteUploadsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  ids?: string[];
}

/** DeleteWorkflowVersionsRequest */
export interface V2DeleteWorkflowVersionsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  /** Delete the versions identified by these ids */
  workflow_version_ids?: string[];
}

/** Request to delete several things by the list of ids. */
export interface V2DeleteWorkflowsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  ids?: string[];
  delete_all?: boolean;
}

/**
 * //////////////////////////////////////////////////
 * Model prediction related stuff needs inputs and produces outputs.
 * //////////////////////////////////////////////////
 * Model prediction.
 */
export interface V2GenerateModelOutputsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  version_id?: string;
  inputs?: ApiInput[];
  /**
   * This allows you to specify config options for the model such as
   * the language which appear's in the model's output_info.
   */
  model?: ApiModel;
  /**
   * Allow filtering of prediction requests down to specific Nodepools, Deployments or Runners
   * ////////////////////////////////////////
   * Don't need RunnerSelector if we're opening up endpoints for deployments.
   * ////////////////////////////////////////
   * The RunnerSelector is an optional field we can provide during runtime
   * of model/workflow predictions to specify which particular runner we want to process the work.
   * This can optionally be used to select a particular nodepool and then within that nodepool
   * a particular runner.
   */
  runner_selector?: ApiRunnerSelector;
  /** Configure the prediction cache to avoid expensive compute for predict requests */
  use_predict_cache?: boolean;
  /** Configuration to provide logs summarization when request errors out */
  enable_log_summary_on_error?: boolean;
}

/** Request to patch several annotation filters. */
export interface V2PatchAnnotationFiltersBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  /** List of annotation filters that are requested to be updated. */
  annotation_filters?: ApiAnnotationFilter[];
  /**
   * The action to perform on the patched objects
   * For now, only 'overwrite' action is supported
   */
  action?: string;
}

/** PatchAnnotationsRequest */
export interface V2PatchAnnotationsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  annotations?: ClarifaiapiAnnotation[];
  /**
   * The action to perform on the patched objects
   * For now actions 'merge', 'overwrite', and 'remove' are supported
   */
  action?: string;
  /**
   * If the request is a "remove" action and the annotation is left with empty data,
   * then setting delete_if_empty_data to true will delete the annotation,
   * if possible (for example, will not delete an input-level annotation).
   */
  delete_if_empty_data?: boolean;
}

export interface V2PatchAnnotationsSearchesBody {
  /**
   * The user_id and app_id to query from.
   * The user_id and app_id to query from.
   */
  user_app_id?: object;
  /** The searches to be patched */
  searches?: ApiSearch[];
  /**
   * The action to perform on the patched Search objects
   * For now only action 'overwrite' is supported
   */
  action?: string;
}

/** PatchAnnotationsStatusRequest */
export interface V2PatchAnnotationsStatusBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  /** Filter by user IDs */
  user_ids?: string[];
  /** Filter by Status codes */
  status_codes?: StatusStatusCode[];
  /** 'overwrite' is supported */
  action?: string;
  /**
   * Update filtered annotations to this status
   * expired cc, still in trial, feature not supported in your tier
   *  - CONN_TOKEN_INVALID: invalid auth token used. Deprecated: we should return CONN_KEY_INVALID instead now in all cases.
   *  - CONN_CREDENTIALS_INVALID: invalid auth credentials
   *  - CONN_EXCEED_HOURLY_LIMIT: throttle hourly limit exceeded
   *  - CONN_EXCEED_MONTHLY_LIMIT: throttle monthly limit exceeded
   *  - CONN_THROTTLED: throttler and billing stuff
   *  - CONN_EXCEEDS_LIMITS: throttler and billing stuff
   *  - CONN_INSUFFICIENT_SCOPES: api key has insufficient permissions
   *  - CONN_KEY_INVALID: api key is invalid
   *  - CONN_KEY_NOT_FOUND: api key not found
   *  - CONN_BAD_REQUEST_FORMAT: multipart form parsing, broken json, etc
   *  - CONN_DOES_NOT_EXIST: when path is bad
   *  - CONN_INVALID_REQUEST: something wrong with a header
   *  - CONN_METHOD_NOT_ALLOWED: when a request method is not allowed
   *  - CONN_NO_GDPR_CONSENT: lack GDPR consent
   *  - CONN_INVALID_RANGE: when invalid range of a resource is requested
   *  - CONN_AUTH_METHOD_DISABLED: authentication method is disabled
   *  - MODEL_TRAINED: Model/Custom Training related 20xxx
   *
   * Custom model has been already trained.
   *  - MODEL_TRAINING: Custom model is currently training.
   *  - MODEL_UNTRAINED: Custom model has not yet been trained.
   *  - MODEL_QUEUED_FOR_TRAINING: Custom model is currently in queue for training, waiting on assets to process first.
   *  - MODEL_TRAINING_FAILED: generic err msg for any type of model training err.
   *  - MODEL_BUILDING: For new V3 DockerInternalType models which are built images
   *  - MODEL_BUILDING_FAILED: Failed to build image for model.
   *  - MODEL_BUILD_UNEXPECTED_ERROR: Failed to build image for model.
   *  - MODEL_TRAINING_NO_DATA: Custom model training had no data.  FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
   *  - MODEL_TRAINING_NO_POSITIVES: Custom model training had no positive examples. FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
   *  - MODEL_TRAINING_ONE_VS_N_SINGLE_CLASS: Custom model training was ONE_VS_N but with a single class. FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
   *  - MODEL_TRAINING_TIMED_OUT: Training took longer than hard coded timeouts. FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
   *  - MODEL_TRAINING_WAITING_ERROR: Training got error waiting on asset pipeline to finish. FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
   *  - MODEL_TRAINING_UNKNOWN_ERROR: Training threw an unknown exception.
   *  - MODEL_TRAINING_MSG_REDELIVER: Training message was redelivered. FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
   *  - MODEL_TRAINING_INSUFFICIENT_DATA: Training got error due to insufficient labelled data. FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
   *  - MODEL_TRAINING_INVALID_PARAMS: FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
   *  - MODEL_TRAINING_INVALID_DATA_TOLERANCE_EXCEEDED: Training is stopped because too much data was dropped. FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
   *  - MODEL_EVALUATION_TIMED_OUT: Evaluation took longer than hard coded timeouts. FIXME(yang): deprecate this. Use the 21317 + errStatusMsg
   *  - MODEL_EVALUATION_WAITING_ERROR: Evaluation got error waiting on asset pipeline to finish.FIXME(yang): deprecate this. Use the 21317 + errStatusMsg
   *  - MODEL_EVALUATION_UNKNOWN_ERROR: EVALUATION THREW AN UNKNOWN EXCEPTION.
   *  - MODEL_EVALUATION_MSG_REDELIVER: Eval message was redelivered. FIXME(yang): deprecate this. Use the 21317 + errStatusMsg
   *  - MODEL_EVALUATION_NEED_LABELS: Don't have enough concepts labelled to perform evaluation. FIXME(yang): deprecate this. Use the 21317 + errStatusMsg
   *  - MODEL_EVALUATION_NEED_INPUTS: Don't have enough inputs per concept to perform evaluation. FIXME(yang): deprecate this. Use the 21317 + errStatusMsg
   *  - MODEL_EVALUATION_FAILED: Generic err code for eval failure.
   *  - MODEL_DEPLOYMENT_FAILED: Used when inference coordinator failed to deploy spire and throws an error
   *  - MODEL_DEPLOYING: Used when calling the inference coordinator to deploy a spire
   *  - MODEL_QUEUED_FOR_DEPLOYMENT: Used when training is completed
   *  - MODEL_NOT_DEPLOYED: Used when model spire deployment is manually taken down or due to inactivity
   *  - MODEL_LOADING: Used when the model pod is running, but not yet ready to serve requests.
   *  - MODEL_REFERENCE_INVALID_ARGUMENT: Used when a model reference field is not set properly
   *  - MODEL_EXAMPLE_INPUT_INVALID_ARGUMENT: Used when a model example input field is not set properly
   *  - MODEL_EXPORTED: Model Export status codes
   *  - WORKFLOW_NO_MATCHING_INPUT: specified model input not in workflow
   *  - WORKFLOW_REQUIRE_TRAINED_MODEL: specified model must be trained
   *  - WORKFLOW_INVALID_ARGUMENT: error in the request somewhere
   *  - WORKFLOW_INVALID_REQUEST: error in the request somewhere
   *  - CONCEPT_MODIFY_SUCCESS: Concept related 23xxx
   *  - ANNOTATION_SUCCESS: Annotation related 24xxx
   *  - ANNOTATION_AWAITING_REVIEW: Annotation is awaiting review from task REVIEWERS.
   *  - ANNOTATION_AWAITING_CONSENSUS_REVIEW: Annotation is awaiting consensus review from task LABELERS.
   *  - METADATA_INVALID_PATCH_ARGUMENTS: Metadata related 249xx
   *  - TRAINER_JOB_STATE_NONE: Training service related 25xxx
   *  - DATA_DUMP_SUCCESS: Data Dump related 251xx
   *  - DATA_DUMP_NO_DATA: DEPRECATED: Not used anymore. Now for an empty data dump, DATA_DUMP_SUCCESS is returned. To detect an empty data dump, check if the inptus count is 0.
   *  - APP_DUPLICATION_SUCCESS: Duplicate related 252xx
   *  - MODULE_DOES_NOT_EXIST: Module related codes 253xx
   *  - BULK_OPERATION_SUCCESS: Bulk Operation related codes 254xx
   *  - RUNNER_DOES_NOT_EXIST: Runner related codes 256xx
   *  - NODEPOOL_DOES_NOT_EXIST: Nodepool related codes 257xx
   *  - COMPUTE_CLUSTER_DOES_NOT_EXIST: ComputeCluster related codes 258xx
   *  - DEPLOYMENT_DOES_NOT_EXIST: Deployment related codes 259xx
   *  - INSTANCE_TYPE_DOES_NOT_EXIST: InstanceType related codes 260xx
   *  - COMPUTE_PLANE_METRICS_INVALID_REQUEST: Compute plane related codes 261xx
   *  - PIPELINE_STEP_DOES_NOT_EXIST: PipelineStep related codes 262xx
   *  - INPUT_SUCCESS: Input:Image related 30xxx
   *  - INPUT_PENDING: when things are async, this is the default status.
   *  - INPUT_FAILED: any type of error downloading and processing
   *  - INPUT_DOWNLOAD_SUCCESS: use INPUT_SUCCESS, INPUT_PENDING, INPUT_FAILED, INPUT_IN_PROGRESS instead
   * DOWNLOAD is no longer correct, but keep old statuses for backward compatibility
   *  - INPUT_VIDEO_DOWNLOAD_SUCCESS: Input:Video related 31xxx -- Deprecated
   *  - INPUT_WRITES_DISABLED_FOR_MAINTENANCE: deprecate this one. Use REQUEST_DISABLED_FOR_MAINTENANCE
   *  - PREDICT_INVALID_REQUEST: API formatting issues 4000x
   *  - DATABASE_DUPLICATE_KEY: Other related 400xx
   *  - EXTERNAL_CONNECTION_ERROR: could not connect to external services
   *  - QUEUE_CONN_ERROR: Queue related errors 41xxx
   *  - SQS_OVERLIMIT: SQS related errors 411xx
   *  - SEARCH_INTERNAL_FAILURE: Search related errors 43xxxx
   *  - EVALUATION_QUEUED: Workflow evaluation err code
   *  - STRIPE_EVENT_ERROR: Stripe 44xxx
   *  - CACHE_MISS: Redis/Cache 45xxx
   *  - SIGNUP_EVENT_ERROR: Sift Science 46xxx
   *  - APP_COUNT_INVALID_MESSAGE: Application counts related errors 470xx
   *  - MP_DOWNLOAD_ERROR: Media processor related errors 471xx -- DEPRECATED
   *  - DATATIER_CONN_ERROR: DataTier related error 472xx
   *  - USER_CONSENT_FACE: User legal consent stauts related 50xxx
   *  - WORKER_MISSING: Workers 51xxx
   *  - COLLECTOR_MISSING: Collectors 52xxx
   *  - SSO_IDENTITY_PROVIDER_DOES_NOT_EXIST: SSO 53xxx
   *  - TASK_IN_PROGRESS: Tasks 54xxx
   * The task was created.
   *  - TASK_DONE: The task is completed.
   *  - TASK_WONT_DO: The task is marked as abandoned.
   *  - TASK_FAILED: An error occurred during add-task-annotations or add-auto-annotations pipeline.
   *  - TASK_IDLE: When an Auto Annotation task job has finished processing its last batch and is waiting for more dataset assets.
   *  - TASK_CONFLICT: The task operation is in conflict with the current state of the server.
   *  - TASK_NOT_IMPLEMENTED: Certain task-related scenarios are not implemented.
   *  - TASK_MISSING: Task was not found.
   *  - TASK_PERMISSION_DENIED: Not allowed to perform a task-related action.
   *  - TASK_ASSIGNMENT_SUCCESS: Task Assignments 542xx
   *  - TASK_ASSIGNMENT_REVIEW_SUCCESS: Task Assignment Reviews 543xx
   *  - LABEL_ORDER_PENDING: Label Order Related Status Code 55xxx
   *  - LICENSE_ACTIVE: License Related Status Code 600xx
   *  - LICENSE_DELETED: hidden state not reflected to users
   *  - PASSWORD_VALIDATION_SUCCESS: Password Related Status Code
   *  - FEATUREFLAG_CONFIG_NOT_FOUND: Feature flags status code
   *  - MAINTENANCE_SUCCESS: Maintenance status code
   *  - DATASET_VERSION_PENDING: Datasets 64xxx
   * The dataset version is pending to be processed.
   *  - DATASET_VERSION_IN_PROGRESS: The dataset version is currently being processed.
   *  - DATASET_VERSION_READY: The dataset version is ready to be used.
   *  - DATASET_VERSION_FAILURE: An error occurred during the dataset version processing.
   *  - DATASET_VERSION_UNEXPECTED_ERROR: An unexpected error occurred during the dataset version processing.
   *  - DATASET_VERSION_CONFLICT: An alteration to dataset version would create a conflict
   *  - DATASET_INPUT_SUCCESS: The dataset input was successfully added.
   *  - DATASET_INPUT_DUPLICATE: The dataset input is a duplicate.
   * Deprecated: Unused.
   *  - DATASET_VERSION_EXPORT_SUCCESS: The dataset version export is completed.
   *  - DATASET_VERSION_EXPORT_PENDING: The dataset version is pending to be exported.
   *  - DATASET_VERSION_EXPORT_FAILED: An error occurred during the dataset version export.
   *  - DATASET_VERSION_EXPORT_IN_PROGRESS: The dataset version is currently being exported.
   *  - DATASET_VERSION_EXPORT_UNEXPECTED_ERROR: An unexpected error occurred during the dataset version export.
   *  - JOB_QUEUED: Generic Job status codes
   *  - AUTH_MISSING_IDP_ASSOC: auth issues
   *
   * TODO: Knowledge graph related 80xxx
   *  - UPLOAD_IN_PROGRESS: Multipart uploading status codes
   *  - BILLING_INVALID_INFO: Billing related issues: 69xxx
   *  - LOG_ENTRIES_INVALID_REQUEST: Logs related issues: 70000;
   *  - INTERNAL_SERVER_ISSUE: Internal issues: 98xxx
   *  - CONN_UNCATEGORIZED: Uncategorized: 99xxx: move off as soon as known
   *  - BAD_REQUEST: Deprecated: migrate off to one of the internal issues
   *  - SERVER_ERROR: Deprecated: migrate off to one of the internal issues
   */
  status_code?: StatusStatusCode;
}

/** PatchAppRequest */
export interface V2PatchAppBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  app?: ApiApp;
  /**
   * The action to perform on the patched App object except App.Metadata
   * Supported values: 'overwrite' and 'remove'.
   *
   * Note that 'remove' can only be used to remove the app image by setting
   * 'image.url' in the request to the current value returned for the app.
   */
  action?: string;
  /** The action to perform on the patched App.Metadata */
  metadata_action?: ApiPatchAction;
  /** If set, the app will be automatically reindexed upon change of its base workflow. */
  reindex?: boolean;
}

/** PatchAppsRequest */
export interface V2PatchAppsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: {
    app_id?: string;
  };
  apps?: ApiApp[];
  /**
   * The action to perform on the patched App objects except App.Metadata
   * Supported values: 'overwrite' and 'remove'.
   *
   * Note that 'remove' can only be used to remove the app image by setting
   * 'image.url' in the request to the current value returned for that app.
   */
  action?: string;
  /** The action to perform on the patched App.Metadata */
  metadata_action?: ApiPatchAction;
  /** If set, the app will be automatically reindexed upon change of its base workflow. */
  reindex?: boolean;
}

export interface V2PatchAppsDetailsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  apps?: ApiApp[];
  /**
   * The action to perform on the patched App objects
   * Supported values: 'overwrite' and 'remove'.
   *
   * Note that 'remove' can only be used to remove the app image by setting
   * 'image.url' in the request to the current value returned for that app.
   */
  action?: string;
}

/** PatchAppsIdsRequest */
export interface V2PatchAppsIdsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: {
    app_id?: string;
  };
  /** Array containing 1 entry */
  ids?: ApiIdUpdateSource[];
  /**
   * The action to perform on the patched objects
   * Only 'overwrite' is supported
   */
  action?: string;
}

/** PatchCollaboratorsRequest */
export interface V2PatchCollaboratorsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  collaborators?: ApiCollaborator[];
  /**
   * The action to perform on the patched objects
   * For now only action 'overwrite' is supported
   */
  action?: string;
}

/** PatchCollectorsRequest */
export interface V2PatchCollectorsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  collectors?: ApiCollector[];
  /**
   * The action to perform on the patched objects
   * Only 'overwrite' is supported
   */
  action?: string;
}

/** PATCH multiple concept languages for the given concept. */
export interface V2PatchConceptLanguagesBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  concept_languages?: ApiConceptLanguage[];
  /** The action to perform with the objects in the PATCH. */
  action?: string;
}

/** PatchConceptsRequest */
export interface V2PatchConceptsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  /** The concepts to patch. */
  concepts?: ApiConcept[];
  /**
   * The action to perform on the patched objects
   * For now ony action 'overwrite' is supported
   */
  action?: string;
}

/** Request to patch several dataset versions. */
export interface V2PatchDatasetVersionsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  /** List of dataset versions that are requested to be updated. */
  dataset_versions?: ApiDatasetVersion[];
  /**
   * The action to perform on the patched objects
   * For now, only 'overwrite' action is supported
   */
  action?: string;
}

/** Request to patch several datasets. */
export interface V2PatchDatasetsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  /** List of datasets that are requested to be updated. */
  datasets?: ApiDataset[];
  /**
   * The action to perform on the patched objects
   * Supported values: 'overwrite', 'merge', and 'remove'.
   *
   * Note that 'remove' can only be used to remove the dataset image by setting
   * 'image.url' in the request to the current value returned for that dataset.
   */
  action?: string;
}

export interface V2PatchDeploymentsBody {
  /**
   * Only the user_id is used from this.
   * Only the user_id is used from this.
   */
  user_app_id?: {
    app_id?: string;
  };
  deployments?: ApiDeployment[];
  /**
   * The action to perform on the patched objects
   * For now actions 'merge', 'overwrite', and 'remove' are supported
   */
  action?: string;
}

/** PatchInputsRequest */
export interface V2PatchInputsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  /**
   * List of inputs to patch.
   * Inputs are identified by id field.
   * For each input, the following fields are patchable:
   * * data
   */
  inputs?: ApiInput[];
  /**
   * The action to perform on the patched objects
   * For now actions 'merge', 'overwrite', and 'remove' are supported
   */
  action?: string;
}

export interface V2PatchInputsSearchesBody {
  /**
   * The user_id and app_id to query from.
   * The user_id and app_id to query from.
   */
  user_app_id?: object;
  /** The searches to be patched */
  searches?: ApiSearch[];
  /**
   * The action to perform on the patched Search objects
   * For now only action 'overwrite' is supported
   */
  action?: string;
}

/** PatchKeysRequest */
export interface V2PatchKeysBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: {
    app_id?: string;
  };
  keys?: ApiKey[];
  /**
   * The action to perform on the patched objects
   * For now only action 'overwrite' is supported
   */
  action?: string;
}

/** Request to patch a list of label orders. */
export interface V2PatchLabelOrdersBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  label_orders?: ApiLabelOrder[];
  /**
   * The action to perform on the patched objects
   * For now actions 'merge', 'overwrite', and 'remove' are supported
   */
  action?: string;
}

/** PatchModelCheckConsentsRequest */
export interface V2PatchModelCheckConsentsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  /** the consents */
  check_consents?: string[];
  /** overwrite supported */
  action?: string;
}

/** PatchModelIdsRequest */
export interface V2PatchModelIdsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  /** Array containing 1 entry */
  ids?: ApiIdUpdateSource[];
  /**
   * The action to perform on the patched objects
   * Only 'overwrite' is supported
   */
  action?: string;
}

export interface V2PatchModelLanguagesBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  languages?: string[];
  /** Only overwrite supported */
  action?: string;
}

export interface V2PatchModelToolkitsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  toolkits?: string[];
  /** overwrite supported */
  action?: string;
}

export interface V2PatchModelUseCasesBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  usecases?: string[];
  /** overwrite supported */
  action?: string;
}

/** PatchModelVersionsRequest */
export interface V2PatchModelVersionsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  model_versions?: ApiModelVersion[];
  /**
   * The action to perform on the patched objects
   * For now actions 'merge', 'overwrite', and 'remove' are supported
   */
  action?: string;
}

/** PatchModelsRequest */
export interface V2PatchModelsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  models?: ApiModel[];
  /**
   * The action to perform on the patched objects
   * For now actions 'merge', 'overwrite', and 'remove' are supported
   * Note that 'remove' can be used to remove the model image by setting
   * 'image.url' in the request to the current value returned for that model.
   * This cannot be used in a request that is patching other fields as well.
   */
  action?: string;
}

/** PatchModuleVersionsRequest */
export interface V2PatchModuleVersionsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  /**
   * This allows you to modify the module version details.
   * ########## Supported fields ##########
   * - description
   * - id
   * - metadata.fields
   * - module_nav.module_sub_navs[].query_key
   * - module_nav.module_sub_navs[].query_value
   * - module_nav.module_sub_navs[].title
   * - module_nav.title
   * - notes
   * - visibility.gettable
   */
  module_versions?: ApiModuleVersion[];
  /**
   * The action to perform on the patched objects
   * For now only action 'merge' is supported
   */
  action?: string;
}

/** PatchModulesRequest */
export interface V2PatchModulesBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  modules?: ApiModule[];
  /**
   * The action to perform on the patched objects
   * Supported values: 'overwrite' and 'remove'.
   *
   * Note that 'remove' can only be used to remove the module image by setting
   * 'image.url' in the request to the current value returned for that module.
   */
  action?: string;
}

/** PatchNodepoolsRequest */
export interface V2PatchNodepoolsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: {
    app_id?: string;
  };
  nodepools?: ApiNodepool[];
  /**
   * The action to perform on the patched objects
   * For now actions 'merge', 'overwrite', and 'remove' are supported
   */
  action?: string;
}

/** PatchRunnersRequest */
export interface V2PatchRunnersBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: {
    app_id?: string;
  };
  /** This allows you to create one or more runner by posting it to the API. */
  runners?: ApiRunner[];
  /**
   * The action to perform on the patched objects
   * For now actions 'merge', 'overwrite', and 'remove' are supported
   */
  action?: string;
}

/** PatchSearchesRequest */
export interface V2PatchSearchesBody {
  /**
   * The user_id and app_id to query from.
   * The user_id and app_id to query from.
   */
  user_app_id?: object;
  /** The searches to be patched */
  searches?: ApiSearch[];
  /**
   * The action to perform on the patched Search objects
   * For now only action 'overwrite' is supported
   */
  action?: string;
}

/** Request to patch a list of tasks. */
export interface V2PatchTasksBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  tasks?: ApiTask[];
  /**
   * The action to perform on the patched objects
   * For now, only 'overwrite' action is supported
   */
  action?: string;
}

/** PatchWorkflowIdsRequest */
export interface V2PatchWorkflowIdsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  /** Array containing 1 entry */
  ids?: ApiIdUpdateSource[];
  /**
   * The action to perform on the patched objects
   * Only 'overwrite' is supported
   */
  action?: string;
}

export interface V2PatchWorkflowVersionEvaluationsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  /**
   * ########## Supported fields ##########
   * - id
   * - predictions_dataset_version.dataset_id
   * - predictions_dataset_version.id
   * - status.code
   * - status.details
   * - workflow_evaluation_result.summary.evaluation_metric_values[].evaluation_metric_id
   * - workflow_evaluation_result.summary.evaluation_metric_values[].explanation
   * - workflow_evaluation_result.summary.evaluation_metric_values[].metric_value.float_value
   * - workflow_evaluation_result.summary.evaluation_metric_values[].metric_value.int_value
   * - workflow_evaluation_result.summary.evaluation_metric_values[].metric_value.string_value
   * - workflow_evaluation_result.summary.evaluation_metric_values[].per_concept_values
   */
  workflow_version_evaluations?: ApiWorkflowVersionEvaluation[];
  /** only overwrite supported */
  action?: string;
}

/** PatchWorkflowVersionsRequest */
export interface V2PatchWorkflowVersionsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  /** Patch these versions. */
  workflow_versions?: ApiWorkflowVersion[];
  /**
   * The action to perform on the patched objects
   * For now actions 'merge', 'overwrite', and 'remove' are supported
   */
  action?: string;
}

/** PatchWorkflowsRequest */
export interface V2PatchWorkflowsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  workflows?: ApiWorkflow[];
  /**
   * The action to perform on the patched objects
   * For now actions 'merge', 'overwrite', and 'remove' are supported
   * Note that 'remove' can be used to remove the workflow image by setting
   * 'image.url' in the request to the current value returned for that workflow.
   * This cannot be used in a request that is patching other fields as well.
   */
  action?: string;
}

/** Request to add one or more annotation filters. */
export interface V2PostAnnotationFiltersBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  /** List of annotation filters that are requested to be added. */
  annotation_filters?: ApiAnnotationFilter[];
}

/** PostAnnotationSearchMetricsRequest */
export interface V2PostAnnotationSearchMetricsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  /** A unique customer facing id to identify this eval request */
  id?: string;
  /**
   * The ground truth we are evaluating against
   * This is the new Search object used in saved searches.
   */
  ground_truth?: ApiSearch;
  /**
   * The set we are evaluating
   * This is the new Search object used in saved searches.
   */
  search_to_eval?: ApiSearch;
  /**
   * List of concepts to evaluate are expected to be in data.concepts
   * If nil, then all app concepts are used
   */
  data?: ApiData;
  /** The type of evaluation to use */
  evaluation_type?: ApiEvaluationType;
}

/** PostAnnotationsRequest */
export interface V2PostAnnotationsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  annotations?: ClarifaiapiAnnotation[];
}

/**
 * Execute a new annotation search and optionally save it
 * annotation search over annotations using rank and filter proto
 */
export interface V2PostAnnotationsSearchesBody {
  /**
   * The user_id and app_id to query from.
   * The user_id and app_id to query from.
   */
  user_app_id?: object;
  /** The searched to be executed or saved */
  searches?: ApiSearch[];
  /** Pagination information to paginate through search result Hits. */
  pagination?: ApiPagination;
}

/** Request to start app duplication jobs. */
export interface V2PostAppDuplicationsBody {
  /**
   * The user and application ID of the source application to duplicate.
   * The user and application ID of the source application to duplicate.
   */
  user_app_id?: object;
  app_duplications?: ApiAppDuplication[];
}

/** PostAppsRequest */
export interface V2PostAppsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: {
    app_id?: string;
  };
  apps?: ApiApp[];
}

/** Search over the available applications. */
export interface V2PostAppsSearchesBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: {
    app_id?: string;
  };
  /** The body of the request. */
  app_query?: ApiAppQuery;
  /**
   * Pagination parameters here since there are no url args in this
   * POST request.
   */
  pagination?: ApiPagination;
}

export interface V2PostAuditLogSearchesBody {
  /**
   * Only the user_id is used from this.
   * Only the user_id is used from this.
   */
  user_app_id?: {
    app_id?: string;
  };
  /** AuditLogQuery is a query for audit log entries. */
  query?: ApiAuditLogQuery;
  /**
   * Sorting options:
   * Whether to sort by timestamp in ascending order. If false, will order in descending order.
   */
  sort_ascending?: boolean;
  /** Split the results into pages. */
  pagination?: ApiPagination;
}

/** Request to perform bulk operations on a list of inputs based on input source. */
export interface V2PostBulkOperationsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  /** List of bulk operation(s) to be performed e.g bulk update metadata or tags or labels etc. */
  bulk_operations?: ApiBulkOperation[];
}

/** PostCollaboratorsRequest */
export interface V2PostCollaboratorsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  collaborators?: ApiCollaborator[];
}

/** Request to create Collectors. */
export interface V2PostCollectorsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  collectors?: ApiCollector[];
}

export interface V2PostComputeClustersBody {
  /**
   * Only the user_id is used from this.
   * Only the user_id is used from this.
   */
  user_app_id?: {
    app_id?: string;
  };
  /** This allows you to create one or more compute_clusters by posting it to the API. */
  compute_clusters?: ApiComputeCluster[];
}

/** POST multiple concept languages for the given concept. */
export interface V2PostConceptLanguagesBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  concept_languages?: ApiConceptLanguage[];
}

/** POST new concept relations */
export interface V2PostConceptRelationsBody {
  /**
   * The user_id and app_id information.
   * The user_id and app_id information.
   */
  user_app_id?: object;
  /** The relationships you're going to add. */
  concept_relations?: ApiConceptRelation[];
}

/** PostConceptsRequest */
export interface V2PostConceptsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  /** The concepts to add. */
  concepts?: ApiConcept[];
}

/** PostConceptsSearchesRequest */
export interface V2PostConceptsSearchesBody {
  /**
   * Ids present in the url of the request.
   * Ids present in the url of the request.
   */
  user_app_id?: object;
  /** The body of the request. */
  concept_query?: ApiConceptQuery;
  /** Request additional info to be retrieved for each concept in the response. */
  extra_info?: ApiConceptExtraInfoRequest;
  /**
   * Pagination parameters here since there are no url args in this
   * POST request.
   */
  pagination?: ApiPagination;
}

/** Request to add one or more datasets. */
export interface V2PostDatasetInputsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  /**
   * List of inputs that are requested to be added to this dataset.
   * Identify each input by id field. All other inputs fields are ignored.
   */
  dataset_inputs?: ApiDatasetInput[];
  /** Query to search inputs to be added to this dataset. */
  search?: ApiSearch;
}

/** Request to add one or more dataset versions. */
export interface V2PostDatasetVersionsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  /** List of dataset versions that are requested to be added. */
  dataset_versions?: ApiDatasetVersion[];
}

/** Request to add one or more datasets. */
export interface V2PostDatasetsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  /** List of datasets that are requested to be added. */
  datasets?: ApiDataset[];
}

export interface V2PostDeploymentsBody {
  /**
   * Only the user_id is used from this.
   * Only the user_id is used from this.
   */
  user_app_id?: {
    app_id?: string;
  };
  /** This allows you to create one or more deployments by posting it to the API. */
  deployments?: ApiDeployment[];
}

/** Evaluate this model vesion */
export interface V2PostEvaluationsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  /**
   * eval_info, id, model, and ground_truth_dataset will be used when creating the evaluation
   * If no dataset is provided, all app data that is annotated with concepts from the model will be used.
   */
  eval_metrics?: ApiEvalMetrics[];
}

/** PostInputsRequest */
export interface V2PostInputsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  /**
   * List of inputs to post.
   * For each input, the following fields are used:
   * * id
   * * data
   * * dataset_ids
   */
  inputs?: ApiInput[];
  /**
   * Collect statistics about created inputs in job with given ID.
   * * If job ID is empty, then job is not created.
   * * If job ID is non-empty and doesn't already exist, then a new job will be created with given ID.
   * * If job ID does already exist, then new inputs statistics are merged with previous inputs statistics.
   */
  inputs_add_job_id?: string;
  /** How to handle input ID conflicts. */
  input_id_conflict_resolution?: ApiInputIDConflictResolution;
}

/**
 * Initiates retrieval of inputs from cloud storage from a user provided data source.
 * Will create and return an inputs-add-job for tracking progress.
 * Archives will be extracted and their contents will be processed as inputs.
 *
 * The cloud URL will be treated as a filter prefix. For example s3:/bucket/images_folder/abc will process
 * files in the images_folder beginning with abc or in a subfolder beginning with abc.
 * For example:
 * bucket/images_folder/abcImage.png
 * bucket/images_folder/abc-1/Data.zip
 *
 * If given URL is for a private bucket or file, then credentials should be provided to access the bucket.
 * Credentials should include rights to list the objects in the bucket, except when pointed directly at a file archive,
 * in which case it only requires rights to access that particular file.
 */
export interface V2PostInputsDataSourcesBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  data_sources?: ApiInputsDataSource[];
  /** If call back url is set, we will send a Post request to this endpoint with job status. */
  call_back_url?: string;
  /**
   * Personal Access Token to the application to which inputs are added
   * Deprecated: No need to send app_pat, it will be generated internally if not present
   */
  app_pat?: string;
}

/** Execute a new input search and optionally save it */
export interface V2PostInputsSearchesBody {
  /**
   * The user_id and app_id to query from.
   * The user_id and app_id to query from.
   */
  user_app_id?: object;
  /** The searched to be executed or saved */
  searches?: ApiSearch[];
  /** Pagination information to paginate through search result Hits. */
  pagination?: ApiPagination;
  /**
   * If only_count is set, then the response will not contain hits,
   * but hit_counts instead.
   */
  only_count?: boolean;
}

/**
 * Start uploading a file archive containing inputs.
 * Will create and return an inputs-add-job for tracking progress.
 *
 * Associated inputs-add-job contains an upload id which should be completed through `PutUploadContentParts` endpoint.
 * Completing the upload will automatically begin unpacking the archive and uploading the contents as inputs.
 */
export interface V2PostInputsUploadsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  inputs_uploads?: ApiInputsUpload[];
}

/** PostInstalledModuleVersionsRequest to install a module version into the app in the URL */
export interface V2PostInstalledModuleVersionsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  /** This allows you to create one or more module by posting it to the API. */
  installed_module_versions?: ApiInstalledModuleVersion[];
}

/**
 * PostInstalledModuleVersionsKeyRequest to associate a key of the caller's to the installed module
 * version.
 */
export interface V2PostInstalledModuleVersionsKeyBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
}

/** PostKeysRequest */
export interface V2PostKeysBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: {
    app_id?: string;
  };
  keys?: ApiKey[];
}

/** POST new knowledge graphs */
export interface V2PostKnowledgeGraphsBody {
  /**
   * The user_id and app_id information.
   * The user_id and app_id information.
   */
  user_app_id?: object;
  knowledge_graphs?: ApiKnowledgeGraph[];
}

/** Request to create label orders. */
export interface V2PostLabelOrdersBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  label_orders?: ApiLabelOrder[];
}

export interface V2PostModelMigrationBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
}

/**
 * //////////////////////////////////////////////////
 * Model prediction related stuff needs inputs and produces outputs.
 * //////////////////////////////////////////////////
 * Model prediction.
 */
export interface V2PostModelOutputsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  model_id?: string;
  version_id?: string;
  inputs?: ApiInput[];
  /**
   * This allows you to specify config options for the model such as
   * the language which appear's in the model's output_info.
   */
  model?: ApiModel;
  /** Allow filtering of prediction requests down to specific Nodepools, Deployments or Runners */
  runner_selector?: {
    /**
     * A particular nodepool for the resource to be run within. This request the id and user_id of
     * the nodepool to be specified. Runners will be scaled according to a deployment for the given
     * resource to be run. There should not be more than one deployment in this nodepool for the
     * particular resource to run. If no deployments then default autoscaling will be used.
     */
    nodepool?: ApiNodepool;
    /** Optionally a partcular runner within the nodepool. */
    runner?: ApiRunner;
    /**
     * Optionally a partcular deployment within the nodepool.
     * In future as we support matching runners based on just labels:
     *  RunnerLabels runner_labels = 3; // FUTURE
     */
    deployment?: {
      /** How to autoscale the object. */
      autoscale_config?: ApiAutoscaleConfig;
      /**
       * You can configure different autoscaling per nodepool(s).
       * These nodepools have to be also owned by the same user_id/org as this deployment.
       * If there is more than one nodepool we use the model's ComputeInfo to match
       * with what the nodepool provides to decide which one can handle it combined with the
       * NodepoolRank below. Note: even within a single nodepool if it is heterogeneous then
       * we need a way to rank scheduling choices when we don't know how to decide (like a model
       * supports
       */
      nodepools?: ApiNodepool[];
      /**
       * In some scenarios it may not be obvous how we should schedule a resource to underlying nodes
       * within the nodepool(s) above. The SchedulerChoice allows us to specify how to decide which
       * nodepool to use when there are multiple nodepools and how to decide which type of node
       * within a nodepool if there are multiple types.
       * If here are multiple nondepools then a decision on which to use comes into play
       * if it is not specified in the prediction request.
       * Even with a single nodepool a choice may come up such as when a resource that needs scheduling
       * has not specified the accelerator types it supports and the nodepool has multiple types.
       *
       *  - FAIL: fail if there is any ambiguity.
       *  - RANDOM: randomly pick amongst the nodepools/nodes to assign.
       *  - PRICE: choose the compute that is cheaper
       *  - PERFORMANCE: schedule to the fastest known iption.
       *  - NETWORK: optimize based on network latency.
       *  - UTILIZATION: send to the least used nodepool based on it's capacity.
       *  - PREFER_SPOT: choose spot instances over on-demand
       *  - PREFER_ONDEMAND: choose on-demand instances over spot.
       */
      scheduling_choice?: DeploymentSchedulingChoice;
      /**
       * The visibility field represents whether this message is privately/publicly visible.
       * To be visible to the public the App that contains it AND the User that contains the App must
       * also be publicly visible.
       */
      visibility?: ClarifaiapiVisibility;
      /**
       * To handle arbitrary json metadata:
       * https://github.com/google/protobuf/blob/master/src/google/protobuf/struct.proto
       */
      metadata?: object;
      /** Short description of deployment. */
      description?: string;
      /**
       * The thing that the autoscaling config applies to for this nodepool.
       * For a given user_id, nodepool_id, and object ID we can only have one deployment as it defines
       * Worker is the author of an annotation.
       */
      worker?: ApiWorker;
      /**
       * When the deployment was created.
       * @format date-time
       */
      created_at?: string;
      /**
       * When the deployment was last modified.
       * @format date-time
       */
      modified_at?: string;
      /** When to always deploy latest model version */
      deploy_latest_version?: boolean;
    };
  };
  /** Configure the prediction cache to avoid expensive compute for predict requests */
  use_predict_cache?: boolean;
  /** Configuration to provide logs summarization when request errors out */
  enable_log_summary_on_error?: boolean;
}

/** Evaluate this model vesion */
export interface V2PostModelVersionEvaluationsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  /** EvalInfo and ID will be used when creating the evaluation */
  eval_metrics?: ApiEvalMetrics[];
}

/** Evaluate this model version. */
export interface V2PostModelVersionMetricsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  /**
   * Use this to filter inputs that are used in evaluation
   * This is the new Search object used in saved searches.
   */
  test_search?: ApiSearch;
  /** evaluation info. Such as dataset used for evaluation. */
  eval_info?: ApiEvalInfo;
}

/** Create (train) a new model version. */
export interface V2PostModelVersionsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  model_versions?: ApiModelVersion[];
  /** Description about this training run */
  description?: string;
  /**
   * When evaluate_after_training set to true, we will do evaluation immediately after training finishes.
   * We will merge this with default_eval_info.
   */
  eval_info?: ApiEvalInfo;
  /** When set to true, we will convert the model into a containerized model after training. */
  do_migration?: boolean;
}

/** PostModelVersionsPublishRequest */
export interface V2PostModelVersionsPublishBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  publications?: ApiModelVersionPublishRequest[];
}

/** Get the estimated training time for a model version */
export interface V2PostModelVersionsTrainingTimeEstimateBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  model_versions?: ApiModelVersion[];
  /** @format uint64 */
  estimated_input_count?: string;
}

/** PostModelVersionsUnPublishRequest */
export interface V2PostModelVersionsUnPublishBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  publications?: ApiModelVersionUnpublishRequest[];
}

/** PostModelsRequest */
export interface V2PostModelsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  /**
   * NOTE: inconsistent since "model" is not plural, please use "models" below.
   * Previously you could only create one model at a time.
   * We still support this but you should pass it as models=[model] so
   * that this endpoint is consistent with the rest of our API.
   */
  model?: ApiModel;
  /** This allows you to create one or more model by posting it to the API. */
  models?: ApiModel[];
}

/** Search over the available models. */
export interface V2PostModelsSearchesBody {
  /**
   * Ids present in the url of the request.
   * Ids present in the url of the request.
   */
  user_app_id?: object;
  /** The body of the request. */
  model_query?: ApiModelQuery;
  /**
   * Pagination parameters here since there are no url args in this
   * POST request.
   */
  pagination?: ApiPagination;
}

/** PostModuleVersionsRequest */
export interface V2PostModuleVersionsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  /** This allows you to create one or more module by posting it to the API. */
  module_versions?: ApiModuleVersion[];
}

/** PostModulesRequest */
export interface V2PostModulesBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  /** This allows you to create one or more module by posting it to the API. */
  modules?: ApiModule[];
}

export interface V2PostNodepoolsBody {
  /**
   * Only the user_id is used from this.
   * Only the user_id is used from this.
   */
  user_app_id?: {
    app_id?: string;
  };
  /** This allows you to create one or more nodepools by posting it to the API. */
  nodepools?: ApiNodepool[];
}

export interface V2PostPipelineStepsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  pipeline_steps?: ApiPipelineStep[];
}

/**
 * PostRunnerItemOutputsRequest
 * This is the message that runners send to the API to communicate.
 * At the end of the request it will have the RunnerItemOutput filled in
 * with results of the workload the runner is processing. Other messages
 * from the runner use this same proto to communicate over to the API
 * and do handshakes.
 */
export interface V2PostRunnerItemOutputsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: {
    app_id?: string;
  };
  /** This allows you to create one or more runner by posting it to the API. */
  runner_item_outputs?: ApiRunnerItemOutput[];
  /**
   * This request has a status so that it can communicate to the API from runners and
   * communicate status, errors, etc. This is on the request since runners operate
   * in a reverse protocol. This status is also used to initiate the
   * ProcessRunnerItems request with RUNNER_STREAM_START code.
   */
  status?: ApistatusStatus;
  /**
   * A unique ID to represent the runner. This may be tied to an underlying compute instance
   * information or just an UUID.
   */
  runner_replica_id?: string;
  /** Used by agent runners to specify their cloud provider. */
  cloud_provider_id?: string;
  /** Used by agent runners to specify their region. */
  region?: string;
}

/** PostRunnersRequest */
export interface V2PostRunnersBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: {
    app_id?: string;
  };
  /** This allows you to create one or more runner by posting it to the API. */
  runners?: ApiRunner[];
}

/** PostSearchesRequest */
export interface V2PostSearchesBody {
  /**
   * The user_id and app_id to query from.
   * The user_id and app_id to query from.
   */
  user_app_id?: object;
  /**
   * The query; this specifies how the data to be searched
   * this will be replaced by "Searches"
   * This is the search query used in /searches, model training requests, bulk data exports, etc.
   */
  query?: ApiQuery;
  /**
   * The searched to be executed or saved
   * Eventually the request level fields will be deprecated in favor of this object
   */
  searches?: ApiSearch[];
  /** Pagination information to paginate through search result Hits. */
  pagination?: ApiPagination;
}

/** PostSearchesByIDRequest performs returns results of a saved search given its ID */
export interface V2PostSearchesByIDBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  /** Pagination information to paginate through search result Hits. */
  pagination?: ApiPagination;
}

/** PostStatValuesAggregateRequest */
export interface V2PostStatValuesAggregateBody {
  /**
   * Ids present in the url of the request.
   * Ids present in the url of the request.
   */
  user_app_id?: object;
  /** Query to retrieve aggregate values. */
  stat_value_aggregate_queries?: ApiStatValueAggregateQuery[];
}

/** PostStatValuesRequest */
export interface V2PostStatValuesBody {
  /**
   * The user and app information for the request.
   * The user and app information for the request.
   */
  user_app_id?: object;
  /** The stats to post, can post more than one at a time. */
  stat_values?: ApiStatValue[];
}

/** Request to create Tasks. */
export interface V2PostTasksBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  tasks?: ApiTask[];
}

/** Start a multipart upload */
export interface V2PostUploadsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  uploads?: ApiUpload[];
}

/** PostValidatePasswordRequest */
export interface V2PostValidatePasswordBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: {
    app_id?: string;
  };
  /** password to be validated */
  password?: ApiPassword;
}

/** PostWorkflowResultsRequest */
export interface V2PostWorkflowResultsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  /**
   * Workflow version ID to retrieve
   * If no ID is specified, latest workflow version is used
   */
  version_id?: string;
  inputs?: ApiInput[];
  /**
   * FIXME(zeiler): the request for post workflows is using an outputconfig object that is supposed
   * to be within models. This is not consistent with setting this on the request for post model
   * outputs where it is inside a model object. To make this consistent we would send in the
   * workflow object so that each model can have it's own output config. If nobody is setting
   * this OutputConfig it would probably be easier to just remove it for now to keep things simpler
   * and then it's more consistent we just don't support the OutputConfig on workflows.
   */
  output_config?: ApiOutputConfig;
  /**
   * Use this flag to look into clarifai published workflows first for a Workflow ID
   * @exclude TODO (EAGLE-4447): Remove unused fields
   */
  favor_clarifai_workflows?: boolean;
  /**
   * A workflow state to be maintained across PostWorkflowResults requests/responses.
   * If it is not sent in the initial request with workflow_state.id = "init" then no
   * state will be saved or returned in PostWorkflowResultsResponse.
   */
  workflow_state?: ApiWorkflowState;
  /**
   * Specify which compute to use for processing each node of the workflow:
   * The key is the node.id from the loaded workflow.
   * The value is a RunnerSelector in which you can specify the deployment or specific nodepool
   * that you'd like that node to run on.
   * This allows for use cases like some light models could run on a CPU-only nodepool
   * while other models in the workflow require large GPUs.
   *
   * If node.id is not in the provided map, it will fall back to searching for
   * an adequate deployment the model owner owns or fall back to
   * the shared nodepools provided by Clarifai.
   * We recommend you specify these RunnerSelectors so that you have better understanding of where
   * processing occurs.
   */
  node_runner_selectors?: Record<string, ApiRunnerSelector>;
}

export interface V2PostWorkflowVersionEvaluationsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  /**
   * ########## Supported fields ##########
   * - ground_truth_dataset_version.app_id
   * - ground_truth_dataset_version.dataset_id
   * - ground_truth_dataset_version.id
   * - id
   * - target_node_id
   * - workflow_version_evaluation_template.id
   */
  workflow_version_evaluations?: ApiWorkflowVersionEvaluation[];
  runner_selectors?: ApiRunnerSelector[];
}

export interface V2PostWorkflowVersionsPublishBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  publications?: ApiWorkflowVersionPublishRequest[];
}

export interface V2PostWorkflowVersionsUnPublishBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  publications?: ApiWorkflowVersionUnPublishRequest[];
}

/** PostWorkflowsRequest */
export interface V2PostWorkflowsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  workflows?: ApiWorkflow[];
}

/** Request to create exports of a dataset version. */
export interface V2PutDatasetVersionExportsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  /**
   * exports is the list of requested dataset version exports.
   * Only setting the 'format' field of the export is supported.
   */
  exports?: ApiDatasetVersionExport[];
}

/** PutTaskAssignmentsRequest */
export interface V2PutTaskAssignmentsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  /**
   * Deprecated: use action and action_config instead.
   * Supported for backwards compatibility: setting this field is equivalent with
   * * action = LABEL_SUBMIT
   * * label_submit_config = [{"task_assignments": {{"id": "<task-assignment-id-for-input-id>"}}]
   */
  input_id?: string;
  /** Action to perform on selected task. */
  action?: ApiPutTaskAssignmentsRequestAction;
  /** LabelStartConfig label_start_config = 5; // no config for label start action */
  label_submit_config?: ApiLabelSubmitConfig;
  review_start_config?: ApiReviewStartConfig;
  review_approve_config?: ApiReviewApproveConfig;
  review_request_changes_config?: ApiReviewRequestChangesConfig;
  review_reject_config?: ApiReviewRejectConfig;
}

/**
 * Upload a part of a multipart upload.
 * Behaviour on completion depends on the endpoint that was used to initiate the upload.
 */
export interface V2PutUploadContentPartsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  content_parts?: ApiUploadContentPart[];
}

/**
 * Gettable defined the level of access for GET operations for this resource.
 *
 *  - UNKNOWN_VISIBILITY: Default value not allowed.
 *  - PRIVATE: PRIVATE requires collaborator or team permissions in order to GET this resource.
 *  - ORG: ORG requires you to be in the same org in order to GET this resource, but don't have to be a
 * teammate or collaborator.
 *  - PUBLIC: PUBLIC opens up GET access to the resource to any user on the platform even if they are not
 * a teammate or collaborator.
 * @default "UNKNOWN_VISIBILITY"
 */
export enum VisibilityGettable {
  UNKNOWN_VISIBILITY = 'UNKNOWN_VISIBILITY',
  PRIVATE = 'PRIVATE',
  ORG = 'ORG',
  PUBLIC = 'PUBLIC',
}

/**
 * Enum for visualization types
 * @default "VISUALIZATION_TYPE_NOT_SET"
 */
export enum WorkflowVersionEvaluationMetricVisualisationType {
  VISUALIZATION_TYPE_NOT_SET = 'VISUALIZATION_TYPE_NOT_SET',
  CONFUSION_MATRIX = 'CONFUSION_MATRIX',
  PRECISION_RECALL_CURVE = 'PRECISION_RECALL_CURVE',
  ROC_AUC_CURVE = 'ROC_AUC_CURVE',
}

/**
 * This is configuration for using the inputs send for model prediction in our API as
 * as the source for data.
 */
export interface ApiAPIPostModelOutputsCollectorSource {
  /**
   * To define the model that we should collect from we need to specify the following 4 IDs:
   * The User ID of the model we want to collect from.
   * This is User B in the example.
   */
  model_user_id?: string;
  /** The App ID of the model we want to collect from. */
  model_app_id?: string;
  /** The Model ID of the model we want to collect from. */
  model_id?: string;
  /** The Version ID of the model we want to collect from. */
  model_version_id?: string;
  /**
   * This key is used to POST /inputs into your app by the collector. It can be an API key or a
   * PAT. This needs the permissions that are needed for POST /inputs for the app_id this
   * Collector is defined in.
   */
  post_inputs_key_id?: string;
  /**
   * This is a private field that defaults to the app owner for public users.
   * If this is left blank then this collector will collect from ALL users calling the given model.
   */
  caller_user_id?: string;
}

/** AWS S3 storage credentials. */
export interface ApiAWSCreds {
  region?: string;
  id?: string;
  secret?: string;
  token?: string;
}

export interface ApiAddConcepts {
  concepts?: ApiConcept[];
}

export interface ApiAddMetadata {
  /**
   * To handle arbitrary json metadata you can use a struct field:
   * https://github.com/google/protobuf/blob/master/src/google/protobuf/struct.proto
   */
  metadata?: object;
}

export interface ApiAddToDataset {
  dataset_id?: string;
}

/** AiAssistParameters */
export interface ApiAiAssistParameters {
  /**
   * Min and max threshold values for approving annotations by default based on prediction score
   * @format float
   */
  min_threshold?: number;
  /** @format float */
  max_threshold?: number;
  /** ids of concept relations. Used in AI assist workflow */
  concept_relation_ids?: string[];
}

/**
 * This is the common building block of a query which is a sequence of And messages ANDed together.
 * Note that some fields are used too RANK results (affect the scores) and some are used to FILTER
 * results (unordered subset of your app's contents). In general, FILTER operations are more
 * efficient queries at scale and when combined with RANK operations can speed up search performance
 * as you effectively operate on a smaller sub-set of your entire app.
 */
export interface ApiAnd {
  /**
   * FILTER by input.data... information.
   * This can include human provided concepts, geo location info, metadata, etc.
   * This is effectively searching over only the trusted annotation attached to an input in your
   * app. To search by more specific annotation fields use the Annotation object here.
   * ########## Supported fields ##########
   *  - data.concepts[].id
   *  - data.concepts[].name
   *  - data.concepts[].value
   *  - data.geo.geo_box[].geo_point.latitude
   *  - data.geo.geo_box[].geo_point.longitude
   *  - data.geo.geo_limit.type
   *  - data.geo.geo_limit.value
   *  - data.geo.geo_point.latitude
   *  - data.geo.geo_point.longitude
   *  - data.image.url
   *  - data.metadata.fields - filter by metadata. metadata key&value fields are OR-ed.
   *  - dataset_ids[] - filter by dataset IDs
   *  - id - filter by input ID
   *  - status.code - filter by input status
   */
  input?: ApiInput;
  /**
   * RANK based predicted outputs from models such as custom trained models, pre-trained models,
   * etc. This is also where you enter the image url for a visual search because what we're asking
   * the system to do is find output embedding most visually similar to the provided input (that
   * input being in And.output.input.data.image.url for example). This will return the Hits
   * sorted by visual similarity (1.0 being very similar or exact match and 0.0 being very
   * dissimlar). For a search by Output concept, this means we're asking the system to rank
   * the Hits by confidence of our model's predicted Outputs. So for example if the model
   * predicts an image is 0.95 likely there is a "dog" present, that should related directly
   * to the score returned if you search for Output concept "dog" in your query. This provides
   * a natural ranking to search results based on confidence of predictions from the models and
   * is used when ANDing multiple of these types of RANK by Output queries together as well.
   *
   * ########## Supported fields ##########
   *  - data.clusters[].id
   *  - data.concepts[].id
   *  - data.concepts[].name
   *  - data.concepts[].value
   *  - input.data.image.base64[]
   *  - input.data.image.url
   *  - input.id
   */
  output?: ApiOutput;
  /**
   * If True then this will flip the meaning of this part of the
   * query. This allow for queries such as dog AND ! metadata=={"blah":"value"}
   */
  negate?: boolean;
  /**
   * FILTER by annotation information. This is more flexible than just filtering by
   * Input information because in the general case each input can have several annotations.
   * Some example use cases for filtering by annotations:
   * 1) find all the inputs annotated "dog" by worker_id = "XYZ"
   * 2) find all the annotations associated with embed_model_version_id = "123"
   * 3) find all the annotations that are trusted, etc.
   *
   * Since all the annotations under the hood are joined to the embedding model's annotation
   * using worker_id's of other models like cluster models or concept models should be
   * combinable with queries like visual search (a query with Output filled in).
   *
   * ########## Supported fields ##########
   *  - annotation_info.fields - filter by annotation info
   *  - data.concepts[].id
   *  - data.concepts[].name
   *  - data.concepts[].value
   *  - data.geo.geo_box[].geo_point.latitude
   *  - data.geo.geo_box[].geo_point.longitude
   *  - data.geo.geo_limit.type
   *  - data.geo.geo_limit.value
   *  - data.geo.geo_point.latitude
   *  - data.geo.geo_point.longitude
   *  - data.image.url
   *  - data.metadata.fields - filter by metadata. metadata key&value fields are OR-ed.
   *  - input_id
   *  - input_level
   *  - model_version_id
   *  - status.code
   *  - task_id
   *  - trusted
   *  - user_id
   */
  annotation?: ClarifaiapiAnnotation;
}

/**
 * AnnotationFilter is used to create a new dataset version.
 * For now, the filter is simply a wrapper over a Search.
 * In the future, we may add extra fields to customize the filtering.
 */
export interface ApiAnnotationFilter {
  /** The ID for the annotation filter */
  id?: string;
  /**
   * When the annotation filter was created.
   * The format is https://www.ietf.org/rfc/rfc3339.txt.
   * Example: "2006-01-02T15:04:05.999999Z".
   * @format date-time
   */
  created_at?: string;
  /**
   * When the annotation filter was modified.
   * The format is https://www.ietf.org/rfc/rfc3339.txt.
   * Example: "2006-01-02T15:04:05.999999Z".
   * @format date-time
   */
  modified_at?: string;
  /** The user the annotation filter belongs to. */
  user_id?: string;
  /** The app the annotation filter belongs to. */
  app_id?: string;
  /** The search that this filter uses. */
  search?: ApiSearch;
}

export interface ApiAnnotationFilterConfig {
  /** The annotation filter that is used. */
  annotation_filter?: ApiAnnotationFilter;
  /**
   * If true, empty inputs are not included in the dataset version.
   * If false, empty inputs are included in the dataset version.
   * We define an empty input as an input without any annotations after annotation filter is applied.
   */
  ignore_empty_inputs?: boolean;
}

/** AnnotationSearchMetrics */
export interface ApiAnnotationSearchMetrics {
  /**
   * The ground truth we are evaluating against
   * This is the new Search object used in saved searches.
   */
  ground_truth?: ApiSearch;
  /**
   * The set we are evaluating
   * This is the new Search object used in saved searches.
   */
  search_to_eval?: ApiSearch;
  /** The metric result */
  metrics?: ApiEvalMetrics;
  /** data is filled out with the concepts used for this evaluation */
  data?: ApiData;
  /**
   * active_concept_count is the number of concepts for this evaluation
   * @format int64
   */
  active_concept_count?: number;
  /**
   * The visibility field represents whether this message is privately/publicly visible.
   * To be visible to the public the App that contains it AND the User that contains the App must
   * also be publicly visible.
   */
  visibility?: ClarifaiapiVisibility;
}

/** Application with tasks and datasets */
export interface ApiApp {
  id?: string;
  name?: string;
  default_language?: string;
  /**
   * Deprecated, use default_workflow instead.
   *
   * @exclude TODO (EAGLE-4506): Remove this field and associated code
   */
  default_workflow_id?: string;
  default_workflow?: ApiWorkflow;
  /**
   * why is user_id present here when this message type is used in PostApps but completely ignored there? PostApp already
   * specifies the userid in path but doesn't even actually use neither of userids, it instead used the id from auth context.
   * This creates a lot of ambiguity, should always have different message types for Post/Get endpoints so that the minimum interface for each op can be described
   */
  user_id?: string;
  /**
   * When the app was created. We follow the XXXX timestamp
   * format. We use https://www.ietf.org/rfc/rfc3339.txt format:
   * "2006-01-02T15:04:05.999999Z" so you can expect results like
   * the following from the API:
   * "2017-04-11T21:50:50.223962Z"
   * @format date-time
   */
  created_at?: string;
  /**
   * When the app was last modified
   * @format date-time
   */
  modified_at?: string;
  /**
   * if user accept legal consent for face recognition
   * @format int64
   */
  legal_consent_status?: number;
  /**
   * To handle arbitrary json metadata you can use a struct field:
   * https://github.com/google/protobuf/blob/master/src/google/protobuf/struct.proto
   */
  metadata?: object;
  /** short description about the app. */
  description?: string;
  /**
   * Default value for model predictions on video: Sample delay for video predicting (1 frame per N milliseconds)
   * @format int64
   */
  sample_ms?: number;
  /**
   * The visibility field represents whether this message is privately/publicly visible.
   * To be visible to the public the App that contains it AND the User that contains the App must
   * also be publicly visible.
   */
  visibility?: ClarifaiapiVisibility;
  /** data tier id this app is using. */
  data_tier_id?: string;
  /**
   * Is starred by the requesting user (only showed on get/list requests)
   * Please use PostAppStars/DeleteAppStars endpoints to star/unstar an app
   */
  is_starred?: boolean;
  /**
   * How many users have starred the app (only showed on get/list requests)
   * Computed value, not editable
   * @format int32
   */
  star_count?: number;
  /**
   * Notes for the application
   * This field should be used for in-depth notes and supports up to 64Kbs.
   */
  notes?: string;
  /** Representative image for this app */
  image?: ApiImage;
  /**
   * An app marked as a template can be duplicated by any user that can see it,
   * including all visible resources within it.
   */
  is_template?: boolean;
  extra_info?: ApiAppExtraInfo;
  /**
   * Where app embeddings are stored
   * postgres (default), qdrant
   */
  embeddings_storage?: AppEmbeddingsStorage;
}

export interface ApiAppCopyProgress {
  field?: string;
  /** @format int32 */
  value?: number;
}

/** AppDuplication */
export interface ApiAppDuplication {
  /** The unique identifier of an app duplication job. */
  id?: string;
  /**
   * The destination application where resources are written.
   *
   * If the destination does not exist, then the fields from the request are
   * used to create the application. If a field is not set or not supported,
   * then it will be copied from the source app, unless otherwise noted.
   *
   * Note: this field can be empty when reading app duplication jobs in cases
   * where the app has been deleted or is just not visible to the caller.
   *
   * ########## Supported fields ##########
   *  - description
   *  - id      - if not set, then generated automatically
   *  - user_id - if not set, then the calling user is used as the app owner
   */
  destination_app?: ApiApp;
  /**
   * The ID of an existing app you want to copy data into.
   *
   * If not provided, then we will create a new application as the destination instead.
   * The various new_app_* fields can be used to set fields of this new application.
   *
   * Deprecated: Use destination_app.id with an existing ID instead.
   */
  existing_app_id?: string;
  /**
   * The ID to use when creating a new application.
   * You cannot set this field when copying into an existing app, i.e., when existing_app_is is set.
   *
   * If not provided, then it will be generated automatically.
   *
   * Deprecated: Use destination_app.id with a new ID instead.
   */
  new_app_id?: string;
  /**
   * The name to use when creating a new application.
   * You cannot set this field when copying into an existing app, i.e., when existing_app_is is set.
   *
   * If not provided, then the ID of the new application is also used as the name.
   *
   * Deprecated: Application names are deprecated, use application IDs instead.
   */
  new_app_name?: string;
  /** The status of the app duplication job. */
  status?: ApistatusStatus;
  /**
   * The time when the app duplication job was created.
   * @format date-time
   */
  created_at?: string;
  /**
   * The last time when the app duplication job status was updated.
   * @format date-time
   */
  last_modified_at?: string;
  /** The filter specifies which resources are copied by the app duplication job. */
  filter?: ApiAppDuplicationFilters;
  /**
   * Copy progress for each resource type requested by the filter. Possible fields:
   *  - inputs
   *  - concepts
   *  - annotations
   *  - models
   *  - workflows
   *  - installed_module_versions
   */
  progress?: ApiAppCopyProgress[];
}

/** AppDuplicationFilters */
export interface ApiAppDuplicationFilters {
  /**
   * Copy inputs. Requires that copy_concepts is also set.
   * Note that this will still copy input-level annotations even if copy_annotations is not set.
   */
  copy_inputs?: boolean;
  /** Copy concepts. */
  copy_concepts?: boolean;
  /** Copy annotations. Requires that copy_inputs and copy_concepts are also set. */
  copy_annotations?: boolean;
  /** Copy models. Requires that copy_concepts is also set. */
  copy_models?: boolean;
  /** Copy workflows. */
  copy_workflows?: boolean;
  /** Copy installed module versions. */
  copy_installed_module_versions?: boolean;
}

export interface ApiAppExtraInfo {
  /**
   * Revision marker for this application.
   * The value of the revision changes when
   * * inputs are added, updated or deleted
   * * annotations are added, updated or deleted
   * * inputs are added to or removed from datasets
   * For example, this value can be used to detect if client side caches related to searching should be invalidated.
   * Field not filled in for list endpoints, use GetApp
   */
  search_revision_marker?: string;
  counts?: ApiAppResourceCounts;
}

/** App query */
export interface ApiAppQuery {
  /** Query by application name. This supports wildcard queries like "gen*" to match "general" as an example. */
  name?: string;
}

export interface ApiAppResourceCounts {
  /** @format int64 */
  datasets?: string;
  /** @format int64 */
  models?: string;
  /** @format int64 */
  workflows?: string;
  /** @format int64 */
  modules?: string;
  /** @format int64 */
  inputs?: string;
}

export interface ApiArgoOrchestrationSpec {
  /**
   * The API version of the orchestration specification.
   * Example: "argoproj.io/v1alpha1", "argoproj.io/v1beta1"
   */
  api_version?: string;
  /** The JSON representation of the Argo orchestration specification. */
  spec_json?: string;
}

/** Argo Workflow Status message */
export interface ApiArgoOrchestrationStatus {
  /** Refer https://pkg.go.dev/github.com/argoproj/argo-workflows/v3/pkg/apis/workflow/v1alpha1#WorkflowStatus */
  status?: string;
}

export interface ApiArgoOrchestrationStepSpec {
  /**
   * The API version of the orchestration W.
   * Example: "argoproj.io/v1alpha1", "argoproj.io/v1beta1"
   */
  api_version?: string;
  /** The JSON representation of the Argo Workflow Template */
  spec_json?: string;
}

/** Audio asset struct */
export interface ApiAudio {
  /**
   * This is a URL to a publicly accessible image file. The platform will download this file server
   * side and then process.
   */
  url?: string;
  /**
   * The base64 field is using image file bytes directly in the request.
   * NOTE: if you're sending a json request, then this MUST be base64 encoded before sending (hence
   * the name here).
   * When using our grpc clients, you DO NOT need to base64 encode
   * it yourself since the clients know how to do this for you automatically and will avoid the
   * base64 encoding if they send a binary request.
   * @format byte
   */
  base64?: string;
  /** If True then you will be allowed to have multiple urls. */
  allow_duplicate_url?: boolean;
  /**
   * The hosted field lists original audio hosted in Clarifai storage. This field is currently used
   * only in response.
   */
  hosted?: ApiHostedURL;
  /** audio info */
  audio_info?: ApiAudioInfo;
}

export interface ApiAudioInfo {
  /** audio format */
  audio_format?: string;
  /**
   * sample rate
   * @format int32
   */
  sample_rate?: number;
  /**
   * audio track duration in seconds
   * @format float
   */
  duration_seconds?: number;
  /**
   * audio track bit rate
   * @format int32
   */
  bit_rate?: number;
}

/** AuditLogEntry is a single operation recorded in an audit log. */
export interface ApiAuditLogEntry {
  /**
   * Time of the operation.
   * @format date-time
   */
  timestamp?: string;
  /** User that performed the operation. */
  user?: ApiUser;
  /** Type of operation that was performed. */
  operation?: ApiEventType;
  /** A human-readable description of the operation. */
  description?: string;
  /**
   * Targets of the operation. For example,
   * - when creating a new model, the targets would be the application and the model,
   * - when adding a team member, the targets would be the team and the member.
   */
  targets?: ApiAuditLogTarget[];
  /**
   * Additional human-readable details of the operation. For example,
   * when patching a resource, these would list what was changed.
   */
  details?: string[];
  /** Was the operation successful? */
  success?: boolean;
  /** Request that triggered the operation. */
  req_id?: string;
  /** IP address where the request originated from. */
  source_ip?: string;
}

/** AuditLogQuery is a query for audit log entries. */
export interface ApiAuditLogQuery {
  /**
   * Query operations within this time range.
   * @format date-time
   */
  timestamp_from?: string;
  /** @format date-time */
  timestamp_to?: string;
  /** Query operations by these users. */
  user_ids?: string[];
  /** Query these types of operations. */
  operations?: ApiEventType[];
  /** Query operations with these targets. */
  targets?: ApiAuditLogTarget[];
  /** Query operations by success. */
  success?: boolean;
  /** Query operations by source IP address. */
  source_ips?: string[];
}

/**
 * AuditLogTarget is a resource on which an operation recorded in an
 * audit log was performed.
 */
export interface ApiAuditLogTarget {
  user?: ApiUser;
  role?: ApiRole;
  /** Represents a group of users. */
  team?: ApiTeam;
  app?: ApiApp;
  /** An app module that a user created in our app module marketplace. */
  module?: ApiModule;
  /** A specific version of an app module that is available for assigning to apps. */
  module_version?: ApiModuleVersion;
  workflow?: ApiWorkflow;
  workflow_version?: ApiWorkflowVersion;
  /**
   * This is the Model object which represents a created model in the platform.
   * Each model has a particular type denoted by the model_type_id.
   * When creating a Model with PostModels the following happens:
   *  - if the ModelType is trainable, then a new ModelVersion is created that is
   *    - UNTRAINED status by default
   *    - TRAINED status if a ModelVersion was included with PretrainedModelConfig in PostModels
   *  - if the ModelType is not trainable, then a new ModelVersion is created with TRAINED status.
   * To modify config settings like OutputInfo for the Model you an use PatchModels. This will
   * also create a new ModelVersion, potentially UNTRAINED following the same rules as above.
   * The fields that are patchable include Model.name, Model.display_name and Model.output_info
   * (except the Model.output_info.type and Model.output_info.type_ext).
   */
  model?: ApiModel;
  model_version?: ApiModelVersion;
  /**
   * We define a cluster here to be used in Nodepools and by the cloud provider.
   * There will be one cloud provider per Cluster.
   * This allows us to define Clusters that are VPCs within one physical cloud and have that
   * managed by one cloud provider which can list all nodepools for that VPC to deploy them and
   * orchestrate work within them.
   */
  compute_cluster?: ApiComputeCluster;
  /**
   * A nodepool is a set of nodes dedicated for a given user's compute needs.
   * This compute will typically be consumed by runners and in the future other objects
   * like UI modules may be assigned to node pools.
   */
  nodepool?: ApiNodepool;
  /**
   * A deployment allows you to configure how runners for a particular type of resource will
   * scale up and down. These are unique per user_id, nodepool and model so for differnet nodepools
   * you can scale differently.
   */
  deployment?: ApiDeployment;
}

/**
 * It might be better to do this as runner autoscaling so that resources
 * of a model are very simply what that model needs at minimum.
 * Note that resources for things like modes inside runners are not
 * related to how many replicas of those runners are needed to handle traffic.
 */
export interface ApiAutoscaleConfig {
  /**
   * The minimum number of replicas for the runner to have.
   * Defaults to 0 which means autoscaling can scale down to zero.
   * If you want a replica always up then set to >= 1.
   * @format int64
   */
  min_replicas?: number;
  /**
   * The maximium number of replicas to scale up the runner to.
   * @format int64
   */
  max_replicas?: number;
  /**
   * The number of seconds of traffic history to consider when autoscaling.
   * @format int64
   */
  traffic_history_seconds?: number;
  /**
   * The time to wait before scaling down after the last request.
   * @format int64
   */
  scale_down_delay_seconds?: number;
  /**
   * The time to wait between scaling up replicas without burst traffic.
   * @format int64
   */
  scale_up_delay_seconds?: number;
  /**
   * Depending on your plan you may be able to enable packing of resources into a single node
   * for more compute and cost efficiency.
   */
  disable_packing?: boolean;
  /**
   * The idle time before scaling down to zero
   * @format int64
   */
  scale_to_zero_delay_seconds?: number;
}

/** Azure Blob storage credentials. */
export interface ApiAzureBlobCreds {
  account_name?: string;
  account_key?: string;
}

/** BinaryMetrics */
export interface ApiBinaryMetrics {
  /** @format int64 */
  num_pos?: number;
  /** @format int64 */
  num_neg?: number;
  /** @format int64 */
  num_tot?: number;
  /** @format float */
  roc_auc?: number;
  /** @format float */
  f1?: number;
  concept?: ApiConcept;
  roc_curve?: ApiROC;
  precision_recall_curve?: ApiPrecisionRecallCurve;
  /** @format float */
  avg_precision?: number;
  area_name?: string;
  /** @format double */
  area_min?: number;
  /** @format double */
  area_max?: number;
  /** @format float */
  iou?: number;
}

export interface ApiBookmarkOrigin {
  /** original resource id */
  id?: string;
  /** original resource app id */
  app_id?: string;
  /** original resource user id */
  user_id?: string;
  /** resource type. */
  resource_type?: BookmarkOriginBookmarkType;
}

/** Rectangular bounding box for a region. */
export interface ApiBoundingBox {
  /**
   * The top left of the bounding box normalized to the data dimension to be within [0-1.0]
   * @format float
   */
  top_row?: number;
  /**
   * The left column of the bounding box normalized to the data dimension to be within [0-1.0]
   * @format float
   */
  left_col?: number;
  /**
   * The bottom row of the bounding box normalized to the data dimension to be within [0-1.0]
   * @format float
   */
  bottom_row?: number;
  /**
   * The right col of the bounding box normalized to the data dimension to be within [0-1.0]
   * @format float
   */
  right_col?: number;
}

export interface ApiBuildInfo {
  /** Docker image name */
  docker_image_name?: string;
  /** Docker image tag */
  docker_image_tag?: string;
  /** Docker image digest */
  docker_image_digest?: string;
}

export interface ApiBulkOperation {
  /** id of the Bulk Operation task */
  id?: string;
  input_ids?: ApiInputIDs;
  /** This is the new Search object used in saved searches. */
  search?: ApiSearch;
  dataset?: ApiDataset;
  /** This is the new Search object used in saved searches. */
  annotation_search?: ApiSearch;
  /** Operation to perform */
  operation?: ApiOperation;
  /** Application ID that this Operation was created from */
  app_id?: string;
  /** Status (pending, in-progress, completed, failed) of the operation */
  status?: ApistatusStatus;
  /** Progress of an on-going Bulk Operation task */
  progress?: ApiProgress;
  /** User id that created this operation */
  created_by?: string;
  /**
   * When the operation was created. We follow the XXXX timestamp
   * format. We use https://www.ietf.org/rfc/rfc3339.txt format:
   * "2006-01-02T15:04:05.999999Z" so you can expect results like
   * the following from the API:
   * "2017-04-11T21:50:50.223962Z"
   * @format date-time
   */
  created_at?: string;
  /**
   * Last time the status got updated
   * @format date-time
   */
  last_modified_at?: string;
}

/** Cancel a list of bulk operation ids */
export interface ApiCancelBulkOperationRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  /** List of bulk operation ids to be cancelled */
  ids?: string[];
}

/** Cancel a list of extraction job ids */
export interface ApiCancelInputsExtractionJobsRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  /** List of extraction job ids to be cancelled */
  ids?: string[];
}

/**
 * CloudProvider represents the entity that provides the infrastructure where the Nodepools are deployed.
 * This could be a public cloud provider like AWS, GCP, Azure, etc., or a self-hosted infrastructure.
 */
export interface ApiCloudProvider {
  /** Unique identifier of the cloud provider. */
  id?: string;
  /** Name of the cloud provider. */
  name?: string;
}

/** Cluster data */
export interface ApiCluster {
  id?: string;
  /**
   * Number of annotations tied to the cluster in the app
   * @format int64
   */
  count?: number;
  /**
   * The score assigned to this cluster.
   * For List Clusters endpoint, this represents percentage of inputs in the app assigned to this cluster.
   * @format float
   */
  score?: number;
  /** Representative hits for cluster (for now we only return 1) */
  hits?: ApiHit[];
  projection?: number[];
}

/** collaboration includes an app you're invited to work on. */
export interface ApiCollaboration {
  /** the application */
  app?: ApiApp;
  /** the app owner's info(including user_unique_id, first_name, last_name, primary_email) */
  app_owner?: ApiUser;
  /** the low-level scope users are shared with for this collaboration */
  scopes?: string[];
  /** the endpoint-level scopes users are shared with for this collaboration */
  endpoints?: string[];
  /**
   * when is the collaboration created
   * @format date-time
   */
  created_at?: string;
}

/** Collaborator - invited user, who shares an access to an application */
export interface ApiCollaborator {
  /** id of this collaborator */
  id?: string;
  /**
   * the app this collaborator has access to
   * FIXME(zeiler): this should be in the user_app_id.app_id already from the endpoint.
   */
  app?: ApiApp;
  /** who is this collaborator */
  user?: ApiUser;
  /** the permission this collaborator */
  scopes?: string[];
  endpoints?: string[];
  /**
   * When the app was shared with. We follow the XXXX timestamp
   * format. We use https://www.ietf.org/rfc/rfc3339.txt format:
   * "2006-01-02T15:04:05.999999Z" so you can expect results like
   * the following from the API:
   * "2017-04-11T21:50:50.223962Z"
   * @format date-time
   */
  created_at?: string;
  /**
   * When the collaborator was updated.
   * @format date-time
   */
  modified_at?: string;
  /**
   * When the collaborator was removed from app.
   * @format date-time
   */
  deleted_at?: string;
}

/**
 * Collector is a data pathway from a CollectorSource to an app to collect data automatically.
 * For example, a CollectorSource
 */
export interface ApiCollector {
  /** Unique ID for the collector. */
  id?: string;
  /** Human readable description for the collector. */
  description?: string;
  /**
   * When the collector is created. We follow the XXXX timestamp
   * format. We use https://www.ietf.org/rfc/rfc3339.txt format:
   * "2006-01-02T15:04:05.999999Z" so you can expect results like
   * the following from the API:
   * "2017-04-11T21:50:50.223962Z"
   * @format date-time
   */
  created_at?: string;
  /**
   * This is a workflow to run inline in model predict calls. It should ONLY have very fast and
   * light-weight models in it as it will effect the speed of the predictions being made.
   * This workflow's purpose is to filter down the inputs to queue for the collector to process.
   * The input to this workflow is going to be the OUTPUT of the model, not the input to the model
   * since we want to encourage having fast workflows that can also take advantage of the model
   * outputs to make deciions (for example: thresholding based on concepts). If the workflow
   * output has any field that is non-empty then the input will be queued for the collector
   * to process with the post_queue_workflow_id.
   *
   * As a simpler alternative, pre_queue_random_sample can be set to just use random sampling instead.
   */
  pre_queue_workflow_id?: string;
  /**
   * Instead of needing to create a new workflow for pre_queue_workflow_id, if just random sampling
   * of the model inputs is required, then pre_queue_random_sample can be set to a value from (0-1]
   * to denote the fraction of inputs to collect.
   * @format float
   */
  pre_queue_random_sample?: number;
  /**
   * A workflow to run to after the collector is processing the queued input. This workflow
   * uses the original input to the model as input to the workflow so that you can run additional
   * models as well on that input to decide whether to queue the model or not. If the workflow
   * output has any field that is non-empty then it will be passed on to POST /inputs to
   * the destination app.
   */
  post_queue_workflow_id?: string;
  /**
   * The source of the collector to feed data into this app.
   * Note(zeiler): if we wanted more than one source per collector we could make this it's own
   * object and introduce /collectors/{collector_id}/sources
   * We will keep it simple for now and have just one source per collector since a user can make
   * more than one collector in the same app anyways.
   */
  collector_source?: ApiCollectorSource;
  /**
   * Status for the collector. This allows you to pause a collector without having to delete it as
   * an example.
   */
  status?: ApistatusStatus;
  /**
   * Whether to collect outputs or not. Default is false. If selected, outputs from the
   * original model predict call will be posted as annotations along with the input with success status.
   */
  collect_outputs?: boolean;
}

/**
 * Configuration for the source to collect data from.
 * Only one of the fields can be present at a time.
 *
 * The ID of the source in case we want to implment /collectors/{collector_id}/sources
 *  string id = 1;
 */
export interface ApiCollectorSource {
  /**
   * Collect from the inputs passed in for PostModelOutputs predictions of a specific model.
   * This does not apply to models used within workflows, only PostModelOutputs calls.
   */
  api_post_model_outputs_collector_source?: ApiAPIPostModelOutputsCollectorSource;
}

/** Color data */
export interface ApiColor {
  raw_hex?: string;
  w3c?: ApiW3C;
  /** @format float */
  value?: number;
}

/** Commitment Value - used to track users' commitment amount and type */
export interface ApiCommitmentValue {
  /**
   * The commitment value, in cents
   * @format int32
   */
  value?: number;
  /** The commitment type, can be either 'monthly' or 'annual' */
  type?: CommitmentValueCommitmentType;
}

/**
 * We define a cluster here to be used in Nodepools and by the cloud provider.
 * There will be one cloud provider per Cluster.
 * This allows us to define Clusters that are VPCs within one physical cloud and have that
 * managed by one cloud provider which can list all nodepools for that VPC to deploy them and
 * orchestrate work within them.
 */
export interface ApiComputeCluster {
  id?: string;
  /** Short description of cluster region. */
  description?: string;
  /**
   * The cloud provider where this cluster is hosted.
   * Some example cloud provider IDs may be aws, gcp, azure, local, kubernetes, etc.
   */
  cloud_provider?: ApiCloudProvider;
  /**
   * The region. The naming here depends on the cluster choice above and will be validated
   * against which clusters+regions that Clarifai currently supports.
   */
  region?: string;
  /** The user/org that this compute cluster belongs to. */
  user_id?: string;
  /**
   * When the compute cluster was created.
   * @format date-time
   */
  created_at?: string;
  /**
   * When the compute cluster was last modified.
   * @format date-time
   */
  modified_at?: string;
  /**
   * The visibility field represents whether this message is privately/publicly visible.
   * To be visible to the public the App that contains it AND the User that contains the App must
   * also be publicly visible.
   */
  visibility?: ClarifaiapiVisibility;
  /**
   * We offer different types of compute clusters such as:
   * 'shared' which only Clarifai can create.
   * 'dedicated' where you're in control of defining the nodepools within the cluster
   * 'local-dev' which means you're responsible for starting runners manually which is great for local
   * development but not recommended for production use cases.
   */
  cluster_type?: string;
  /**
   * Managed by represents who is responsible for the cluster.
   * This is currently either "clarifai" where we fully manage the infrastructure.
   * Or, "user" where the user is responsible for the underlying infrastructure.
   */
  managed_by?: string;
  /**
   * Key to use within the compute cluster for all requests to the API.
   * You can post with the key.id filled in to set the key for the compute cluster.
   * The responses will intentionaly only return the description of the key for security
   * purposes since you may have other people through orgs/teams having access to this compute
   * cluster who should not view your key.
   * This must be a valid key created before creating the ComputeCluster.
   * Deleting this key will not be prevented, which means all resources in this ComputeCluster
   * will lose connection to the API, so delete keys at your own risk.
   * The user_id who owns the key must match the user_id provided in the ComputeCluster.
   */
  key?: ApiKey;
}

/**
 * These are the resource needs of a given API object such as a model.
 * This is what they require as a minimum to run and will be used upon scheduling
 * as the request and limit for the k8s pod. If we want to separate limits and requests in the
 * future we can allow setting a limits ComputeInfo and a requests ComputeInfo.
 */
export interface ApiComputeInfo {
  /**
   * Amount of CPUs to use as a limit. This follows kubernetes notation like: "1", "100m", "4.5", etc.
   * See https://kubernetes.io/docs/reference/kubernetes-api/common-definitions/quantity/
   * For instances, this is the instance's CPU count.
   * For runners, this is the maximum amount of CPU that the runner pod can use.
   */
  cpu_limit?: string;
  /**
   * Amount of CPU memory to use as a limit. This follows kubernetes notation like:
   * 1Ki, 1500Mi, 3Gi, 4Ti, etc.
   * See https://kubernetes.io/docs/reference/kubernetes-api/common-definitions/quantity/
   * For instances, this is the instance's CPU memory.
   * For runners, this is the maximum amount of CPU memory that the runner pod can use.
   */
  cpu_memory?: string;
  /**
   * Amount of CPUs to use as a minimum. This follows kubernetes notation like: "1", "100m", "4.5", etc.
   * See https://kubernetes.io/docs/reference/kubernetes-api/common-definitions/quantity/
   * For runners, this is the minimum amount of CPU requested for the runner pod.
   * Optional. If unspecified, a small default is used.
   */
  cpu_requests?: string;
  /**
   * Amount of CPU memory to use as a minimum. This follows kubernetes notation like:
   * 1Ki, 1500Mi, 3Gi, 4Ti, etc.
   * For runners, this is the minimum amount of CPU memory requested for the runner pod.
   * Optional. If unspecified, a small default is used.
   */
  cpu_memory_requests?: string;
  /**
   * Amount of GPU/TPUs to use.
   * @format int64
   */
  num_accelerators?: number;
  /**
   * Amount of accelerator/GPU memory to use as a minimum.
   * This is defined per accelerator.
   * This follows the format used by kubernetes like 1Ki, 2Mi, 3Gi, 4Ti.
   * See https://kubernetes.io/docs/reference/kubernetes-api/common-definitions/quantity/
   * The supported accelerators that the resource can run on. If the resource requires a specific
   *  accelerator type then it will only be scheduled on nodes that have that type of accelerator.
   *  If there is no hard requirements beyond the number of accelerators and their memory then this
   *  field can be left empty.
   *  This setting will cause an error if num_accelerators == 0
   */
  accelerator_memory?: string;
  /**
   * Or should it be removed completely and use the nodepool accelerator type itself.
   * These are the supported accelerators that the model can run on.
   */
  accelerator_type?: string[];
}

/**
 * ComputePlaneMetrics captures the compute plane metrics to send back to the control plane.
 * Each message should have the meta filled and one or more of the other fields.
 */
export interface ApiComputePlaneMetrics {
  /**
   * Who and where the metrics are from.
   *
   * required.
   */
  meta?: ApiComputeSourceMetadata;
  /** e.g. aws, azure, on-prem. */
  cloud?: string;
  /** e.g. us-east, us-west. */
  region?: string;
  /** e.g. t3a.medium, g5.xlarge. */
  instance_type?: string;
  /** e.g. spot, on-demand. */
  reservation_type?: string;
  /**
   * Metrics billing
   * cost of the reservation. Spot prices may change over time.
   * @format float
   */
  reservation_price?: number;
  /**
   * Runtime in seconds.
   * @format int32
   */
  runtime_s?: number;
  /**
   * Metrics for latency.
   *
   * Time of the event.
   * @format date-time
   */
  timestamp?: string;
  /** e.g. NodeProvisioned, NodeTerminated, ModelDeployed, ModelScheduled, ModelReady. */
  event_type?: string;
  /** GPU metrics. */
  gpu_metrics?: ApiGpuMetrics[];
  /** Hostname of the node. */
  hostname?: string;
  /** CPU metrics. */
  cpu_metrics?: ApiCpuMetrics[];
}

/** ComputeSourceMetadata describes the source of something computed. The who and where. */
export interface ApiComputeSourceMetadata {
  /** The user app id, if any. */
  user_app_id?: ApiUserAppIDSet;
  /** The Model ID, if any. */
  model_id?: string;
  /** The Version ID, if any. */
  model_version_id?: string;
  /** Workflow Id, if any. */
  workflow_id?: string;
  /** Compute Cluster, Nodepool, Runner. */
  compute_cluster_id?: string;
  nodepool_id?: string;
  runner_id?: string;
  /** Pipeline related data, if any */
  pipeline_id?: string;
  pipeline_version_id?: string;
  pipeline_version_run_id?: string;
  pipeline_step_id?: string;
  pipeline_step_version_id?: string;
}

/** Concept or tag */
export interface ApiConcept {
  /** The concept's unique id. */
  id?: string;
  /** The name of the concept in the given language. */
  name?: string;
  /**
   * Used to indicate presence (1.0) or not (0.0) of this concept when making a request.
   * This is also the prediction probability when returning predictions from our API.
   * For convenience we use the default of 1.0 when making requests so the concept you provide is
   * is treated as a positive (1.0) and not a negative (which would be value == 0.0).
   * @format float
   */
  value?: number;
  /**
   * When the concept was created. The format is https://www.ietf.org/rfc/rfc3339.txt .
   * Example: "2006-01-02T15:04:05.999999Z". This field is used only in a response.
   * @format date-time
   */
  created_at?: string;
  /**
   * The language in which the concept name is in. This is *ONLY* used in the response and setting
   * it in a request is ignored since the default language of your app is used when creating
   * or patching a Concept. To set other languages for your concept use the ConceptLanguage object
   * and its corresponding endpoints.
   */
  language?: string;
  /** The application id that this concept is within. This can be ignored by most users. */
  app_id?: string;
  /** The definition for the concept. Similar to name. This can be ignored by most users. */
  definition?: string;
  /**
   * The vocabulary that this concept belongs to. This is useful if you have different unique sets
   * of concepts that you can separate out based on this field. For example "age_appearance" vs
   * "gender_appearance" in a list of concept returned from the demographics model.
   */
  vocab_id?: string;
  /**
   * The visibility field represents whether this message is privately/publicly visible.
   * To be visible to the public the App that contains it AND the User that contains the App must
   * also be publicly visible.
   */
  visibility?: ClarifaiapiVisibility;
  /** The user the concept belongs to. */
  user_id?: string;
  /** Information about keypoints for this concept */
  keypoint_info?: ApiKeypointInfo;
  /** Optional extra info. */
  extra_info?: ApiConceptExtraInfo;
  /**
   * To handle arbitrary json metadata:
   * https://github.com/google/protobuf/blob/master/src/google/protobuf/struct.proto
   */
  metadata?: object;
  /** Representative image for the concept */
  image?: ApiImage;
}

/** ConceptCount */
export interface ApiConceptCount {
  /** The concept's unique id. */
  id?: string;
  /** The name of the concept. */
  name?: string;
  /** The total count for concepts labeled for all asset statues (processing, to_process, processed, error) */
  concept_type_count?: ApiConceptTypeCount;
  /** The detail count for different assets status */
  detail_concept_count?: ApiDetailConceptCount;
}

/**
 * ConceptExtraInfo represents extra information related to a concept that is context-dependent.
 * It is only set when requested in ConceptExtraInfoRequest.
 */
export interface ApiConceptExtraInfo {
  /** Whether this concept is rankable based on ConceptExtraInfoRequest configuration. */
  is_rankable?: boolean;
}

export interface ApiConceptExtraInfoRequest {
  /**
   * Determine if the concept is searchable by rank using this model.
   * Currently, only embedder models are supported.
   * ########## Supported fields ##########
   * - app_id
   * - id
   * - model_version.id
   * - user_id
   * This is the Model object which represents a created model in the platform.
   * Each model has a particular type denoted by the model_type_id.
   * When creating a Model with PostModels the following happens:
   *  - if the ModelType is trainable, then a new ModelVersion is created that is
   *    - UNTRAINED status by default
   *    - TRAINED status if a ModelVersion was included with PretrainedModelConfig in PostModels
   *  - if the ModelType is not trainable, then a new ModelVersion is created with TRAINED status.
   * To modify config settings like OutputInfo for the Model you an use PatchModels. This will
   * also create a new ModelVersion, potentially UNTRAINED following the same rules as above.
   * The fields that are patchable include Model.name, Model.display_name and Model.output_info
   * (except the Model.output_info.type and Model.output_info.type_ext).
   */
  rankable_model?: ApiModel;
}

/**
 * This represents a link to an outside source for the given concept.
 * The values from here are sticked into Concept message into the name and definition fields when
 * returning from the API in your default language. The "id" field here becomes the "language"
 * field of the Concept message which is a little weird.
 */
export interface ApiConceptLanguage {
  /** This is the language code for the language such as "en". */
  id?: string;
  /** The type of the outside source. */
  name?: string;
  /** The ID that is referenced in the source. */
  definition?: string;
}

/** ConceptQuery */
export interface ApiConceptQuery {
  /** The name of the concept to search. */
  name?: string;
  /** The language of the concept name in a search. Defaults to English. */
  language?: string;
  /**
   * Deprecated: Use workflow.id instead.
   *
   * @exclude TODO (EAGLE-4506): Remove this field and associated code
   */
  workflow_id?: string;
  /**
   * The concepts must belong to models with specified use cases.
   * Multiple values are joined using an OR condition.
   */
  use_cases?: ApiWorkflowModelUseCase[];
  /**
   * This is the Model object which represents a created model in the platform.
   * Each model has a particular type denoted by the model_type_id.
   * When creating a Model with PostModels the following happens:
   *  - if the ModelType is trainable, then a new ModelVersion is created that is
   *    - UNTRAINED status by default
   *    - TRAINED status if a ModelVersion was included with PretrainedModelConfig in PostModels
   *  - if the ModelType is not trainable, then a new ModelVersion is created with TRAINED status.
   * To modify config settings like OutputInfo for the Model you an use PatchModels. This will
   * also create a new ModelVersion, potentially UNTRAINED following the same rules as above.
   * The fields that are patchable include Model.name, Model.display_name and Model.output_info
   * (except the Model.output_info.type and Model.output_info.type_ext).
   */
  model?: ApiModel;
  workflow?: ApiWorkflow;
  /**
   * By default, we return app concepts combined with source (model or workflow) concepts.
   * If source is not set, then we only return app concepts.
   * If ignore_app_concepts is true, then we only return source concepts.
   * When use_cases are set, then ignore_app_concepts is always true, because
   * concept use cases can only be determined in relation to a model or a workflow.
   */
  ignore_app_concepts?: boolean;
}

/** This represents a relation (i.e. edge) between the subject concept and the object concept */
export interface ApiConceptRelation {
  /** ID of the concept relation */
  id?: string;
  /** The subject concept (i.e. source) of the concept relation */
  subject_concept?: ApiConcept;
  /** The subject concept (i.e. destination) of the concept relation */
  object_concept?: ApiConcept;
  /**
   * The predicate (i.e. edge) linking the subject and the object
   * Both subject_concept and object_concept are concepts.
   * The predicate is the type of relationship.
   * That predicate acts on the subject.
   *
   * There are three current types of predicates:
   * 1) "hyponym"
   * 2) "hypernym"
   * 3) "synonym"
   *
   * 1) For example, 'hyponym' is a type of predicate which represents 'is_a_kind_of' relation so
   * the following relationship:
   * 'honey' (subject), 'hyponym' (predicate), 'food' (object)
   * Can more easily be read as:
   * 'honey' 'is a kind of' 'food'
   *
   *
   * 2) The 'hypernym' relation is the opposite of 'hyponym' and when you add one of the
   * relationships the opposite will automatically appear for you in queries.
   *
   * The 'hypernym' can be read as 'is a parent of' so:
   * 'food' (subject), 'hypernym' (predicate), 'honey' (object)
   * Can more easily be read as:
   * 'food' is a parent of 'honey'
   *
   * 3) The 'synonym' relation defines two concepts that essential mean the same thing. This
   * is more like a "is" relationship. So for example a 'synonym' relationship could be:
   * "puppy" is "pup"
   * The reverse is also true once the former is added so:
   * "pup" is "puppy"
   * will appear in queries as well.
   */
  predicate?: string;
  /**
   * The knowledge graph id that this edge belongs to. If using the app's global knowledge graph
   * and not a specific one then this should be the empty string "".
   */
  knowledge_graph_id?: string;
  /**
   * The visibility field represents whether this message is privately/publicly visible.
   * To be visible to the public the App that contains it AND the User that contains the App must
   * also be publicly visible.
   */
  visibility?: ClarifaiapiVisibility;
}

/** ConceptTypeCount */
export interface ApiConceptTypeCount {
  /**
   * The number of inputs that have a concept with a value of 1.0 (indicating presence of the
   * concept in an input).
   * @format int64
   */
  positive?: number;
  /**
   * The number of inputs that have a concept with a value of 0.0 (indicating absence of the
   * concept in an input).
   * @format int64
   */
  negative?: number;
}

/** ConfusionMatrix */
export interface ApiConfusionMatrix {
  matrix?: ApiConfusionMatrixEntry[];
  /** These concept_ids are ordered by the strength of the diagonal in the ConfusionMatrix. */
  concept_ids?: string[];
}

/** ConfusionMatrixEntry */
export interface ApiConfusionMatrixEntry {
  predicted?: string;
  actual?: string;
  /** @format float */
  value?: number;
  predicted_concept?: ApiConcept;
  actual_concept?: ApiConcept;
}

/** CooccurrenceMatrix */
export interface ApiCooccurrenceMatrix {
  matrix?: ApiCooccurrenceMatrixEntry[];
  /** These concept_ids are ordered by the strength of the diagonal in the ConfusionMatrix. */
  concept_ids?: string[];
}

/** NOTE: this is inefficient, should just have the order of the rows/cols */
export interface ApiCooccurrenceMatrixEntry {
  /** concept_id for the row */
  row?: string;
  /** concept_id for the col */
  col?: string;
  /** @format int64 */
  count?: number;
}

export interface ApiCpuMetrics {
  /**
   * Time of the event.
   * @format date-time
   */
  timestamp?: string;
  /**
   * CPU utilization.
   * @format float
   */
  cpu_utilization_pct?: number;
  /**
   * Memory utilization.
   * @format float
   */
  memory_utilization_pct?: number;
  /**
   * CPU millicores.
   * @format int64
   */
  millicores?: string;
  /**
   * Memory bytes.
   * @format int64
   */
  memory_bytes?: string;
}

/** Data */
export interface ApiData {
  /** Input and output images. */
  image?: ApiImage;
  /** Input and output videos. */
  video?: ApiVideo;
  /** A list of concepts. */
  concepts?: ApiConcept[];
  /**
   * To handle arbitrary json metadata you can use a struct field:
   * https://github.com/google/protobuf/blob/master/src/google/protobuf/struct.proto
   */
  metadata?: object;
  /** Geography information. */
  geo?: ApiGeo;
  /** The dominant colors within an image. */
  colors?: ApiColor[];
  /** Clustering centroids for inputs. */
  clusters?: ApiCluster[];
  /** Embedding vectors representing each input. */
  embeddings?: ApiEmbedding[];
  /** For recursing into localized regions of an input. */
  regions?: ApiRegion[];
  /** For temporal content like video. */
  frames?: ApiFrame[];
  /** Input, output or annotation text. */
  text?: ApiText;
  /** Input and output audio. */
  audio?: ApiAudio;
  /** Track information. */
  tracks?: ApiTrack[];
  /** Time segments information. */
  time_segments?: ApiTimeSegment[];
  /** Holds score, rank, and user, app, input IDs and search hit data */
  hits?: ApiHit[];
  /** Heatmap as 2d image */
  heatmaps?: ApiImage[];
  /**
   * For data messages that have multiple parts such as multi-modal
   * requests, we allow you to specify those as a list of Data objects.
   */
  parts?: ApiPart[];
  /**
   * A proto representation for numpy arrays, useful to pass information from python SDK to a
   * python based model implementation.
   */
  ndarray?: ApiNDArray;
  /**
   * Input and output integer number
   * @format int64
   */
  int_value?: string;
  /**
   * Input and output floating number
   * @format double
   */
  float_value?: number;
  /**
   * Input and output bytes data
   * @format byte
   */
  bytes_value?: string;
  /** Input and output bool data */
  bool_value?: boolean;
  /** Input and output string data */
  string_value?: string;
}

export interface ApiDataSourceCredentials {
  /** AWS S3 credentials for authentication. */
  s3_creds?: ApiAWSCreds;
  /**
   * GCP Cloud Storage uses service account key data(creds.json) as Byte array for authentication.
   * @format byte
   */
  gcp_creds?: string;
  /** Azure Blob credentials for authentication. */
  azure_blob_creds?: ApiAzureBlobCreds;
}

export interface ApiDataSourceURL {
  /** Supported providers are AWS S3, Azure blob, GCP cloud storage. */
  url?: string;
  /** Credentials that would allow access to the provided url */
  credentials?: ApiDataSourceCredentials;
}

/** Dataset */
export interface ApiDataset {
  /** The ID for the dataset */
  id?: string;
  /**
   * When the dataset was created.
   * The format is https://www.ietf.org/rfc/rfc3339.txt.
   * Example: "2006-01-02T15:04:05.999999Z".
   * @format date-time
   */
  created_at?: string;
  /**
   * When the dataset was modified.
   * The format is https://www.ietf.org/rfc/rfc3339.txt.
   * Example: "2006-01-02T15:04:05.999999Z".
   * @format date-time
   */
  modified_at?: string;
  /** The app the dataset belongs to. */
  app_id?: string;
  /** The user the dataset belongs to. */
  user_id?: string;
  /** Description of the dataset */
  description?: string;
  /**
   * To handle arbitrary json metadata you can use a struct field:
   * https://github.com/google/protobuf/blob/master/src/google/protobuf/struct.proto
   */
  metadata?: object;
  /**
   * The visibility field represents whether this message is privately/publicly visible.
   * To be visible to the public the App that contains it AND the User that contains the App must
   * also be publicly visible.
   */
  visibility?: ClarifaiapiVisibility;
  /** Default annotation filter used for this dataset. */
  default_annotation_filter?: ApiAnnotationFilter;
  /** Default processing info used for this dataset. */
  default_processing_info?: ApiDatasetVersionProcessingInfo;
  /**
   * Notes for the dataset
   * This field should be used for in-depth notes and supports up to 64Kbs.
   */
  notes?: string;
  /**
   * Dataset version associated with this dataset. This is used in listing Datasets
   * and including the latest version.
   */
  version?: ApiDatasetVersion;
  /** Whether the dataset is starred by the requesting user. */
  is_starred?: boolean;
  /**
   * Number of users that starred this dataset.
   * @format int32
   */
  star_count?: number;
  /**
   * bookmark info. When set, this dataset is a bookmarked dataset of this app.
   * Info in this field will allow you to find/access original dataset.
   */
  bookmark_origin?: ApiBookmarkOrigin;
  /** Representative image for this dataset */
  image?: ApiImage;
}

/** DatasetInput */
export interface ApiDatasetInput {
  /**
   * When the input was added to the dataset.
   * The format is https://www.ietf.org/rfc/rfc3339.txt.
   * Example: "2006-01-02T15:04:05.999999Z".
   * @format date-time
   */
  created_at?: string;
  /** The input data. */
  input?: ApiInput;
}

export interface ApiDatasetSplit {
  /** Expected to have ID */
  dataset?: ApiDataset;
  /**
   * For RANDOM_PERCENTAGE_SPLIT.
   * Values from (0,100]
   * @format int64
   */
  percentage?: number;
}

/** DatasetVersion */
export interface ApiDatasetVersion {
  /** The ID for the dataset version */
  id?: string;
  /**
   * When the dataset version was created.
   * The format is https://www.ietf.org/rfc/rfc3339.txt.
   * Example: "2006-01-02T15:04:05.999999Z".
   * @format date-time
   */
  created_at?: string;
  /**
   * When the dataset version was modified.
   * The format is https://www.ietf.org/rfc/rfc3339.txt.
   * Example: "2006-01-02T15:04:05.999999Z".
   * @format date-time
   */
  modified_at?: string;
  /** The app the dataset version belongs to. */
  app_id?: string;
  /** The user the dataset version belongs to. */
  user_id?: string;
  /** The dataset the dataset version belongs to. */
  dataset_id?: string;
  /** The dataset version will be generated based on a single annotation filter. */
  annotation_filter_config?: ApiAnnotationFilterConfig;
  /** The dataset version will be generated based on model version inferences. */
  model_predict_config?: ApiModelPredictConfig;
  /** Status for this dataset version. */
  status?: ApistatusStatus;
  /** Description of the dataset version */
  description?: string;
  /**
   * Dataset version processing. If this is not set when the dataset version is
   * created, then the dataset default_processing_info is copied instead. Later
   * updates to default_processing_info will not apply to existing versions.
   */
  processing_info?: ApiDatasetVersionProcessingInfo;
  /** Dataset version metrics */
  metrics?: Record<string, ApiDatasetVersionMetrics>;
  /**
   * Dataset version exports
   * DatasetVersionExportInfo contains information about all exports of a dataset version.
   *
   * If the dataset version has not been exported in a format, then the DatasetVersionExport
   * field for that format is empty instead of having a "not exported" status.
   */
  export_info?: ApiDatasetVersionExportInfo;
  /**
   * To handle arbitrary json metadata you can use a struct field:
   * https://github.com/google/protobuf/blob/master/src/google/protobuf/struct.proto
   */
  metadata?: object;
  /**
   * The visibility field represents whether this message is privately/publicly visible.
   * To be visible to the public the App that contains it AND the User that contains the App must
   * also be publicly visible.
   */
  visibility?: ClarifaiapiVisibility;
  /** The embedding models to return embeddings for. If empty, no embeddings are returned. */
  embed_model_version_ids?: string[];
  /**
   * Read Only. Cannot be Set
   * Origin of request for new dataset version
   */
  request_origin?: ApiDatasetVersionRequestOrigin;
}

/** DatasetVersionExport contains metadata for a single dataset version export. */
export interface ApiDatasetVersionExport {
  /** format is the format of the dataset version export. */
  format?: ApiDatasetVersionExportFormat;
  /** status is the current status of the dataset version export. */
  status?: ApistatusStatus;
  /** url is the URL from where the dataset version export can be downloaded. */
  url?: string;
  /**
   * size is the size of the dataset version export in number of bytes.
   * @format uint64
   */
  size?: string;
  /** whether to include embeddings in the export or not. */
  include_embeddings?: boolean;
}

/**
 *  - CLARIFAI_DATA_PROTOBUF: CLARIFAI_DATA_PROTOBUF is the proprietary Clarifai API Data format. It
 * is a ZIP-archive containing batches of serialized InputBatch protobuf messages.
 *
 * Note that only the "id" and "data" fields of exported inputs are set.
 *  - CLARIFAI_DATA_JSON: CLARIFAI_DATA_JSON is the proprietary Clarifai API Data format in JSON. It
 * is a ZIP-archive containing batches of serialized InputBatch JSON messages.
 *
 * Note that only the "id" and "data" fields of exported inputs are set.
 *  - COCO: COCO is the data format used by Common Objects in Context. It is a
 * ZIP-archive containing JSON files with the dataset version annotations.
 * See https://cocodataset.org/#format-data.
 * @default "DATASET_VERSION_EXPORT_FORMAT_NOT_SET"
 */
export enum ApiDatasetVersionExportFormat {
  DATASET_VERSION_EXPORT_FORMAT_NOT_SET = 'DATASET_VERSION_EXPORT_FORMAT_NOT_SET',
  CLARIFAI_DATA_PROTOBUF = 'CLARIFAI_DATA_PROTOBUF',
  CLARIFAI_DATA_JSON = 'CLARIFAI_DATA_JSON',
  COCO = 'COCO',
}

/**
 * DatasetVersionExportInfo contains information about all exports of a dataset version.
 *
 * If the dataset version has not been exported in a format, then the DatasetVersionExport
 * field for that format is empty instead of having a "not exported" status.
 */
export interface ApiDatasetVersionExportInfo {
  /** clarifai_data_protobuf is a CLARIFAI_DATA_PROTOBUF export of the dataset version. */
  clarifai_data_protobuf?: ApiDatasetVersionExport;
  /** clarifai_data_json is a CLARIFAI_DATA_JSON export of the dataset version. */
  clarifai_data_json?: ApiDatasetVersionExport;
  /** coco is a COCO export of the dataset version. */
  coco?: ApiDatasetVersionExport;
}

export interface ApiDatasetVersionMetrics {
  /**
   * Number of inputs
   * @format uint64
   */
  inputs_count?: string;
  /**
   * Number of unlabeled inputs
   * An input is considered unlabeled if it there are no annotations with positive labels for that input.
   * @format uint64
   */
  unlabeled_inputs_count?: string;
  /**
   * Number of inputs that have metadata
   * @format uint64
   */
  inputs_with_metadata_count?: string;
  /**
   * Number of inputs that have geo information
   * @format uint64
   */
  inputs_with_geo_count?: string;
  /**
   * Number of regions
   * @format uint64
   */
  regions_count?: string;
  /**
   * The matrix shows where the regions are located.
   * Example: If the matrix has 2x2 dimensions, then
   * * region_location_matrix[0][0] = the number of regions that appear in the top left corner, i.e. [0,0]..(0.5,0.5)
   * * region_location_matrix[0][1] = the number of regions that appear in the top right corner, i.e. [0,0.5]..[0.5,1]
   * * region_location_matrix[1][0] = the number of regions that appear in the bottom left corner, i.e. [0.5,0]..[1,0.5)
   * * region_location_matrix[1][1] = the number of regions that appear in the bottom right corner, i.e. [0.5,0.5]..[1,1]
   * Store matrix of uint64s values.
   * It is recommended to store the matrix as a 1D array
   * because it produces less bytes during serialization than a 2D array.
   * The matrix does store the number of columns, but it does not store the number of rows.
   * The number of rows can automatically be calculated as length(data)/n_cols.
   */
  region_location_matrix?: MatrixUint64;
  /**
   * Number of bounding boxes
   * @format uint64
   */
  bounding_boxes_count?: string;
  /**
   * Number of polygons
   * @format uint64
   */
  polygons_count?: string;
  /**
   * Number of points
   * @format uint64
   */
  points_count?: string;
  /**
   * Number of masks
   * @format uint64
   */
  masks_count?: string;
  /**
   * Number of inputs that have regions attached
   * Note that this is not a recursive count: if an input contains frames that contains regions, then the region_frames_count is increased, but region_inputs_count is not increased.
   * @format uint64
   */
  region_inputs_count?: string;
  /**
   * Number of frames that have regions attached
   * @format uint64
   */
  region_frames_count?: string;
  /**
   * Number of frames
   * @format uint64
   */
  frames_count?: string;
  /**
   * Number of inputs that have frames attached
   * @format uint64
   */
  frame_inputs_count?: string;
  /**
   * Number of embeddings
   * @format uint64
   */
  embeddings_count?: string;
  /**
   * Number of positive tags added at input-level
   * @format uint64
   */
  positive_input_tags_count?: string;
  /**
   * Number of positive tags added at region-level
   * @format uint64
   */
  positive_region_tags_count?: string;
  /**
   * Number of positive tags added at frame-level
   * @format uint64
   */
  positive_frame_tags_count?: string;
}

export interface ApiDatasetVersionMetricsGroup {
  parent_path?: string;
  /**
   *  - INPUT_TYPE: Group data examples by input type.
   * Examples: images, videos, text, audio.
   *  - CONCEPT_ID: Group data examples by concept ID.
   * Examples: inputs with cat concept, inputs with dog concept.
   *  - CONCEPTS_COUNT: Group data examples by concepts count.
   * Examples: inputs with 20 concepts, inputs with 21 concepts.
   *  - BOUNDING_BOXES_COUNT: Group data examples by bounding boxes count.
   * Examples: inputs with 20 bounding boxes, inputs with 21 bounding boxes.
   *  - POLYGONS_COUNT: Group data examples by polygons count.
   * Examples: inputs with 20 polygons, inputs with 21 polygons.
   *  - POINTS_COUNT: Group data examples by points count.
   * Examples: inputs with 20 points, inputs with 21 points.
   *  - MASKS_COUNT: Group data examples by masks count.
   * Examples: inputs with 20 masks, inputs with 21 masks.
   *  - PIXELS_COUNT: Group data examples by pixels count.
   * In order to reduce the number of groups, we use bins.
   * Examples for bin size = 400: inputs with [200000, 200400) pixels, inputs with [200400, 200800) pixels.
   *  - ASPECT_RATIO: Group data examples by aspect ratio.
   * In order to reduce the number of groups, we use bins.
   * Examples for bin size = 0.1: inputs with [0.5, 0.6) aspect ratio, inputs with [0.6, 0.7) aspect ratio.
   */
  type?: ApiDatasetVersionMetricsGroupType;
  value?: any;
  metrics?: ApiDatasetVersionMetrics;
}

/**
 *  - INPUT_TYPE: Group data examples by input type.
 * Examples: images, videos, text, audio.
 *  - CONCEPT_ID: Group data examples by concept ID.
 * Examples: inputs with cat concept, inputs with dog concept.
 *  - CONCEPTS_COUNT: Group data examples by concepts count.
 * Examples: inputs with 20 concepts, inputs with 21 concepts.
 *  - BOUNDING_BOXES_COUNT: Group data examples by bounding boxes count.
 * Examples: inputs with 20 bounding boxes, inputs with 21 bounding boxes.
 *  - POLYGONS_COUNT: Group data examples by polygons count.
 * Examples: inputs with 20 polygons, inputs with 21 polygons.
 *  - POINTS_COUNT: Group data examples by points count.
 * Examples: inputs with 20 points, inputs with 21 points.
 *  - MASKS_COUNT: Group data examples by masks count.
 * Examples: inputs with 20 masks, inputs with 21 masks.
 *  - PIXELS_COUNT: Group data examples by pixels count.
 * In order to reduce the number of groups, we use bins.
 * Examples for bin size = 400: inputs with [200000, 200400) pixels, inputs with [200400, 200800) pixels.
 *  - ASPECT_RATIO: Group data examples by aspect ratio.
 * In order to reduce the number of groups, we use bins.
 * Examples for bin size = 0.1: inputs with [0.5, 0.6) aspect ratio, inputs with [0.6, 0.7) aspect ratio.
 * @default "DATASET_VERSION_METRICS_GROUP_TYPE_NOT_SET"
 */
export enum ApiDatasetVersionMetricsGroupType {
  DATASET_VERSION_METRICS_GROUP_TYPE_NOT_SET = 'DATASET_VERSION_METRICS_GROUP_TYPE_NOT_SET',
  INPUT_TYPE = 'INPUT_TYPE',
  CONCEPT_ID = 'CONCEPT_ID',
  CONCEPTS_COUNT = 'CONCEPTS_COUNT',
  BOUNDING_BOXES_COUNT = 'BOUNDING_BOXES_COUNT',
  POLYGONS_COUNT = 'POLYGONS_COUNT',
  POINTS_COUNT = 'POINTS_COUNT',
  MASKS_COUNT = 'MASKS_COUNT',
  PIXELS_COUNT = 'PIXELS_COUNT',
  ASPECT_RATIO = 'ASPECT_RATIO',
}

/**
 * DatasetVersionProcessingInfo contains information about processing applied
 * to a dataset version.
 */
export interface ApiDatasetVersionProcessingInfo {
  /**
   * If frame_interpolation_info is set, then these settings are used to
   * interpolate new frame annotation from other video annotations.
   *
   * If frame_interpolation_info is set in the dataset default_processing_info,
   * then it can be disabled for a single dataset version by setting
   * processing_info but not setting processing_info.frame_interpolation_info.
   */
  frame_interpolation_info?: ApiFrameInterpolationInfo;
}

/** @default "DATASET_VERSION_REQUEST_ORIGIN_NOT_SET" */
export enum ApiDatasetVersionRequestOrigin {
  DATASET_VERSION_REQUEST_ORIGIN_NOT_SET = 'DATASET_VERSION_REQUEST_ORIGIN_NOT_SET',
  MANUAL = 'MANUAL',
  TRAINING = 'TRAINING',
  EVAL_GROUND_TRUTH = 'EVAL_GROUND_TRUTH',
  EVAL_PREDICTIONS = 'EVAL_PREDICTIONS',
}

/** Request to delete several annotation filters by list of ids. */
export interface ApiDeleteAnnotationFiltersRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  /** Specify which filters to delete. */
  annotation_filter_ids?: string[];
}

/** Request to delete several things by the list of ids. */
export interface ApiDeleteAnnotationsRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  /** Delete annotations with IDs */
  ids?: string[];
  /**
   * Delete annotations for these Input IDs
   * Note that 'ids' are optional but if the are provided the number and order in
   * 'ids' and 'input_ids' should match
   * If you do not specifiy 'ids' all the annotations for 'input_ids' are deleted
   * However you need to specify at least one value for 'input_ids'
   * i.e. this API does not support deleting all annotations
   */
  input_ids?: string[];
}

/**
 * Request to delete the terminated bulk operations by ID
 * Only operations in terminated state can be deleted.
 */
export interface ApiDeleteBulkOperationRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  /** List of bulk operation ids to be deleted */
  ids?: string[];
}

/** Request to delete several things by the list of ids. */
export interface ApiDeleteCollectorsRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  ids?: string[];
  delete_all?: boolean;
}

export interface ApiDeleteConcepts {
  concepts?: ApiConcept[];
  user_ids?: string[];
}

/** Request to delete several datasets by list of ids. */
export interface ApiDeleteDatasetsRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  dataset_ids?: string[];
}

export interface ApiDeleteFromDataset {
  dataset_id?: string;
}

export type ApiDeleteGeo = object;

/** Request to delete several things by the list of ids. */
export interface ApiDeleteInputsRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  ids?: string[];
}

/** Request to delete a list of label orders. */
export interface ApiDeleteLabelOrdersRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  ids?: string[];
}

export interface ApiDeleteMetadata {
  /**
   * To handle arbitrary json metadata you can use a struct field:
   * https://github.com/google/protobuf/blob/master/src/google/protobuf/struct.proto
   */
  metadata?: object;
}

/** Request to delete several things by the list of ids. */
export interface ApiDeleteModelsRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  ids?: string[];
  delete_all?: boolean;
}

/** Request to delete a list of tasks. */
export interface ApiDeleteTasksRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  ids?: string[];
}

/** Stops or deletes multipart upload */
export interface ApiDeleteUploadsRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  ids?: string[];
}

/** Request to delete several things by the list of ids. */
export interface ApiDeleteWorkflowsRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  ids?: string[];
  delete_all?: boolean;
}

/**
 * A deployment allows you to configure how runners for a particular type of resource will
 * scale up and down. These are unique per user_id, nodepool and model so for differnet nodepools
 * you can scale differently.
 */
export interface ApiDeployment {
  /** An id for this configured deployment. */
  id?: string;
  /** The user who owns the deployment. These live in the user/org account. */
  user_id?: string;
  /** How to autoscale the object. */
  autoscale_config?: ApiAutoscaleConfig;
  /**
   * You can configure different autoscaling per nodepool(s).
   * These nodepools have to be also owned by the same user_id/org as this deployment.
   * If there is more than one nodepool we use the model's ComputeInfo to match
   * with what the nodepool provides to decide which one can handle it combined with the
   * NodepoolRank below. Note: even within a single nodepool if it is heterogeneous then
   * we need a way to rank scheduling choices when we don't know how to decide (like a model
   * supports
   */
  nodepools?: ApiNodepool[];
  /**
   * In some scenarios it may not be obvous how we should schedule a resource to underlying nodes
   * within the nodepool(s) above. The SchedulerChoice allows us to specify how to decide which
   * nodepool to use when there are multiple nodepools and how to decide which type of node
   * within a nodepool if there are multiple types.
   * If here are multiple nondepools then a decision on which to use comes into play
   * if it is not specified in the prediction request.
   * Even with a single nodepool a choice may come up such as when a resource that needs scheduling
   * has not specified the accelerator types it supports and the nodepool has multiple types.
   *
   *  - FAIL: fail if there is any ambiguity.
   *  - RANDOM: randomly pick amongst the nodepools/nodes to assign.
   *  - PRICE: choose the compute that is cheaper
   *  - PERFORMANCE: schedule to the fastest known iption.
   *  - NETWORK: optimize based on network latency.
   *  - UTILIZATION: send to the least used nodepool based on it's capacity.
   *  - PREFER_SPOT: choose spot instances over on-demand
   *  - PREFER_ONDEMAND: choose on-demand instances over spot.
   */
  scheduling_choice?: DeploymentSchedulingChoice;
  /**
   * The visibility field represents whether this message is privately/publicly visible.
   * To be visible to the public the App that contains it AND the User that contains the App must
   * also be publicly visible.
   */
  visibility?: ClarifaiapiVisibility;
  /**
   * To handle arbitrary json metadata:
   * https://github.com/google/protobuf/blob/master/src/google/protobuf/struct.proto
   */
  metadata?: object;
  /** Short description of deployment. */
  description?: string;
  /**
   * The thing that the autoscaling config applies to for this nodepool.
   * For a given user_id, nodepool_id, and object ID we can only have one deployment as it defines
   * Worker is the author of an annotation.
   */
  worker?: ApiWorker;
  /**
   * When the deployment was created.
   * @format date-time
   */
  created_at?: string;
  /**
   * When the deployment was last modified.
   * @format date-time
   */
  modified_at?: string;
  /** When to always deploy latest model version */
  deploy_latest_version?: boolean;
}

/** DetailConceptCount */
export interface ApiDetailConceptCount {
  /** The concept count for processed assets */
  processed?: ApiConceptTypeCount;
  /** The concept count for to process assets */
  to_process?: ApiConceptTypeCount;
  /** The concept count for assets with status error */
  errors?: ApiConceptTypeCount;
  /** The concept count for processing assets */
  processing?: ApiConceptTypeCount;
}

/** EmailAddress */
export interface ApiEmailAddress {
  email?: string;
  primary?: boolean;
  verified?: boolean;
}

/** Embedding */
export interface ApiEmbedding {
  vector?: number[];
  /** @format int64 */
  num_dimensions?: number;
}

/** EndpointDeps */
export interface ApiEndpointDeps {
  /** The fully qualified endpoint to */
  endpoint?: string;
  /** Other scopes that are required. */
  depending_scopes?: string[];
}

export interface ApiEvalInfo {
  /**
   * To control the evaluation process.
   * Allow a list of parameters.
   */
  params?: object;
}

/** EvalMetrics */
export interface ApiEvalMetrics {
  status?: ApistatusStatus;
  /** user id that owns this evaluation */
  user_id?: string;
  /** app id that owns this evaluation */
  app_id?: string;
  /** Id of this evaluation */
  id?: string;
  /**
   * Model to evaluate
   * This is the Model object which represents a created model in the platform.
   * Each model has a particular type denoted by the model_type_id.
   * When creating a Model with PostModels the following happens:
   *  - if the ModelType is trainable, then a new ModelVersion is created that is
   *    - UNTRAINED status by default
   *    - TRAINED status if a ModelVersion was included with PretrainedModelConfig in PostModels
   *  - if the ModelType is not trainable, then a new ModelVersion is created with TRAINED status.
   * To modify config settings like OutputInfo for the Model you an use PatchModels. This will
   * also create a new ModelVersion, potentially UNTRAINED following the same rules as above.
   * The fields that are patchable include Model.name, Model.display_name and Model.output_info
   * (except the Model.output_info.type and Model.output_info.type_ext).
   */
  model?: ApiModel;
  /** The ground truth dataset */
  ground_truth_dataset?: ApiDataset;
  /** The dataset with predictions */
  predictions_dataset?: ApiDataset;
  summary?: ApiMetricsSummary;
  confusion_matrix?: ApiConfusionMatrix;
  cooccurrence_matrix?: ApiCooccurrenceMatrix;
  label_counts?: ApiLabelDistribution;
  binary_metrics?: ApiBinaryMetrics[];
  test_set?: ApiEvalTestSetEntry[];
  metrics_by_area?: ApiBinaryMetrics[];
  metrics_by_class?: ApiBinaryMetrics[];
  tracker_metrics?: ApiTrackerMetrics[];
  /**
   * Evaluation parameters to pass. Expected to match what
   * is defined in the model type for the respective model.
   */
  eval_info?: ApiEvalInfo;
  extended_metrics?: ApiExtendedMetrics;
}

/** EvalTestSetEntry */
export interface ApiEvalTestSetEntry {
  /** the input information */
  input?: ApiInput;
  predicted_concepts?: ApiConcept[];
  /** All the ground truth concepts will be show on the top level */
  ground_truth_concepts?: ApiConcept[];
  /**
   * Only region-based/frame-based app contains this annotation
   * Each annotation only contains one region
   * And the concepts is in ground_truth_concepts instead of this annotation
   */
  annotation?: ClarifaiapiAnnotation;
  /** For region based models, region and associated concepts are stored together. */
  predicted_annotation?: ClarifaiapiAnnotation;
  ground_truth_annotation?: ClarifaiapiAnnotation;
}

export interface ApiEvaluationMetricValue {
  /** The metric values */
  evaluation_metric_id?: string;
  /** Aggregated metric value */
  metric_value?: ApiMetricValue;
  /** explanation for the value */
  explanation?: string;
  /** Metric values for each concept */
  per_concept_values?: Record<string, ApiMetricValue>;
}

/**
 * - Classification: default
 * @default "Undefined"
 */
export enum ApiEvaluationType {
  Undefined = 'Undefined',
  Classification = 'Classification',
  Detection = 'Detection',
  Segmentation = 'Segmentation',
  Clustering = 'Clustering',
  Tracker = 'Tracker',
  Generation = 'Generation',
}

/**
 * - ORGANIZATION_MEMBER_ADD: Event types related to organization memberships and teams: 100 - 199
 *  - MODULE_CREATE: Event types related to modules: 200 - 299
 *  - MODEL_CREATE: Event types related to models: 300 - 399
 *  - WORKFLOW_CREATE: Event types related to workflows: 400 - 499
 *  - APPLICATION_CREATE: Event types related to applications: 600 - 699
 *  - COLLABORATOR_ADD: Event types related to collaborators: 700 - 799
 *  - USER_UPDATE: Event types related to users: 800 - 899
 *  - COMPUTE_CLUSTER_CREATE: Event types related to compute clusters: 900-999
 *  - NODEPOOL_CREATE: Event types related to nodepools: 1000-1099
 *  - DEPLOYMENT_CREATE: Event types related to deployments: 1100-1199
 * @default "EVENT_TYPE_NOT_SET"
 */
export enum ApiEventType {
  EVENT_TYPE_NOT_SET = 'EVENT_TYPE_NOT_SET',
  ORGANIZATION_MEMBER_ADD = 'ORGANIZATION_MEMBER_ADD',
  ORGANIZATION_MEMBER_CHANGE = 'ORGANIZATION_MEMBER_CHANGE',
  ORGANIZATION_MEMBER_REMOVE = 'ORGANIZATION_MEMBER_REMOVE',
  ORGANIZATION_MEMBER_INVITATION_CREATE = 'ORGANIZATION_MEMBER_INVITATION_CREATE',
  ORGANIZATION_MEMBER_INVITATION_CANCEL = 'ORGANIZATION_MEMBER_INVITATION_CANCEL',
  ORGANIZATION_MEMBER_INVITATION_ACCEPT = 'ORGANIZATION_MEMBER_INVITATION_ACCEPT',
  ORGANIZATION_MEMBER_INVITATION_DECLINE = 'ORGANIZATION_MEMBER_INVITATION_DECLINE',
  ORGANIZATION_TEAM_CREATE = 'ORGANIZATION_TEAM_CREATE',
  ORGANIZATION_TEAM_UPDATE = 'ORGANIZATION_TEAM_UPDATE',
  ORGANIZATION_TEAM_DELETE = 'ORGANIZATION_TEAM_DELETE',
  ORGANIZATION_TEAM_MEMBER_ADD = 'ORGANIZATION_TEAM_MEMBER_ADD',
  ORGANIZATION_TEAM_MEMBER_REMOVE = 'ORGANIZATION_TEAM_MEMBER_REMOVE',
  ORGANIZATION_TEAM_APP_ADD = 'ORGANIZATION_TEAM_APP_ADD',
  ORGANIZATION_TEAM_APP_REMOVE = 'ORGANIZATION_TEAM_APP_REMOVE',
  MODULE_CREATE = 'MODULE_CREATE',
  MODULE_UPDATE = 'MODULE_UPDATE',
  MODULE_DELETE = 'MODULE_DELETE',
  MODULE_VERSION_CREATE = 'MODULE_VERSION_CREATE',
  MODULE_VERSION_UPDATE = 'MODULE_VERSION_UPDATE',
  MODULE_VERSION_DELETE = 'MODULE_VERSION_DELETE',
  MODEL_CREATE = 'MODEL_CREATE',
  MODEL_UPDATE = 'MODEL_UPDATE',
  MODEL_DELETE = 'MODEL_DELETE',
  MODEL_VERSION_CREATE = 'MODEL_VERSION_CREATE',
  MODEL_VERSION_UPDATE = 'MODEL_VERSION_UPDATE',
  MODEL_VERSION_DELETE = 'MODEL_VERSION_DELETE',
  WORKFLOW_CREATE = 'WORKFLOW_CREATE',
  WORKFLOW_UPDATE = 'WORKFLOW_UPDATE',
  WORKFLOW_DELETE = 'WORKFLOW_DELETE',
  WORKFLOW_VERSION_CREATE = 'WORKFLOW_VERSION_CREATE',
  WORKFLOW_VERSION_UPDATE = 'WORKFLOW_VERSION_UPDATE',
  WORKFLOW_VERSION_DELETE = 'WORKFLOW_VERSION_DELETE',
  APPLICATION_CREATE = 'APPLICATION_CREATE',
  APPLICATION_UPDATE = 'APPLICATION_UPDATE',
  APPLICATION_DELETE = 'APPLICATION_DELETE',
  COLLABORATOR_ADD = 'COLLABORATOR_ADD',
  COLLABORATOR_UPDATE = 'COLLABORATOR_UPDATE',
  COLLABORATOR_REMOVE = 'COLLABORATOR_REMOVE',
  USER_UPDATE = 'USER_UPDATE',
  COMPUTE_CLUSTER_CREATE = 'COMPUTE_CLUSTER_CREATE',
  COMPUTE_CLUSTER_DELETE = 'COMPUTE_CLUSTER_DELETE',
  NODEPOOL_CREATE = 'NODEPOOL_CREATE',
  NODEPOOL_UPDATE = 'NODEPOOL_UPDATE',
  NODEPOOL_DELETE = 'NODEPOOL_DELETE',
  DEPLOYMENT_CREATE = 'DEPLOYMENT_CREATE',
  DEPLOYMENT_UPDATE = 'DEPLOYMENT_UPDATE',
  DEPLOYMENT_DELETE = 'DEPLOYMENT_DELETE',
}

export interface ApiExtendedMetrics {
  user_metrics?: object;
}

/** FieldsValue */
export interface ApiFieldsValue {
  confusion_matrix?: boolean;
  cooccurrence_matrix?: boolean;
  label_counts?: boolean;
  binary_metrics?: boolean;
  test_set?: boolean;
  metrics_by_area?: boolean;
  metrics_by_class?: boolean;
}

/** Filter */
export interface ApiFilter {
  /**
   * If True then this will flip the meaning of this part of the
   * query. This allow for queries such as dog AND ! metadata=={"blah":"value"}
   */
  negate?: boolean;
  /**
   * FILTER by annotation information.
   * ########## Supported fields ##########
   *  # Filter by ID fields
   *  - id                                      - example: `{"id": "xyz"}`
   *  - input_id
   *  - model_version_id
   *  - task_id
   *  - user_id
   * # Filter by worker fields such as model, workflow and user IDs
   *  - worker.model.model_version.id
   *  - worker.user.id
   *  - worker.workflow.version.id
   *
   *  # Filter by other top-level fields
   *  - annotation_info.fields                  - filter by annotation info
   *  - input_level                             - filter only input-level annotations
   *  - status.code                             - filter by annotation status code
   *  - trusted                                 - filter only trusted annotations
   *
   *  # Filter by space-time info fields, i.e. region, frames and time-segments
   *  - data                                    - filter only annotations without space-time info, e.g. classifications
   *                                            - in order to enable this, you need to set the field to an empty object, i.e. `{"data": {}}`
   *  - data.frames[].frame_info                - filter only frame annotations
   *                                            - in order to enable this, you need to set the field to an empty object, i.e. `{"data": {"frames": [{"frame_info": {}}]}}`
   *  - data.regions[].region_info.bounding_box - filter only bounding box annotations
   *                                            - in order to enable this, you need to set the field to an empty object, i.e. `{"data": {"regions": [{"region_info": {"bounding_box":{}}}]}}`
   *  - data.regions[].region_info.mask         - filter only mask annotations
   *                                            - in order to enable this, you need to set the field to an empty object, i.e. `{"data": {"regions": [{"region_info": {"mask":{}}}]}}`
   *  - data.regions[].region_info.point        - filter only point annotations
   *                                            - in order to enable this, you need to set the field to an empty object, i.e. `{"data": {"regions": [{"region_info": {"point":{}}}]}}`
   *  - data.regions[].region_info.polygon      - filter only polygon annotations
   *                                            - in order to enable this, you need to set the field to an empty object, i.e. `{"data": {"regions": [{"region_info": {"polygon":{}}}]}}`
   *  - data.regions[].region_info.span         - filter only span annotations
   *                                            - in order to enable this, you need to set the field to an empty object, i.e. `{"data": {"regions": [{"region_info": {"span":{}}}]}}`
   *  - data.regions[].track_id                 - filter annotations by track_id
   *                                            - in order to enable this, you need to provide "track_id_value" i.e. `{"data": {"regions": [{"track_id" : "track_id_value"}]}}`
   *  - data.time_segments[].time_info          - filter only time-segment annotations
   *                                            - in order to enable this, you need to set the field to an empty object, i.e. `{"data": {"time_segments": [{"time_info": {}}]}}`
   *
   *  # Filter by other data fields
   *  - data.clusters[].id
   *  - data.concepts[].id
   *  - data.concepts[].name
   *  - data.concepts[].value
   *  - data.geo.geo_box[].geo_point.latitude
   *  - data.geo.geo_box[].geo_point.longitude
   *  - data.geo.geo_limit.type
   *  - data.geo.geo_limit.value
   *  - data.geo.geo_point.latitude
   *  - data.geo.geo_point.longitude
   *  - data.metadata.fields                    - filter by metadata
   *                                            - Important to note: metadata key&value fields are OR-ed.
   *                                            - example with 1 metadata key: searching by
   *                                                      `{
   *                                                      `  "data": {
   *                                                      `    "metadata": {
   *                                                      `      "fields": {
   *                                                      `        "foo": {
   *                                                      `          "string_value": "bar"
   *                                                      `        },
   *                                                      `      }
   *                                                      `    }
   *                                                      `  }
   *                                                      `}
   *                                                      will result in a search condition like `metadata includes {"foo": "bar}`;
   *                                            - example with 2 metadata keys: searching by
   *                                                      `{
   *                                                      `  "data": {
   *                                                      `    "metadata": {
   *                                                      `      "fields": {
   *                                                      `        "foo1": {
   *                                                      `          "string_value": "bar2"
   *                                                      `        },
   *                                                      `        "foo2": {
   *                                                      `          "string_value": "bar2"
   *                                                      `        }
   *                                                      `      }
   *                                                      `    }
   *                                                      `  }
   *                                                      `}
   *                                                      will result in a search condition like `(metadata includes {"foo1": "bar1"}) OR (metadata includes {"foo2": "bar2"})`.
   *  - data.text                               - filter only text annotations
   *                                            - in order to enable this, you need to set the field to an empty object, i.e. `{"data": {"text": {}}}`
   */
  annotation?: ClarifaiapiAnnotation;
  /**
   * FILTER by input information.
   * ########## Supported fields ##########
   *  - data.audio                              - filter only audio inputs
   *                                            - in order to enable this, you need to set the field to an empty object, i.e. `{"audio": {}}`
   *  - data.image                              - filter only image inputs
   *                                            - enable using `{"image": {}}`
   *  - data.text                               - filter only text inputs
   *                                            - enable using `{"text": {}}`
   *  - data.video                              - filter only video inputs
   *                                            - enable using `{"video": {}}`
   *  - dataset_ids[]                           - filter by dataset IDs
   *                                            - example: `{"dataset_ids": ["d1", "d2"]}` will filter for inputs in d1 OR d2
   *  - status.code                             - filter by input status
   *                                            - example: `{"status": {"code": 30000}}` to filter only for SUCCESS inputs
   */
  input?: ApiInput;
  /** Filter by annotation last updated time range. */
  last_updated_time_range?: ApiTimeRange;
}

/** A Frame of time-series Data such as a Video. */
export interface ApiFrame {
  /** Information aboue frame such as number and time. */
  frame_info?: ApiFrameInfo;
  /**
   * A recursive definition of the data within the Frame. For example, this will contain
   * data.concepts if the Frame also has annotations or predictions of concepts within it.
   * This can also have data.regions for annotation or predictions of detection regions, which can
   * then recursively have their data field filled in as well.
   */
  data?: ApiData;
  /** An ID for the frame. */
  id?: string;
}

/** The information of the location of the Frame. */
export interface ApiFrameInfo {
  /**
   * Deprecated. Use Time instead.
   * The index of the frame, informational and optional.
   * Depends on the sampling rate used during processing
   * May be 0 for interpolated frames that are generated for brief time (training) or if new frame is manually added
   * @format int64
   */
  index?: number;
  /**
   * time in the video in milliseconds. This is independent of the sampling rates used during
   * processing.
   * @format int64
   */
  time?: number;
}

/**
 * FrameInterpolationInfo contains information about frame annotations
 * interpolated from other video annotations, such as image object-detection
 * regions generated from video object-tracking regions.
 */
export interface ApiFrameInterpolationInfo {
  /**
   * sample_ms is the sampling rate at which frame annotations are interpolated.
   * If sample_ms is zero, then the dataset default_processing_info value is used.
   * If the dataset default is zero or not set, then the input frame prediction
   * sampling rate is used.
   * @format int64
   */
  sample_ms?: number;
}

export interface ApiFullTag {
  /** Display name of the tag. Ex. "English" */
  name?: string;
  /** Id value for referencing. Ex. "en" */
  id?: string;
}

/** Geo */
export interface ApiGeo {
  geo_point?: ApiGeoPoint;
  geo_limit?: ApiGeoLimit;
  /** NOTE: inconsistency: should have been geo_boxed_points */
  geo_box?: ApiGeoBoxedPoint[];
}

/** GeoBoxedPoint */
export interface ApiGeoBoxedPoint {
  geo_point?: ApiGeoPoint;
}

/** GeoLimit */
export interface ApiGeoLimit {
  type?: string;
  /** @format float */
  value?: number;
}

/** GeoPoint */
export interface ApiGeoPoint {
  /** @format float */
  longitude?: number;
  /** @format float */
  latitude?: number;
}

/** ResourceCountResponse */
export interface ApiGetResourceCountsResponse {
  status?: ApistatusStatus;
  /** @format int64 */
  datasets?: string;
  /** @format int64 */
  models?: string;
  /** @format int64 */
  workflows?: string;
  /** @format int64 */
  modules?: string;
  /** @format int64 */
  inputs?: string;
}

export interface ApiGetVideoManifestResponse {
  status?: ApistatusStatus;
  /**
   * MPEG-dash manifest as data-URI, base64-encoded
   * Can be empty if status is FAILED
   * Can be fallback manifest if status is MIXED_STATUS
   */
  manifest_url?: string;
}

export interface ApiGpuMetrics {
  /** GPU UUID. */
  uuid?: string;
  /** GPU model name. e.g. NVIDIA_A10G */
  model_name?: string;
  /**
   * GPU utilization. e.g. DCGM_FI_DEV_GPU_UTIL
   * @format float
   */
  utilization_pct?: number;
  /**
   * Tensor utilization. e.g. DCGM_FI_PROF_PIPE_TENSOR_ACTIVE
   * @format float
   */
  tensor_utilization_pct?: number;
  /**
   * Memory utilization. e.g. DCGM_FI_PROF_DRAM_ACTIVE
   * @format float
   */
  memory_utilization_pct?: number;
}

/** Hit */
export interface ApiHit {
  /**
   * This is the score for the ranked Hit results of the search query. This score is a number
   * between 0.0 and 1.0 as it represents a confidence in the search Hit. For example, if you search
   * for "car" and get a close matching Hit, the score should be close to 1.0. If you get a score
   * of close to 0.0 that means it's very disimilar to your query, in this case NOT a "car". There
   * is a special intermediate score of 0.5 that means that the Hit is not really correlated with
   * your search query (ie. not similar or dissimlar to the query) which is a common occurrence
   * when using negate queries.
   * Note: some queries that are just filtering down your app of inputs may just return a score of
   * 1.0 for all Hits.
   * @format float
   */
  score?: number;
  /**
   * This is the matched input returned from the search query. This will contain information about
   * the Input such as the url, created_at time and trusted annotation information (for backwards
   * compatibility with apps that existed before Annotations were introduced.
   */
  input?: ApiInput;
  /**
   * We also provide back the specific matched annotation for the above input. We do this in order
   * to support more complex Annotation queries in the And message below. For example if we match
   * the search results to a region in your input, or a frame in a video input, this annotation
   * field will be that matched annotation info and the input will be the image/video that the user
   * originally added which contains those regions / frames.
   */
  annotation?: ClarifaiapiAnnotation;
  /** The customer-facing id of the user who owns the app the asset came from. */
  user_id?: string;
  /** The cfid of the app the asset came from. */
  app_id?: string;
}

export interface ApiHitCount {
  /**
   * The estimated total number of hits for the search query, not just the current page.
   * @format uint64
   */
  estimated_total?: string;
}

/** HostedURL */
export interface ApiHostedURL {
  /** Prefix of the URL of every hosted image. */
  prefix?: string;
  /** Suffix of an image stored in different sizes. */
  suffix?: string;
  /**
   * The sizes field lists which images of the different sizes are hosted in our storage. The URL
   * of each hosted image can be obtained by joining the prefix, one of the sizes and suffix.
   */
  sizes?: string[];
  /**
   * The crossorigin property of html media tag
   * For Secure Data Hosting this needs to be set to 'use-credentials'
   */
  crossorigin?: string;
}

export interface ApiIdUpdateSource {
  /** old id */
  id?: string;
  /** new id */
  new_id?: string;
}

/** Image */
export interface ApiImage {
  /**
   * This is a URL to a publicly accessible image file. The platform will download this file server
   * side and then process.
   */
  url?: string;
  /**
   * The base64 field is using image file bytes directly in the request.
   * NOTE: if you're sending a json request, then this MUST be base64 encoded before sending (hence
   * the name here).
   * When using our grpc clients, you DO NOT need to base64 encode
   * it yourself since the clients know how to do this for you automatically and will avoid the
   * base64 encoding if they send a binary request.
   * @format byte
   */
  base64?: string;
  allow_duplicate_url?: boolean;
  /** The hosted field lists images in different sizes hosted in Clarifai storage. */
  hosted?: ApiHostedURL;
  /** image info for original size. for image info for other sizes, use hosted_image_info */
  image_info?: ApiImageInfo;
  /**
   * The map of hosted image info of different sizes (see hosted.sizes), excluding the original image.
   * Note: keys(hosted_image_info) = hosted.sizes - "orig"
   */
  hosted_image_info?: Record<string, ApiImageInfo>;
  /**
   * For internal processing of already decoded bytes.
   * @format byte
   */
  decoded_bytes?: string;
}

export interface ApiImageInfo {
  /**
   * width
   * @format int32
   */
  width?: number;
  /**
   * height
   * @format int32
   */
  height?: number;
  /** image format */
  format?: string;
  /** image color mode */
  color_mode?: string;
  /** mode (when used for decoded_bytes) (RGB, RGBA, P, L, etc.) */
  mode?: string;
}

/** DEPRECATED: no longer support importing models from third party toolkits */
export interface ApiImportInfo {
  /**
   * Used to configure model imports from third-party toolkits.
   * DEPRECATED: no longer support importing models from third party toolkits
   */
  params?: object;
}

/** Input */
export interface ApiInput {
  /** The ID for the input */
  id?: string;
  /** The data passed along in this input. */
  data?: ApiData;
  /**
   * When the input was created. We follow the XXXX timestamp
   * format. We use https://www.ietf.org/rfc/rfc3339.txt format:
   * "2006-01-02T15:04:05.999999Z" so you can expect results like
   * the following from the API:
   * "2017-04-11T21:50:50.223962Z"
   * @format date-time
   */
  created_at?: string;
  /**
   * When the input was modified.
   * @format date-time
   */
  modified_at?: string;
  /**
   * This is the status at a per Input level which allows for
   * partial failures.
   */
  status?: ApistatusStatus;
  /**
   * List of dataset IDs that this input is part of
   * Currently, this field is ONLY used to
   * * search inputs part of dataset(s), e.g. in `PostSearches`, `PostInputsSearches` and `PostAnnotationsSearches` endpoints, and
   * * to add inputs to dataset(s) in `PostInputs` endpoint.
   * Note that this field is ignored for other endpoints, e.g. `GetInput`, `ListInputs` and `PatchInputs`.
   */
  dataset_ids?: string[];
}

/** NOTE: inconsistency: this is weird mix of plural and singular words. */
export interface ApiInputCount {
  /** @format int64 */
  processed?: number;
  /** @format int64 */
  to_process?: number;
  /** @format int64 */
  errors?: number;
  /** @format int64 */
  processing?: number;
  /** @format int64 */
  reindexed?: number;
  /** @format int64 */
  to_reindex?: number;
  /** @format int64 */
  reindex_errors?: number;
  /** @format int64 */
  reindexing?: number;
}

/**
 *  - INPUT_ID_CONFLICT_RESOLUTION_NOT_SET: Defaults to SKIP
 *  - SKIP: Mark duplicate inputs as error and skip processing them.
 *  - SUFFIX: Add a suffix to inputs with conflicting IDs. Attempts numeric suffixes "-1" to "-9" and then a randomized suffix. Identical ID's in the same request are still treated as errors.
 * @default "INPUT_ID_CONFLICT_RESOLUTION_NOT_SET"
 */
export enum ApiInputIDConflictResolution {
  INPUT_ID_CONFLICT_RESOLUTION_NOT_SET = 'INPUT_ID_CONFLICT_RESOLUTION_NOT_SET',
  SKIP = 'SKIP',
  SUFFIX = 'SUFFIX',
}

export interface ApiInputIDs {
  input_ids?: string[];
}

/** InputInfo */
export interface ApiInputInfo {
  /**
   * Map from the api.Data field names to the underlying model graph's inputs. When using a
   * PretrainedModelConfig the values in this map need to match the Triton config.pbtxt input names.
   */
  fields_map?: object;
  /**
   * To control the inputs to the given model we allow a list of parameters
   * defined for each ModelType as a Struct (JSON object) here. During training or inference, the
   * settings contained within are sent to the training processor to alter the training process.
   */
  params?: object;
  /** For base model to get embeddings from for transfer learned models. */
  base_embed_model?: ApiModel;
}

export interface ApiInputsAddJob {
  /** id of the job */
  id?: string;
  /** If call back url is set, we will send a Post request to this endpoint with job status. */
  call_back_url?: string;
  /** Personal Access Token to the application to which inputs are added */
  app_pat?: string;
  /** Progress of an on-going Input Ingestion task */
  progress?: ApiInputsAddJobProgress;
  /**
   * When the job was created.
   * The format is https://www.ietf.org/rfc/rfc3339.txt.
   * Example: "2006-01-02T15:04:05.999999Z".
   * @format date-time
   */
  created_at?: string;
  /**
   * Most recent time when the job was updated.
   * The format is https://www.ietf.org/rfc/rfc3339.txt.
   * Example: "2006-01-02T15:04:05.999999Z".
   * @format date-time
   */
  modified_at?: string;
  /** Sub-jobs that extract inputs from the cloud and/or archives */
  extraction_jobs?: ApiInputsExtractionJob[];
  /** Archive uploads */
  uploads?: ApiUpload[];
  /** Status of the job */
  status?: ApistatusStatus;
}

export interface ApiInputsAddJobProgress {
  /** @format uint64 */
  pending_count?: string;
  /** @format uint64 */
  in_progress_count?: string;
  /** @format uint64 */
  success_count?: string;
  /** @format uint64 */
  failed_count?: string;
}

export interface ApiInputsDataSource {
  /**
   * Collect statistics about created inputs in job with given ID.
   * On Post call:
   * * If job ID is empty, then job is automatically created with random ID.
   * * If job ID is non-empty, then a new job will be created with given ID.
   */
  inputs_add_job_id?: string;
  url?: ApiDataSourceURL;
  /** How to handle input ID conflicts. */
  input_id_conflict_resolution?: ApiInputIDConflictResolution;
  /** Fields set in the template will also be added to all generated inputs */
  input_template?: ApiInput;
}

export interface ApiInputsExtractionJob {
  status?: ApistatusStatus;
  /** ID of extraction job */
  id?: string;
  /** Url of archive or bucket */
  url?: string;
  /** Progress counts of the job */
  progress?: ApiInputsExtractionJobProgress;
  /**
   * When the extraction job was started.
   * The format is https://www.ietf.org/rfc/rfc3339.txt.
   * Example: "2006-01-02T15:04:05.999999Z".
   * @format date-time
   */
  created_at?: string;
  /**
   * Most recent time when the extraction job was updated.
   * The format is https://www.ietf.org/rfc/rfc3339.txt.
   * Example: "2006-01-02T15:04:05.999999Z".
   * @format date-time
   */
  modified_at?: string;
  /** How to handle input ID conflicts. */
  input_id_conflict_resolution?: ApiInputIDConflictResolution;
  /** Fields set in the template are added to all generated inputs */
  input_template?: ApiInput;
}

export interface ApiInputsExtractionJobProgress {
  /** @format uint64 */
  audio_inputs_count?: string;
  /** @format uint64 */
  image_inputs_count?: string;
  /** @format uint64 */
  video_inputs_count?: string;
  /** @format uint64 */
  text_inputs_count?: string;
  /** @format uint64 */
  pending_archives_count?: string;
  /** @format uint64 */
  in_progress_archives_count?: string;
  /** @format uint64 */
  completed_archives_count?: string;
  /** @format uint64 */
  failed_archives_count?: string;
}

export interface ApiInputsUpload {
  /**
   * Collect statistics about created inputs in job with given ID.
   * * If job ID is empty, then job is automatically created with random ID.
   * * If job ID is non-empty, then a new job will be created with given ID.
   */
  inputs_add_job_id?: string;
  /**
   * Personal Access Token to the application to which inputs are added
   * Deprecated: No need to send app_pat, it will be generated internally if not present
   */
  app_pat?: string;
  upload?: ApiUpload;
  /** How to handle input ID conflicts. */
  input_id_conflict_resolution?: ApiInputIDConflictResolution;
  /** Fields set in the template will also be added to all generated inputs */
  input_template?: ApiInput;
}

export interface ApiInstalledModuleVersion {
  /** A unique id for this install. This will be used in the browser url. */
  id?: string;
  /**
   * The installed module version provided here so that we users don't need to do an additional
   * fetch. When creating a new InstalledModuleVersion you should provide the:
   * module_version.user_id
   * module_version.app_id
   * module_version.module_id
   * module_version.id
   * in order to uniquely define which module version.
   */
  module_version?: ApiModuleVersion;
  /**
   * The app_id the ModuleVersion is installed into (not necessary where the ModuleVersion was
   * created). This doesn't have to be provided in requests to install, but will be returned in
   * responses.
   */
  app_id?: string;
  /**
   * The user that the app belongs to where the ModuleVersion is installed into (not necessary where
   * the ModuleVersion was created). This doesn't have to be provided in requests to install, but
   * will be returned in responses.
   */
  user_id?: string;
  /**
   * When the install was created.
   * @format date-time
   */
  created_at?: string;
  /**
   * When the install was last modified.
   * @format date-time
   */
  modified_at?: string;
  /**
   * The URL of where this app module version is deployed.
   * If you provide this deploy_url when creating the install then it will
   * be treated as a pre-deployed module. You can only use a pre-deployed module
   * in when installing to an app_id that you own as the creator of the module.
   * If you want to install someone elses module or to rely on Clarifai deploying
   * your module for you, leave deploy_url empty when creating the install.
   * If it is left empty, then deployment will occur when this module version is
   * installed into an app using the git_commit_url of the ModuleVersion.
   */
  deploy_url?: string;
  /**
   * The visibility field represents whether this message is privately/publicly visible.
   * To be visible to the public the App that contains it AND the User that contains the App must
   * also be publicly visible. For the InstalledModuleVersion this allows the app owner who
   * installed the module version to decide if they want other users of their app to have
   * the added functionality that the modules version provides to their app.
   * Defaults to PRIVATE if not provided.
   */
  visibility?: ClarifaiapiVisibility;
  /**
   * The key ID to use for making requests to the API for this module.
   * This key is associated to this installed module version by PostInstalledModuleVersionsKey
   * request. The key is associated with the CALLER not the App Owner where this module is installed
   * nor the author of the module. This allows the module to act on behalf of the caller at all
   * times so we get proper permissions the caller has (such as if they are stranger, teammate or
   * collaborator). This key should be a personal access token to enable modules to work across apps
   * and have necessary abilities beyond what app-specific keys offer.
   */
  key_id?: string;
}

/**
 * The instance types that will be available in this pool of nodes.
 * Clarifai offers multiple different choices that combine cpu cores, memory and accelerator.
 */
export interface ApiInstanceType {
  id?: string;
  /** Short description of instance type. */
  description?: string;
  /**
   * These are the resource needs of a given API object such as a model.
   * This is what they require as a minimum to run and will be used upon scheduling
   * as the request and limit for the k8s pod. If we want to separate limits and requests in the
   * future we can allow setting a limits ComputeInfo and a requests ComputeInfo.
   */
  compute_info?: ApiComputeInfo;
  price?: string;
  /** The cloud provider where this instance type is available, if any. */
  cloud_provider?: ApiCloudProvider;
  /** The region where this instance type is available, if any. */
  region?: string;
  /** The capacity types allowed for this instance type. If empty - all capacity types are allowed. */
  allowed_capacity_types?: ApiNodeCapacityType;
}

/** Key */
export interface ApiKey {
  /** The id of this key, it is used for authorization. */
  id?: string;
  /** The type of key, it can be app_specific_key (default) or personal_access_token */
  type?: string;
  /** The description */
  description?: string;
  /** The low-level scopes this key has */
  scopes?: string[];
  /** The endpoint-level scopes this key has */
  endpoints?: string[];
  /**
   * The apps that this key give you access to, it is empty if this key is personal_access_token
   * API key can only give you access to a single app.
   */
  apps?: ApiApp[];
  /**
   * When the key was created. We follow the XXXX timestamp
   * format. We use https://www.ietf.org/rfc/rfc3339.txt format:
   * "2006-01-02T15:04:05.999999Z" so you can expect results like
   * the following from the API:
   * "2017-04-11T21:50:50.223962Z"
   * @format date-time
   */
  created_at?: string;
  /**
   * When does the key expires, the key won't expire if this is empty
   * @format date-time
   */
  expires_at?: string;
  /** list of idp ids at which key is currently authorized */
  authorized_idp_ids?: string[];
}

export interface ApiKeypointEdge {
  /** @format int64 */
  k1?: number;
  /** @format int64 */
  k2?: number;
}

export interface ApiKeypointInfo {
  /** Names of the keypoints */
  keypoint_names?: string[];
  /** Defines the connections between keypoint_names. Each value represents the index in keypoint_names. */
  skeleton?: ApiKeypointEdge[];
}

/** A Knowledge Graph is a logical subsets of edges in the overall Concept Graph */
export interface ApiKnowledgeGraph {
  /** ID of the knowledge graph */
  id?: string;
  /** Name of the knowledge graph */
  name?: string;
  /** Human readable description of the knowledge graph */
  description?: string;
  /** The app that contains the images that correspond to the concepts in the knowledge graph */
  examples_app_id?: string;
  /** The app that contains the sample images that we want to show the customer for the concepts in the knowledge graph */
  sampled_examples_app_id?: string;
}

/** LOPQEvalResult */
export interface ApiLOPQEvalResult {
  /**
   * Rank k for which all metrics are reported.
   * @format int32
   */
  k?: number;
  /**
   * Recall @ k assuming the brute force search is the ground truth.
   * @format float
   */
  recall_vs_brute_force?: number;
  /**
   * Kendall's tau correlation @ k assuming the brute force search is the ground truth.
   * @format float
   */
  kendall_tau_vs_brute_force?: number;
  /**
   * The percentage of the most frequent code in the indexed part of evaluation data.
   * @format float
   */
  most_frequent_code_percent?: number;
  /**
   * Normalized Discounted Cumulative Gain (NDCG) @ k with a ground truth inferred from annotations
   * and/or prediction for this evaluation LOPQ model.
   * NDCG uses individual relevance scores of each returned image to evaluate the usefulness, or
   * gain, of a document based on its position in the result list. The premise of DCG is that
   * highly relevant documents appearing lower in a search result list should be penalized as the
   * graded relevance value is reduced logarithmically proportional to the position of the result.
   * See: https://en.wikipedia.org/wiki/Information_retrieval#Discounted_cumulative_gain
   * To compute the relevance score between two images we consider two cases:
   * 1) Only one label for each image
   * An image is relevant to an image query iff they are labeled the same (score 1), and
   * not relevant otherwise (score 0)
   * 2) Multiple labels for each image
   * Here an image relevancy with respect to a single image query is measured by f-beta score
   * assuming the query image list of labels as ground truth and comparing them with that of
   * the search result. These labels can come from image annotations or if substitute_annotation_misses
   * is set, predictions of base classifier where any prediction with prob < prob_threshold are
   * discarded. To quantify the relevancy score of a single search result we opt to compute precision
   * and recall @ k for simplicity, and combine them with f-beta score to obtain a single number.
   * @format float
   */
  lopq_ndcg?: number;
  /**
   * Brute force NDCG which gives a baseline to compare to and is a measure of how good
   * the embeddings are.
   * @format float
   */
  brute_force_ndcg?: number;
}

/** LabelCount */
export interface ApiLabelCount {
  concept_name?: string;
  /** @format int64 */
  count?: number;
  concept?: ApiConcept;
}

/** LabelDistribution */
export interface ApiLabelDistribution {
  positive_label_counts?: ApiLabelCount[];
}

/** LabelOrder */
export interface ApiLabelOrder {
  /** id of the order */
  id?: string;
  /** name of the order */
  name?: string;
  /**
   * status of the order.
   * pending (QA lead review the order),
   * in progress (labeling in progress),
   * ready for release (passed clarifai QA and client can review)
   * success (released)
   */
  status?: ApistatusStatus;
  /** if set to true, automatically release the labels once passed clarifai review. */
  auto_release?: boolean;
  /** allow input without any tag. */
  allow_empty_tag?: boolean;
  /**
   * User desired estimation when the task should be done
   * @format date-time
   */
  desired_fulfill_time?: string;
  /**
   * Clarifai estimation when the task should be done .
   * @format date-time
   */
  estimate_fulfill_time?: string;
  /**
   * task for this label order
   * Task is the work that needs to be done for labeling the inputs in an app.
   */
  task?: ApiTask;
  /**
   * When the label order was created.
   * The format is https://www.ietf.org/rfc/rfc3339.txt.
   * Example: "2006-01-02T15:04:05.999999Z".
   * @format date-time
   */
  created_at?: string;
  /**
   * Most recent time when the label order was updated.
   * The format is https://www.ietf.org/rfc/rfc3339.txt.
   * Example: "2006-01-02T15:04:05.999999Z".
   * @format date-time
   */
  modified_at?: string;
}

export interface ApiLabelSubmitConfig {
  task_assignments?: ApiTaskAssignment[];
}

export interface ApiLayerShape {
  /**
   * Supported dimensions
   * Example: [-1,4] is a 2-dimensional array with the first dimension of variablesize, but second dimension with a static size: [[1,2,3,4],[4,5,6,7],...]
   */
  dims?: number[];
  /** Max dimension size, applicable to layers that can have flexible sizes. */
  max_dims?: number[];
  /** The triton data type */
  data_type?: ClarifaiapiDataType;
  /** Description about the dimensions */
  description?: string;
}

/** @default "UNKNOWN_LICENSE_TYPE" */
export enum ApiLicenseType {
  UNKNOWN_LICENSE_TYPE = 'UNKNOWN_LICENSE_TYPE',
  FIRST_PARTY = 'FIRST_PARTY',
  OPEN_SOURCE = 'OPEN_SOURCE',
  CLOSED_SOURCE = 'CLOSED_SOURCE',
}

/** ListOpenSourceLicensesResponse */
export interface ApiListOpenSourceLicensesResponse {
  status?: ApistatusStatus;
  licenses?: string[];
}

/** LogEntry is a single technical log entry (e.g. service log, stack traces, etc). */
export interface ApiLogEntry {
  /** Text of the log entry. */
  message?: string;
  /** The type of log entry. Examples: model, agent, build, training. */
  log_type?: string;
  /** URL to log file or stream. */
  url?: string;
  /** Who and where the metrics are from. */
  meta?: ApiComputeSourceMetadata;
}

/** Segmentation mask. */
export interface ApiMask {
  /** The image of the mask in a non-raster format. */
  image?: ApiImage;
}

/**
 * MethodSignature is a definition of a method that a model can have.
 * This is used to communicate between a python method definition of any arbitrary function
 * to the client or UI on how to call that function from the client side.
 */
export interface ApiMethodSignature {
  /** The name of the method on the server. */
  name?: string;
  /** whether the method is for predict(unary-unary), generate(unary-stream), stream(stream-stream) */
  method_type?: ApiRunnerMethodType;
  /** description from the docstring of the method on the server. */
  description?: string;
  /** input fields and signature of every method arguments */
  input_fields?: ApiModelTypeField[];
  /** output signature of method */
  output_fields?: ApiModelTypeField[];
}

export interface ApiMetricValue {
  string_value?: string;
  /** @format float */
  float_value?: number;
  /** @format int32 */
  int_value?: number;
}

/** MetricsSummary */
export interface ApiMetricsSummary {
  /** @format float */
  top1_accuracy?: number;
  /** @format float */
  top5_accuracy?: number;
  /** @format float */
  macro_avg_roc_auc?: number;
  /** @format float */
  macro_std_roc_auc?: number;
  /** @format float */
  macro_avg_f1_score?: number;
  /** @format float */
  macro_std_f1_score?: number;
  /** @format float */
  macro_avg_precision?: number;
  /** @format float */
  macro_avg_recall?: number;
  /** @format float */
  mean_avg_precision_iou_50?: number;
  /** @format float */
  mean_avg_precision_iou_range?: number;
  lopq_metrics?: ApiLOPQEvalResult[];
}

/**
 * This is the Model object which represents a created model in the platform.
 * Each model has a particular type denoted by the model_type_id.
 * When creating a Model with PostModels the following happens:
 *  - if the ModelType is trainable, then a new ModelVersion is created that is
 *    - UNTRAINED status by default
 *    - TRAINED status if a ModelVersion was included with PretrainedModelConfig in PostModels
 *  - if the ModelType is not trainable, then a new ModelVersion is created with TRAINED status.
 * To modify config settings like OutputInfo for the Model you an use PatchModels. This will
 * also create a new ModelVersion, potentially UNTRAINED following the same rules as above.
 * The fields that are patchable include Model.name, Model.display_name and Model.output_info
 * (except the Model.output_info.type and Model.output_info.type_ext).
 */
export interface ApiModel {
  /** The model's ID. Must be unique within a particular app and URL-friendly. */
  id?: string;
  /** DEPRECATED: Please use the model id to name the model. */
  name?: string;
  /**
   * When the model was created. We follow the XXXX timestamp
   * format. We use https://www.ietf.org/rfc/rfc3339.txt format:
   * "2006-01-02T15:04:05.999999Z" so you can expect results like
   *  the following from the API:
   *  "2017-04-11T21:50:50.223962Z"
   * @format date-time
   */
  created_at?: string;
  /**
   * When was the most recent model version created at
   * @format date-time
   */
  modified_at?: string;
  /** The app the model belongs to. */
  app_id?: string;
  /**
   * Info about the model's output and configuration.
   * DEPRECATED: Will be moved to model version
   * OutputInfo defines some of the settings for each model version that PatchModels can effect. These
   * parameters control some of the training or inference operations that this model can do.
   * As the number of parameters continued to grow when we launched more ModelTypes we decided to move
   * to using the OutputInfo.params field which is a Struct (or JSON object if you're using
   * our JSON REST APIs). This allows each ModelType to define the set of fields, their default values
   * and description of each field so that we can display those in Portal and make the creation of
   * Model's very extensible. The OutputConfig object will eventually go away in favor of
   * output_info.params struct.
   */
  output_info?: ApiOutputInfo;
  /**
   * A particular version of the model, e.g., to specify the version when creating a workflow or
   * when listing Models to include the latest ModelVersion of the model in the response.
   */
  model_version?: ApiModelVersion;
  /** DEPRECATED: Please use the model id to name the model. */
  display_name?: string;
  /** The user id that the model belongs to. */
  user_id?: string;
  /** The default evaluation info. Can be overwritten by eval request. */
  default_eval_info?: ApiEvalInfo;
  /**
   * The ModelType.Id that is used for this model. This is used for all versions and you cannot
   * change model_type_id between versions of the same model.
   */
  model_type_id?: string;
  /** The task the model was trained to do */
  task?: string;
  /**
   * The visibility field represents whether this message is privately/publicly visible.
   * To be visible to the public the App that contains it AND the User that contains the App must
   * also be publicly visible.
   */
  visibility?: ClarifaiapiVisibility;
  /** Short description about this model */
  description?: string;
  /**
   * To handle arbitrary json metadata you can use a struct field:
   * https://github.com/google/protobuf/blob/master/src/google/protobuf/struct.proto
   */
  metadata?: object;
  presets?: object;
  /**
   * Notes for the model
   * This field should be used for in-depth notes and supports up to 64Kbs.
   */
  notes?: string;
  /** Tags from toolkits category */
  toolkits?: string[];
  /** Tags from use_cases category */
  use_cases?: string[];
  /** Tags from languages category. */
  languages?: string[];
  /** Tags from languages category with names, only used in responses. */
  languages_full?: ApiFullTag[];
  check_consents?: string[];
  /**
   * Is starred by the requesting user (only showed on get/list requests)
   * Please use PostModelStars/DeleteModelStars endpoints to star/unstar a model
   */
  is_starred?: boolean;
  /**
   * How many users have starred the model (only showed on get/list requests)
   * Computed value, not editable
   * @format int32
   */
  star_count?: number;
  /** Whether it's recommended that this model is used within a workflow */
  workflow_recommended?: boolean;
  /**
   * bookmark info. When set, this model is a bookmarked model of this app.
   * Info in this field will allow you to find/access original model.
   */
  bookmark_origin?: ApiBookmarkOrigin;
  /** Representative image for this model */
  image?: ApiImage;
  /** License Type */
  license_type?: ApiLicenseType;
  source?: ModelSource;
  /** Creator of Model */
  creator?: string;
  /** @format int32 */
  version_count?: number;
  billing_type?: ModelBillingType;
  /**
   * Whether the model should be featured, and if so, the order in which it should be featured.
   * The order is relative to other models that are also featured.
   * Models with a higher order will be featured first.
   * @format int32
   */
  featured_order?: number;
}

export interface ApiModelLayerInfo {
  /** The api.Data field this layer will be parsed into */
  data_field_name?: string;
  /** Description of the expected shape. Can support multiple support layer shapes. */
  shapes?: ApiLayerShape[];
  /** Brief description about the layer if needed */
  description?: string;
  /** Whether this layer should have a label_filename specified and provided */
  requires_label_filename?: boolean;
}

export interface ApiModelPredictConfig {
  /** Assumed to be owned by the calling users app unless user_id and app_id are filled out. */
  model?: ApiModel;
}

/** ModelQuery */
export interface ApiModelQuery {
  /** The name ofthe field. This supports wilcard queries like "gen*" to match "general" as an example. */
  name?: string;
  /**
   * Filter models by the specific model_type_id. See ListModelTypes for the list of ModelType.Id's
   * supported.
   */
  model_type_id?: string;
}

/** A link to a html/markdown/text file that stores reference material tied to a model. */
export interface ApiModelReference {
  /** Id of the reference */
  id?: string;
  /** The id of the model this Model reference is tied to. */
  model_id?: string;
  /** address of resource */
  url?: string;
  /** name of link */
  name?: string;
  /**
   * To handle arbitrary json metadata:
   * https://github.com/google/protobuf/blob/master/src/google/protobuf/struct.proto
   */
  metadata?: object;
}

/**
 * ModelType is a definition of a set of models that generally have the same input and output fields.
 * This is used to understand more about the possible models in our platform.
 */
export interface ApiModelType {
  /** A unique identifier for this model type. */
  id?: string;
  /** A display title for this model. */
  title?: string;
  /** Description of this model type. */
  description?: string;
  /**
   * The list of input fields that this model expects as inputs.
   * Used to validate that request input data has the expected fields.
   */
  input_fields?: string[];
  /** The list of output fields that this model accepts. */
  output_fields?: string[];
  /** Is this model trainable in our platform. */
  trainable?: boolean;
  /**
   * Is this model creatable. We have some pre-trained model types that users cannot create yet in
   * model mode.
   */
  creatable?: boolean;
  /** Is this model type only for internal users at this time. */
  internal_only?: boolean;
  /** The remaining fields are definitions of the configurable fields that exist. */
  model_type_fields?: ApiModelTypeField[];
  /**
   * For sequence models we need to know when processing that they require temporal time frames
   * in sequential order. This will be true for model types like trackers as an example.
   */
  requires_sequential_frames?: boolean;
  /** Expected input layers of an uploaded model. */
  expected_input_layers?: ApiModelLayerInfo[];
  /** Expected output layers of an uploaded model */
  expected_output_layers?: ApiModelLayerInfo[];
  /** What type of evaluation is supported for this model type. */
  evaluation_type?: ApiEvaluationType;
  /**
   * method signature for this model type
   * This will be used in the future to replace input_fields, output_fields, and model_type_fields
   * as it can define any python function call.
   */
  method_signatures?: ApiMethodSignature[];
}

/** ModelTypeEnumOption */
export interface ApiModelTypeEnumOption {
  /** The unique value of the enum option. */
  id?: string;
  /**
   * List of other ID values that are equivalent with this ID.
   * This allows the user to choose this option by multiple IDs.
   * Example: if enum is "Phone Number Prefix", you could add an option that is selectable by two values:
   * 1. ID: "Estonia"
   * 2. Alias: 37
   */
  aliases?: ApiModelTypeEnumOptionAlias[];
  /** Optional description for this enum option. */
  description?: string;
  /**
   * These are additional fields that are specific to this enum choice. This allows
   * us to use enums to control configuration settings as well.
   */
  model_type_fields?: ApiModelTypeField[];
  /** If this enum option should be internal only. */
  internal_only?: boolean;
  /**
   * Whether this is the recommended enum option. Set to `true` when there
   * are multiple options, and one is shown to be better than the others.
   */
  recommended?: boolean;
}

export interface ApiModelTypeEnumOptionAlias {
  /**
   * Integer alias for id.
   * @format int64
   */
  id_int?: string;
  /** String that can contain wild cards and the regex needs to match. */
  wildcard_string?: string;
}

/** ModelTypeField stores a field value of a configurable type. */
export interface ApiModelTypeField {
  /**
   * The path where the value of the field will be stored in the model version object.
   * Example:
   * "output_info.data" would be the Data message in the OutputInfo message.
   * "output_info.output_config.language" is in the OutputConfig message within OutputInfo
   * "input_info.params" is in the params struct within InputInfo.
   * "output_info.params" is in the params struct within OutputInfo.
   * "train_info.params" is in the params struct within TrainInfo.
   * and so on.
   */
  path?: string;
  /**
   * The field for this field. This is often used for displaying the field in the UI whereas
   * the DataType enum below defines the specific type of datain the Python function.
   */
  field_type?: ModelTypeFieldModelTypeFieldType;
  /**
   * A default value. We use the Value field because we want to have structured data (just like
   * google.protobuf.Struct but this is just a single value).
   */
  default_value?: any;
  /** Description for this field. */
  description?: string;
  /** Placeholder text for the UI element. */
  placeholder?: string;
  /** List of options of the ENUM type and potentially additional fields they bring with them. */
  model_type_enum_options?: ApiModelTypeEnumOption[];
  /** If this field should appear for internal users only. */
  internal_only?: boolean;
  /**
   * If this field is a required field. If True then during validation you won't be able to create
   * a model of this type with providing a value for this field. When False, the ModelType's
   * default_value will be used for this field.
   */
  required?: boolean;
  /** If the field_type is RANGE, this must be filled in. */
  model_type_range_info?: ApiModelTypeRangeInfo;
  /** name of method signature argument */
  name?: string;
  /** The type of the argument. */
  type?: ApiModelTypeFieldDataType;
  /**
   * type enum, and recursively set type_args with
   * the inner type argumets in complex objects (e.g. List[Tuple[int, str]])
   */
  type_args?: ApiModelTypeField[];
  /** this will be use to define whether the method argument supports streaming as an iterator. */
  iterator?: boolean;
  /**
   * This specify the default value of the method argument
   * If this argument is not passed, the input is required. If it is explicitly set to None, the input is optional
   * We define this as a string
   * because the default value can be a string, int, float, bool, or a complex object like a JSON
   * The default_value field above should not also be used.
   */
  default?: string;
  /** wheather it's a inference param or a modeltype field */
  is_param?: boolean;
}

/**
 * DataType is used in MethodSignature to define all the possible types that a python function
 * may have that we want to support. These include built-ins like int, float, str, bool, and
 * more complex types like JSON, numpy arrays, List, Tuple, Dict (as Named Fields), as well as Clarifai provided
 * unstructured types like Image, Video, Text, etc.
 *
 *  - STR: A string value.
 *  - BYTES: A byte string. This is used for binary data.
 *  - INT: An integer value.
 *  - FLOAT: A float value.
 *  - BOOL: A boolean value.
 *  - NDARRAY: A proto representation for numpy arrays.
 *  - JSON_DATA: For arbitrary json object: "{...}"
 *  - TEXT: For text data
 *  - IMAGE: A image is a image proto for url or bytes.
 *  - CONCEPT: A concept is a concept proto that represents a concept in the app.
 *  - REGION: A region is a bounding box in an image or video frame.
 *  - FRAME: A frame is a single image in a video stream
 *  - AUDIO: A audio is a audio proto for url or bytes.
 *  - VIDEO: A video is a video proto for url or bytes.
 *  - NAMED_FIELDS: this can be used to store named fields with values similar to Dict
 *  - TUPLE: An arg that is a tuple.
 *  - LIST: An arg that is a list.
 * @default "NOT_SET"
 */
export enum ApiModelTypeFieldDataType {
  NOT_SET = 'NOT_SET',
  STR = 'STR',
  BYTES = 'BYTES',
  INT = 'INT',
  FLOAT = 'FLOAT',
  BOOL = 'BOOL',
  NDARRAY = 'NDARRAY',
  JSON_DATA = 'JSON_DATA',
  TEXT = 'TEXT',
  IMAGE = 'IMAGE',
  CONCEPT = 'CONCEPT',
  REGION = 'REGION',
  FRAME = 'FRAME',
  AUDIO = 'AUDIO',
  VIDEO = 'VIDEO',
  NAMED_FIELDS = 'NAMED_FIELDS',
  TUPLE = 'TUPLE',
  LIST = 'LIST',
}

/** ModelTypeRangeInfo */
export interface ApiModelTypeRangeInfo {
  /**
   * The start of the range as a float.
   * @format float
   */
  min?: number;
  /**
   * The end of the range as a float.
   * @format float
   */
  max?: number;
  /**
   * An optional step size for the range. If provided then only values at that step size will be
   * rounded to. For example if step is 0.02 then 0.0245 will round to 0.02.
   * @format float
   */
  step?: number;
}

/** ModelVersion */
export interface ApiModelVersion {
  id?: string;
  /**
   * When the version was created.
   * @format date-time
   */
  created_at?: string;
  /** The status of the version (whether it's untrained, training, trained, etc.). */
  status?: ApistatusStatus;
  /** @format int64 */
  active_concept_count?: number;
  metrics?: ApiEvalMetrics;
  /**
   * number of inputs in the model version
   * @format int64
   */
  total_input_count?: number;
  /**
   * When a model has already been trained externally, you can upload
   * it directly to the platform as a model version directly by
   * setting the PretrainedModelConfig
   */
  pretrained_model_config?: ApiPretrainedModelConfig;
  /**
   * When training of this version was completed.
   * @format date-time
   */
  completed_at?: string;
  /** Description about this version */
  description?: string;
  /**
   * The visibility field represents whether this message is privately/publicly visible.
   * To be visible to the public the App that contains it AND the User that contains the App must
   * also be publicly visible.
   */
  visibility?: ClarifaiapiVisibility;
  /** The app the model version belongs to. */
  app_id?: string;
  /** The user the model version belongs to. */
  user_id?: string;
  /**
   * When this model version was last modified
   * @format date-time
   */
  modified_at?: string;
  /**
   * To handle arbitrary json metadata you can use a struct field:
   * https://github.com/google/protobuf/blob/master/src/google/protobuf/struct.proto
   */
  metadata?: object;
  license?: string;
  /**
   * Info about the model's output. Besides `output_info.data`, these fields should
   * be reserved for parameters that affect the models outputs when inferencing.
   * `output_info.data` is used to specify the training concepts for this model version.
   */
  output_info?: ApiOutputInfo;
  /**
   * Info about preprocessing the models inputs, before they are sent to this model for training or inferencing.
   * E.g.: `input_info.base_embed_model` lets us know inputs should be ran through a base model before being sent to an embedding-classifier.
   */
  input_info?: ApiInputInfo;
  /** Configuration for the training process of this model version. */
  train_info?: ApiTrainInfo;
  /**
   * Configuration used to import model from third-party toolkits
   * DEPRECATED: no longer support importing models from third party toolkits
   */
  import_info?: ApiImportInfo;
  /** Contains the training logs if available */
  train_log?: string;
  /** The minimum required compute resource for this model for inference. */
  inference_compute_info?: ApiComputeInfo;
  /** Build information for the model version */
  build_info?: ApiBuildInfo;
  /** Model signature information for the model version */
  method_signatures?: ApiMethodSignature[];
}

/** ModelVersionExport contains metadata for a single Model version export. */
export interface ApiModelVersionExport {
  /** status is the current status of the dataset version export. */
  status?: ApistatusStatus;
  /** url is the URL from where the model version export can be downloaded. */
  url?: string;
  /**
   * size of model file
   * @format int64
   */
  size?: string;
}

/** ModelVersionInputExample */
export interface ApiModelVersionInputExample {
  /** user unique id */
  id?: string;
  /** external id of model */
  model_id?: string;
  /** external id of model version */
  model_version_id?: string;
  /** data to store as example input for model */
  data?: ApiData;
  /** name of link for display */
  name?: string;
  /** description of link contents */
  description?: string;
}

/** ModelVersionPublishRequest */
export interface ApiModelVersionPublishRequest {
  version_id?: string;
}

/** ModelVersionUnpublishRequest */
export interface ApiModelVersionUnpublishRequest {
  version_id?: string;
}

/** An app module that a user created in our app module marketplace. */
export interface ApiModule {
  /** A unique ID for this app module. */
  id?: string;
  /** A short description for this app module to be used in grids of modules. */
  description?: string;
  /**
   * When the app module was created.
   * @format date-time
   */
  created_at?: string;
  /**
   * When the app module was last modified.
   * @format date-time
   */
  modified_at?: string;
  /**
   * The visibility field represents whether this message is privately/publicly visible.
   * To be visible to the public the App that contains it AND the User that contains the App must
   * also be publicly visible.
   * Defaults to PRIVATE if not provided.
   */
  visibility?: ClarifaiapiVisibility;
  /**
   * To handle arbitrary json metadata you can use a struct field:
   * https://github.com/google/protobuf/blob/master/src/google/protobuf/struct.proto
   * This is an optional arg.
   */
  metadata?: object;
  /** The creator of the app module. */
  user_id?: string;
  /** The app_id this module was created in. */
  app_id?: string;
  /**
   * A ModuleVersion which is used when listing modules to include the latest module version
   * in the response.
   */
  module_version?: ApiModuleVersion;
  /**
   * Is starred by the requesting user (only showed on get/list requests)
   * Please use PostModuleStars/DeleteModuleStars endpoints to star/unstar a module
   */
  is_starred?: boolean;
  /**
   * How many users have starred the module (only showed on get/list requests)
   * Computed value, not editable
   * @format int32
   */
  star_count?: number;
  /**
   * bookmark info. When set, this module is a bookmarked module of this app.
   * Info in this field will allow you to find/access original module.
   */
  bookmark_origin?: ApiBookmarkOrigin;
  /** Representative image for this module */
  image?: ApiImage;
}

/** A specific version of an app module that is available for assigning to apps. */
export interface ApiModuleVersion {
  /** A name for this version like 1_0, 1_1_0, etc. */
  id?: string;
  /** The module this version belongs to. */
  module_id?: string;
  /** The app_id this module version belongs to. */
  app_id?: string;
  /** The user_id this module version belongs to. */
  user_id?: string;
  /** A short description for this version. */
  description?: string;
  /**
   * A markdown formatted string to detailed description of the app module.
   * This is within each version so that it can be change version to version.
   */
  notes?: string;
  /**
   * When the app module version was created.
   * @format date-time
   */
  created_at?: string;
  /**
   * When the app module version was last modified.
   * @format date-time
   */
  modified_at?: string;
  /**
   * The code repo of the streamlit app.
   * If you are still developing your Module you should create a ModuleVersion
   * with an empty git_commit_url and then create an InstalledModuleVersion
   * with a pre-deployed deploy_url (such as localhost or streamlit cloud).
   * Once you are ready to create a production, create a new ModuleVersion with
   * the ready git url to a specific commit that you would like to be reviewed by the
   * Clarifai team for approval within our community. You cannot publish a ModuleVersion
   * is reviewed and approved. Please only provide the git_commit_url when you're
   * ready for a review. This url needs to include a specific commit, for example:
   * https://github.com/user/repo/commit/767ff9c08ba3429c8e7b8825da148555
   */
  git_commit_url?: string;
  module_nav?: ModuleVersionModuleNav;
  /**
   * A boolean to mark if Clarifai has approved this app version.
   * This cannot be set in the request to True.
   */
  approved?: boolean;
  /**
   * The visibility field represents whether this message is privately/publicly visible.
   * To be visible to the public the App that contains it AND the User that contains the App must
   * also be publicly visible.
   * Defaults to PRIVATE if not provided.
   */
  visibility?: ClarifaiapiVisibility;
  /**
   * To handle arbitrary json metadata you can use a struct field:
   * https://github.com/google/protobuf/blob/master/src/google/protobuf/struct.proto
   * This is an optional arg.
   */
  metadata?: object;
}

/** MultiAnnotationFilterResponse */
export interface ApiMultiAnnotationFilterResponse {
  status?: ApistatusStatus;
  annotation_filters?: ApiAnnotationFilter[];
}

/** MultiAnnotationResponse */
export interface ApiMultiAnnotationResponse {
  status?: ApistatusStatus;
  annotations?: ClarifaiapiAnnotation[];
}

/** MultiAnnotationSearchMetricsResponse */
export interface ApiMultiAnnotationSearchMetricsResponse {
  /** Status of the request */
  status?: ApistatusStatus;
  annotation_search_metrics?: ApiAnnotationSearchMetrics[];
}

/** MultiAppDuplicationsResponse */
export interface ApiMultiAppDuplicationsResponse {
  status?: ApistatusStatus;
  app_duplications?: ApiAppDuplication[];
}

/** MultiAppResponse */
export interface ApiMultiAppResponse {
  status?: ApistatusStatus;
  apps?: ApiApp[];
}

export interface ApiMultiAuditLogEntryResponse {
  status?: ApistatusStatus;
  entries?: ApiAuditLogEntry[];
}

/** MultiBulkOperationsResponse */
export interface ApiMultiBulkOperationsResponse {
  status?: ApistatusStatus;
  bulk_operation?: ApiBulkOperation[];
}

export interface ApiMultiCloudProviderResponse {
  status?: ApistatusStatus;
  cloud_providers?: ApiCloudProvider[];
}

export interface ApiMultiCloudRegionResponse {
  status?: ApistatusStatus;
  regions?: string[];
}

/** MultiCollaborationsResponse */
export interface ApiMultiCollaborationsResponse {
  status?: ApistatusStatus;
  collaborations?: ApiCollaboration[];
}

/** MultiCollaboratorsResponse */
export interface ApiMultiCollaboratorsResponse {
  status?: ApistatusStatus;
  collaborators?: ApiCollaborator[];
  /**
   * The owner of the application.
   *
   * When listing users that have access to the application, i.e. collaborators,
   * it is often relevant to also include the application owner, so return
   * their information here for convenience.
   *
   * Note: app_owner is only returned by ListCollaborators and only if the
   * owner is a regular user, not an organization.
   */
  app_owner?: ApiUser;
}

/** Response with multiple Collectors. */
export interface ApiMultiCollectorResponse {
  status?: ApistatusStatus;
  collectors?: ApiCollector[];
}

export interface ApiMultiComputeClusterResponse {
  status?: ApistatusStatus;
  compute_clusters?: ApiComputeCluster[];
}

/** MultiConceptCountResponse */
export interface ApiMultiConceptCountResponse {
  /** The response status. */
  status?: ApistatusStatus;
  /** The returned concept counts. */
  concept_counts?: ApiConceptCount[];
}

/** MultiConceptLanguageResponse */
export interface ApiMultiConceptLanguageResponse {
  status?: ApistatusStatus;
  concept_languages?: ApiConceptLanguage[];
}

/** MultiConceptRelationResponse */
export interface ApiMultiConceptRelationResponse {
  /** The response status. */
  status?: ApistatusStatus;
  /** The returned concept relations. */
  concept_relations?: ApiConceptRelation[];
}

/** MultiConceptResponse */
export interface ApiMultiConceptResponse {
  /** The response status. */
  status?: ApistatusStatus;
  /** The returned concepts. */
  concepts?: ApiConcept[];
}

/** MultiDatasetInputResponse */
export interface ApiMultiDatasetInputResponse {
  status?: ApistatusStatus;
  dataset_inputs?: ApiDatasetInput[];
  bulk_operation?: ApiBulkOperation;
}

/** MultiDatasetResponse */
export interface ApiMultiDatasetResponse {
  status?: ApistatusStatus;
  datasets?: ApiDataset[];
}

export interface ApiMultiDatasetVersionExportResponse {
  status?: ApistatusStatus;
  exports?: ApiDatasetVersionExport[];
}

export interface ApiMultiDatasetVersionMetricsGroupResponse {
  status?: ApistatusStatus;
  dataset_version_metrics_groups?: ApiDatasetVersionMetricsGroup[];
}

export interface ApiMultiDatasetVersionResponse {
  status?: ApistatusStatus;
  dataset_versions?: ApiDatasetVersion[];
}

export interface ApiMultiDeploymentResponse {
  status?: ApistatusStatus;
  deployments?: ApiDeployment[];
}

export interface ApiMultiEvalMetricsResponse {
  status?: ApistatusStatus;
  eval_metrics?: ApiEvalMetrics[];
}

/** MultiInputAnnotationResponse */
export interface ApiMultiInputAnnotationResponse {
  status?: ApistatusStatus;
  hits?: ApiHit[];
}

/** MultiInputResponse */
export interface ApiMultiInputResponse {
  status?: ApistatusStatus;
  inputs?: ApiInput[];
  inputs_add_job?: ApiInputsAddJob;
}

/** MultiInputsAddJobResponse */
export interface ApiMultiInputsAddJobResponse {
  status?: ApistatusStatus;
  inputs_add_jobs?: ApiInputsAddJob[];
}

export interface ApiMultiInputsExtractionJobResponse {
  status?: ApistatusStatus;
  inputs_extraction_jobs?: ApiInputsExtractionJob[];
}

/** MultiInstalledModuleVersionResponse */
export interface ApiMultiInstalledModuleVersionResponse {
  status?: ApistatusStatus;
  installed_module_versions?: ApiInstalledModuleVersion[];
}

export interface ApiMultiInstanceTypeResponse {
  status?: ApistatusStatus;
  instance_types?: ApiInstanceType[];
}

/** MultiKeyResponse */
export interface ApiMultiKeyResponse {
  status?: ApistatusStatus;
  keys?: ApiKey[];
}

/** MultiKnowledgeGraphResponse */
export interface ApiMultiKnowledgeGraphResponse {
  /** The response status. */
  status?: ApistatusStatus;
  /** The returned knowledge graphs. */
  knowledge_graphs?: ApiKnowledgeGraph[];
}

/** Response with multiple label order. */
export interface ApiMultiLabelOrderResponse {
  status?: ApistatusStatus;
  label_orders?: ApiLabelOrder[];
}

export interface ApiMultiLogEntryResponse {
  status?: ApistatusStatus;
  /** Log entries. */
  log_entries?: ApiLogEntry[];
  /**
   * The page the log entries are from. If the request's page was omitted or greater than the total pages, then this is set to the last page.
   * @format int64
   */
  page?: number;
  /**
   * The number of results contained in each page.
   * @format int64
   */
  per_page?: number;
}

export interface ApiMultiModelCheckConsentResponse {
  status?: ApistatusStatus;
  check_consents?: string[];
}

export interface ApiMultiModelLanguageResponse {
  status?: ApistatusStatus;
  languages?: string[];
}

/** MultiModelReferenceResponse */
export interface ApiMultiModelReferenceResponse {
  status?: ApistatusStatus;
  model_references?: ApiModelReference[];
}

/** MultiModelResponse */
export interface ApiMultiModelResponse {
  status?: ApistatusStatus;
  models?: ApiModel[];
}

export interface ApiMultiModelToolkitResponse {
  status?: ApistatusStatus;
  toolkits?: string[];
}

/** MultiModelTypeResponse */
export interface ApiMultiModelTypeResponse {
  /** Status of the response. */
  status?: ApistatusStatus;
  /** List of ModelType objects. */
  model_types?: ApiModelType[];
  /**
   * List of model importers
   * ModelTypeField stores a field value of a configurable type.
   */
  model_importers?: ApiModelTypeField;
  /** Triton model envs that can be used for model upload */
  triton_conda_envs_info?: ApiTritonCondaEnvInfo[];
}

export interface ApiMultiModelUseCaseResponse {
  status?: ApistatusStatus;
  usecases?: string[];
}

/** MultiModelVersionInputExampleResponse */
export interface ApiMultiModelVersionInputExampleResponse {
  /** status of response */
  status?: ApistatusStatus;
  /** model input example messages */
  model_version_input_examples?: ApiModelVersionInputExample[];
}

/** MultiModelVersionResponse */
export interface ApiMultiModelVersionResponse {
  status?: ApistatusStatus;
  model_versions?: ApiModelVersion[];
}

/** MultiModuleResponse */
export interface ApiMultiModuleResponse {
  status?: ApistatusStatus;
  modules?: ApiModule[];
}

/** MultiModuleVersionResponse */
export interface ApiMultiModuleVersionResponse {
  status?: ApistatusStatus;
  module_versions?: ApiModuleVersion[];
}

export interface ApiMultiNodepoolResponse {
  status?: ApistatusStatus;
  nodepools?: ApiNodepool[];
}

/** MultiOutputResponse */
export interface ApiMultiOutputResponse {
  status?: ApistatusStatus;
  /** For each input processed during model prediction we create one output. */
  outputs?: ApiOutput[];
  /**
   * Information on where the computation is executed down to specific Deployment, Nodepool and ComputeCluster
   * ////////////////////////////////////////
   * Don't need RunnerSelector if we're opening up endpoints for deployments.
   * ////////////////////////////////////////
   * The RunnerSelector is an optional field we can provide during runtime
   * of model/workflow predictions to specify which particular runner we want to process the work.
   * This can optionally be used to select a particular nodepool and then within that nodepool
   * a particular runner.
   */
  runner_selector?: ApiRunnerSelector;
}

export interface ApiMultiPipelineStepResponse {
  status?: ApistatusStatus;
  pipeline_steps?: ApiPipelineStep[];
}

export interface ApiMultiPipelineStepVersionResponse {
  /** The status of the request */
  status?: ApistatusStatus;
  /** The pipeline step versions that were requested */
  pipeline_step_versions?: ApiPipelineStepVersion[];
}

export interface ApiMultiRunnerItemOutputResponse {
  status?: ApistatusStatus;
  runner_item_outputs?: ApiRunnerItemOutput[];
}

/** MultiRunnerItemResponse */
export interface ApiMultiRunnerItemResponse {
  status?: ApistatusStatus;
  runner_items?: ApiRunnerItem[];
}

/** MultiRunnerResponse */
export interface ApiMultiRunnerResponse {
  status?: ApistatusStatus;
  runners?: ApiRunner[];
}

/** MultiScopeDepsResponse */
export interface ApiMultiScopeDepsResponse {
  /** The status of the request. */
  status?: ApistatusStatus;
  /** scopes is a list of low-level scopes and their dependencies. */
  scope_deps?: ApiScopeDeps[];
  /**
   * endpoint_scopes is a listof all the publicly available endponts which can be
   * used as scopes as well. A call to each of those endpoint depends on a subset
   * of the above "scopes"
   */
  endpoint_deps?: ApiEndpointDeps[];
}

/** MultiScopeResponse */
export interface ApiMultiScopeResponse {
  /** The status of the request. */
  status?: ApistatusStatus;
  /** This is a list of the scopes that your key has. */
  scopes?: string[];
  /** The app that the key has access to. */
  app?: ApiApp;
  /** This is a list of endpoint permissions that your key has. */
  endpoints?: string[];
  user_feature_flags?: string;
}

/** MultiScopeRootResponse */
export interface ApiMultiScopeRootResponse {
  /** The status of the request. */
  status?: ApistatusStatus;
  /** This is a list of the scopes that your key has. */
  scopes?: string[];
  /** This is a list of endpoint permissions that your key has. */
  endpoints?: string[];
  user_feature_flags?: string;
}

/** MultiScopeUserResponse */
export interface ApiMultiScopeUserResponse {
  /** The status of the request. */
  status?: ApistatusStatus;
  /** This is a list of the scopes that your key has. */
  scopes?: string[];
  /** This is a list of endpoint permissions that your key has. */
  endpoints?: string[];
  user_feature_flags?: string;
}

/** MultiSearchResponse */
export interface ApiMultiSearchResponse {
  /** Status of whether the search was successful. */
  status?: ApistatusStatus;
  /** A unique id which uniquely identifies a search */
  id?: string;
  /** The list of search result Hits. */
  hits?: ApiHit[];
  /** The original query provided in the request. */
  query?: ApiQuery;
  /** The original Searches provided in the request. */
  searches?: ApiSearch[];
  /**
   * The counts of hits for each search, in the same order as searches.
   * Only returned if the request set only_count.
   */
  hit_counts?: ApiHitCount[];
}

/** MultiStatValueAggregateResponse */
export interface ApiMultiStatValueAggregateResponse {
  /** The response status. */
  status?: ApistatusStatus;
  /** The aggregate results for each query passedin. */
  stat_value_aggregate_results?: ApiStatValueAggregateResult[];
}

/** MultiStatValueResponse */
export interface ApiMultiStatValueResponse {
  /** The response status. */
  status?: ApistatusStatus;
  /** The returned stats values. */
  stat_values?: ApiStatValue[];
}

/** MultiStatusCodeResponse */
export interface ApiMultiStatusCodeResponse {
  status?: ApistatusStatus;
  statuses?: ApistatusStatus[];
}

export interface ApiMultiTaskAssignmentResponse {
  status?: ApistatusStatus;
  task_assignments?: ApiTaskAssignment[];
}

/** Response with multiple Tasks. */
export interface ApiMultiTaskResponse {
  status?: ApistatusStatus;
  tasks?: ApiTask[];
}

/** Estimated training time in seconds */
export interface ApiMultiTrainingTimeEstimateResponse {
  status?: ApistatusStatus;
  training_time_estimates?: string[];
}

export interface ApiMultiUploadResponse {
  status?: ApistatusStatus;
  uploads?: ApiUpload[];
}

/** MultiWorkerResponse */
export interface ApiMultiWorkerResponse {
  status?: ApistatusStatus;
  workers?: ApiWorker[];
}

export interface ApiMultiWorkflowEvaluationTemplateResponse {
  status?: ApistatusStatus;
  workflow_version_evaluation_templates?: ApiWorkflowVersionEvaluationTemplate[];
}

/** MultiWorkflowResponse */
export interface ApiMultiWorkflowResponse {
  status?: ApistatusStatus;
  workflows?: ApiWorkflow[];
}

export interface ApiMultiWorkflowVersionEvaluationResponse {
  status?: ApistatusStatus;
  workflow_version_evaluations?: ApiWorkflowVersionEvaluation[];
}

/** MultiWorkflowVersionResponse */
export interface ApiMultiWorkflowVersionResponse {
  status?: ApistatusStatus;
  workflow_versions?: ApiWorkflowVersion[];
}

/**
 * A representation of a numpy array as a proto.
 * To convert a numpy array 'ndarray' to this proto do:
 * NDArray(buffer=ndarray.tobytes(), shape=ndarray.shape, dtype=str(ndarray.dtype))
 * To convert this proto 'ndarray_proto' to a numpy array:
 * array = np.frombuffer(ndarray_proto.buffer, dtype=ndarray_proto.dtype)
 * array = array.reshape(tuple(ndarray_proto.shape))
 */
export interface ApiNDArray {
  /**
   * The bytes of data from the array from array.tobytes()
   * @format byte
   */
  buffer?: string;
  /** Simply the shape of the numpy array. array.shape. */
  shape?: number[];
  /**
   * Dtype for numpy. You can get it back from this string format using:
   * np.dtype('float32') for example.
   */
  dtype?: string;
}

/**
 * Type of nodes that are ok for instances in this pool.
 * If both spot and on-demand are provided then the runner will be able to run on either
 * with a preference for spot until they are not available.
 */
export interface ApiNodeCapacityType {
  capacity_types?: NodeCapacityTypeCapacityType[];
}

/** NodeInput represents inputs to a node of the graph. */
export interface ApiNodeInput {
  /** The id to a connected WorkflowNode which will be used as an input for current WorkflowNode. */
  node_id?: string;
}

/**
 * A nodepool is a set of nodes dedicated for a given user's compute needs.
 * This compute will typically be consumed by runners and in the future other objects
 * like UI modules may be assigned to node pools.
 */
export interface ApiNodepool {
  /** The user defined ID of the nodepool. */
  id?: string;
  /** Short description about the nodepool. */
  description?: string;
  /**
   * When the nodepool was created.
   * @format date-time
   */
  created_at?: string;
  /**
   * When the nodepool was last modified.
   * @format date-time
   */
  modified_at?: string;
  /** Which cluster this nodepool is within. */
  compute_cluster?: ApiComputeCluster;
  /**
   * Type of nodes that are ok for instances in this pool.
   * If both spot and on-demand are provided then the runner will be able to run on either
   * with a preference for spot until they are not available.
   */
  node_capacity_type?: ApiNodeCapacityType;
  instance_types?: ApiInstanceType[];
  /**
   * Minimum number of instances in this nodepool. This allows the nodepool to scale down to this
   * amount. This is the user desired minimum.
   * @format int64
   */
  min_instances?: number;
  /**
   * An upper limit on the number of instances in this nodepool. This allows the nodepool to scale
   * up to this amount. This is the user desired maximum.
   * @format int64
   */
  max_instances?: number;
  /**
   * The actual minimum number of instances. Enforced by the user's plan limits.
   * @format int64
   */
  enforced_min_instances?: number;
  /**
   * The actual maximum number of instances. Enforced by the user's plan limits.
   * @format int64
   */
  enforced_max_instances?: number;
  /**
   * The visibility field represents whether this message is privately/publicly visible.
   * To be visible to the public the App that contains it AND the User that contains the App must
   * also be publicly visible.
   */
  visibility?: ClarifaiapiVisibility;
  /**
   * To handle arbitrary json metadata:
   * https://github.com/google/protobuf/blob/master/src/google/protobuf/struct.proto
   */
  metadata?: object;
}

export interface ApiOperation {
  add_concepts?: ApiAddConcepts;
  delete_concepts?: ApiDeleteConcepts;
  add_metadata?: ApiAddMetadata;
  delete_metadata?: ApiDeleteMetadata;
  overwrite_geo?: ApiOverwriteGeo;
  delete_geo?: ApiDeleteGeo;
  delete_from_dataset?: ApiDeleteFromDataset;
  add_to_dataset?: ApiAddToDataset;
  split_into_datasets?: ApiSplitIntoDatasets;
  /** This operation takes no data (payload). */
  delete_annotations?: ClarifaiapiDeleteAnnotations;
}

export interface ApiOrchestrationSpec {
  /** Argo orchestration specification */
  argo_orchestration_spec?: ApiArgoOrchestrationSpec;
}

export interface ApiOrchestrationStatus {
  /** Status for Argo Workflow */
  argo_status?: ApiArgoOrchestrationStatus;
  /** This will help us with filtering the PipelineVersionRuns based on status */
  status?: ApistatusStatus;
}

export interface ApiOrchestrationStepSpec {
  /** Argo orchestration step template */
  argo_orchestration_step_spec?: ApiArgoOrchestrationStepSpec;
}

/** Output */
export interface ApiOutput {
  /** One of these outputs per Input */
  id?: string;
  status?: ApistatusStatus;
  /**
   * When the object was created. We follow the XXXX timestamp
   * format. We use https://www.ietf.org/rfc/rfc3339.txt format:
   * "2006-01-02T15:04:05.999999Z" so you can expect results like
   * the following from the API:
   * "2017-04-11T21:50:50.223962Z"
   * @format date-time
   */
  created_at?: string;
  /** The model that created this Output. */
  model?: ApiModel;
  /**
   * The input that was passed to the model to create this Output. For example if we have an image
   * model then it will take as input here an Input object with Image filled in.
   */
  input?: ApiInput;
  /**
   * The output data for this Output. For example if we have a concept model then the predicted
   * concepts will appear here.
   */
  data?: ApiData;
  /**
   * Number of prompt tokens as reported by the model or third-party API.
   * @format int64
   */
  prompt_tokens?: number;
  /**
   * Number of completion tokens as reported by the model or third-party API.
   * @format int64
   */
  completion_tokens?: number;
}

/**
 * OutputConfig is a collection of parameters controlling either inference or training settings for
 * the given Model. This message will be deprecated over time in favor or output_info.params and
 * train_params in OutputInfo which are cleaner and more extensible for many ModelTypes.
 */
export interface ApiOutputConfig {
  /** For custom concept model training: whether the concept predictions must sum to 1. */
  concepts_mutually_exclusive?: boolean;
  /**
   * DEPRECATED: For custom models, this is the base model to use for image embeddings.
   * Default is general model.
   */
  existing_model_id?: string;
  /** For concept model predictions: Overrides the default_language for the app in a predict call. */
  language?: string;
  /**
   * DEPRECATED: Hyper-parameters for custom training.
   * Use new hyper_params field instead.
   */
  hyper_parameters?: string;
  /**
   * For concept model predictions:  Maximum number of concepts in result. Defaults to 0 which under
   * the hood will return default of 20. We do a server side default in order to control this
   * feature in the future.
   * @format int64
   */
  max_concepts?: number;
  /**
   * For concept model predictions: Minimum value of concept's probability score in result.
   * Defaults to 0.0 which means we won't do any thresholding as all probabilities will
   * likely be > 0.0.
   * @format float
   */
  min_value?: number;
  /** For concept model predictions: Select concepts in result by name or by id */
  select_concepts?: ApiConcept[];
  /**
   * For custom concept model training: Training timeout of the model (in seconds)
   * @format int64
   */
  training_timeout?: number;
  /**
   * For model predictions on video: Sample delay for video predicting (1 frame per N milliseconds)
   * @format int64
   */
  sample_ms?: number;
  /** For custom model training: Hyperparameters for custom training */
  hyper_params?: object;
  /**
   * For custom model training: this is the base model version to use for image embeddings.
   * This has to be one of the embed models in the app workflow.
   *
   * Use input_info.base_embed_model instead.
   */
  embed_model_version_id?: string;
  /**
   * For custom model training: Use this flag to fail on missing positive examples
   * By default we fill in the missing with random examples
   */
  fail_on_missing_positive_examples?: boolean;
  /**
   * For custom model training: This is any additional metadata as a JSON object that we want
   * want to persist in the model's output config. This is a useful quick way to set fields for
   * introducing fields for new model types so we don't have to add a new proto field and DB field
   * each time. Please refer to the documentation or model implementation internally for more
   * details on what fields are supported for which models.
   * TODO(zeiler): remove this field after Portal is updated.
   */
  model_metadata?: object;
}

/**
 * OutputInfo defines some of the settings for each model version that PatchModels can effect. These
 * parameters control some of the training or inference operations that this model can do.
 * As the number of parameters continued to grow when we launched more ModelTypes we decided to move
 * to using the OutputInfo.params field which is a Struct (or JSON object if you're using
 * our JSON REST APIs). This allows each ModelType to define the set of fields, their default values
 * and description of each field so that we can display those in Portal and make the creation of
 * Model's very extensible. The OutputConfig object will eventually go away in favor of
 * output_info.params struct.
 */
export interface ApiOutputInfo {
  /** List of concepts or other output related data for the model. */
  data?: ApiData;
  /**
   * Model configuration...going away in favor of output_info.params and train_params over time.
   * TO BE DEPRECATED
   * OutputConfig is a collection of parameters controlling either inference or training settings for
   * the given Model. This message will be deprecated over time in favor or output_info.params and
   * train_params in OutputInfo which are cleaner and more extensible for many ModelTypes.
   */
  output_config?: ApiOutputConfig;
  /** For returning where to look for the Output info if not returning it. */
  message?: string;
  /**
   * Map from the api.Data field names to the underlying model graph's outputs. When using a
   * PretrainedModelConfig the values in this map need to match the Triton config.pbtxt output names.
   */
  fields_map?: object;
  /**
   * For predicting with the various ModelType's we accept a Struct (JSON object) worth of args
   * that the ModelTypeField defines. During inference, the settings contained within are sent
   * to the model predictor to alter predictions from this Model.
   */
  params?: object;
  /**
   * These allow you to specifcy addition fields that a specific model supports beyond those defined
   * in it's ModelType. This field is to be deprecated and will be replaced by MethodSignature
   * proto.
   */
  params_specs?: ApiModelTypeField[];
}

export interface ApiOverwriteGeo {
  /** Geo info */
  geo?: ApiGeo;
}

/** Split the results into pages. */
export interface ApiPagination {
  /**
   * (optional URL parameter) The page number. Pagination is used to split the results into chunks. Defaults to 1.
   * @format int64
   */
  page?: number;
  /**
   * (optional URL parameter) The number of results that will be contained in each page. Defaults to 128.
   * @format int64
   */
  per_page?: number;
}

/** A part of data used for multi-modal processing. */
export interface ApiPart {
  /** The data for this part. */
  data?: ApiData;
  /** A unique id for the part. */
  id?: string;
}

/** Password */
export interface ApiPassword {
  /** unencrypted password string */
  plaintext?: string;
}

/** PasswordViolations */
export interface ApiPasswordViolations {
  /** when new password length is shorter than minimum length set */
  minimum_length?: boolean;
  /** when new password length is longer than maximum length set */
  maximum_length?: boolean;
  /** there is no upper case letter in the new password when there should be at least one */
  upper_case_needed?: boolean;
  /** there is no lower case letter in the new password when there should be at least one */
  lower_case_needed?: boolean;
  /** there is no numerics in the new password when there should be at least one */
  numeric_needed?: boolean;
  /** there is no special character in the new password when there should be at least one */
  non_alphanumeric_needed?: boolean;
  /** when one of the N most recent old password is reused, N is specified by password_reuse_epoch in db.password_policies */
  password_reuse?: boolean;
  /** when either user's first, middle or last name is used in the new password */
  exclude_names?: boolean;
  /** when first part of user's email (exact string or after removing special characters) is used in the new password */
  exclude_email?: boolean;
  /** when there are confusing letters in the new password, such as o (first character of 'omega') vs 0 (zero) */
  no_confusing_letters?: boolean;
  /** when there are simple password patterns used, such as 12345678 or aaaaaaa1 */
  no_simple_passwords?: boolean;
  /** when there are common vocabs from the common vocab list used */
  no_common_vocabs?: boolean;
  /** when the current password is contained in the new password or vice versa */
  no_overlap_with_old?: boolean;
  /** when password has to be changed becauase it's too old */
  password_lifespan?: boolean;
}

/** PatchAction */
export interface ApiPatchAction {
  /**
   * The operation to perform on the patched metadata given a path
   * For now only operations 'overwrite', 'delete, and 'merge' is supported
   */
  op?: string;
  /**
   * If the action is 'merge' and there is a conflict, how to resolve it.
   * The options are
   * 'overwrite_by_id', 'remove_by_id', 'merge_by_id','overwrite', 'append' and 'do_nothing'
   * Note that for conflict resolutions '*_by_id' to work on a list, the list should contain
   * objects with an 'id' field which will be used to uniquely identify each field. For example
   * Patching existing json
   * {
   *   "tag": [
   *     {
   *       "id": "1",
   *       "data": 1
   *     },
   *     {
   *       "id": "2",
   *       "data": 2
   *     }
   *   ]
   * }
   * with op 'merge' and merge_conflict_resolution 'overwrite_by_id'
   * {
   *   "tag": [
   *     {
   *       "id": "2",
   *       "data": 3
   *     }
   *   ]
   * }
   * would produce
   * {
   *   "tag": [
   *     {
   *       "id": "1",
   *       "data": 1
   *     },
   *     {
   *       "id": "2",
   *       "data": 3
   *     }
   *   ]
   * }
   * while with merge_conflict_resolution 'remove_by_id' it would produce
   * {
   *   "tag": [
   *     {
   *       "id": "1",
   *       "data": 1
   *     }
   *   ]
   * }
   * Option 'append' will simply create a list on conflicts. For example in above example
   * the final result would be
   * {
   *   "tag": [
   *     {
   *       "id": "1",
   *       "data": 1
   *     },
   *     {
   *       "id": "2",
   *       "data": [2, 3]
   *     }
   *   ]
   * }
   */
  merge_conflict_resolution?: string;
  /**
   * Path for the change. For example 'tag[1].data' is a valid path in above example.
   * Default path is root level i.e. ''.
   */
  path?: string;
}

/** Request to patch several annotation filters. */
export interface ApiPatchAnnotationFiltersRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  /** List of annotation filters that are requested to be updated. */
  annotation_filters?: ApiAnnotationFilter[];
  /**
   * The action to perform on the patched objects
   * For now, only 'overwrite' action is supported
   */
  action?: string;
}

/** PatchAnnotationsRequest */
export interface ApiPatchAnnotationsRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  annotations?: ClarifaiapiAnnotation[];
  /**
   * The action to perform on the patched objects
   * For now actions 'merge', 'overwrite', and 'remove' are supported
   */
  action?: string;
  /**
   * If the request is a "remove" action and the annotation is left with empty data,
   * then setting delete_if_empty_data to true will delete the annotation,
   * if possible (for example, will not delete an input-level annotation).
   */
  delete_if_empty_data?: boolean;
}

export interface ApiPatchAnnotationsSearchesRequest {
  /** The user_id and app_id to query from. */
  user_app_id?: ApiUserAppIDSet;
  /** The searches to be patched */
  searches?: ApiSearch[];
  /**
   * The action to perform on the patched Search objects
   * For now only action 'overwrite' is supported
   */
  action?: string;
}

/** PatchAnnotationsStatusResponse */
export interface ApiPatchAnnotationsStatusResponse {
  status?: ApistatusStatus;
  user_ids?: string[];
  /** @format int64 */
  updated_count?: number;
}

/** PatchCollectorsRequest */
export interface ApiPatchCollectorsRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  collectors?: ApiCollector[];
  /**
   * The action to perform on the patched objects
   * Only 'overwrite' is supported
   */
  action?: string;
}

/** PatchConceptsRequest */
export interface ApiPatchConceptsRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  /** The concepts to patch. */
  concepts?: ApiConcept[];
  /**
   * The action to perform on the patched objects
   * For now ony action 'overwrite' is supported
   */
  action?: string;
}

/** Request to patch several datasets. */
export interface ApiPatchDatasetsRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  /** List of datasets that are requested to be updated. */
  datasets?: ApiDataset[];
  /**
   * The action to perform on the patched objects
   * Supported values: 'overwrite', 'merge', and 'remove'.
   *
   * Note that 'remove' can only be used to remove the dataset image by setting
   * 'image.url' in the request to the current value returned for that dataset.
   */
  action?: string;
}

/** PatchInputsRequest */
export interface ApiPatchInputsRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  /**
   * List of inputs to patch.
   * Inputs are identified by id field.
   * For each input, the following fields are patchable:
   * * data
   */
  inputs?: ApiInput[];
  /**
   * The action to perform on the patched objects
   * For now actions 'merge', 'overwrite', and 'remove' are supported
   */
  action?: string;
}

export interface ApiPatchInputsSearchesRequest {
  /** The user_id and app_id to query from. */
  user_app_id?: ApiUserAppIDSet;
  /** The searches to be patched */
  searches?: ApiSearch[];
  /**
   * The action to perform on the patched Search objects
   * For now only action 'overwrite' is supported
   */
  action?: string;
}

/** Request to patch a list of label orders. */
export interface ApiPatchLabelOrdersRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  label_orders?: ApiLabelOrder[];
  /**
   * The action to perform on the patched objects
   * For now actions 'merge', 'overwrite', and 'remove' are supported
   */
  action?: string;
}

/** PatchModelsRequest */
export interface ApiPatchModelsRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  models?: ApiModel[];
  /**
   * The action to perform on the patched objects
   * For now actions 'merge', 'overwrite', and 'remove' are supported
   * Note that 'remove' can be used to remove the model image by setting
   * 'image.url' in the request to the current value returned for that model.
   * This cannot be used in a request that is patching other fields as well.
   */
  action?: string;
}

/** PatchSearchesRequest */
export interface ApiPatchSearchesRequest {
  /** The user_id and app_id to query from. */
  user_app_id?: ApiUserAppIDSet;
  /** The searches to be patched */
  searches?: ApiSearch[];
  /**
   * The action to perform on the patched Search objects
   * For now only action 'overwrite' is supported
   */
  action?: string;
}

/** Request to patch a list of tasks. */
export interface ApiPatchTasksRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  tasks?: ApiTask[];
  /**
   * The action to perform on the patched objects
   * For now, only 'overwrite' action is supported
   */
  action?: string;
}

/** PatchWorkflowsRequest */
export interface ApiPatchWorkflowsRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  workflows?: ApiWorkflow[];
  /**
   * The action to perform on the patched objects
   * For now actions 'merge', 'overwrite', and 'remove' are supported
   * Note that 'remove' can be used to remove the workflow image by setting
   * 'image.url' in the request to the current value returned for that workflow.
   * This cannot be used in a request that is patching other fields as well.
   */
  action?: string;
}

export interface ApiPipelineStep {
  /** The ID of the pipeline step. */
  id?: string;
  /** The user the pipeline step belongs to */
  user_id?: string;
  /** Description of the pipeline step */
  description?: string;
  /** Latest Pipeline Step Version */
  pipeline_step_version?: ApiPipelineStepVersion;
  /**
   * The visibility field represents whether this is privately/publicly visible.
   * To be visible to the public the App that contains it AND the User that contains the App must
   * also be publicly visible.
   */
  visibility?: ClarifaiapiVisibility;
  /**
   * When the pipeline step was created
   * @format date-time
   */
  created_at?: string;
  /**
   * When the pipeline step was last modified
   * @format date-time
   */
  modified_at?: string;
}

export interface ApiPipelineStepInputParam {
  /** The name of the input parameter. */
  name?: string;
  /** The default value of the input parameter. */
  default_value?: string;
  /** The description of the input parameter. */
  description?: string;
  /** The accepted values for the input parameter. */
  accepted_values?: string[];
}

export interface ApiPipelineStepVersion {
  /** The ID of the pipeline step version. */
  id?: string;
  /** The user the pipeline step version belongs to */
  user_id?: string;
  /** The app the pipeline step version belongs to */
  app_id?: string;
  /** Description of the pipeline step version */
  description?: string;
  /** Pipeline Step */
  pipeline_step?: ApiPipelineStep;
  /** Orchestration Step Specification using oneof */
  orchestration_step_spec?: ApiOrchestrationStepSpec;
  /** The pipeline step version input parameters */
  pipeline_step_input_params?: ApiPipelineStepInputParam[];
  /** Pipeline step Status - Created, Building Artifacts, Completed, Failed */
  status?: ApistatusStatus;
  /**
   * The minimum required compute resource to run the pipeline step as part of a Pipeline
   * These are the resource needs of a given API object such as a model.
   * This is what they require as a minimum to run and will be used upon scheduling
   * as the request and limit for the k8s pod. If we want to separate limits and requests in the
   * future we can allow setting a limits ComputeInfo and a requests ComputeInfo.
   */
  pipeline_step_compute_info?: ApiComputeInfo;
  /** Build information for the pipeline step */
  build_info?: ApiBuildInfo;
  /**
   * The visibility field represents whether this is privately/publicly visible.
   * To be visible to the public the App that contains it AND the User that contains the App must
   * also be publicly visible.
   */
  visibility?: ClarifaiapiVisibility;
  /**
   * When the pipeline step was created
   * @format date-time
   */
  created_at?: string;
  /**
   * When the pipeline step was last modified
   * @format date-time
   */
  modified_at?: string;
}

export interface ApiPipelineVersion {
  id?: string;
  /** The app the pipeline version belongs to. */
  app_id?: string;
  /** The user the pipeline version belongs to. */
  user_id?: string;
  /** Orchestration Specification using oneof */
  orchestration_spec?: ApiOrchestrationSpec;
  /** Pipeline's Id */
  pipeline_id?: string;
  /** Short description about this pipeline version */
  description?: string;
  /**
   * The visibility field represents whether this message is privately/publicly visible.
   * To be visible to the public the App that contains it AND the User that contains the App must
   * also be publicly visible.
   */
  visibility?: ClarifaiapiVisibility;
  /**
   * To handle arbitrary json metadata, use a struct field
   * https://github.com/google/protobuf/blob/master/src/google/protobuf/struct.proto
   */
  metadata?: object;
  /**
   * When the pipeline was created
   * @format date-time
   */
  created_at?: string;
  /**
   * When the pipeline was last modified
   * @format date-time
   */
  modified_at?: string;
}

export interface ApiPipelineVersionRun {
  id?: string;
  /** Pipeline Version associated with this run */
  pipeline_version?: ApiPipelineVersion;
  /** Nodepool(s) used for the Pipeline Version Run */
  nodepools?: ApiNodepool[];
  /** Orchestration Status for this run, supporting multiple orchestration systems */
  orchestration_status?: ApiOrchestrationStatus;
  /** The user the pipeline belongs to */
  user_id?: string;
  /** The app the pipeline belongs to */
  app_id?: string;
}

/** Point */
export interface ApiPoint {
  /**
   * The row location of the point. This has a [0.0-1.0] range with 0.0 being top row and 1.0
   * being the bottom row.
   * @format float
   */
  row?: number;
  /**
   * The column location of the point. This has a [0.0-1.0] range with 0.0 being left col and 1.0
   * being the right col.
   * @format float
   */
  col?: number;
  /**
   * Depth if applicable for the point.
   * @format float
   */
  z?: number;
  /**
   * - NOT_SET: Visibility of the point is not set
   *  - VISIBLE: Point is visible
   *  - NOT_VISIBLE: Point is occluded
   *  - NOT_PRESENT: Point is not in the image
   */
  visibility?: ApiPointVisibility;
}

/**
 * Whether this point is visible or occluded
 * - NOT_SET: Visibility of the point is not set
 *  - VISIBLE: Point is visible
 *  - NOT_VISIBLE: Point is occluded
 *  - NOT_PRESENT: Point is not in the image
 * @default "NOT_SET"
 */
export enum ApiPointVisibility {
  NOT_SET = 'NOT_SET',
  VISIBLE = 'VISIBLE',
  NOT_VISIBLE = 'NOT_VISIBLE',
  NOT_PRESENT = 'NOT_PRESENT',
}

/** Polygon */
export interface ApiPolygon {
  /** A list of points connected together to form the polygon. */
  points?: ApiPoint[];
}

/** Request to add one or more annotation filters. */
export interface ApiPostAnnotationFiltersRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  /** List of annotation filters that are requested to be added. */
  annotation_filters?: ApiAnnotationFilter[];
}

/** PostAnnotationSearchMetricsRequest */
export interface ApiPostAnnotationSearchMetricsRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  /** A unique customer facing id to identify this eval request */
  id?: string;
  /**
   * The ground truth we are evaluating against
   * This is the new Search object used in saved searches.
   */
  ground_truth?: ApiSearch;
  /**
   * The set we are evaluating
   * This is the new Search object used in saved searches.
   */
  search_to_eval?: ApiSearch;
  /**
   * List of concepts to evaluate are expected to be in data.concepts
   * If nil, then all app concepts are used
   */
  data?: ApiData;
  /** The type of evaluation to use */
  evaluation_type?: ApiEvaluationType;
}

/** PostAnnotationsRequest */
export interface ApiPostAnnotationsRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  annotations?: ClarifaiapiAnnotation[];
}

/**
 * Execute a new annotation search and optionally save it
 * annotation search over annotations using rank and filter proto
 */
export interface ApiPostAnnotationsSearchesRequest {
  /** The user_id and app_id to query from. */
  user_app_id?: ApiUserAppIDSet;
  /** The searched to be executed or saved */
  searches?: ApiSearch[];
  /** Pagination information to paginate through search result Hits. */
  pagination?: ApiPagination;
}

/** Request to perform bulk operations on a list of inputs based on input source. */
export interface ApiPostBulkOperationsRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  /** List of bulk operation(s) to be performed e.g bulk update metadata or tags or labels etc. */
  bulk_operations?: ApiBulkOperation[];
}

/** Request to create Collectors. */
export interface ApiPostCollectorsRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  collectors?: ApiCollector[];
}

export interface ApiPostComputePlaneMetricsRequest {
  /** List of ComputePlaneMetrics. */
  compute_plane_metrics?: ApiComputePlaneMetrics[];
}

/** PostConceptsRequest */
export interface ApiPostConceptsRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  /** The concepts to add. */
  concepts?: ApiConcept[];
}

/** PostConceptsSearchesRequest */
export interface ApiPostConceptsSearchesRequest {
  /** Ids present in the url of the request. */
  user_app_id?: ApiUserAppIDSet;
  /** The body of the request. */
  concept_query?: ApiConceptQuery;
  /** Request additional info to be retrieved for each concept in the response. */
  extra_info?: ApiConceptExtraInfoRequest;
  /**
   * Pagination parameters here since there are no url args in this
   * POST request.
   */
  pagination?: ApiPagination;
}

/** Request to add one or more datasets. */
export interface ApiPostDatasetsRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  /** List of datasets that are requested to be added. */
  datasets?: ApiDataset[];
}

/** Evaluate this model vesion */
export interface ApiPostEvaluationsRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  /**
   * eval_info, id, model, and ground_truth_dataset will be used when creating the evaluation
   * If no dataset is provided, all app data that is annotated with concepts from the model will be used.
   */
  eval_metrics?: ApiEvalMetrics[];
}

/**
 * Initiates retrieval of inputs from cloud storage from a user provided data source.
 * Will create and return an inputs-add-job for tracking progress.
 * Archives will be extracted and their contents will be processed as inputs.
 *
 * The cloud URL will be treated as a filter prefix. For example s3:/bucket/images_folder/abc will process
 * files in the images_folder beginning with abc or in a subfolder beginning with abc.
 * For example:
 * bucket/images_folder/abcImage.png
 * bucket/images_folder/abc-1/Data.zip
 *
 * If given URL is for a private bucket or file, then credentials should be provided to access the bucket.
 * Credentials should include rights to list the objects in the bucket, except when pointed directly at a file archive,
 * in which case it only requires rights to access that particular file.
 */
export interface ApiPostInputsDataSourcesRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  data_sources?: ApiInputsDataSource[];
  /** If call back url is set, we will send a Post request to this endpoint with job status. */
  call_back_url?: string;
  /**
   * Personal Access Token to the application to which inputs are added
   * Deprecated: No need to send app_pat, it will be generated internally if not present
   */
  app_pat?: string;
}

/** PostInputsRequest */
export interface ApiPostInputsRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  /**
   * List of inputs to post.
   * For each input, the following fields are used:
   * * id
   * * data
   * * dataset_ids
   */
  inputs?: ApiInput[];
  /**
   * Collect statistics about created inputs in job with given ID.
   * * If job ID is empty, then job is not created.
   * * If job ID is non-empty and doesn't already exist, then a new job will be created with given ID.
   * * If job ID does already exist, then new inputs statistics are merged with previous inputs statistics.
   */
  inputs_add_job_id?: string;
  /** How to handle input ID conflicts. */
  input_id_conflict_resolution?: ApiInputIDConflictResolution;
}

/** Execute a new input search and optionally save it */
export interface ApiPostInputsSearchesRequest {
  /** The user_id and app_id to query from. */
  user_app_id?: ApiUserAppIDSet;
  /** The searched to be executed or saved */
  searches?: ApiSearch[];
  /** Pagination information to paginate through search result Hits. */
  pagination?: ApiPagination;
  /**
   * If only_count is set, then the response will not contain hits,
   * but hit_counts instead.
   */
  only_count?: boolean;
}

/**
 * Start uploading a file archive containing inputs.
 * Will create and return an inputs-add-job for tracking progress.
 *
 * Associated inputs-add-job contains an upload id which should be completed through `PutUploadContentParts` endpoint.
 * Completing the upload will automatically begin unpacking the archive and uploading the contents as inputs.
 */
export interface ApiPostInputsUploadsRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  inputs_uploads?: ApiInputsUpload[];
}

/** POST new knowledge graphs */
export interface ApiPostKnowledgeGraphsRequest {
  /** The user_id and app_id information. */
  user_app_id?: ApiUserAppIDSet;
  knowledge_graphs?: ApiKnowledgeGraph[];
}

/** Request to create label orders. */
export interface ApiPostLabelOrdersRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  label_orders?: ApiLabelOrder[];
}

export interface ApiPostLogEntriesRequest {
  /** List of log entries to be stored. */
  log_entries?: ApiLogEntry[];
}

/**
 * //////////////////////////////////////////////////
 * Model prediction related stuff needs inputs and produces outputs.
 * //////////////////////////////////////////////////
 * Model prediction.
 */
export interface ApiPostModelOutputsRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  model_id?: string;
  version_id?: string;
  inputs?: ApiInput[];
  /**
   * This allows you to specify config options for the model such as
   * the language which appear's in the model's output_info.
   */
  model?: ApiModel;
  /**
   * Allow filtering of prediction requests down to specific Nodepools, Deployments or Runners
   * ////////////////////////////////////////
   * Don't need RunnerSelector if we're opening up endpoints for deployments.
   * ////////////////////////////////////////
   * The RunnerSelector is an optional field we can provide during runtime
   * of model/workflow predictions to specify which particular runner we want to process the work.
   * This can optionally be used to select a particular nodepool and then within that nodepool
   * a particular runner.
   */
  runner_selector?: ApiRunnerSelector;
  /** Configure the prediction cache to avoid expensive compute for predict requests */
  use_predict_cache?: boolean;
  /** Configuration to provide logs summarization when request errors out */
  enable_log_summary_on_error?: boolean;
}

export interface ApiPostModelVersionsUploadConfig {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  /** Model to create version for */
  model_id?: string;
  /** Specification for the model version to be uploaded */
  model_version?: ApiModelVersion;
  /**
   * Number of bytes in the model files to be uploaded
   * @format uint64
   */
  total_size?: string;
  /** Whether the uploaded package will be a .tar.gz which contains a Dockerfile or the standard .zip */
  is_v3?: boolean;
  /**
   * Number of bytes requested for the build process.
   * @format uint64
   */
  storage_request_size?: string;
}

export interface ApiPostModelVersionsUploadRequest {
  upload_config?: ApiPostModelVersionsUploadConfig;
  content_part?: ApiUploadContentPart;
}

export interface ApiPostModelVersionsUploadResponse {
  status?: ApistatusStatus;
  /** @format uint64 */
  bytes_remaining?: string;
  /** ID of the model version being uploaded */
  model_version_id?: string;
}

/** PostModelsRequest */
export interface ApiPostModelsRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  /**
   * NOTE: inconsistent since "model" is not plural, please use "models" below.
   * Previously you could only create one model at a time.
   * We still support this but you should pass it as models=[model] so
   * that this endpoint is consistent with the rest of our API.
   */
  model?: ApiModel;
  /** This allows you to create one or more model by posting it to the API. */
  models?: ApiModel[];
}

/** Search over the available models. */
export interface ApiPostModelsSearchesRequest {
  /** Ids present in the url of the request. */
  user_app_id?: ApiUserAppIDSet;
  /** The body of the request. */
  model_query?: ApiModelQuery;
  /**
   * Pagination parameters here since there are no url args in this
   * POST request.
   */
  pagination?: ApiPagination;
}

export interface ApiPostPipelineStepVersionsUploadConfig {
  /**
   * User ID and App ID of the user uploading the pipeline step
   * Common message to identify the app in a url endpoint.
   */
  user_app_id?: ApiUserAppIDSet;
  /** Pipeline Step to create version for */
  pipeline_step_id?: string;
  /** Specification for the pipeline step version to be uploaded */
  pipeline_step_version?: ApiPipelineStepVersion;
  /**
   * Number of bytes in the pipeline step files to be uploaded
   * @format uint64
   */
  total_size?: string;
  /**
   * Number of bytes requested for the build process.
   * @format uint64
   */
  storage_request_size?: string;
}

export interface ApiPostPipelineStepVersionsUploadRequest {
  /** Upload a new pipeline step version. */
  upload_config?: ApiPostPipelineStepVersionsUploadConfig;
  /** Upload a part of a multipart upload. */
  content_part?: ApiUploadContentPart;
}

export interface ApiPostPipelineStepVersionsUploadResponse {
  /** Status of the upload */
  status?: ApistatusStatus;
  /**
   * Bytes remaining to be uploaded - This is total_size - bytes_uploaded
   * @format uint64
   */
  bytes_remaining?: string;
  /** ID of the pipeline step version being uploaded */
  pipeline_step_version_id?: string;
}

/**
 * PostRunnerItemOutputsRequest
 * This is the message that runners send to the API to communicate.
 * At the end of the request it will have the RunnerItemOutput filled in
 * with results of the workload the runner is processing. Other messages
 * from the runner use this same proto to communicate over to the API
 * and do handshakes.
 */
export interface ApiPostRunnerItemOutputsRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  /** The particular nodepool that runner belongs to */
  nodepool_id?: string;
  /** The particular runner that processed the work. */
  runner_id?: string;
  /** The particular item of work processed. */
  runner_item_id?: string;
  /** This allows you to create one or more runner by posting it to the API. */
  runner_item_outputs?: ApiRunnerItemOutput[];
  /**
   * This request has a status so that it can communicate to the API from runners and
   * communicate status, errors, etc. This is on the request since runners operate
   * in a reverse protocol. This status is also used to initiate the
   * ProcessRunnerItems request with RUNNER_STREAM_START code.
   */
  status?: ApistatusStatus;
  /**
   * A unique ID to represent the runner. This may be tied to an underlying compute instance
   * information or just an UUID.
   */
  runner_replica_id?: string;
  compute_cluster_id?: string;
  /** Used by agent runners to specify their cloud provider. */
  cloud_provider_id?: string;
  /** Used by agent runners to specify their region. */
  region?: string;
}

/** PostSearchesRequest */
export interface ApiPostSearchesRequest {
  /** The user_id and app_id to query from. */
  user_app_id?: ApiUserAppIDSet;
  /**
   * The query; this specifies how the data to be searched
   * this will be replaced by "Searches"
   * This is the search query used in /searches, model training requests, bulk data exports, etc.
   */
  query?: ApiQuery;
  /**
   * The searched to be executed or saved
   * Eventually the request level fields will be deprecated in favor of this object
   */
  searches?: ApiSearch[];
  /** Pagination information to paginate through search result Hits. */
  pagination?: ApiPagination;
}

/** PostStatValuesAggregateRequest */
export interface ApiPostStatValuesAggregateRequest {
  /** Ids present in the url of the request. */
  user_app_id?: ApiUserAppIDSet;
  /** Query to retrieve aggregate values. */
  stat_value_aggregate_queries?: ApiStatValueAggregateQuery[];
}

/** PostStatValuesRequest */
export interface ApiPostStatValuesRequest {
  /** The user and app information for the request. */
  user_app_id?: ApiUserAppIDSet;
  /** The stats to post, can post more than one at a time. */
  stat_values?: ApiStatValue[];
}

/** Request to create Tasks. */
export interface ApiPostTasksRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  tasks?: ApiTask[];
}

/** Start a multipart upload */
export interface ApiPostUploadsRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  uploads?: ApiUpload[];
}

/** PostValidatePasswordRequest */
export interface ApiPostValidatePasswordRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  /** password to be validated */
  password?: ApiPassword;
}

/** PostWorkflowResultsResponse */
export interface ApiPostWorkflowResultsResponse {
  /** The status of the request. */
  status?: ApistatusStatus;
  /** The workflow that was used in predictions with PostWorkflowResults */
  workflow?: ApiWorkflow;
  /** The resulting predictions of all models in the workflow. */
  results?: ApiWorkflowResult[];
  /**
   * A workflow state to be maintained across PostWorkflowResults requests/responses.
   * This WorkflowState should be passed in to subsequent PostWorkflowResults calls
   * if you want to keep track of state across requests.
   * If no WorkflowState was initialized in a request then no WorkflowState will be returned in this
   * response.
   */
  workflow_state?: ApiWorkflowState;
}

/** PostWorkflowsRequest */
export interface ApiPostWorkflowsRequest {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: ApiUserAppIDSet;
  workflows?: ApiWorkflow[];
}

/** PrecisionRecallCurve */
export interface ApiPrecisionRecallCurve {
  recall?: number[];
  precision?: number[];
  thresholds?: number[];
}

/** PretrainedModelConfig */
export interface ApiPretrainedModelConfig {
  /**
   * This is the internal id of the pretrained model.
   * Map from the api.Data field names to the Triton config.pbtxt input.
   */
  input_fields_map?: object;
  /** Map from the api.Data field names to the Triton config.pbtxt output. */
  output_fields_map?: object;
  /**
   * Url to a zipped up model in triton format with the following files and folders at the root:
   *  config.pbtxt
   *  version 1 folder that contains model files (onnx graph, torch script, python BE model, and etc.)
   */
  model_zip_url?: string;
  /**
   * Whether to overwrite the model for the existing internal id
   * If this is a local dev model that runs external to the platform, set this to true.
   * This helps during development of models before uploading them to the platform.
   * These models MUST run in an associated compute cluster with cluster_type = "local-dev"
   */
  local_dev?: boolean;
}

/** Processing info tells the runner how to process a RunnerItem */
export interface ApiProcessingInfo {
  /** The type of method witin the runner to call. */
  runner_method_type?: ApiRunnerMethodType;
  /**
   * A status of the processing. We use this for signalling end of a request stream, a runner
   * item's processing should be cancelled, etc.
   */
  status?: ApistatusStatus;
  /** Internal field to track processing. Runners will not have access to this. */
  processing_id?: string;
}

export interface ApiProgress {
  /** @format int64 */
  processed?: number;
  last_processed_id?: string;
}

/**
 * - LABEL_START: Create a list of task assignments for labeler => 10 inputs are assigned to the labeler.
 * This is a fully sync action.
 * If task assignments already exist, then return existing task assignments.
 *  - LABEL_SUBMIT: Submit task assignments => mark task assignment work as completed.
 * This is a partially sync action.
 * Sync: task assignments are updated as follows:
 * * when review_strategy is NONE, then task assignment status is updated to SUCCESS.
 * * when review strategy is CONSENSUS, then task assignment status is updated to AWAITING_CONSENSUS_REVIEW.
 * * when review strategy is MANUAL, then task assignment status is updated to AWAITING_REVIEW.
 * If task assignments are already submitted, then no update is performed on them.
 * Async: annotations added for the same input as the task assignment are updated as follows:
 * * when review_strategy is NONE, then annotation status is updated to SUCCESS.
 * * when review strategy is CONSENSUS, then annotation status is updated to SUCCESS (if it reaches consensus) or AWAITING_REVIEW (if it does not reach consensus).
 * * when review strategy is MANUAL, then annotation status is updated to AWAITING_REVIEW.
 *  - REVIEW_START: Assign task assignments for reviewer to review => 10 task assignments are assigned to the reviewer.
 * This is a fully sync action.
 * If task assignments are already assigned for review, then return existing task assignments.
 *  - REVIEW_APPROVE: Approve task assignments.
 * There are two types of configurations:
 * * Batch approve: approve a list of task assignment IDs;
 * * Bulk approve: approve all task assignments from a list of workers.
 * This is a partially sync action.
 * Sync: task assignments are updated to SUCCESS
 * Async: annotations added for the same input as the task assignment are updated to SUCCESS
 *  - REVIEW_REQUEST_CHANGES: Request changes for task assignments.
 * There are two types of configurations:
 * * Batch request changes: request changes for a list of task assignment IDs;
 * * Bulk request changes: request changes for all task assignments from a list of workers.
 * This is a partially sync action.
 * Sync: task assignments are updated to PENDING
 * Async: annotations added for the same input as the task assignment are updated to PENDING
 *  - REVIEW_REJECT: Reject task assignments.
 * There are two types of configurations:
 * * Batch reject: reject a list of task assignment IDs;
 * * Bulk reject: reject all task assignments from a list of workers.
 * This is a partially sync action.
 * Sync: task assignments are updated to REVIEW_DENIED
 * Async: annotations added for the same input as the task assignment are updated to REVIEW_DENIED
 * @default "PUT_TASK_ASSIGNMENTS_REQUEST_ACTION_NOT_SET"
 */
export enum ApiPutTaskAssignmentsRequestAction {
  PUT_TASK_ASSIGNMENTS_REQUEST_ACTION_NOT_SET = 'PUT_TASK_ASSIGNMENTS_REQUEST_ACTION_NOT_SET',
  LABEL_START = 'LABEL_START',
  LABEL_SUBMIT = 'LABEL_SUBMIT',
  REVIEW_START = 'REVIEW_START',
  REVIEW_APPROVE = 'REVIEW_APPROVE',
  REVIEW_REQUEST_CHANGES = 'REVIEW_REQUEST_CHANGES',
  REVIEW_REJECT = 'REVIEW_REJECT',
}

/** This is the search query used in /searches, model training requests, bulk data exports, etc. */
export interface ApiQuery {
  /**
   * The query syntax is simply a list of And operatiosn that will be ANDed together to fetch
   * results which are returned to the user as Hit messages.
   *
   * Deprecated: Only used by the deprecated PostSearches endpoint. Use filters
   * and ranks instead with PostInputsSearches or PostAnnotationsSearches.
   */
  ands?: ApiAnd[];
  /**
   * This allows the query to override any default language the app was setup in when doing Concept
   * based searches. This currently only affects public Models Output searches when those public
   * Models have translations for their Concepts.
   */
  language?: string;
  /**
   * filters in this query
   * e.q. only fetch annotations that have certain metadata
   */
  filters?: ApiFilter[];
  /**
   * rankings in this query
   * e.g. visual search by a url
   */
  ranks?: ApiRank[];
}

/** ROC */
export interface ApiROC {
  fpr?: number[];
  tpr?: number[];
  thresholds?: number[];
  fpr_per_image?: number[];
  fpr_per_object?: number[];
}

/** Rank */
export interface ApiRank {
  /**
   * If True then this will flip the meaning of this part of the
   * query. This allow for queries such as !dog
   */
  negate?: boolean;
  /**
   * RANK by annotation information.
   * ########## Supported fields ##########
   *  - data.concepts[].id
   *  - data.concepts[].name
   *  - data.concepts[].value
   *  - data.embeddings[].num_dimensions
   *  - data.embeddings[].vector[]
   *  - data.image.base64[]
   *  - data.image.url
   *  - data.text.raw
   *  - input_id
   *  - model_version_id
   */
  annotation?: ClarifaiapiAnnotation;
}

/** A region within the data. */
export interface ApiRegion {
  /** A unique id for the region. */
  id?: string;
  /** The details about the location of the region. */
  region_info?: ApiRegionInfo;
  /**
   * A recursive definition of the data within the Region. For example, this will contain
   * data.concepts if the region also has annotations or predictions of concepts within it.
   */
  data?: ApiData;
  /**
   * This is the confidence score of the overall Region.
   * @format float
   */
  value?: number;
  /** For tracking algorithsm and annotations we tie regions together with this track id. */
  track_id?: string;
}

/** The information of the location of the Region. */
export interface ApiRegionInfo {
  /** Details of the region's rectangular bounding box. */
  bounding_box?: ApiBoundingBox;
  /** Details of the region's segmentation mask. */
  mask?: ApiMask;
  /** A polygon of points. */
  polygon?: ApiPolygon;
  /** A landmark point location. */
  point?: ApiPoint;
  /** Span char sequence for NLP. */
  span?: ApiSpan;
  /** Token char sequence for NLP. */
  token?: ApiToken;
  /**
   * The locations of detected keypoints, which are to be used in conjunction with the detected concept's skeleton to connect the keypoint locations.
   * These will be in the same order as the respective keypoint_names inside the concept.
   */
  keypoint_locations?: ApiPoint[];
}

export interface ApiReviewApproveConfig {
  task_assignments?: ApiTaskAssignment[];
  workers?: ApiWorker[];
}

export interface ApiReviewRejectConfig {
  task_assignments?: ApiTaskAssignment[];
  workers?: ApiWorker[];
}

export interface ApiReviewRequestChangesConfig {
  task_assignments?: ApiTaskAssignment[];
  workers?: ApiWorker[];
}

export interface ApiReviewStartConfig {
  /**
   * Review the work done by these workers.
   * If empty, review the work for all workers.
   */
  workers?: ApiWorker[];
}

/** Role represents a list of permissions */
export interface ApiRole {
  id?: string;
  /**
   * When the role was created.
   * The format is https://www.ietf.org/rfc/rfc3339.txt.
   * Example: "2006-01-02T15:04:05.999999Z".
   * @format date-time
   */
  created_at?: string;
  /**
   * Most recent time when the role was updated.
   * The format is https://www.ietf.org/rfc/rfc3339.txt.
   * Example: "2006-01-02T15:04:05.999999Z".
   * @format date-time
   */
  modified_at?: string;
  name?: string;
  description?: string;
  /** The low-level scopes this role has */
  scopes?: string[];
  /** The endpoint-level scopes this role has */
  endpoints?: string[];
  /** Type of the role 'team' or 'org' */
  type?: ApiRoleType;
}

/** @default "TEAM" */
export enum ApiRoleType {
  TEAM = 'TEAM',
  ORG = 'ORG',
}

/**
 * A worker for compute within a nodepool of instances.
 * This asks the API for work
 */
export interface ApiRunner {
  /**
   * A unique ID for this runner.
   * This is a UUID since runners can be automatically orchestrated.
   */
  id?: string;
  /** short description about the runner. */
  description?: string;
  /**
   * When the runner was created.
   * @format date-time
   */
  created_at?: string;
  /**
   * When the runner was last modified.
   * @format date-time
   */
  modified_at?: string;
  /**
   * To handle arbitrary json metadata you can use a struct field:
   * https://github.com/google/protobuf/blob/master/src/google/protobuf/struct.proto
   * This is an optional arg.
   */
  metadata?: object;
  /** Labels to match in order to find work. */
  labels?: string[];
  /**
   * Instead of just matching on labels we might want to have more explicit matching of what
   * work this runner is looking for.
   * The thing that the autoscaling config applies to for this nodepool.
   */
  worker?: ApiWorker;
  /**
   * Runners are defined within nodepools so this field needs the id and user_id of the nodepool
   * to be provided when creating a Runner.
   * This nodepool must be accessible to you or an org you are part of.
   */
  nodepool?: ApiNodepool;
  /**
   * //////////////////////////
   * Need resources on the runner so we can schedule this Runner into the Nodepool.
   * If this runner is being orchestrated for a model then the orchestrator will set this to the
   * model resource requirements. If a workflow then it'll compute those requirements and set
   * populate this resource field.
   * Having this on the underlying object like Model and Workflow allows us to represent the minimum
   * requirements on those object, which may be less than what the Runner allocates (as a safety
   * margin for the runner to for sure run the resource).
   */
  compute_info?: ApiComputeInfo;
  /**
   * Number of replicas that this runner should have up.
   * We keep it separate from ComputeInfo which defines how many resources each replica needs.
   * @format int64
   */
  num_replicas?: number;
}

/**
 * This is a unit of work for a runner to process. This comes from the API
 * in the MultiRunnerItemResponse and contains the user's requests
 * to process.
 */
export interface ApiRunnerItem {
  /** A UUID hash for this work item. */
  id?: string;
  /** A description of the work to be done in case needed for UIs. */
  description?: string;
  /** Information on how to process the given RunnerItem. */
  processing_info?: ApiProcessingInfo;
  /** Model prediction request from a user. */
  post_model_outputs_request?: ApiPostModelOutputsRequest;
  /**
   * Agent sync request from control plane.
   *
   * Workflow request from a user.  // FUTURE
   *  training request next, etc.
   */
  sync_state_request?: ApiSyncStateRequest;
}

/**
 * This contains the response of the user's request once processing is done.
 * The runner should fill in the matching output to the RunnerItem.request
 * oneof field. This is sent to the API within PostRunnerItemOutputsRequest
 */
export interface ApiRunnerItemOutput {
  /**
   * The output of a model prediction request.
   *
   * Workflow response. // FUTURE
   *  training response ???
   */
  multi_output_response?: ApiMultiOutputResponse;
}

/**
 * - UNARY_UNARY: single request, single response. predict() in code
 *  - UNARY_STREAMING: single request, streamed response. generate() in code
 *  - STREAMING_UNARY: stream of requests, single response.
 *  - STREAMING_STREAMING: stream of requests, stream of responses. stream() in code
 * @default "UNKNOWN"
 */
export enum ApiRunnerMethodType {
  UNKNOWN = 'UNKNOWN',
  UNARY_UNARY = 'UNARY_UNARY',
  UNARY_STREAMING = 'UNARY_STREAMING',
  STREAMING_UNARY = 'STREAMING_UNARY',
  STREAMING_STREAMING = 'STREAMING_STREAMING',
}

/**
 * ////////////////////////////////////////
 * Don't need RunnerSelector if we're opening up endpoints for deployments.
 * ////////////////////////////////////////
 * The RunnerSelector is an optional field we can provide during runtime
 * of model/workflow predictions to specify which particular runner we want to process the work.
 * This can optionally be used to select a particular nodepool and then within that nodepool
 * a particular runner.
 */
export interface ApiRunnerSelector {
  /**
   * A particular nodepool for the resource to be run within. This request the id and user_id of
   * the nodepool to be specified. Runners will be scaled according to a deployment for the given
   * resource to be run. There should not be more than one deployment in this nodepool for the
   * particular resource to run. If no deployments then default autoscaling will be used.
   */
  nodepool?: ApiNodepool;
  /** Optionally a partcular runner within the nodepool. */
  runner?: ApiRunner;
  /**
   * Optionally a partcular deployment within the nodepool.
   *
   * In future as we support matching runners based on just labels:
   *  RunnerLabels runner_labels = 3; // FUTURE
   */
  deployment?: ApiDeployment;
}

/** ScopeDeps */
export interface ApiScopeDeps {
  /** The scope */
  scope?: string;
  /** Other scopes that are required. */
  depending_scopes?: string[];
}

/** This is the new Search object used in saved searches. */
export interface ApiSearch {
  /** Search query. */
  query?: ApiQuery;
  /**
   * Customer facing, external ID for search to be saved. Provided by the user, e.g. "saved-search-1.
   * It is unique per application.
   */
  id?: string;
  /** Application that owns this saved search. */
  application_id?: string;
  /** Human readable display name of the saved search. */
  name?: string;
  /**
   * "As of" timestamp, indicating a time in the past as of which we want to
   * retrieve the annotations satisfying the query.
   * @format date-time
   */
  as_of?: string;
  /** Git hash of the code that ran the filter. */
  git_hash?: string;
  /**
   * When the saved search was created.
   * @format date-time
   */
  created_at?: string;
  /**
   * When the saved search was updated.
   * @format date-time
   */
  modified_at?: string;
  /**
   * The search algorithm to be used.
   * Options are are 'nearest_neighbor', 'brute_force', and 'avg_concept_brute_force'
   * The last two perform a brute force search visual search instead of a more scalable distributed
   * nearest neighbor search and should be used by advanced users only.
   * If not specified we default to nearest neighbor
   */
  algorithm?: string;
  /**
   * If true, save this search, and exit without executing the search.
   * If false execute the query
   */
  save?: boolean;
  /**
   * Minimum value of confidence threshold score in result.
   * Defaults to 0.0 which means we won't do any thresholding as all probabilities will
   * likely be > 0.0.
   * @format float
   */
  min_value?: number;
  /**
   * The visibility field represents whether this message is privately/publicly visible.
   * To be visible to the public the App that contains it AND the User that contains the App must
   * also be publicly visible.
   */
  visibility?: ClarifaiapiVisibility;
  /**
   * Metric used for search. Can be EUCLIDEAN_DISTANCE (default) or COSINE_DISTANCE.
   * Currently only brute force search supports non-eudlicean metrics.
   */
  metric?: SearchMetric;
}

/** SingleAnnotationFilterResponse */
export interface ApiSingleAnnotationFilterResponse {
  status?: ApistatusStatus;
  /**
   * AnnotationFilter is used to create a new dataset version.
   * For now, the filter is simply a wrapper over a Search.
   * In the future, we may add extra fields to customize the filtering.
   */
  annotation_filter?: ApiAnnotationFilter;
}

/** SingleAnnotationResponse */
export interface ApiSingleAnnotationResponse {
  status?: ApistatusStatus;
  annotation?: ClarifaiapiAnnotation;
}

/** SingleAppDuplicationResponse */
export interface ApiSingleAppDuplicationResponse {
  status?: ApistatusStatus;
  app_duplication?: ApiAppDuplication;
}

/** SingleAppResponse */
export interface ApiSingleAppResponse {
  status?: ApistatusStatus;
  app?: ApiApp;
}

/** SingleBulkOperationsResponse */
export interface ApiSingleBulkOperationsResponse {
  status?: ApistatusStatus;
  bulk_operation?: ApiBulkOperation;
}

/** Response with a single Collector. */
export interface ApiSingleCollectorResponse {
  status?: ApistatusStatus;
  collector?: ApiCollector;
}

export interface ApiSingleComputeClusterResponse {
  status?: ApistatusStatus;
  /**
   * We define a cluster here to be used in Nodepools and by the cloud provider.
   * There will be one cloud provider per Cluster.
   * This allows us to define Clusters that are VPCs within one physical cloud and have that
   * managed by one cloud provider which can list all nodepools for that VPC to deploy them and
   * orchestrate work within them.
   */
  compute_cluster?: ApiComputeCluster;
}

/** SingleConceptLanguageResponse */
export interface ApiSingleConceptLanguageResponse {
  status?: ApistatusStatus;
  /**
   * This represents a link to an outside source for the given concept.
   * The values from here are sticked into Concept message into the name and definition fields when
   * returning from the API in your default language. The "id" field here becomes the "language"
   * field of the Concept message which is a little weird.
   */
  concept_language?: ApiConceptLanguage;
}

/** SingleConceptResponse */
export interface ApiSingleConceptResponse {
  /** The response status. */
  status?: ApistatusStatus;
  /** The returned concept. */
  concept?: ApiConcept;
}

/** SingleDatasetInputResponse */
export interface ApiSingleDatasetInputResponse {
  status?: ApistatusStatus;
  dataset_input?: ApiDatasetInput;
}

/** SingleDatasetResponse */
export interface ApiSingleDatasetResponse {
  status?: ApistatusStatus;
  dataset?: ApiDataset;
}

export interface ApiSingleDatasetVersionResponse {
  status?: ApistatusStatus;
  dataset_version?: ApiDatasetVersion;
}

export interface ApiSingleDeploymentResponse {
  status?: ApistatusStatus;
  /**
   * A deployment allows you to configure how runners for a particular type of resource will
   * scale up and down. These are unique per user_id, nodepool and model so for differnet nodepools
   * you can scale differently.
   */
  deployment?: ApiDeployment;
}

export interface ApiSingleEvalMetricsResponse {
  status?: ApistatusStatus;
  eval_metrics?: ApiEvalMetrics;
}

/** SingleInputCountResponse */
export interface ApiSingleInputCountResponse {
  status?: ApistatusStatus;
  /** NOTE: inconsistency: this is weird mix of plural and singular words. */
  counts?: ApiInputCount;
}

/** SingleInputResponse */
export interface ApiSingleInputResponse {
  status?: ApistatusStatus;
  input?: ApiInput;
}

/** SingleInputsAddJobResponse */
export interface ApiSingleInputsAddJobResponse {
  status?: ApistatusStatus;
  inputs_add_job?: ApiInputsAddJob;
}

export interface ApiSingleInputsExtractionJobResponse {
  status?: ApistatusStatus;
  inputs_extraction_job?: ApiInputsExtractionJob;
}

/** SingleInstalledModuleVersionResponse */
export interface ApiSingleInstalledModuleVersionResponse {
  status?: ApistatusStatus;
  installed_module_version?: ApiInstalledModuleVersion;
}

/** SingleKeyResponse */
export interface ApiSingleKeyResponse {
  status?: ApistatusStatus;
  key?: ApiKey;
}

/** Response with a label order. */
export interface ApiSingleLabelOrderResponse {
  status?: ApistatusStatus;
  label_order?: ApiLabelOrder;
}

/** SingleModelResponse */
export interface ApiSingleModelResponse {
  status?: ApistatusStatus;
  /**
   * This is the Model object which represents a created model in the platform.
   * Each model has a particular type denoted by the model_type_id.
   * When creating a Model with PostModels the following happens:
   *  - if the ModelType is trainable, then a new ModelVersion is created that is
   *    - UNTRAINED status by default
   *    - TRAINED status if a ModelVersion was included with PretrainedModelConfig in PostModels
   *  - if the ModelType is not trainable, then a new ModelVersion is created with TRAINED status.
   * To modify config settings like OutputInfo for the Model you an use PatchModels. This will
   * also create a new ModelVersion, potentially UNTRAINED following the same rules as above.
   * The fields that are patchable include Model.name, Model.display_name and Model.output_info
   * (except the Model.output_info.type and Model.output_info.type_ext).
   */
  model?: ApiModel;
  /** @format int32 */
  workflow_count?: number;
}

/** SingleModelTypeResponse */
export interface ApiSingleModelTypeResponse {
  /** Status of the response. */
  status?: ApistatusStatus;
  /** The retrieved ModelType object. . */
  model_type?: ApiModelType;
}

/** SingleModelVersionExportResponse */
export interface ApiSingleModelVersionExportResponse {
  status?: ApistatusStatus;
  /** ModelVersionExport contains metadata for a single Model version export. */
  export?: ApiModelVersionExport;
}

/** SingleModelVersionInputExampleResponse */
export interface ApiSingleModelVersionInputExampleResponse {
  /** status of response */
  status?: ApistatusStatus;
  /** model input example message */
  model_version_input_example?: ApiModelVersionInputExample;
}

/** SingleModelVersionResponse */
export interface ApiSingleModelVersionResponse {
  status?: ApistatusStatus;
  model_version?: ApiModelVersion;
}

/** SingleModuleResponse */
export interface ApiSingleModuleResponse {
  status?: ApistatusStatus;
  /** An app module that a user created in our app module marketplace. */
  module?: ApiModule;
}

/** SingleModuleVersionResponse */
export interface ApiSingleModuleVersionResponse {
  status?: ApistatusStatus;
  /** A specific version of an app module that is available for assigning to apps. */
  module_version?: ApiModuleVersion;
}

/** SingleModuleVersionUsageCountResponse */
export interface ApiSingleModuleVersionUsageCountResponse {
  status?: ApistatusStatus;
  /** @format int64 */
  usage_count?: number;
}

export interface ApiSingleNodepoolResponse {
  status?: ApistatusStatus;
  /**
   * A nodepool is a set of nodes dedicated for a given user's compute needs.
   * This compute will typically be consumed by runners and in the future other objects
   * like UI modules may be assigned to node pools.
   */
  nodepool?: ApiNodepool;
}

/** SinglePasswordValidationResponse */
export interface ApiSinglePasswordValidationResponse {
  /** Standard clarifai status code */
  status?: ApistatusStatus;
  password_violations?: ApiPasswordViolations;
}

export interface ApiSinglePipelineStepResponse {
  /** The status of the request */
  status?: ApistatusStatus;
  /** The pipeline step that was requested */
  pipeline_step?: ApiPipelineStep;
}

export interface ApiSinglePipelineStepVersionResponse {
  /** The status of the request */
  status?: ApistatusStatus;
  /** The pipeline step version that was requested */
  pipeline_step_version?: ApiPipelineStepVersion;
}

/** SingleRunnerResponse */
export interface ApiSingleRunnerResponse {
  status?: ApistatusStatus;
  runner?: ApiRunner;
}

/** SingleSearchResponse returns saved search in response to GetSearchRequest */
export interface ApiSingleSearchResponse {
  /** Status of whether the search was successful. */
  status?: ApistatusStatus;
  /** This is the new Search object used in saved searches. */
  search?: ApiSearch;
}

/** SingleStatusCodeResponse */
export interface ApiSingleStatusCodeResponse {
  /** Status of this request. */
  status?: ApistatusStatus;
}

/** SingleTaskCountResponse represents counts of task annotations or inputs (i.e. task assignments) for labelers in given task */
export interface ApiSingleTaskCountResponse {
  status?: ApistatusStatus;
  app_id?: string;
  task_id?: string;
  counts?: ApiTaskStatusCountPerUser[];
}

/** Response with a single Task. */
export interface ApiSingleTaskResponse {
  status?: ApistatusStatus;
  /** Task is the work that needs to be done for labeling the inputs in an app. */
  task?: ApiTask;
}

export interface ApiSingleUploadResponse {
  status?: ApistatusStatus;
  upload?: ApiUpload;
}

/** SingleUserResponse */
export interface ApiSingleUserResponse {
  status?: ApistatusStatus;
  user?: ApiUser;
}

/** SingleWorkflowResponse */
export interface ApiSingleWorkflowResponse {
  status?: ApistatusStatus;
  workflow?: ApiWorkflow;
}

export interface ApiSingleWorkflowVersionEvaluationResponse {
  status?: ApistatusStatus;
  workflow_version_evaluation?: ApiWorkflowVersionEvaluation;
}

/** SingleWorkflowVersionResponse */
export interface ApiSingleWorkflowVersionResponse {
  status?: ApistatusStatus;
  workflow_version?: ApiWorkflowVersion;
}

export interface ApiSpan {
  /** @format int64 */
  char_start?: number;
  /** @format int64 */
  char_end?: number;
  raw_text?: string;
}

export interface ApiSplitIntoDatasets {
  dataset_splits?: ApiDatasetSplit[];
  method?: SplitIntoDatasetsDatasetSplitMethod;
}

/** @default "NO_TIME_AGG" */
export enum ApiStatTimeAggType {
  NO_TIME_AGG = 'NO_TIME_AGG',
  YEAR = 'YEAR',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  DAY = 'DAY',
  HOUR = 'HOUR',
  MINUTE = 'MINUTE',
}

/** StatValue */
export interface ApiStatValue {
  /**
   * The time of the event. Defaults to now().
   * @format date-time
   */
  time?: string;
  /**
   * A value for the metric you're recording.
   * @format float
   */
  value?: number;
  /**
   * List of tags to attach to this stat. Each should contain one colon so that the first part will
   * be used as a tag group while the second being the tag itself. For example: ["task_id:a",
   * "worker_id:1"]. These tag groups like "task_id" or "worker_id" are important for aggregating
   * values in the StatValueAggregateQuery.
   */
  tags?: string[];
}

/** @default "SUM" */
export enum ApiStatValueAggType {
  SUM = 'SUM',
  AVG = 'AVG',
}

/** StatValueAggregate */
export interface ApiStatValueAggregate {
  /**
   * The time of the aggregation. For example, if you aggregate over "HOUR" buckets then you can
   * expect each hour that has atleast one value (matching the rest of your query fields) will have
   * a StatValueAggregate with the time filled into that hour.
   * @format date-time
   */
  time?: string;
  /**
   * The value aggregated according to the stat_value_agg_type
   * @format float
   */
  aggregate_value?: number;
  /**
   * The count of the stat values that were used in this aggregation.
   * @format uint64
   */
  count?: string;
  /**
   * The tags for this aggregated_value and count. This will be filled in if tag groups were used in
   * the query to group aggregations.
   */
  tags?: string[];
}

/** StatValueAggregateQuery */
export interface ApiStatValueAggregateQuery {
  /**
   * These tags are used to filter down the values before they are aggregated. For example,
   * if you want to aggregate values for "task_id:a" you could specify that as a tag here.
   */
  tags?: string[];
  /**
   * These are tag groups to aggregate over. So for example if you added stat values with tags
   * "task_id:a" and others with "task_id:b", then added ["task_id"] to the task group, it the
   * aggregation would return StatValueAggregate values for each task_id. If you provide more than
   * one tag_group the response will return all rolled up combinations of them. For example
   * ["task_id", "something"] where "something:1" and "something:2" were used as tags for some
   * values then you'd get StatValueAggregate values back for:
   * task_id | something
   * a       | 1
   * a       | 2
   * b       | 1
   * b       | 1
   */
  tag_groups?: string[];
  /**
   * Aggregation function to use over the values. Count(value) is also always returns.
   * Defaults to 'sum' if not provided.
   */
  stat_value_agg_type?: ApiStatValueAggType;
  /**
   * Aggregation bins for time where the values will be aggregated at this bin granualarity.
   * And the "time" field will be returned in StatValueAggregate object.
   * If not provided then bins are not used, and all time is aggregated over.
   */
  stat_time_agg_type?: ApiStatTimeAggType;
  /**
   * If provided the time range over which values will be >= this time. If not provided then
   * all values will be used back to start of time.
   * @format date-time
   */
  start_time?: string;
  /**
   * If provided the time range over which values will be <= this time. If not provided then all
   * values will be used up until now().
   * @format date-time
   */
  end_time?: string;
}

/** StatValueAggregateResult */
export interface ApiStatValueAggregateResult {
  /** The list of repeated aggregate values and their counts. */
  stat_value_aggregates?: ApiStatValueAggregate[];
  /** The query that created these results. */
  stat_value_aggregate_query?: ApiStatValueAggregateQuery;
}

/**
 * SyncStateRequest is a message that the control plane sends to the agent runner to notify it of
 * changes to objects.
 */
export interface ApiSyncStateRequest {
  /** The operation that was performed: create, update, delete. */
  operation_type?: string;
  /** Objects that were affected. */
  compute_clusters?: ApiComputeCluster[];
  nodepools?: ApiNodepool[];
  runners?: ApiRunner[];
  pipeline_version_runs?: ApiPipelineVersionRun[];
}

/** Task is the work that needs to be done for labeling the inputs in an app. */
export interface ApiTask {
  /** Unique ID for the task. */
  id?: string;
  /**
   * When the task was created.
   * The format is https://www.ietf.org/rfc/rfc3339.txt.
   * Example: "2006-01-02T15:04:05.999999Z".
   * @format date-time
   */
  created_at?: string;
  /**
   * Most recent time when the task was updated.
   * The format is https://www.ietf.org/rfc/rfc3339.txt.
   * Example: "2006-01-02T15:04:05.999999Z".
   * @format date-time
   */
  modified_at?: string;
  /** Task type. */
  type?: ApiTaskTaskType;
  /** Description of the task. */
  description?: string;
  /** Worker details. */
  worker?: ApiTaskWorker;
  /**
   * List of concept ids used in the work of this task.
   * DEPRECATED: Use task.concepts instead.
   */
  concept_ids?: string[];
  /** List of inputs used in this task will be taken from this source. */
  input_source?: ApiTaskInputSource;
  /**
   * For model predictions on video: Sample delay for video predicting (1 frame per N milliseconds)
   * @format int64
   */
  sample_ms?: number;
  /** AI assistant details. */
  ai_assistant?: ApiTaskAIAssistant;
  /** Review details. */
  review?: ApiTaskReview;
  /** Status of this task. */
  status?: ApistatusStatus;
  /** Add a title for this task to quickly recognise it in a list of tasks. */
  name?: string;
  ai_assist_params?: ApiAiAssistParameters;
  /**
   * The visibility field represents whether this message is privately/publicly visible.
   * To be visible to the public the App that contains it AND the User that contains the App must
   * also be publicly visible.
   */
  visibility?: ClarifaiapiVisibility;
  /** The app the task belongs to. */
  app_id?: string;
  /** The user the task belongs to. */
  user_id?: string;
  /** The label order the task belongs to. */
  label_order_id?: string;
  /** Ignore Task.concept_ids field if Task.TaskConcept are supplied. */
  concepts?: ApiTaskConcept[];
  /**
   * Specify whether existing Annotations within the same app that are generated by other auto annotation tasks
   * with the specified Concept from the selected Model or Workflow should deleted before executing the Task
   */
  delete_previous_annotations?: boolean;
  /** Tasks metrics are filled in upon user-request. */
  metrics?: ApiTaskMetrics;
  /** Priority of the task */
  priority?: TaskTaskPriority;
  /**
   * To handle arbitrary json metadata you can use a struct field:
   * https://github.com/google/protobuf/blob/master/src/google/protobuf/struct.proto
   */
  metadata?: object;
}

/** TaskAIAssistant */
export interface ApiTaskAIAssistant {
  /**
   * The worker is helped by an AI assistant.
   * This field is the workflow id which is used to assist the worker with predictions.
   * If empty, then AI assistant is disabled.
   */
  workflow_id?: string;
  workflow?: ApiWorkflow;
}

export interface ApiTaskAssignment {
  id?: string;
  /**
   * Creation time.
   * The format is https://www.ietf.org/rfc/rfc3339.txt.
   * Example: "2006-01-02T15:04:05.999999Z".
   * @format date-time
   */
  created_at?: string;
  /**
   * Most recent modification time.
   * The format is https://www.ietf.org/rfc/rfc3339.txt.
   * Example: "2006-01-02T15:04:05.999999Z".
   * @format date-time
   */
  modified_at?: string;
  /** Assigned worker. */
  worker?: ApiWorker;
  /** Assigned input. */
  input?: ApiInput;
  /**
   * Assignment status.
   * Read as: This is the status of the work assigned to worker W, on input I in task T.
   */
  status?: ApistatusStatus;
}

export interface ApiTaskConcept {
  /** For auto annotation, id/name and value, user + app id must be specified. For other tasks, only the id field is required. */
  concept?: ApiConcept;
  auto_annotation_config?: ApiTaskConceptAutoAnnotationConfig;
}

export interface ApiTaskConceptAutoAnnotationConfig {
  /**
   * Filter annotations by their annotation data type.
   * This is a bit-mask field that holds multiple AnnotationDataType values that are combined in an OR fashion.
   * Example: if annotation_data_types = 34, then we filter annotations that appear as a mask or a bounding box,
   * because MASK = 32 and BOUNDING_BOX = 2.
   * @format int64
   */
  annotation_data_types?: number;
  /**
   * Filter annotations by concept value.
   * Only concepts that fit in the threshold will be used to generate annotations.
   */
  threshold_range?: ApiThresholdRange;
  /** The output annotations will be created using this status code. */
  status_code?: StatusStatusCode;
}

/** TaskInputSource */
export interface ApiTaskInputSource {
  /** Type of input source. */
  type?: TaskInputSourceTaskInputSourceType;
  /** If type is SAVED_SEARCH, then this is the saved search id. */
  id?: string;
}

export interface ApiTaskInputSourceMetrics {
  /**
   * Estimated number of inputs that are in the source of data
   * @format uint64
   */
  inputs_count_estimated?: string;
}

export interface ApiTaskMetrics {
  work?: ApiTaskWorkMetrics;
  review?: ApiTaskReviewMetrics;
  input_source?: ApiTaskInputSourceMetrics;
}

/** TaskReview */
export interface ApiTaskReview {
  /** Task review strategy. */
  strategy?: TaskReviewTaskReviewStrategy;
  /**
   * Who will review this task.
   * DEPRECATED: Use users.id instead.
   */
  user_ids?: string[];
  /**
   * Users who will review this task.
   * When the 'review.users' field is additionally requested, then all user
   * info is filled for the reviewers. Otherwise, only the user 'id' is filled.
   */
  users?: ApiUser[];
  manual_strategy_info?: ApiTaskReviewManualStrategyInfo;
  consensus_strategy_info?: ApiTaskReviewConsensusStrategyInfo;
}

/** TaskReviewConsensusStrategyInfo */
export interface ApiTaskReviewConsensusStrategyInfo {
  /**
   * Deprecated: Use approval_threshold_labelers.
   * @format int64
   */
  approval_threshold?: number;
  /**
   * The number of labelers that need to agree in order to automatically approve an annotation.
   * When 0, labelers consensus is disabled.
   * When 1, the labels are automatically approved once a single labeler labels the input.
   * When greater than 1, the labels are automatically approved when the specified number of labelers agree.
   * If the number of labelers that agree is less than the specified number, then the input will reviewed by reviewers.
   * @format int64
   */
  approval_threshold_labelers?: number;
  /**
   * The number of reviewers that need to agree in order to approve an input.
   * Currently, the only allowed values are:
   * 0  - when not set, it defaults to 1
   * 1  - only a single reviewer needs to approve each labeled input
   * -1 - an input will be approved when all reviewers approve it
   * @format int32
   */
  approval_threshold_reviewers?: number;
}

/** TaskReviewManualStrategyInfo */
export interface ApiTaskReviewManualStrategyInfo {
  /**
   * This field represents the percentage of inputs that will be reviewed by reviewers. It is a value between 0 and 1.
   * @format float
   */
  sample_percentage?: number;
  /**
   * Deprecated: Use consensus_strategy_info.approval_threshold_reviewers.
   * @format int32
   */
  approval_threshold?: number;
}

export interface ApiTaskReviewMetrics {
  /**
   * Estimated number of fully reviewed inputs.
   * An input is considered fully reviewed if it has been reviewed by all necessary reviewers.
   * Example: if task has no review, then an input is considered fully reviewed right after it's labeled (as review is skipped).
   * Example: if task has manual review with single-reviewer per input, then an input is considered fully reviewed when 1 reviewer has approved/rejected it.
   * Example: if task has consensus review with 3 reviewers per input, then an input is considered fully reviewed when 3 reviewers have approved it or 1 reviewer has rejected it.
   * @format uint64
   */
  inputs_count_estimated?: string;
  /**
   * Estimated percent of review work that was finished.
   * This is a value between 0 and 100, where 0 = 0% and 100 = 100%.
   * Calculated as inputs_count_estimated/task.metrics.input_source.inputs_count_estimated.
   * As the counts are estimated, the percentage is also estimated.
   * However, additional checks are made to ensure that 100% percentage is only returned when all inputs are reviewed - giving a guarantee that the 100% percentage is always accurate.
   * @format int64
   */
  inputs_percent_estimated?: number;
  /**
   * Estimated number of reviewed inputs per reviewer index.
   * The reviewer indexes are based on task.review.users.
   * An input is considered reviewed by a reviewer if:
   * * the reviewer approved the input
   * * the reviewer rejected the input
   * Note that when a reviewer requests changes for an input, the input is sent to back to work again, so the whole work & review process is restarted.
   * The reviewer will have to review the input again after work has been completed.
   * As such, the review that requests changes for an input is immediately dis-regarded and not counted in this metric.
   */
  inputs_count_estimated_per_reviewer?: string[];
  /**
   * The number of inputs actually available for review for each reviewer.
   * Most times, this equals task.metrics.input_source.inputs_count_estimated.
   * Several situations may result in different values:
   * * When task has no review, then this is 0 for each reviewer.
   * * When task has auto-annotation, then this number equals the inputs that have been auto-annotated with AWAITING_REVIEW status. All other inputs are considered completed by the auto-annotation process.
   * * When task has consensus review with approval_threshold_labelers > 0, then it's possible that labelers will approve inputs through consensus, which skips review. In this case, the number of inputs available for review is less than task.metrics.input_source.inputs_count_estimated.
   * * When task has consensus review with approval_threshold_reviewers = 1, then all inputs are assigned only to one reviewer, so each reviewer will get only a part of the inputs to review. It's expected that the sum(inputs_reviewable_count_estimated) = task.metrics.input_source.inputs_count_estimated.
   * * When task has consensus review with approval_threshold_reviewers = -1, then all inputs are assigned to all reviewers. However, if an input is rejected, then rejection is final and all other reviewers will not review it. In this case, the number of inputs available for review for other reviewers will be less than task.metrics.input_source.inputs_count_estimated.
   */
  inputs_reviewable_count_estimated_per_reviewer?: string[];
  /**
   * Estimated percent of review work that was finished per reviewer.
   * This is a value between 0 and 100, where 0 = 0% and 100 = 100%.
   * Calculated as inputs_count_estimated_per_reviewer/inputs_reviewable_count_estimated_per_reviewer.
   * As the counts are estimated, the percentage is also estimated.
   * However, additional checks are made to ensure that 100% percentage is only returned when all inputs are reviewed - giving a guarantee that the 100% percentage is always accurate.
   */
  inputs_percent_estimated_per_reviewer?: number[];
}

/**
 * TaskStatusCountPerUser can represent one of the following:
 * * count of task annotations created by a worker for each valid status,
 * * count of task inputs assigned to a worker  (i.e. task assignments) for each valid status
 */
export interface ApiTaskStatusCountPerUser {
  /** Deprecated: Use worker instead. */
  user_id?: string;
  /** @format int64 */
  pending?: number;
  /** @format int64 */
  awaiting_review?: number;
  /** @format int64 */
  success?: number;
  /** @format int64 */
  review_denied?: number;
  /** @format int64 */
  awaiting_consensus_review?: number;
  /** Worker is the author of an annotation. */
  worker?: ApiWorker;
}

/**
 *  - CONCEPTS_CLASSIFICATION: Concepts classification tasks annotate concepts for the overall image, frame of video or section of text.
 *  - BOUNDING_BOX_DETECTION: Bounding box detection tasks annotate rectangular bounding box regions around each concept in an image, frame of video or section of text.
 *  - POLYGON_DETECTION: Polygon detection tasks annotate free-form regions around concepts in an image, frame of video or section of text.
 * @default "TYPE_NOT_SET"
 */
export enum ApiTaskTaskType {
  TYPE_NOT_SET = 'TYPE_NOT_SET',
  CONCEPTS_CLASSIFICATION = 'CONCEPTS_CLASSIFICATION',
  BOUNDING_BOX_DETECTION = 'BOUNDING_BOX_DETECTION',
  POLYGON_DETECTION = 'POLYGON_DETECTION',
}

export interface ApiTaskWorkMetrics {
  /**
   * Estimated number of inputs that workers have worked on.
   * @format uint64
   */
  inputs_count_estimated?: string;
  /**
   * Estimated percent of inputs that workers have worked on.
   * This is a value between 0 and 100, where 0 = 0% and 100 = 100%.
   * @format int64
   */
  inputs_percent_estimated?: number;
}

/** TaskWorker includes information about the workers that will work on this task. */
export interface ApiTaskWorker {
  /** Worker strategy. */
  strategy?: TaskWorkerTaskWorkerStrategy;
  /**
   * Who will work on this task.
   * DEPRECATED: Use workers.user.id instead.
   */
  user_ids?: string[];
  /**
   * Users who will work on this task.
   * When the 'worker.users' field is additionally requested, then all user
   * info is filled for the workers. Otherwise, only the user 'id' is filled.
   * DEPRECATED: Use workers.user instead.
   */
  users?: ApiUser[];
  partitioned_strategy_info?: ApiTaskWorkerPartitionedStrategyInfo;
  /**
   * Workers that will work on this task.
   *
   * For Auto Annotation Tasks:
   *   the worker can be either a model or a workflow;
   *   currently only supports 1 worker.
   * For manual labeling Tasks:
   *   the workers can only be users;
   *   no limitation on number of workers.
   */
  workers?: ApiWorker[];
  /**
   * Who is doing annotations - human Worker or auto-annotation via Model/Workflow.
   * If set, worker must have be set accordingly to either human worker or model/workflow worker
   */
  type?: TaskWorkerWorkerType;
}

/** TaskWorkerPartitionedStrategyInfo */
export interface ApiTaskWorkerPartitionedStrategyInfo {
  /** Define how the partitioning should work. */
  type?: TaskWorkerPartitionedStrategyInfoTaskWorkerPartitionedStrategy;
  /**
   * How many workers will label each input.
   * @format int32
   */
  workers_per_input?: number;
  /**
   * In case of weighted partitioning, map user ids to weights.
   * Each labeler will be assigned work proportional to its own weight as compared to the sum of total weight.
   *
   * EXAMPLE:
   * If we have 3 workers, and weights = {1: 30, 2: 30, 3: 40},
   * then first worker will have assigned 30% of the work,
   * second worker will have assigned 30% of the work,
   * and third worker will have assigned 40% of the work.
   * You may use weights which add up to 100, but it's not necessary.
   * For example, weights {1: 30, 2: 30, 3: 40} are equivalent with {1: 3, 2: 3, 3: 4}
   * because they represent the same percentages: {1: 30%, 2: 30%, 3: 40%}.
   *
   * NOTE:
   * Note that no worker should be assigned a weight percentage greater than 1/workers_per_input.
   * It is mathematically impossible to partition the work in such a case.
   * Why? Say, we have 3 workers. And workers_per_input = 2, i.e. each input must be labeled by 2 workers.
   * Let's assign weights {1: 51%, 2: 25%, 3: 24%}.
   * Note that first worker has a weight percentage higher than 1/workers_per_input = 1/2 = 50%.
   * If we have 100 inputs, then a total of 100 * workers_per_input = 200 cumulative inputs will be labeled by these 3 workers.
   * Worker 1 should label 102 cumulative inputs, while worker 2 and worker 3 will label 98 cumulative inputs together.
   * No matter how we assign the 98 cumulative inputs, the 2 workers will be able to label up to 98 actual inputs.
   * This means the remaining 2 inputs will be labeled only by worker 1. This contradicts the worker_per_input = 2 requirement.
   */
  weights?: object;
}

/** Represents a group of users. */
export interface ApiTeam {
  /** Identify the team (unique). */
  id?: string;
  /**
   * When the team was created.
   * The format is https://www.ietf.org/rfc/rfc3339.txt.
   * Example: "2006-01-02T15:04:05.999999Z".
   * @format date-time
   */
  created_at?: string;
  /**
   * Most recent time when the team was updated.
   * The format is https://www.ietf.org/rfc/rfc3339.txt.
   * Example: "2006-01-02T15:04:05.999999Z".
   * @format date-time
   */
  modified_at?: string;
  /** Name the team. */
  name?: string;
  /** When a new application is assigned to the team without an explicit role, then the default role will be used */
  default_role_id?: string;
}

/** Text */
export interface ApiText {
  /** This is a raw text string. */
  raw?: string;
  /** Url to a text file */
  url?: string;
  allow_duplicate_url?: boolean;
  /**
   * The hosted field lists original text hosted in Clarifai storage. This field is currently used
   * only in response.
   */
  hosted?: ApiHostedURL;
  /** text info */
  text_info?: ApiTextInfo;
}

export interface ApiTextInfo {
  /**
   * count of characters in text
   * @format int32
   */
  char_count?: number;
  /** text encoding */
  encoding?: string;
}

export interface ApiThresholdRange {
  /**
   * The range used to filter over concept values.
   * e.g. GREATER_THAN_OR_EQUAL_TO 0.7 -> is_lower_inclusive = true, lower = 0.7, is_upper_inclusive = true, upper = 1.0
   * e.g. (0.3, 0.75] -> is_lower_inclusive = false, lower = 0.3, is_upper_inclusive = true, upper = 0.75
   */
  is_lower_inclusive?: boolean;
  is_upper_inclusive?: boolean;
  /** @format float */
  lower?: number;
  /** @format float */
  upper?: number;
}

/** TimeInfo */
export interface ApiTimeInfo {
  /**
   * Number of frames
   * @format int64
   */
  num_frames?: number;
  /**
   * Timestamp where track begins.
   * @format float
   */
  begin_time?: number;
  /**
   * Timestamp where track ends.
   * @format float
   */
  end_time?: number;
}

/** TimeRange */
export interface ApiTimeRange {
  /**
   * Begin of the time range, optional, inclusive.
   * @format date-time
   */
  start_time?: string;
  /**
   * End of the time range, optional, inclusive.
   * @format date-time
   */
  end_time?: string;
}

/** TimeSegment */
export interface ApiTimeSegment {
  /** A unique id for the time segment. */
  id?: string;
  data?: ApiData;
  time_info?: ApiTimeInfo;
}

export interface ApiToken {
  /** @format int64 */
  char_start?: number;
  /** @format int64 */
  char_end?: number;
  raw_text?: string;
}

/** Track proto encodes information of a track over a number of frames */
export interface ApiTrack {
  /** track id */
  id?: string;
  /**
   * This is a recursive definition which can contain all the concepts,
   * embeddings, etc. that are computed within this track.
   */
  data?: ApiData;
  time_info?: ApiTimeInfo;
  /** @format float */
  quality?: number;
}

/** TrackerMetrics */
export interface ApiTrackerMetrics {
  /**
   * Multiple object tracking accuracy
   * @format float
   */
  mot_mota?: number;
  /**
   * Number of switches between tracks
   * @format int32
   */
  mot_num_switches?: number;
  /**
   * MORSE fragmentation rate (a.k.a unique switch rate, only calculated in public sector)
   * @format float
   */
  morse_frag?: number;
  /**
   * Average precision calculated from all processed frames
   * @format float
   */
  avg_precision?: number;
  /** The concept that we are evaluating the tracker */
  aiid?: string;
  /**
   * Same as morse_frag but calculated using MOT mapping/metrics
   * @format float
   */
  unique_switch_rate?: number;
}

export interface ApiTrainInfo {
  /**
   * To control the training process when PostModelVersions is used we allow a list of parameters
   * defined for each ModelType as a Struct (JSON object) here. During training, the settings
   * contained within are sent to the training processor to alter the training process.
   */
  params?: object;
  /** The dataset and dataset version this model version was or will be trained on */
  dataset?: ApiDataset;
  /** The model to resume training from. */
  resume_from_model?: ApiModel;
}

export interface ApiTritonCondaEnvInfo {
  conda_pack_url?: string;
  conda_yaml_url?: string;
}

export interface ApiUpload {
  /** ID of upload */
  id?: string;
  /**
   * When the upload was started.
   * The format is https://www.ietf.org/rfc/rfc3339.txt.
   * Example: "2006-01-02T15:04:05.999999Z".
   * @format date-time
   */
  created_at?: string;
  /**
   * Most recent time when the upload was updated.
   * The format is https://www.ietf.org/rfc/rfc3339.txt.
   * Example: "2006-01-02T15:04:05.999999Z".
   * @format date-time
   */
  modified_at?: string;
  /**
   * When the upload will expire and be deleted
   * The format is https://www.ietf.org/rfc/rfc3339.txt.
   * Example: "2006-01-02T15:04:05.999999Z".
   * @format date-time
   */
  expires_at?: string;
  /** Status of the upload */
  status?: ApistatusStatus;
  /** name of uploaded content (e.g. filename) */
  content_name?: string;
  /**
   * Total size of the upload content
   * @format uint64
   */
  content_length?: string;
  /** Url of uploaded content */
  content_url?: string;
}

export interface ApiUploadContentPart {
  /** @format uint64 */
  range_start?: string;
  /** @format int64 */
  part_number?: string;
  /** @format byte */
  data?: string;
}

/** User */
export interface ApiUser {
  id?: string;
  primary_email?: string;
  first_name?: string;
  last_name?: string;
  company_name?: string;
  job_title?: string;
  job_role?: string;
  /** This specifies user intent when registering on clarifai */
  intention?: string;
  /** This specifies how one got to know about clarifai */
  referral_source?: string;
  bill_type?: string;
  /**
   * When the user was created. We follow the XXXX timestamp
   * format. We use https://www.ietf.org/rfc/rfc3339.txt format:
   * "2006-01-02T15:04:05.999999Z" so you can expect results like
   * the following from the API:
   * "2017-04-11T21:50:50.223962Z"
   * @format date-time
   */
  created_at?: string;
  /** @format date-time */
  date_gdpr_consent?: string;
  /** @format date-time */
  date_tos_consent?: string;
  /** @format date-time */
  date_marketing_consent?: string;
  /** @format date-time */
  date_pii_consent?: string;
  /**
   * To handle arbitrary json metadata you can use a struct field:
   * https://github.com/google/protobuf/blob/master/src/google/protobuf/struct.proto
   */
  metadata?: object;
  email_addresses?: ApiEmailAddress[];
  two_factor_auth_enabled?: boolean;
  /** @format int64 */
  teams_count?: number;
  /**
   * Is starred by the requesting user (only showed on get/list requests)
   * Please use PostUserStars/DeleteUserStars endpoints to star/unstar an user
   */
  is_starred?: boolean;
  /**
   * How many users have starred the user (only showed on get/list requests)
   * Computed value, not editable
   * @format int32
   */
  star_count?: number;
  /**
   * The visibility field represents whether this message is privately/publicly visible.
   * To be visible to the public the App that contains it AND the User that contains the App must
   * also be publicly visible.
   */
  visibility?: ClarifaiapiVisibility;
  /**
   * This is all the personal information of a user. GetUser/ListUsers will not return this
   * information unless the caller has the UserAccounts_Get scope on their key or is the user
   * themselves.
   */
  user_detail?: ApiUserDetail;
  /** Representative image for this User (a.k.a. Profile or cover photo) */
  image?: ApiImage;
}

/** Common message to identify the app in a url endpoint. */
export interface ApiUserAppIDSet {
  /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
  user_id?: string;
  app_id?: string;
}

/**
 * This message holds the confidential information from the User object that we don't want to expose
 * to other users. It will be accessible only from /users/{user_id}/account and with the User scopes.
 */
export interface ApiUserDetail {
  primary_email?: string;
  bill_type?: string;
  /** @format date-time */
  date_gdpr_consent?: string;
  /** @format date-time */
  date_tos_consent?: string;
  /** @format date-time */
  date_marketing_consent?: string;
  /** @format date-time */
  date_pii_consent?: string;
  /**
   * To handle arbitrary json metadata you can use a struct field:
   * https://github.com/google/protobuf/blob/master/src/google/protobuf/struct.proto
   */
  metadata?: object;
  email_addresses?: ApiEmailAddress[];
  two_factor_auth_enabled?: boolean;
  /** @format int64 */
  teams_count?: number;
  country?: string;
  state?: string;
  commitment_value?: ApiCommitmentValue;
}

/** Request to delete several things by the list of ids. */
export interface ApiV2DeleteAnnotationsBody {
  /** Common message to identify the app in a url endpoint. */
  user_app_id?: object;
  /** Delete annotations with IDs */
  ids?: string[];
  /**
   * Delete annotations for these Input IDs
   * Note that 'ids' are optional but if the are provided the number and order in
   * 'ids' and 'input_ids' should match
   * If you do not specifiy 'ids' all the annotations for 'input_ids' are deleted
   * However you need to specify at least one value for 'input_ids'
   * i.e. this API does not support deleting all annotations
   */
  input_ids?: string[];
}

/** Video */
export interface ApiVideo {
  /**
   * This is a URL to a publicly accessible video file. The platform will download this file server
   * side and then process.
   */
  url?: string;
  /**
   * The base64 field is using video file bytes directly in the request.
   * NOTE: if you're sending a json request, then this MUST be base64 encoded before sending (hence
   * the name here).
   * When using our grpc clients, you DO NOT need to base64 encode
   * it yourself since the clients know how to do this for you automatically and will avoid the
   * base64 encoding if they send a binary request.
   * @format byte
   */
  base64?: string;
  allow_duplicate_url?: boolean;
  /**
   * URL of thumbnail image, which is currently frame at position of 1s. This field is currently
   * used only in response.
   * Deprecated in favour of thumbnail_hosted, which also contains alternate sizes of thumbnail
   */
  thumbnail_url?: string;
  /**
   * The hosted field lists original video hosted in Clarifai storage. This field is currently used
   * only in response.
   */
  hosted?: ApiHostedURL;
  /**
   * The hosted field lists various sizes of the vide thumbnail hosted in Clarifai storage, with 'thumbnail' as the full size
   * This field is currently used only in response.
   */
  hosted_thumbnail?: ApiHostedURL;
  /** video info */
  video_info?: ApiVideoInfo;
}

export interface ApiVideoInfo {
  /**
   * width
   * @format int32
   */
  width?: number;
  /**
   * height
   * @format int32
   */
  height?: number;
  /**
   * Frames per second of the video.
   * @format float
   */
  fps?: number;
  /** video format */
  video_format?: string;
  /**
   * video track bit rate
   * @format int32
   */
  bit_rate?: number;
  /**
   * video frame count
   * @format int32
   */
  frame_count?: number;
  /**
   * video duration in seconds
   * @format float
   */
  duration_seconds?: number;
}

export interface ApiW3C {
  hex?: string;
  name?: string;
}

/** Worker is the author of an annotation. */
export interface ApiWorker {
  /**
   * User is the human that created the annotation.
   *
   * By default no real names of users are returned in responses. These can
   * be requested with the 'names' additional field.
   */
  user?: ApiUser;
  /** Model is the model that created the annotation. */
  model?: ApiModel;
  /** Workflow is the workflow that created the annotation. */
  workflow?: ApiWorkflow;
}

/** Workflow */
export interface ApiWorkflow {
  /** The workflows's unique id. */
  id?: string;
  /** The app the workflow belongs to */
  app_id?: string;
  /**
   * When the workflow was created. We follow the XXXX timestamp
   * format. We use https://www.ietf.org/rfc/rfc3339.txt format:
   * "2006-01-02T15:04:05.999999Z" so you can expect results like
   * the following from the API:
   * "2017-04-11T21:50:50.223962Z"
   * @format date-time
   */
  created_at?: string;
  /**
   * The list of nodes retrieved from latest workflow version.
   * Each node can specify an input node that it connects to in order to define the graph.
   */
  nodes?: ApiWorkflowNode[];
  /**
   * To handle arbitrary json metadata you can use a struct field:
   * https://github.com/google/protobuf/blob/master/src/google/protobuf/struct.proto
   */
  metadata?: object;
  /**
   * The visibility field represents whether this message is privately/publicly visible.
   * To be visible to the public the App that contains it AND the User that contains the App must
   * also be publicly visible.
   */
  visibility?: ClarifaiapiVisibility;
  /** The user the workflow belongs to */
  user_id?: string;
  /**
   * When the workflow was last modified
   * @format date-time
   */
  modified_at?: string;
  /** Info about the workflow version used to return the latest version when listing Workflows. */
  version?: ApiWorkflowVersion;
  /**
   * Is starred by the requesting user (only showed on get/list requests)
   * Please use PostWorkflowStars/DeleteWorkflowStars endpoints to star/unstar a workflow
   */
  is_starred?: boolean;
  /**
   * How many users have starred the workflow (only showed on get/list requests)
   * Computed value, not editable
   * @format int32
   */
  star_count?: number;
  /** Short description about this workflow */
  description?: string;
  /**
   * Notes for the workflow
   * This field should be used for in-depth notes and supports up to 64Kbs.
   */
  notes?: string;
  /** Tags from use_cases category */
  use_cases?: string[];
  /** Tags for check consents */
  check_consents?: string[];
  /**
   * bookmark info. When set, this workflow is a bookmarked workflow of this app.
   * Info in this field will allow you to find/access original workflow.
   */
  bookmark_origin?: ApiBookmarkOrigin;
  /** Representative image for this workflow */
  image?: ApiImage;
}

export interface ApiWorkflowEvaluationResult {
  /** The summary of the evaluation result. */
  summary?: ApiWorkflowEvaluationResultSummary;
}

export interface ApiWorkflowEvaluationResultSummary {
  /** The evaluation metrics. */
  evaluation_metric_values?: ApiEvaluationMetricValue[];
}

/**
 *  - CLASSIFICATION: Classifier models without a detector parent (recursive check) in a workflow
 * are used for classification.
 *  - DETECTION: Detector models in a workflow are used for detection.
 * Classifier models that run after a detector model are also used for detection.
 * @default "WORKFLOW_MODEL_USE_CASE_NOT_SET"
 */
export enum ApiWorkflowModelUseCase {
  WORKFLOW_MODEL_USE_CASE_NOT_SET = 'WORKFLOW_MODEL_USE_CASE_NOT_SET',
  CLASSIFICATION = 'CLASSIFICATION',
  DETECTION = 'DETECTION',
}

/** WorkflowNode */
export interface ApiWorkflowNode {
  /**
   * An identifier for this node in the graph. This is used when connecting NodeInputs
   * together.
   */
  id?: string;
  /**
   * The model that will do the processing at this node. We only vlidate the model.id and
   * model.model_version.id fields.
   */
  model?: ApiModel;
  /**
   * Each WorkflowNode can connect to multiple input nodes so that we can handle multi-model data
   * and more complex workflow operations.
   */
  node_inputs?: ApiNodeInput[];
  /** suppress the output for workflow prediction */
  suppress_output?: boolean;
  /**
   * Used to override the output_info.data and output_info.params of the model specified by the node.
   * Values for fields_map, message, and output_config are ignored.
   */
  output_info_override?: ApiOutputInfo;
}

/**
 * WorkflowResult
 * One result per input in the workflow.
 */
export interface ApiWorkflowResult {
  id?: string;
  status?: ApistatusStatus;
  /**
   * When the object was created. We follow the XXXX timestamp
   * format. We use https://www.ietf.org/rfc/rfc3339.txt format:
   * "2006-01-02T15:04:05.999999Z" so you can expect results like
   * the following from the API:
   * "2017-04-11T21:50:50.223962Z"
   * @format date-time
   */
  created_at?: string;
  /** The input that ran through the workflow to generate the outputs in this WorkflowResult. */
  input?: ApiInput;
  /** For each model in the workflow we return an Output. */
  outputs?: ApiOutput[];
  /** Indicate if the output of this model is suppressed. */
  suppress_output?: boolean;
}

/** WorkflowState */
export interface ApiWorkflowState {
  /**
   * A unique ID for the workflow state.
   * To start saving a state in a PostWorkflowResults request set this ID to "init"
   * and it will return a newly generated unique state id that you can then pass in subsequent
   * PostWorkflowResults calls. These state expire after 5 minutes between calls.
   */
  id?: string;
}

/** WorkflowVersion */
export interface ApiWorkflowVersion {
  /** Id of this version. */
  id?: string;
  /** Workflow id for this version. */
  workflow_id?: string;
  /**
   * When the version was created.
   * The format is https://www.ietf.org/rfc/rfc3339.txt.
   * Example: "2006-01-02T15:04:05.999999Z".
   * @format date-time
   */
  created_at?: string;
  /**
   * Most recent time when the version was updated.
   * The format is https://www.ietf.org/rfc/rfc3339.txt.
   * Example: "2006-01-02T15:04:05.999999Z".
   * @format date-time
   */
  modified_at?: string;
  /**
   * The visibility field represents whether this message is privately/publicly visible.
   * To be visible to the public the App that contains it AND the User that contains the App must
   * also be publicly visible.
   */
  visibility?: ClarifaiapiVisibility;
  /**
   * The list of nodes that make up the workflow version. Each node can specify an input node
   * that it connects to in order to define the graph.
   */
  nodes?: ApiWorkflowNode[];
  /**
   * To handle arbitrary json metadata you can use a struct field:
   * https://github.com/google/protobuf/blob/master/src/google/protobuf/struct.proto
   */
  metadata?: object;
  /** The app the workflow version belongs to. */
  app_id?: string;
  /** The user the workflow version belongs to. */
  user_id?: string;
  /** Short description about this workflow version */
  description?: string;
  /** License associated to this workflow version */
  license?: string;
  /**
   * If a model version associated with the workflow version is deleted, the workflow version
   * will be marked as deprecated.
   */
  is_deprecated?: boolean;
}

export interface ApiWorkflowVersionEvaluation {
  /** Customer-Facing / External ID of the workflow version evaluation. */
  id?: string;
  /** Workflow version that is being evaluated. */
  workflow_version?: ApiWorkflowVersion;
  /** The target node id that is being evaluated. */
  target_node_id?: string;
  /** The dataset version that contains the ground-truth and is used for evaluation. */
  ground_truth_dataset_version?: ApiDatasetVersion;
  /** The dataset version that contains the predictions and is used for evaluation. */
  predictions_dataset_version?: ApiDatasetVersion;
  /** Evaluation template that is used for evaluation. */
  workflow_version_evaluation_template?: ApiWorkflowVersionEvaluationTemplate;
  /** The user the workflow version evaluation belongs to. */
  user_id?: string;
  /** The app the workflow version evaluation belongs to. */
  app_id?: string;
  /** Results of the evaluation. */
  workflow_evaluation_result?: ApiWorkflowEvaluationResult;
  /** Status of the evaluation */
  status?: ApistatusStatus;
  /**
   * When the workflow version evaluation was created.
   * @format date-time
   */
  created_at?: string;
  /**
   * When the workflow version evaluation was modified.
   * @format date-time
   */
  modified_at?: string;
}

export interface ApiWorkflowVersionEvaluationMetric {
  id?: string;
  summary?: string;
  description?: string;
  /** Metric data type - string, float, int */
  data_type?: ApiWorkflowVersionEvaluationMetricDataType;
  visualisation_type?: WorkflowVersionEvaluationMetricVisualisationType;
}

/**
 * Enum for data types
 * @default "DATA_TYPE_NOT_SET"
 */
export enum ApiWorkflowVersionEvaluationMetricDataType {
  DATA_TYPE_NOT_SET = 'DATA_TYPE_NOT_SET',
  FLOAT = 'FLOAT',
}

export interface ApiWorkflowVersionEvaluationTemplate {
  id?: string;
  description?: string;
  /** Applicable for the task types like TextClassification, TextGeneration, etc */
  task_types?: ApiWorkflowVersionEvaluationTemplateTaskType[];
  /** The Workflow Evaluation template metrics */
  workflow_version_evaluation_metrics?: ApiWorkflowVersionEvaluationMetric[];
}

/** @default "TASK_TYPE_NOT_SET" */
export enum ApiWorkflowVersionEvaluationTemplateTaskType {
  TASK_TYPE_NOT_SET = 'TASK_TYPE_NOT_SET',
  TEXT_CLASSIFICATION = 'TEXT_CLASSIFICATION',
}

export interface ApiWorkflowVersionPublishRequest {
  version_id?: string;
}

export interface ApiWorkflowVersionUnPublishRequest {
  version_id?: string;
}

export interface ApistatusStatus {
  /** Status code from internal codes. */
  code?: StatusStatusCode;
  /** A short description of the error. */
  description?: string;
  /**
   * More details of the given error.
   * These details may be exposed to non-technical users.
   * For technical details, try to use developer_notes field.
   */
  details?: string;
  /**
   * For some environment we may return a stack trace to help debug
   * any issues.
   */
  stack_trace?: string[];
  /**
   * specifically for long running jobs
   * @format int64
   */
  percent_completed?: number;
  /**
   * if status is pending, how much time is remaining (in seconds)
   * @format int64
   */
  time_remaining?: number;
  /** A request ID may be present, to help monitoring and tracking requests */
  req_id?: string;
  /** Internal Annotation (do not set in production, for internal Clarifai use only). */
  internal_details?: string;
  /** Resource location info for redirect, when resource location has been changed. */
  redirect_info?: StatusRedirectInfo;
  /**
   * Notes for developer.
   * These notes are rather technical details for developers how to interpret the status,
   * e.g. why an error occurred and how to avoid getting the error.
   */
  developer_notes?: string;
}

/** Annotation of an asset with metadata */
export interface ClarifaiapiAnnotation {
  /** The ID for the annotation */
  id?: string;
  /** ID of the input this annotation is tied to */
  input_id?: string;
  /** The data passed along in this annotation. */
  data?: ApiData;
  /** task_id is deprecated in annotation_info. Use task_id */
  annotation_info?: object;
  /** DEPRECATED: Use worker.user.id instead. */
  user_id?: string;
  /** DEPRECATED: Use worker.model.model_version.id instead */
  model_version_id?: string;
  /** DEPRECATED. */
  embed_model_version_id?: string;
  /** Annotation Status */
  status?: ApistatusStatus;
  /**
   * When the annotation was created. We follow the XXXX timestamp
   * format. We use https://www.ietf.org/rfc/rfc3339.txt format:
   * "2006-01-02T15:04:05.999999Z" so you can expect results like
   * the following from the API:
   * "2017-04-11T21:50:50.223962Z"
   * @format date-time
   */
  created_at?: string;
  /**
   * When the annotation was modified.
   * @format date-time
   */
  modified_at?: string;
  /**
   * Whether or not this annotation is trusted
   * Will be deprecated
   */
  trusted?: boolean;
  /** Is this the input level annotation. */
  input_level?: boolean;
  /**
   * Consensus review related information, e.g.
   * * annotation group
   * * id of annotation parent, in case the annotation was split from another annotation
   */
  consensus_info?: object;
  /** The id of the task annotation belongs to */
  task_id?: string;
  /** Worker is the worker that created the annotation. */
  worker?: ApiWorker;
}

/**
 * - UNDEFINED: Default value, should not be used
 * @default "UNDEFINED"
 */
export enum ClarifaiapiDataType {
  UNDEFINED = 'UNDEFINED',
  STRING = 'STRING',
  UINT8 = 'UINT8',
  INT32 = 'INT32',
  INT64 = 'INT64',
  FP32 = 'FP32',
}

/** This operation takes no data (payload). */
export type ClarifaiapiDeleteAnnotations = object;

/**
 * Visibility represents how visible the given resource is to other users.
 * When authenticating a request we can tell if a user is a collaborator or a teammate for the
 * the app that contains the resource and set their allowed visibility. We use that to restrict
 * what they are allowed to see:
 * If AllowedVisibility is PRIVATE then we allow PRIVATE (10), ORG (30), PUBLIC (50)
 * If AllowedVisibility is ORG then we allow ORG (30), PUBLIC (50)
 * If AllowedVisibility is PUBLIC then we allow PUBLIC (50) only.
 */
export interface ClarifaiapiVisibility {
  /**
   * Gettable defined the level of access for GET operations for this resource.
   *
   *  - UNKNOWN_VISIBILITY: Default value not allowed.
   *  - PRIVATE: PRIVATE requires collaborator or team permissions in order to GET this resource.
   *  - ORG: ORG requires you to be in the same org in order to GET this resource, but don't have to be a
   * teammate or collaborator.
   *  - PUBLIC: PUBLIC opens up GET access to the resource to any user on the platform even if they are not
   * a teammate or collaborator.
   */
  gettable?: VisibilityGettable;
}

export interface GooglerpcStatus {
  /** @format int32 */
  code?: number;
  message?: string;
  details?: ProtobufAny[];
}

export interface ProtobufAny {
  '@type'?: string;
  [key: string]: any;
}

/**
 * `NullValue` is a singleton enumeration to represent the null value for the
 * `Value` type union.
 *
 *  The JSON representation for `NullValue` is JSON `null`.
 *
 *  - NULL_VALUE: Null value.
 * @default "NULL_VALUE"
 */
export enum ProtobufNullValue {
  NULL_VALUE = 'NULL_VALUE',
}

/**
 * Base message to return when there is a internal server error that
 * is not caught elsewhere.
 */
export interface StatusBaseResponse {
  status?: ApistatusStatus;
}

export interface StatusRedirectInfo {
  /** New location for the resource. Used to set response Location header. */
  url?: string;
  /** Resource type */
  resource_type?: string;
  /** Old resource id */
  old_resource_id?: string;
  /** New resource id */
  new_resource_id?: string;
}

/**
 * - ZERO: to be revised and greatly expanded
 *  - SUCCESS: Generic
 *  - MOVED: Resource moved. Respond with Http status 307 and add new Location header to response
 *  - ACCEPTED: Request has been accepted. Respond with Http status 202.
 *  - CONN_ACCOUNT_ISSUES: Clarifai Connection Codes: 11xxx
 * expired cc, still in trial, feature not supported in your tier
 *  - CONN_TOKEN_INVALID: invalid auth token used. Deprecated: we should return CONN_KEY_INVALID instead now in all cases.
 *  - CONN_CREDENTIALS_INVALID: invalid auth credentials
 *  - CONN_EXCEED_HOURLY_LIMIT: throttle hourly limit exceeded
 *  - CONN_EXCEED_MONTHLY_LIMIT: throttle monthly limit exceeded
 *  - CONN_THROTTLED: throttler and billing stuff
 *  - CONN_EXCEEDS_LIMITS: throttler and billing stuff
 *  - CONN_INSUFFICIENT_SCOPES: api key has insufficient permissions
 *  - CONN_KEY_INVALID: api key is invalid
 *  - CONN_KEY_NOT_FOUND: api key not found
 *  - CONN_BAD_REQUEST_FORMAT: multipart form parsing, broken json, etc
 *  - CONN_DOES_NOT_EXIST: when path is bad
 *  - CONN_INVALID_REQUEST: something wrong with a header
 *  - CONN_METHOD_NOT_ALLOWED: when a request method is not allowed
 *  - CONN_NO_GDPR_CONSENT: lack GDPR consent
 *  - CONN_INVALID_RANGE: when invalid range of a resource is requested
 *  - CONN_AUTH_METHOD_DISABLED: authentication method is disabled
 *  - MODEL_TRAINED: Model/Custom Training related 20xxx
 *
 * Custom model has been already trained.
 *  - MODEL_TRAINING: Custom model is currently training.
 *  - MODEL_UNTRAINED: Custom model has not yet been trained.
 *  - MODEL_QUEUED_FOR_TRAINING: Custom model is currently in queue for training, waiting on assets to process first.
 *  - MODEL_TRAINING_FAILED: generic err msg for any type of model training err.
 *  - MODEL_BUILDING: For new V3 DockerInternalType models which are built images
 *  - MODEL_BUILDING_FAILED: Failed to build image for model.
 *  - MODEL_BUILD_UNEXPECTED_ERROR: Failed to build image for model.
 *  - MODEL_TRAINING_NO_DATA: Custom model training had no data.  FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
 *  - MODEL_TRAINING_NO_POSITIVES: Custom model training had no positive examples. FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
 *  - MODEL_TRAINING_ONE_VS_N_SINGLE_CLASS: Custom model training was ONE_VS_N but with a single class. FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
 *  - MODEL_TRAINING_TIMED_OUT: Training took longer than hard coded timeouts. FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
 *  - MODEL_TRAINING_WAITING_ERROR: Training got error waiting on asset pipeline to finish. FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
 *  - MODEL_TRAINING_UNKNOWN_ERROR: Training threw an unknown exception.
 *  - MODEL_TRAINING_MSG_REDELIVER: Training message was redelivered. FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
 *  - MODEL_TRAINING_INSUFFICIENT_DATA: Training got error due to insufficient labelled data. FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
 *  - MODEL_TRAINING_INVALID_PARAMS: FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
 *  - MODEL_TRAINING_INVALID_DATA_TOLERANCE_EXCEEDED: Training is stopped because too much data was dropped. FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
 *  - MODEL_EVALUATION_TIMED_OUT: Evaluation took longer than hard coded timeouts. FIXME(yang): deprecate this. Use the 21317 + errStatusMsg
 *  - MODEL_EVALUATION_WAITING_ERROR: Evaluation got error waiting on asset pipeline to finish.FIXME(yang): deprecate this. Use the 21317 + errStatusMsg
 *  - MODEL_EVALUATION_UNKNOWN_ERROR: EVALUATION THREW AN UNKNOWN EXCEPTION.
 *  - MODEL_EVALUATION_MSG_REDELIVER: Eval message was redelivered. FIXME(yang): deprecate this. Use the 21317 + errStatusMsg
 *  - MODEL_EVALUATION_NEED_LABELS: Don't have enough concepts labelled to perform evaluation. FIXME(yang): deprecate this. Use the 21317 + errStatusMsg
 *  - MODEL_EVALUATION_NEED_INPUTS: Don't have enough inputs per concept to perform evaluation. FIXME(yang): deprecate this. Use the 21317 + errStatusMsg
 *  - MODEL_EVALUATION_FAILED: Generic err code for eval failure.
 *  - MODEL_DEPLOYMENT_FAILED: Used when inference coordinator failed to deploy spire and throws an error
 *  - MODEL_DEPLOYING: Used when calling the inference coordinator to deploy a spire
 *  - MODEL_QUEUED_FOR_DEPLOYMENT: Used when training is completed
 *  - MODEL_NOT_DEPLOYED: Used when model spire deployment is manually taken down or due to inactivity
 *  - MODEL_LOADING: Used when the model pod is running, but not yet ready to serve requests.
 *  - MODEL_REFERENCE_INVALID_ARGUMENT: Used when a model reference field is not set properly
 *  - MODEL_EXAMPLE_INPUT_INVALID_ARGUMENT: Used when a model example input field is not set properly
 *  - MODEL_EXPORTED: Model Export status codes
 *  - WORKFLOW_NO_MATCHING_INPUT: specified model input not in workflow
 *  - WORKFLOW_REQUIRE_TRAINED_MODEL: specified model must be trained
 *  - WORKFLOW_INVALID_ARGUMENT: error in the request somewhere
 *  - WORKFLOW_INVALID_REQUEST: error in the request somewhere
 *  - CONCEPT_MODIFY_SUCCESS: Concept related 23xxx
 *  - ANNOTATION_SUCCESS: Annotation related 24xxx
 *  - ANNOTATION_AWAITING_REVIEW: Annotation is awaiting review from task REVIEWERS.
 *  - ANNOTATION_AWAITING_CONSENSUS_REVIEW: Annotation is awaiting consensus review from task LABELERS.
 *  - METADATA_INVALID_PATCH_ARGUMENTS: Metadata related 249xx
 *  - TRAINER_JOB_STATE_NONE: Training service related 25xxx
 *  - DATA_DUMP_SUCCESS: Data Dump related 251xx
 *  - DATA_DUMP_NO_DATA: DEPRECATED: Not used anymore. Now for an empty data dump, DATA_DUMP_SUCCESS is returned. To detect an empty data dump, check if the inptus count is 0.
 *  - APP_DUPLICATION_SUCCESS: Duplicate related 252xx
 *  - MODULE_DOES_NOT_EXIST: Module related codes 253xx
 *  - BULK_OPERATION_SUCCESS: Bulk Operation related codes 254xx
 *  - RUNNER_DOES_NOT_EXIST: Runner related codes 256xx
 *  - NODEPOOL_DOES_NOT_EXIST: Nodepool related codes 257xx
 *  - COMPUTE_CLUSTER_DOES_NOT_EXIST: ComputeCluster related codes 258xx
 *  - DEPLOYMENT_DOES_NOT_EXIST: Deployment related codes 259xx
 *  - INSTANCE_TYPE_DOES_NOT_EXIST: InstanceType related codes 260xx
 *  - COMPUTE_PLANE_METRICS_INVALID_REQUEST: Compute plane related codes 261xx
 *  - PIPELINE_STEP_DOES_NOT_EXIST: PipelineStep related codes 262xx
 *  - INPUT_SUCCESS: Input:Image related 30xxx
 *  - INPUT_PENDING: when things are async, this is the default status.
 *  - INPUT_FAILED: any type of error downloading and processing
 *  - INPUT_DOWNLOAD_SUCCESS: use INPUT_SUCCESS, INPUT_PENDING, INPUT_FAILED, INPUT_IN_PROGRESS instead
 * DOWNLOAD is no longer correct, but keep old statuses for backward compatibility
 *  - INPUT_VIDEO_DOWNLOAD_SUCCESS: Input:Video related 31xxx -- Deprecated
 *  - INPUT_WRITES_DISABLED_FOR_MAINTENANCE: deprecate this one. Use REQUEST_DISABLED_FOR_MAINTENANCE
 *  - PREDICT_INVALID_REQUEST: API formatting issues 4000x
 *  - DATABASE_DUPLICATE_KEY: Other related 400xx
 *  - EXTERNAL_CONNECTION_ERROR: could not connect to external services
 *  - QUEUE_CONN_ERROR: Queue related errors 41xxx
 *  - SQS_OVERLIMIT: SQS related errors 411xx
 *  - SEARCH_INTERNAL_FAILURE: Search related errors 43xxxx
 *  - EVALUATION_QUEUED: Workflow evaluation err code
 *  - STRIPE_EVENT_ERROR: Stripe 44xxx
 *  - CACHE_MISS: Redis/Cache 45xxx
 *  - SIGNUP_EVENT_ERROR: Sift Science 46xxx
 *  - APP_COUNT_INVALID_MESSAGE: Application counts related errors 470xx
 *  - MP_DOWNLOAD_ERROR: Media processor related errors 471xx -- DEPRECATED
 *  - DATATIER_CONN_ERROR: DataTier related error 472xx
 *  - USER_CONSENT_FACE: User legal consent stauts related 50xxx
 *  - WORKER_MISSING: Workers 51xxx
 *  - COLLECTOR_MISSING: Collectors 52xxx
 *  - SSO_IDENTITY_PROVIDER_DOES_NOT_EXIST: SSO 53xxx
 *  - TASK_IN_PROGRESS: Tasks 54xxx
 * The task was created.
 *  - TASK_DONE: The task is completed.
 *  - TASK_WONT_DO: The task is marked as abandoned.
 *  - TASK_FAILED: An error occurred during add-task-annotations or add-auto-annotations pipeline.
 *  - TASK_IDLE: When an Auto Annotation task job has finished processing its last batch and is waiting for more dataset assets.
 *  - TASK_CONFLICT: The task operation is in conflict with the current state of the server.
 *  - TASK_NOT_IMPLEMENTED: Certain task-related scenarios are not implemented.
 *  - TASK_MISSING: Task was not found.
 *  - TASK_PERMISSION_DENIED: Not allowed to perform a task-related action.
 *  - TASK_ASSIGNMENT_SUCCESS: Task Assignments 542xx
 *  - TASK_ASSIGNMENT_REVIEW_SUCCESS: Task Assignment Reviews 543xx
 *  - LABEL_ORDER_PENDING: Label Order Related Status Code 55xxx
 *  - LICENSE_ACTIVE: License Related Status Code 600xx
 *  - LICENSE_DELETED: hidden state not reflected to users
 *  - PASSWORD_VALIDATION_SUCCESS: Password Related Status Code
 *  - FEATUREFLAG_CONFIG_NOT_FOUND: Feature flags status code
 *  - MAINTENANCE_SUCCESS: Maintenance status code
 *  - DATASET_VERSION_PENDING: Datasets 64xxx
 * The dataset version is pending to be processed.
 *  - DATASET_VERSION_IN_PROGRESS: The dataset version is currently being processed.
 *  - DATASET_VERSION_READY: The dataset version is ready to be used.
 *  - DATASET_VERSION_FAILURE: An error occurred during the dataset version processing.
 *  - DATASET_VERSION_UNEXPECTED_ERROR: An unexpected error occurred during the dataset version processing.
 *  - DATASET_VERSION_CONFLICT: An alteration to dataset version would create a conflict
 *  - DATASET_INPUT_SUCCESS: The dataset input was successfully added.
 *  - DATASET_INPUT_DUPLICATE: The dataset input is a duplicate.
 * Deprecated: Unused.
 *  - DATASET_VERSION_EXPORT_SUCCESS: The dataset version export is completed.
 *  - DATASET_VERSION_EXPORT_PENDING: The dataset version is pending to be exported.
 *  - DATASET_VERSION_EXPORT_FAILED: An error occurred during the dataset version export.
 *  - DATASET_VERSION_EXPORT_IN_PROGRESS: The dataset version is currently being exported.
 *  - DATASET_VERSION_EXPORT_UNEXPECTED_ERROR: An unexpected error occurred during the dataset version export.
 *  - JOB_QUEUED: Generic Job status codes
 *  - AUTH_MISSING_IDP_ASSOC: auth issues
 *
 * TODO: Knowledge graph related 80xxx
 *  - UPLOAD_IN_PROGRESS: Multipart uploading status codes
 *  - BILLING_INVALID_INFO: Billing related issues: 69xxx
 *  - LOG_ENTRIES_INVALID_REQUEST: Logs related issues: 70000;
 *  - INTERNAL_SERVER_ISSUE: Internal issues: 98xxx
 *  - CONN_UNCATEGORIZED: Uncategorized: 99xxx: move off as soon as known
 *  - BAD_REQUEST: Deprecated: migrate off to one of the internal issues
 *  - SERVER_ERROR: Deprecated: migrate off to one of the internal issues
 * @default "ZERO"
 */
export enum StatusStatusCode {
  ZERO = 'ZERO',
  SUCCESS = 'SUCCESS',
  MIXED_STATUS = 'MIXED_STATUS',
  FAILURE = 'FAILURE',
  TRY_AGAIN = 'TRY_AGAIN',
  NOT_IMPLEMENTED = 'NOT_IMPLEMENTED',
  MOVED = 'MOVED',
  TEAPOT = 'TEAPOT',
  ACCEPTED = 'ACCEPTED',
  CONN_ACCOUNT_ISSUES = 'CONN_ACCOUNT_ISSUES',
  CONN_TOKEN_INVALID = 'CONN_TOKEN_INVALID',
  CONN_CREDENTIALS_INVALID = 'CONN_CREDENTIALS_INVALID',
  CONN_EXCEED_HOURLY_LIMIT = 'CONN_EXCEED_HOURLY_LIMIT',
  CONN_EXCEED_MONTHLY_LIMIT = 'CONN_EXCEED_MONTHLY_LIMIT',
  CONN_THROTTLED = 'CONN_THROTTLED',
  CONN_EXCEEDS_LIMITS = 'CONN_EXCEEDS_LIMITS',
  CONN_INSUFFICIENT_SCOPES = 'CONN_INSUFFICIENT_SCOPES',
  CONN_KEY_INVALID = 'CONN_KEY_INVALID',
  CONN_KEY_NOT_FOUND = 'CONN_KEY_NOT_FOUND',
  CONN_BAD_REQUEST_FORMAT = 'CONN_BAD_REQUEST_FORMAT',
  CONN_DOES_NOT_EXIST = 'CONN_DOES_NOT_EXIST',
  CONN_INVALID_REQUEST = 'CONN_INVALID_REQUEST',
  CONN_METHOD_NOT_ALLOWED = 'CONN_METHOD_NOT_ALLOWED',
  CONN_NO_GDPR_CONSENT = 'CONN_NO_GDPR_CONSENT',
  CONN_INVALID_RANGE = 'CONN_INVALID_RANGE',
  CONN_AUTH_METHOD_DISABLED = 'CONN_AUTH_METHOD_DISABLED',
  MODEL_TRAINED = 'MODEL_TRAINED',
  MODEL_TRAINING = 'MODEL_TRAINING',
  MODEL_UNTRAINED = 'MODEL_UNTRAINED',
  MODEL_QUEUED_FOR_TRAINING = 'MODEL_QUEUED_FOR_TRAINING',
  MODEL_UPLOADING = 'MODEL_UPLOADING',
  MODEL_UPLOADING_FAILED = 'MODEL_UPLOADING_FAILED',
  MODEL_TRAINING_FAILED = 'MODEL_TRAINING_FAILED',
  MODEL_BUILDING = 'MODEL_BUILDING',
  MODEL_BUILDING_FAILED = 'MODEL_BUILDING_FAILED',
  MODEL_BUILD_UNEXPECTED_ERROR = 'MODEL_BUILD_UNEXPECTED_ERROR',
  MODEL_TRAINING_NO_DATA = 'MODEL_TRAINING_NO_DATA',
  MODEL_TRAINING_NO_POSITIVES = 'MODEL_TRAINING_NO_POSITIVES',
  MODEL_TRAINING_ONE_VS_N_SINGLE_CLASS = 'MODEL_TRAINING_ONE_VS_N_SINGLE_CLASS',
  MODEL_TRAINING_TIMED_OUT = 'MODEL_TRAINING_TIMED_OUT',
  MODEL_TRAINING_WAITING_ERROR = 'MODEL_TRAINING_WAITING_ERROR',
  MODEL_TRAINING_UNKNOWN_ERROR = 'MODEL_TRAINING_UNKNOWN_ERROR',
  MODEL_TRAINING_MSG_REDELIVER = 'MODEL_TRAINING_MSG_REDELIVER',
  MODEL_TRAINING_INSUFFICIENT_DATA = 'MODEL_TRAINING_INSUFFICIENT_DATA',
  MODEL_TRAINING_INVALID_PARAMS = 'MODEL_TRAINING_INVALID_PARAMS',
  MODEL_TRAINING_INVALID_DATA_TOLERANCE_EXCEEDED = 'MODEL_TRAINING_INVALID_DATA_TOLERANCE_EXCEEDED',
  MODEL_MODIFY_SUCCESS = 'MODEL_MODIFY_SUCCESS',
  MODEL_MODIFY_PENDING = 'MODEL_MODIFY_PENDING',
  MODEL_MODIFY_FAILED = 'MODEL_MODIFY_FAILED',
  MODEL_DOES_NOT_EXIST = 'MODEL_DOES_NOT_EXIST',
  MODEL_PERMISSION_DENIED = 'MODEL_PERMISSION_DENIED',
  MODEL_INVALID_ARGUMENT = 'MODEL_INVALID_ARGUMENT',
  MODEL_INVALID_REQUEST = 'MODEL_INVALID_REQUEST',
  MODEL_EVALUATED = 'MODEL_EVALUATED',
  MODEL_EVALUATING = 'MODEL_EVALUATING',
  MODEL_NOT_EVALUATED = 'MODEL_NOT_EVALUATED',
  MODEL_QUEUED_FOR_EVALUATION = 'MODEL_QUEUED_FOR_EVALUATION',
  MODEL_EVALUATION_TIMED_OUT = 'MODEL_EVALUATION_TIMED_OUT',
  MODEL_EVALUATION_WAITING_ERROR = 'MODEL_EVALUATION_WAITING_ERROR',
  MODEL_EVALUATION_UNKNOWN_ERROR = 'MODEL_EVALUATION_UNKNOWN_ERROR',
  MODEL_PREDICTION_FAILED = 'MODEL_PREDICTION_FAILED',
  MODEL_EVALUATION_MSG_REDELIVER = 'MODEL_EVALUATION_MSG_REDELIVER',
  MODEL_EVALUATION_NEED_LABELS = 'MODEL_EVALUATION_NEED_LABELS',
  MODEL_EVALUATION_NEED_INPUTS = 'MODEL_EVALUATION_NEED_INPUTS',
  MODEL_EVALUATION_FAILED = 'MODEL_EVALUATION_FAILED',
  MODEL_DEPLOYMENT_FAILED = 'MODEL_DEPLOYMENT_FAILED',
  MODEL_DEPLOYING = 'MODEL_DEPLOYING',
  MODEL_QUEUED_FOR_DEPLOYMENT = 'MODEL_QUEUED_FOR_DEPLOYMENT',
  MODEL_NOT_DEPLOYED = 'MODEL_NOT_DEPLOYED',
  MODEL_BUSY_PLEASE_RETRY = 'MODEL_BUSY_PLEASE_RETRY',
  MODEL_LOADING = 'MODEL_LOADING',
  MODEL_REFERENCE_INVALID_ARGUMENT = 'MODEL_REFERENCE_INVALID_ARGUMENT',
  MODEL_EXAMPLE_INPUT_INVALID_ARGUMENT = 'MODEL_EXAMPLE_INPUT_INVALID_ARGUMENT',
  MODEL_EXPORTED = 'MODEL_EXPORTED',
  MODEL_EXPORTING = 'MODEL_EXPORTING',
  MODEL_EXPORTING_FAILED = 'MODEL_EXPORTING_FAILED',
  MODEL_EXPORT_PENDING = 'MODEL_EXPORT_PENDING',
  WORKFLOW_NO_MATCHING_INPUT = 'WORKFLOW_NO_MATCHING_INPUT',
  WORKFLOW_REQUIRE_TRAINED_MODEL = 'WORKFLOW_REQUIRE_TRAINED_MODEL',
  WORKFLOW_DUPLICATE = 'WORKFLOW_DUPLICATE',
  WORKFLOW_UNSUPPORTED_FORMAT = 'WORKFLOW_UNSUPPORTED_FORMAT',
  WORKFLOW_DOES_NOT_EXIST = 'WORKFLOW_DOES_NOT_EXIST',
  WORKFLOW_PERMISSION_DENIED = 'WORKFLOW_PERMISSION_DENIED',
  WORKFLOW_INVALID_ARGUMENT = 'WORKFLOW_INVALID_ARGUMENT',
  WORKFLOW_INVALID_RECIPE = 'WORKFLOW_INVALID_RECIPE',
  WORKFLOW_INVALID_TEMPLATE = 'WORKFLOW_INVALID_TEMPLATE',
  WORKFLOW_INVALID_GRAPH = 'WORKFLOW_INVALID_GRAPH',
  WORKFLOW_INTERNAL_FAILURE = 'WORKFLOW_INTERNAL_FAILURE',
  WORKFLOW_INVALID_REQUEST = 'WORKFLOW_INVALID_REQUEST',
  WORKFLOW_MODIFY_SUCCESS = 'WORKFLOW_MODIFY_SUCCESS',
  WORKFLOW_MODIFY_PENDING = 'WORKFLOW_MODIFY_PENDING',
  WORKFLOW_MODIFY_FAILED = 'WORKFLOW_MODIFY_FAILED',
  WORKFLOW_REINDEX_FAILED = 'WORKFLOW_REINDEX_FAILED',
  CONCEPT_MODIFY_SUCCESS = 'CONCEPT_MODIFY_SUCCESS',
  CONCEPT_MODIFY_PENDING = 'CONCEPT_MODIFY_PENDING',
  CONCEPT_MODIFY_FAILED = 'CONCEPT_MODIFY_FAILED',
  ANNOTATION_SUCCESS = 'ANNOTATION_SUCCESS',
  ANNOTATION_PENDING = 'ANNOTATION_PENDING',
  ANNOTATION_FAILED = 'ANNOTATION_FAILED',
  ANNOTATION_UNKNOWN_STATUS = 'ANNOTATION_UNKNOWN_STATUS',
  ANNOTATION_INVALID_ARGUMENT = 'ANNOTATION_INVALID_ARGUMENT',
  ANNOTATION_PERMISSION_DENIED = 'ANNOTATION_PERMISSION_DENIED',
  ANNOTATION_AWAITING_REVIEW = 'ANNOTATION_AWAITING_REVIEW',
  ANNOTATION_AWAITING_CONSENSUS_REVIEW = 'ANNOTATION_AWAITING_CONSENSUS_REVIEW',
  ANNOTATION_REVIEW_DENIED = 'ANNOTATION_REVIEW_DENIED',
  ANNOTATION_MODIFY_SUCCESS = 'ANNOTATION_MODIFY_SUCCESS',
  ANNOTATION_MODIFY_PENDING = 'ANNOTATION_MODIFY_PENDING',
  ANNOTATION_MODIFY_FAILED = 'ANNOTATION_MODIFY_FAILED',
  METADATA_INVALID_PATCH_ARGUMENTS = 'METADATA_INVALID_PATCH_ARGUMENTS',
  METADATA_PARSING_ISSUE = 'METADATA_PARSING_ISSUE',
  METADATA_MANIPULATION_ISSUE = 'METADATA_MANIPULATION_ISSUE',
  TRAINER_JOB_STATE_NONE = 'TRAINER_JOB_STATE_NONE',
  TRAINER_JOB_STATE_QUEUED = 'TRAINER_JOB_STATE_QUEUED',
  TRAINER_JOB_STATE_RUNNING = 'TRAINER_JOB_STATE_RUNNING',
  TRAINER_JOB_STATE_COMPLETE = 'TRAINER_JOB_STATE_COMPLETE',
  TRAINER_JOB_STATE_ERROR = 'TRAINER_JOB_STATE_ERROR',
  DATA_DUMP_SUCCESS = 'DATA_DUMP_SUCCESS',
  DATA_DUMP_PENDING = 'DATA_DUMP_PENDING',
  DATA_DUMP_FAILED = 'DATA_DUMP_FAILED',
  DATA_DUMP_IN_PROGRESS = 'DATA_DUMP_IN_PROGRESS',
  DATA_DUMP_NO_DATA = 'DATA_DUMP_NO_DATA',
  DATA_DUMP_UNEXPECTED_ERROR = 'DATA_DUMP_UNEXPECTED_ERROR',
  DATA_DUMP_EXPORT_SUCCESS = 'DATA_DUMP_EXPORT_SUCCESS',
  DATA_DUMP_EXPORT_PENDING = 'DATA_DUMP_EXPORT_PENDING',
  DATA_DUMP_EXPORT_FAILED = 'DATA_DUMP_EXPORT_FAILED',
  DATA_DUMP_EXPORT_IN_PROGRESS = 'DATA_DUMP_EXPORT_IN_PROGRESS',
  DATA_DUMP_EXPORT_UNEXPECTED_ERROR = 'DATA_DUMP_EXPORT_UNEXPECTED_ERROR',
  APP_DUPLICATION_SUCCESS = 'APP_DUPLICATION_SUCCESS',
  APP_DUPLICATION_FAILED = 'APP_DUPLICATION_FAILED',
  APP_DUPLICATION_PENDING = 'APP_DUPLICATION_PENDING',
  APP_DUPLICATION_IN_PROGRESS = 'APP_DUPLICATION_IN_PROGRESS',
  APP_DUPLICATION_INVALID_REQUEST = 'APP_DUPLICATION_INVALID_REQUEST',
  MODULE_DOES_NOT_EXIST = 'MODULE_DOES_NOT_EXIST',
  MODULE_PERMISSION_DENIED = 'MODULE_PERMISSION_DENIED',
  MODULE_INVALID_ARGUMENT = 'MODULE_INVALID_ARGUMENT',
  MODULE_INVALID_REQUEST = 'MODULE_INVALID_REQUEST',
  BULK_OPERATION_SUCCESS = 'BULK_OPERATION_SUCCESS',
  BULK_OPERATION_FAILED = 'BULK_OPERATION_FAILED',
  BULK_OPERATION_PENDING = 'BULK_OPERATION_PENDING',
  BULK_OPERATION_IN_PROGRESS = 'BULK_OPERATION_IN_PROGRESS',
  BULK_OPERATION_INVALID_REQUEST = 'BULK_OPERATION_INVALID_REQUEST',
  BULK_OPERATION_CANCELLED = 'BULK_OPERATION_CANCELLED',
  BULK_OPERATION_UNEXPECTED_ERROR = 'BULK_OPERATION_UNEXPECTED_ERROR',
  RUNNER_DOES_NOT_EXIST = 'RUNNER_DOES_NOT_EXIST',
  RUNNER_PERMISSION_DENIED = 'RUNNER_PERMISSION_DENIED',
  RUNNER_INVALID_ARGUMENT = 'RUNNER_INVALID_ARGUMENT',
  RUNNER_INVALID_REQUEST = 'RUNNER_INVALID_REQUEST',
  RUNNER_NEEDS_RETRY = 'RUNNER_NEEDS_RETRY',
  RUNNER_STREAM_START = 'RUNNER_STREAM_START',
  RUNNER_STREAM_END = 'RUNNER_STREAM_END',
  RUNNER_ITEM_CANCELLED = 'RUNNER_ITEM_CANCELLED',
  RUNNER_PROCESSING_FAILED = 'RUNNER_PROCESSING_FAILED',
  NODEPOOL_DOES_NOT_EXIST = 'NODEPOOL_DOES_NOT_EXIST',
  NODEPOOL_INVALID_ARGUMENT = 'NODEPOOL_INVALID_ARGUMENT',
  NODEPOOL_INVALID_REQUEST = 'NODEPOOL_INVALID_REQUEST',
  COMPUTE_CLUSTER_DOES_NOT_EXIST = 'COMPUTE_CLUSTER_DOES_NOT_EXIST',
  COMPUTE_CLUSTER_INVALID_ARGUMENT = 'COMPUTE_CLUSTER_INVALID_ARGUMENT',
  COMPUTE_CLUSTER_INVALID_REQUEST = 'COMPUTE_CLUSTER_INVALID_REQUEST',
  DEPLOYMENT_DOES_NOT_EXIST = 'DEPLOYMENT_DOES_NOT_EXIST',
  DEPLOYMENT_INVALID_ARGUMENT = 'DEPLOYMENT_INVALID_ARGUMENT',
  DEPLOYMENT_INVALID_REQUEST = 'DEPLOYMENT_INVALID_REQUEST',
  INSTANCE_TYPE_DOES_NOT_EXIST = 'INSTANCE_TYPE_DOES_NOT_EXIST',
  INSTANCE_TYPE_INVALID_ARGUMENT = 'INSTANCE_TYPE_INVALID_ARGUMENT',
  INSTANCE_TYPE_INVALID_REQUEST = 'INSTANCE_TYPE_INVALID_REQUEST',
  COMPUTE_PLANE_METRICS_INVALID_REQUEST = 'COMPUTE_PLANE_METRICS_INVALID_REQUEST',
  PIPELINE_STEP_DOES_NOT_EXIST = 'PIPELINE_STEP_DOES_NOT_EXIST',
  PIPELINE_STEP_INVALID_ARGUMENT = 'PIPELINE_STEP_INVALID_ARGUMENT',
  PIPELINE_STEP_INVALID_REQUEST = 'PIPELINE_STEP_INVALID_REQUEST',
  PIPELINE_STEP_UPLOADING = 'PIPELINE_STEP_UPLOADING',
  PIPELINE_STEP_UPLOADING_FAILED = 'PIPELINE_STEP_UPLOADING_FAILED',
  PIPELINE_STEP_BUILDING = 'PIPELINE_STEP_BUILDING',
  PIPELINE_STEP_BUILDING_FAILED = 'PIPELINE_STEP_BUILDING_FAILED',
  PIPELINE_STEP_BUILD_UNEXPECTED_ERROR = 'PIPELINE_STEP_BUILD_UNEXPECTED_ERROR',
  PIPELINE_STEP_READY = 'PIPELINE_STEP_READY',
  PIPELINE_STEP_NOT_READY = 'PIPELINE_STEP_NOT_READY',
  INPUT_SUCCESS = 'INPUT_SUCCESS',
  INPUT_PENDING = 'INPUT_PENDING',
  INPUT_FAILED = 'INPUT_FAILED',
  INPUT_IN_PROGRESS = 'INPUT_IN_PROGRESS',
  INPUT_DOWNLOAD_SUCCESS = 'INPUT_DOWNLOAD_SUCCESS',
  INPUT_DOWNLOAD_PENDING = 'INPUT_DOWNLOAD_PENDING',
  INPUT_DOWNLOAD_FAILED = 'INPUT_DOWNLOAD_FAILED',
  INPUT_DOWNLOAD_IN_PROGRESS = 'INPUT_DOWNLOAD_IN_PROGRESS',
  INPUT_STATUS_UPDATE_FAILED = 'INPUT_STATUS_UPDATE_FAILED',
  INPUT_DELETE_FAILED = 'INPUT_DELETE_FAILED',
  INPUT_DUPLICATE = 'INPUT_DUPLICATE',
  INPUT_UNSUPPORTED_FORMAT = 'INPUT_UNSUPPORTED_FORMAT',
  INPUT_DOES_NOT_EXIST = 'INPUT_DOES_NOT_EXIST',
  INPUT_PERMISSION_DENIED = 'INPUT_PERMISSION_DENIED',
  INPUT_INVALID_ARGUMENT = 'INPUT_INVALID_ARGUMENT',
  INPUT_OVER_LIMIT = 'INPUT_OVER_LIMIT',
  INPUT_INVALID_URL = 'INPUT_INVALID_URL',
  INPUT_MODIFY_SUCCESS = 'INPUT_MODIFY_SUCCESS',
  INPUT_MODIFY_PENDING = 'INPUT_MODIFY_PENDING',
  INPUT_MODIFY_FAILED = 'INPUT_MODIFY_FAILED',
  INPUT_STORAGE_HOST_FAILED = 'INPUT_STORAGE_HOST_FAILED',
  ALL_INPUT_INVALID_BYTES = 'ALL_INPUT_INVALID_BYTES',
  INPUT_CLUSTER_SUCCESS = 'INPUT_CLUSTER_SUCCESS',
  INPUT_CLUSTER_PENDING = 'INPUT_CLUSTER_PENDING',
  INPUT_CLUSTER_FAILED = 'INPUT_CLUSTER_FAILED',
  INPUT_CLUSTER_IN_PROGRESS = 'INPUT_CLUSTER_IN_PROGRESS',
  INPUT_REINDEX_SUCCESS = 'INPUT_REINDEX_SUCCESS',
  INPUT_REINDEX_PENDING = 'INPUT_REINDEX_PENDING',
  INPUT_REINDEX_FAILED = 'INPUT_REINDEX_FAILED',
  INPUT_REINDEX_IN_PROGRESS = 'INPUT_REINDEX_IN_PROGRESS',
  INPUT_VIDEO_DOWNLOAD_SUCCESS = 'INPUT_VIDEO_DOWNLOAD_SUCCESS',
  INPUT_VIDEO_DOWNLOAD_PENDING = 'INPUT_VIDEO_DOWNLOAD_PENDING',
  INPUT_VIDEO_DOWNLOAD_FAILED = 'INPUT_VIDEO_DOWNLOAD_FAILED',
  INPUT_VIDEO_DUPLICATE = 'INPUT_VIDEO_DUPLICATE',
  INPUT_VIDEO_UNSUPPORTED_FORMAT = 'INPUT_VIDEO_UNSUPPORTED_FORMAT',
  INPUT_VIDEO_DOES_NOT_EXIST = 'INPUT_VIDEO_DOES_NOT_EXIST',
  INPUT_VIDEO_PERMISSION_DENIED = 'INPUT_VIDEO_PERMISSION_DENIED',
  INPUT_VIDEO_INVALID_ARGUMENT = 'INPUT_VIDEO_INVALID_ARGUMENT',
  INPUT_VIDEO_OVER_LIMIT = 'INPUT_VIDEO_OVER_LIMIT',
  INPUT_VIDEO_INVALID_URL = 'INPUT_VIDEO_INVALID_URL',
  INPUT_VIDEO_MODIFY_SUCCESS = 'INPUT_VIDEO_MODIFY_SUCCESS',
  INPUT_VIDEO_MODIFY_PENDING = 'INPUT_VIDEO_MODIFY_PENDING',
  INPUT_VIDEO_MODIFY_FAILED = 'INPUT_VIDEO_MODIFY_FAILED',
  INPUT_VIDEO_STORAGE_HOST_FAILED = 'INPUT_VIDEO_STORAGE_HOST_FAILED',
  ALL_INPUT_VIDEOS_INVALID_BYTES = 'ALL_INPUT_VIDEOS_INVALID_BYTES',
  INPUT_VIDEO_PROCESSING_SUCCESS = 'INPUT_VIDEO_PROCESSING_SUCCESS',
  INPUT_VIDEO_PROCESSING_PENDING = 'INPUT_VIDEO_PROCESSING_PENDING',
  INPUT_VIDEO_PROCESSING_FAILED = 'INPUT_VIDEO_PROCESSING_FAILED',
  INPUT_VIDEO_STORAGE_INCONSISTENCY = 'INPUT_VIDEO_STORAGE_INCONSISTENCY',
  INPUT_VIDEO_STORAGE_FAILURE = 'INPUT_VIDEO_STORAGE_FAILURE',
  INPUT_VIDEO_URL_GENERATION_FAILURE = 'INPUT_VIDEO_URL_GENERATION_FAILURE',
  INPUT_CONNECTION_FAILED = 'INPUT_CONNECTION_FAILED',
  REQUEST_DISABLED_FOR_MAINTENANCE = 'REQUEST_DISABLED_FOR_MAINTENANCE',
  INPUT_WRITES_DISABLED_FOR_MAINTENANCE = 'INPUT_WRITES_DISABLED_FOR_MAINTENANCE',
  INPUT_INVALID_REQUEST = 'INPUT_INVALID_REQUEST',
  PREDICT_INVALID_REQUEST = 'PREDICT_INVALID_REQUEST',
  SEARCH_INVALID_REQUEST = 'SEARCH_INVALID_REQUEST',
  CONCEPTS_INVALID_REQUEST = 'CONCEPTS_INVALID_REQUEST',
  STATS_INVALID_REQUEST = 'STATS_INVALID_REQUEST',
  DATABASE_DUPLICATE_KEY = 'DATABASE_DUPLICATE_KEY',
  DATABASE_STATEMENT_TIMEOUT = 'DATABASE_STATEMENT_TIMEOUT',
  DATABASE_INVALID_ROWS_AFFECTED = 'DATABASE_INVALID_ROWS_AFFECTED',
  DATABASE_DEADLOCK_DETECTED = 'DATABASE_DEADLOCK_DETECTED',
  DATABASE_FAIL_TASK = 'DATABASE_FAIL_TASK',
  DATABASE_FAIL_TO_GET_CONNECTIONS = 'DATABASE_FAIL_TO_GET_CONNECTIONS',
  DATABASE_TOO_MANY_CLIENTS = 'DATABASE_TOO_MANY_CLIENTS',
  DATABASE_CONSTRAINT_VIOLATED = 'DATABASE_CONSTRAINT_VIOLATED',
  DATABASE_CANCELED = 'DATABASE_CANCELED',
  ASYNC_WORKER_MULTI_ERRORS = 'ASYNC_WORKER_MULTI_ERRORS',
  RPC_REQUEST_QUEUE_FULL = 'RPC_REQUEST_QUEUE_FULL',
  RPC_SERVER_UNAVAILABLE = 'RPC_SERVER_UNAVAILABLE',
  RPC_REQUEST_TIMEOUT = 'RPC_REQUEST_TIMEOUT',
  RPC_MAX_MESSAGE_SIZE_EXCEEDED = 'RPC_MAX_MESSAGE_SIZE_EXCEEDED',
  RPC_CANCELED = 'RPC_CANCELED',
  RPC_UNKNOWN_METHOD = 'RPC_UNKNOWN_METHOD',
  REQUEST_CANCELED_BY_USER = 'REQUEST_CANCELED_BY_USER',
  CLUSTER_INTERNAL_FAILURE = 'CLUSTER_INTERNAL_FAILURE',
  EXTERNAL_CONNECTION_ERROR = 'EXTERNAL_CONNECTION_ERROR',
  QUERY_INVALID_SYNTAX = 'QUERY_INVALID_SYNTAX',
  QUEUE_CONN_ERROR = 'QUEUE_CONN_ERROR',
  QUEUE_CLOSE_REQUEST_TIMEOUT = 'QUEUE_CLOSE_REQUEST_TIMEOUT',
  QUEUE_CONN_CLOSED = 'QUEUE_CONN_CLOSED',
  QUEUE_PUBLISH_ACK_TIMEOUT = 'QUEUE_PUBLISH_ACK_TIMEOUT',
  QUEUE_PUBLISH_ERROR = 'QUEUE_PUBLISH_ERROR',
  QUEUE_SUBSCRIPTION_TIMEOUT = 'QUEUE_SUBSCRIPTION_TIMEOUT',
  QUEUE_SUBSCRIPTION_ERROR = 'QUEUE_SUBSCRIPTION_ERROR',
  QUEUE_MARSHALLING_FAILED = 'QUEUE_MARSHALLING_FAILED',
  QUEUE_UNMARSHALLING_FAILED = 'QUEUE_UNMARSHALLING_FAILED',
  QUEUE_MAX_MSG_REDELIVERY_EXCEEDED = 'QUEUE_MAX_MSG_REDELIVERY_EXCEEDED',
  QUEUE_ACK_FAILURE = 'QUEUE_ACK_FAILURE',
  SQS_OVERLIMIT = 'SQS_OVERLIMIT',
  SQS_INVALID_RECEIPT_HANDLE = 'SQS_INVALID_RECEIPT_HANDLE',
  SQS_UNKNOWN = 'SQS_UNKNOWN',
  SEARCH_INTERNAL_FAILURE = 'SEARCH_INTERNAL_FAILURE',
  SEARCH_PROJECTION_FAILURE = 'SEARCH_PROJECTION_FAILURE',
  SEARCH_PREDICTION_FAILURE = 'SEARCH_PREDICTION_FAILURE',
  SEARCH_BY_NOT_FULLY_INDEXED_INPUT = 'SEARCH_BY_NOT_FULLY_INDEXED_INPUT',
  SAVED_SEARCH_MODIFY_FAILED = 'SAVED_SEARCH_MODIFY_FAILED',
  SEARCH_COUNTS_UNAVAILABLE = 'SEARCH_COUNTS_UNAVAILABLE',
  EVALUATION_QUEUED = 'EVALUATION_QUEUED',
  EVALUATION_IN_PROGRESS = 'EVALUATION_IN_PROGRESS',
  EVALUATION_SUCCESS = 'EVALUATION_SUCCESS',
  EVALUATION_FAILED_TO_RETRIEVE_DATA = 'EVALUATION_FAILED_TO_RETRIEVE_DATA',
  EVALUATION_INVALID_ARGUMENT = 'EVALUATION_INVALID_ARGUMENT',
  EVALUATION_FAILED = 'EVALUATION_FAILED',
  EVALUATION_PENDING = 'EVALUATION_PENDING',
  EVALUATION_TIMED_OUT = 'EVALUATION_TIMED_OUT',
  EVALUATION_UNEXPECTED_ERROR = 'EVALUATION_UNEXPECTED_ERROR',
  EVALUATION_MIXED = 'EVALUATION_MIXED',
  STRIPE_EVENT_ERROR = 'STRIPE_EVENT_ERROR',
  CACHE_MISS = 'CACHE_MISS',
  REDIS_SCRIPT_EXITED_WITH_FAILURE = 'REDIS_SCRIPT_EXITED_WITH_FAILURE',
  REDIS_STREAM_ERR = 'REDIS_STREAM_ERR',
  REDIS_NO_CONSUMERS = 'REDIS_NO_CONSUMERS',
  REDIS_STREAM_BACKOFF = 'REDIS_STREAM_BACKOFF',
  SIGNUP_EVENT_ERROR = 'SIGNUP_EVENT_ERROR',
  SIGNUP_FLAGGED = 'SIGNUP_FLAGGED',
  FILETYPE_UNSUPPORTED = 'FILETYPE_UNSUPPORTED',
  APP_COUNT_INVALID_MESSAGE = 'APP_COUNT_INVALID_MESSAGE',
  APP_COUNT_UPDATE_INCREMENT_FAILED = 'APP_COUNT_UPDATE_INCREMENT_FAILED',
  APP_COUNT_REBUILD_FAILED = 'APP_COUNT_REBUILD_FAILED',
  APP_COUNT_INTERNAL_FAILURE = 'APP_COUNT_INTERNAL_FAILURE',
  MP_DOWNLOAD_ERROR = 'MP_DOWNLOAD_ERROR',
  MP_RESOLVE_DNS_ERROR = 'MP_RESOLVE_DNS_ERROR',
  MP_DOWNLOAD_MAX_SIZE_EXCEEDED_ERROR = 'MP_DOWNLOAD_MAX_SIZE_EXCEEDED_ERROR',
  MP_IMAGE_DECODE_ERROR = 'MP_IMAGE_DECODE_ERROR',
  MP_INVALID_ARGUMENT = 'MP_INVALID_ARGUMENT',
  MP_IMAGE_PROCESSING_ERROR = 'MP_IMAGE_PROCESSING_ERROR',
  DATATIER_CONN_ERROR = 'DATATIER_CONN_ERROR',
  USER_CONSENT_FACE = 'USER_CONSENT_FACE',
  WORKER_MISSING = 'WORKER_MISSING',
  WORKER_ACTIVE = 'WORKER_ACTIVE',
  WORKER_INACTIVE = 'WORKER_INACTIVE',
  COLLECTOR_MISSING = 'COLLECTOR_MISSING',
  COLLECTOR_ACTIVE = 'COLLECTOR_ACTIVE',
  COLLECTOR_INACTIVE = 'COLLECTOR_INACTIVE',
  COLLECTOR_POST_INPUT_FAILED = 'COLLECTOR_POST_INPUT_FAILED',
  SSO_IDENTITY_PROVIDER_DOES_NOT_EXIST = 'SSO_IDENTITY_PROVIDER_DOES_NOT_EXIST',
  TASK_IN_PROGRESS = 'TASK_IN_PROGRESS',
  TASK_DONE = 'TASK_DONE',
  TASK_WONT_DO = 'TASK_WONT_DO',
  TASK_FAILED = 'TASK_FAILED',
  TASK_IDLE = 'TASK_IDLE',
  TASK_CONFLICT = 'TASK_CONFLICT',
  TASK_NOT_IMPLEMENTED = 'TASK_NOT_IMPLEMENTED',
  TASK_MISSING = 'TASK_MISSING',
  TASK_PERMISSION_DENIED = 'TASK_PERMISSION_DENIED',
  TASK_ASSIGNMENT_SUCCESS = 'TASK_ASSIGNMENT_SUCCESS',
  TASK_ASSIGNMENT_PENDING = 'TASK_ASSIGNMENT_PENDING',
  TASK_ASSIGNMENT_AWAITING_REVIEW = 'TASK_ASSIGNMENT_AWAITING_REVIEW',
  TASK_ASSIGNMENT_AWAITING_CONSENSUS_REVIEW = 'TASK_ASSIGNMENT_AWAITING_CONSENSUS_REVIEW',
  TASK_ASSIGNMENT_REJECTED = 'TASK_ASSIGNMENT_REJECTED',
  TASK_ASSIGNMENT_REVIEW_SUCCESS = 'TASK_ASSIGNMENT_REVIEW_SUCCESS',
  TASK_ASSIGNMENT_REVIEW_PENDING = 'TASK_ASSIGNMENT_REVIEW_PENDING',
  TASK_ASSIGNMENT_REVIEW_DISMISSED = 'TASK_ASSIGNMENT_REVIEW_DISMISSED',
  LABEL_ORDER_PENDING = 'LABEL_ORDER_PENDING',
  LABEL_ORDER_IN_PROGRESS = 'LABEL_ORDER_IN_PROGRESS',
  LABEL_ORDER_SUCCESS = 'LABEL_ORDER_SUCCESS',
  LABEL_ORDER_CANCELED = 'LABEL_ORDER_CANCELED',
  LICENSE_ACTIVE = 'LICENSE_ACTIVE',
  LICENSE_DOES_NOT_EXIST = 'LICENSE_DOES_NOT_EXIST',
  LICENSE_NEED_UPDATE = 'LICENSE_NEED_UPDATE',
  LICENSE_EXPIRED = 'LICENSE_EXPIRED',
  LICENSE_REVOKED = 'LICENSE_REVOKED',
  LICENSE_DELETED = 'LICENSE_DELETED',
  LICENSE_VOLUME_EXCEEDED = 'LICENSE_VOLUME_EXCEEDED',
  PASSWORD_VALIDATION_SUCCESS = 'PASSWORD_VALIDATION_SUCCESS',
  PASSWORD_VALIDATION_FAILED = 'PASSWORD_VALIDATION_FAILED',
  PASSWORDPOLICY_INVALID_ARGUMENT = 'PASSWORDPOLICY_INVALID_ARGUMENT',
  FEATUREFLAG_CONFIG_NOT_FOUND = 'FEATUREFLAG_CONFIG_NOT_FOUND',
  FEATUREFLAG_INVALID_ARGUMENT = 'FEATUREFLAG_INVALID_ARGUMENT',
  FEATUREFLAG_BLOCKED = 'FEATUREFLAG_BLOCKED',
  FEATUREFLAG_NOT_FOUND = 'FEATUREFLAG_NOT_FOUND',
  MAINTENANCE_SUCCESS = 'MAINTENANCE_SUCCESS',
  MAINTENANCE_FAILED = 'MAINTENANCE_FAILED',
  DATASET_VERSION_PENDING = 'DATASET_VERSION_PENDING',
  DATASET_VERSION_IN_PROGRESS = 'DATASET_VERSION_IN_PROGRESS',
  DATASET_VERSION_READY = 'DATASET_VERSION_READY',
  DATASET_VERSION_FAILURE = 'DATASET_VERSION_FAILURE',
  DATASET_VERSION_UNEXPECTED_ERROR = 'DATASET_VERSION_UNEXPECTED_ERROR',
  DATASET_VERSION_CONFLICT = 'DATASET_VERSION_CONFLICT',
  DATASET_INPUT_SUCCESS = 'DATASET_INPUT_SUCCESS',
  DATASET_INPUT_DUPLICATE = 'DATASET_INPUT_DUPLICATE',
  DATASET_VERSION_EXPORT_SUCCESS = 'DATASET_VERSION_EXPORT_SUCCESS',
  DATASET_VERSION_EXPORT_PENDING = 'DATASET_VERSION_EXPORT_PENDING',
  DATASET_VERSION_EXPORT_FAILED = 'DATASET_VERSION_EXPORT_FAILED',
  DATASET_VERSION_EXPORT_IN_PROGRESS = 'DATASET_VERSION_EXPORT_IN_PROGRESS',
  DATASET_VERSION_EXPORT_UNEXPECTED_ERROR = 'DATASET_VERSION_EXPORT_UNEXPECTED_ERROR',
  JOB_QUEUED = 'JOB_QUEUED',
  JOB_RUNNING = 'JOB_RUNNING',
  JOB_COMPLETED = 'JOB_COMPLETED',
  JOB_FAILED = 'JOB_FAILED',
  JOB_CANCELLED = 'JOB_CANCELLED',
  JOB_UNEXPECTED_ERROR = 'JOB_UNEXPECTED_ERROR',
  JOB_CONFLICT = 'JOB_CONFLICT',
  AUTH_MISSING_IDP_ASSOC = 'AUTH_MISSING_IDP_ASSOC',
  LIST_OBJECTS_FAILED = 'LIST_OBJECTS_FAILED',
  ARCHIVE_EXTRACT_FAILED = 'ARCHIVE_EXTRACT_FAILED',
  UPLOAD_IN_PROGRESS = 'UPLOAD_IN_PROGRESS',
  UPLOAD_DONE = 'UPLOAD_DONE',
  UPLOAD_FAILED = 'UPLOAD_FAILED',
  UPLOAD_UNEXPECTED_ERROR = 'UPLOAD_UNEXPECTED_ERROR',
  UPLOAD_EXPIRED = 'UPLOAD_EXPIRED',
  UPLOAD_CANCELED = 'UPLOAD_CANCELED',
  UPLOAD_CONFLICT = 'UPLOAD_CONFLICT',
  BILLING_INVALID_INFO = 'BILLING_INVALID_INFO',
  BILLING_MISSING_TOKENS = 'BILLING_MISSING_TOKENS',
  LOG_ENTRIES_INVALID_REQUEST = 'LOG_ENTRIES_INVALID_REQUEST',
  INTERNAL_SERVER_ISSUE = 'INTERNAL_SERVER_ISSUE',
  INTERNAL_FETCHING_ISSUE = 'INTERNAL_FETCHING_ISSUE',
  INTERNAL_DATABASE_ISSUE = 'INTERNAL_DATABASE_ISSUE',
  INTERNAL_CONTEXT_CANCELED = 'INTERNAL_CONTEXT_CANCELED',
  INTERNAL_UNEXPECTED_TIMEOUT = 'INTERNAL_UNEXPECTED_TIMEOUT',
  INTERNALUNEXPECTEDV1 = 'INTERNAL_UNEXPECTED_V1',
  INTERNAL_UNEXPECTED_PANIC = 'INTERNAL_UNEXPECTED_PANIC',
  INTERNAL_UNEXPECTED_SPIRE = 'INTERNAL_UNEXPECTED_SPIRE',
  INTERNAL_REDIS_UNAVAILABLE = 'INTERNAL_REDIS_UNAVAILABLE',
  INTERNAL_RESOURCE_EXHAUSTED = 'INTERNAL_RESOURCE_EXHAUSTED',
  INTERNAL_REDIS_UNCATEGORIZED = 'INTERNAL_REDIS_UNCATEGORIZED',
  INTERNAL_AWS_UNCATEGORIZED = 'INTERNAL_AWS_UNCATEGORIZED',
  INTERNAL_AZURE_UNCATEGORIZED = 'INTERNAL_AZURE_UNCATEGORIZED',
  INTERNAL_VECTORDB_UNCATEGORIZED = 'INTERNAL_VECTORDB_UNCATEGORIZED',
  INTERNAL_ORACLE_UNCATEGORIZED = 'INTERNAL_ORACLE_UNCATEGORIZED',
  INTERNAL_VULTR_UNCATEGORIZED = 'INTERNAL_VULTR_UNCATEGORIZED',
  CONN_UNCATEGORIZED = 'CONN_UNCATEGORIZED',
  MODEL_UNCATEGORIZED = 'MODEL_UNCATEGORIZED',
  INPUT_UNCATEGORIZED = 'INPUT_UNCATEGORIZED',
  ANNOTATION_UNCATEGORIZED = 'ANNOTATION_UNCATEGORIZED',
  BILLING_UNCATEGORIZED = 'BILLING_UNCATEGORIZED',
  INTERNAL_UNCATEGORIZED = 'INTERNAL_UNCATEGORIZED',
  BAD_REQUEST = 'BAD_REQUEST',
  SERVER_ERROR = 'SERVER_ERROR',
}

export namespace V2 {
  /**
   * No description
   * @tags V2
   * @name V2ListAnnotationFilters2
   * @summary List all the annotation filters.
   * @request GET:/v2/annotation_filters
   */
  export namespace V2ListAnnotationFilters2 {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiAnnotationFilterResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteAnnotationFilters2
   * @summary Delete one or more annotation filters in a single request.
   * @request DELETE:/v2/annotation_filters
   */
  export namespace V2DeleteAnnotationFilters2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiDeleteAnnotationFiltersRequest;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostAnnotationFilters2
   * @summary Add annotation filters.
   * @request POST:/v2/annotation_filters
   */
  export namespace V2PostAnnotationFilters2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPostAnnotationFiltersRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiAnnotationFilterResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchAnnotationFilters2
   * @summary Patch one or more annotation filters.
   * @request PATCH:/v2/annotation_filters
   */
  export namespace V2PatchAnnotationFilters2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPatchAnnotationFiltersRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiAnnotationFilterResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetAnnotationFilter2
   * @summary Get a specific annotation filter.
   * @request GET:/v2/annotation_filters/{annotation_filter_id}
   */
  export namespace V2GetAnnotationFilter2 {
    export type RequestParams = {
      /** Identify annotation filter by id. */
      annotationFilterId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleAnnotationFilterResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListAnnotations2
   * @summary List all the annotation.
   * @request GET:/v2/annotations
   */
  export namespace V2ListAnnotations2 {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /** List annotations for these IDs */
      ids?: string[];
      /**
       * List annotations for these Input IDs
       * Note that 'ids' are optional but if the are provided the number and order in
       * 'ids' and 'input_ids' should match
       * If you do not specify 'ids' all the annotations for 'input_ids' are returned
       * If a you do not specify both 'input_ids' and 'ids' all the annotations in the app are returned
       */
      input_ids?: string[];
      /**
       * Only return the annotations that has one of these user IDs, effectively operating as an
       * OR among them to filter down the results.
       * If model_version_ids or workflow_version_ids are also provided, these user_ids are OR'd with them as well because
       * we want the union of all worker (user, model or workflow) annotations in the results of ListAnnotations request.
       * Setting user_ids does also set list_all_annotations=True.
       */
      user_ids?: string[];
      /**
       * Only return the annotations that has one of these model version IDs, effectively operating as an
       * OR among them to filter down the results.
       * If user_ids or workflow_version_ids are also provided, these model_version_ids are OR'd with them as well because
       * we want the union of all worker (user, model or workflow) annotations in the results of ListAnnotations request.
       * Setting model_version_ids does also set list_all_annotations=True.
       */
      model_version_ids?: string[];
      /**
       * Only return the annotations that has one of these workflow version IDs, effectively operating as an
       * OR among them to filter down the results.
       * If user_ids or model_version_ids are also provided, these workflow_version_ids are OR'd with them as well because
       * we want the union of all worker (user, model or workflow) annotations in the results of ListAnnotations request.
       * Setting workflow_version_ids does also set list_all_annotations=True.
       */
      workflow_version_ids?: string[];
      /**
       * Set this flag to list both trusted and not trusted annotations
       * by default it's listing only trusted annotations
       */
      list_all_annotations?: boolean;
      /** Set this flag to return the model output for model annotations in the response. */
      return_model_output?: boolean;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      /** Flag to filter annotations by task_id */
      task_id?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiAnnotationResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteAnnotations4
   * @summary Delete multiple annotations in one request.
   * @request DELETE:/v2/annotations
   */
  export namespace V2DeleteAnnotations4 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiDeleteAnnotationsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostAnnotations2
   * @summary Post annotations.
   * @request POST:/v2/annotations
   */
  export namespace V2PostAnnotations2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPostAnnotationsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiAnnotationResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchAnnotations2
   * @summary Patch one or more annotations.
   * @request PATCH:/v2/annotations
   */
  export namespace V2PatchAnnotations2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPatchAnnotationsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiAnnotationResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostAnnotationsSearches2
   * @summary Execute a search over annotations
   * @request POST:/v2/annotations/searches
   */
  export namespace V2PostAnnotationsSearches2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPostAnnotationsSearchesRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiSearchResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchAnnotationsSearches2
   * @summary Patch saved annotations searches by ids.
   * @request PATCH:/v2/annotations/searches
   */
  export namespace V2PatchAnnotationsSearches2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPatchAnnotationsSearchesRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiSearchResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListAnnotationSearchMetrics2
   * @summary List the evaluation results between two search requests
   * @request GET:/v2/annotations/searches/metrics
   */
  export namespace V2ListAnnotationSearchMetrics2 {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiAnnotationSearchMetricsResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostAnnotationSearchMetrics2
   * @summary Evaluate the results of two search requests
   * @request POST:/v2/annotations/searches/metrics
   */
  export namespace V2PostAnnotationSearchMetrics2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPostAnnotationSearchMetricsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiAnnotationSearchMetricsResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetAnnotationSearchMetrics2
   * @summary Get the evaluation results between two search requests
   * @request GET:/v2/annotations/searches/metrics/{id}
   */
  export namespace V2GetAnnotationSearchMetrics2 {
    export type RequestParams = {
      /** Unique custom facing id that identifies the eval to get */
      id: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiAnnotationSearchMetricsResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteAnnotationSearchMetrics2
   * @summary DeleteAnnotationSearchMetrics
   * @request DELETE:/v2/annotations/searches/metrics/{id}
   */
  export namespace V2DeleteAnnotationSearchMetrics2 {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2ListAnnotationWorkers2
 * @summary ListAnnotationWorkers lists users, models, and workflows (collectively
known as "workers") that have added annotations to the application.
 * @request GET:/v2/annotations/workers
*/
  export namespace V2ListAnnotationWorkers2 {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      /**
       * (optional URL parameter) List of additional fields to be included in the response.
       * Currently supported: all, names
       */
      additional_fields?: string[];
      /** (optional URL parameter) Only list workers that have created trusted annotations. */
      trusted_only?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiWorkerResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetApp2
   * @summary Get a specific app from an app.
   * @request GET:/v2/app
   */
  export namespace V2GetApp2 {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /** (optional URL parameter) List of additional fields to be included in the response. Currently supported: all, stars, counts */
      additional_fields?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleAppResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListApps2
   * @summary List all the apps.
   * @request GET:/v2/apps
   */
  export namespace V2ListApps2 {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      /** (optional URL parameter) List of additional fields to be included in the response. Currently supported: all, stars, counts */
      additional_fields?: string[];
      /**
       * Sorting options:
       * Whether to sort in ascending order. If false, will order in descending order.
       */
      sort_ascending?: boolean;
      /** Whether to order by the name. */
      sort_by_name?: boolean;
      /**
       * Whether to order by the modified_at time.
       * If none of the sort options is set to true, will sort by modified_at.
       */
      sort_by_modified_at?: boolean;
      /** Whether to order by the created_at time. */
      sort_by_created_at?: boolean;
      /** Whether to order by the number of users stared the app */
      sort_by_star_count?: boolean;
      /** Whether to order by the id */
      sort_by_id?: boolean;
      /**
       * Filtering options:
       * If true, we only return apps that are handpicked by clarifai staff
       */
      featured_only?: boolean;
      /** If true, we only return apps that are starred by the requesting user */
      starred_only?: boolean;
      /** If true, we only return apps that are marked as a template by the app owner. */
      template_only?: boolean;
      /**
       * Searching options:
       * Specify a search parameter in order to perform keyword search on the
       * following fields of the application:
       *   - id
       *   - name
       *   - description
       *   - notes
       *   - user_id (unless user_app_id.user_id is already set)
       *
       * Keywords are both normalized for search (so searching for "satisfy" matches "satisfied")
       * and used for partial prefix-matching (so searching for "clari" matches "clarifai").
       *
       * NOTE: Both the list of fields searched and the exact keyword matching
       * rules are subject to change and not guaranteed to be backwards-compatible.
       */
      search?: string;
      /**
       * Query various text fields (id, name, description, and notes) that can contain the words in the query string
       * Deprecated: use search instead.
       */
      query?: string;
      /**
       * Filter by the id, name and notes of the app. This supports wilcard queries like "gen*" to match "general" as an example.
       * Deprecated: use search instead.
       */
      name?: string;
      /**
       * Filter by the user-unique-id of the app. This supports wilcard queries like "gen*" to match "general" as an example.
       * Deprecated: use search instead.
       */
      id?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiAppResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListBulkOperations2
   * @summary List all the bulk operations
   * @request GET:/v2/bulk_operations
   */
  export namespace V2ListBulkOperations2 {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiBulkOperationsResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteBulkOperations2
   * @summary delete one or more terminated bulk operations
   * @request DELETE:/v2/bulk_operations
   */
  export namespace V2DeleteBulkOperations2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiDeleteBulkOperationRequest;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2PostBulkOperations2
 * @summary Perform bulk operations on a list of inputs based on input source.
Operation include add, update, delete of concepts, metadata and geo data.
This is an Asynchronous process. Use ListBulkOperations or GetBulkOperation to check the status.
 * @request POST:/v2/bulk_operations
*/
  export namespace V2PostBulkOperations2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPostBulkOperationsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiBulkOperationsResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2CancelBulkOperations2
   * @summary Cancel one or more bulk operations
   * @request PATCH:/v2/bulk_operations
   */
  export namespace V2CancelBulkOperations2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiCancelBulkOperationRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiBulkOperationsResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetBulkOperation2
   * @summary Get the bulk operation details by ID
   * @request GET:/v2/bulk_operations/{id}
   */
  export namespace V2GetBulkOperation2 {
    export type RequestParams = {
      /** The bulk operation id */
      id: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleBulkOperationsResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListCloudProviders
   * @summary List Available Cloud Providers
   * @request GET:/v2/cloud_providers
   */
  export namespace V2ListCloudProviders {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiCloudProviderResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListCloudRegions
   * @summary List Regions for given Cloud Provider
   * @request GET:/v2/cloud_providers/{cloud_provider.id}/regions
   */
  export namespace V2ListCloudRegions {
    export type RequestParams = {
      /** Unique identifier of the cloud provider. */
      cloudProviderId: string;
    };
    export type RequestQuery = {
      /** Name of the cloud provider. */
      cloudProviderName?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiCloudRegionResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListInstanceTypes
   * @summary Get InstanceTypes given Cloud Provider and Region
   * @request GET:/v2/cloud_providers/{cloud_provider.id}/regions/{region}/instance_types
   */
  export namespace V2ListInstanceTypes {
    export type RequestParams = {
      /** Unique identifier of the cloud provider. */
      cloudProviderId: string;
      /**
       * The region to list for so when there are multiple regions we get only the clusters
       * that are supposed to be up in that region.
       */
      region: string;
    };
    export type RequestQuery = {
      /** Name of the cloud provider. */
      cloudProviderName?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiInstanceTypeResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListCollectors2
   * @summary List all the collectors.
   * @request GET:/v2/collectors
   */
  export namespace V2ListCollectors2 {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiCollectorResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2DeleteCollectors2
 * @summary Delete multiple collectors in one request.
This call is asynchronous. Use DeleteCollector if you want a synchronous version.
 * @request DELETE:/v2/collectors
*/
  export namespace V2DeleteCollectors2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiDeleteCollectorsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2PostCollectors2
 * @summary Add a list of Collectors to an app.
In the handler of this endpoint we also check for all the scopes of the  POST /inputs
endpoint.
Those current scopes are listed here as a hard requirement.
They are needed when adding the collectors just so we now that you have permission with
that key at least to do the writing to this app with POST /inputs.
 * @request POST:/v2/collectors
*/
  export namespace V2PostCollectors2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPostCollectorsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiCollectorResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchCollectors2
   * @summary Patch one or more collectors.
   * @request PATCH:/v2/collectors
   */
  export namespace V2PatchCollectors2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPatchCollectorsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiCollectorResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetCollector2
   * @summary Get a specific collector from an app.
   * @request GET:/v2/collectors/{collector_id}
   */
  export namespace V2GetCollector2 {
    export type RequestParams = {
      collectorId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleCollectorResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostComputePlaneMetrics
   * @request POST:/v2/compute_plane_metrics
   */
  export namespace V2PostComputePlaneMetrics {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPostComputePlaneMetricsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListConcepts2
   * @summary List all the concepts.
   * @request GET:/v2/concepts
   */
  export namespace V2ListConcepts2 {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      /** Fuzzy match on concept ID */
      id?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiConceptResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostConcepts2
   * @summary Add a concept to an app.
   * @request POST:/v2/concepts
   */
  export namespace V2PostConcepts2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPostConceptsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiConceptResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchConcepts2
   * @summary Patch one or more concepts.
   * @request PATCH:/v2/concepts
   */
  export namespace V2PatchConcepts2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPatchConceptsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiConceptResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListKnowledgeGraphs2
   * @summary List all domain graphs.
   * @request GET:/v2/concepts/knowledge_graphs
   */
  export namespace V2ListKnowledgeGraphs2 {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiKnowledgeGraphResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostKnowledgeGraphs2
   * @summary Post domain graphs.
   * @request POST:/v2/concepts/knowledge_graphs
   */
  export namespace V2PostKnowledgeGraphs2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPostKnowledgeGraphsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiKnowledgeGraphResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2PostConceptsSearches2
 * @summary Search over the concepts to find one or more you're looking for.
This leverage the "body" parameter because we also have page and
per_page as url query param variables in this request.
 * @request POST:/v2/concepts/searches
*/
  export namespace V2PostConceptsSearches2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPostConceptsSearchesRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiConceptResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetConceptCounts2
   * @summary List all the concepts with their positive and negative counts
   * @request GET:/v2/concepts/status
   */
  export namespace V2GetConceptCounts2 {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiConceptCountResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetConcept2
   * @summary Get a specific concept from an app.
   * @request GET:/v2/concepts/{concept_id}
   */
  export namespace V2GetConcept2 {
    export type RequestParams = {
      /** The concept's id. */
      conceptId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleConceptResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListConceptLanguages2
   * @summary List the concept in all the translated languages.
   * @request GET:/v2/concepts/{concept_id}/languages
   */
  export namespace V2ListConceptLanguages2 {
    export type RequestParams = {
      conceptId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiConceptLanguageResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostConceptLanguages2
   * @summary Add a new translation for this concept.
   * @request POST:/v2/concepts/{concept_id}/languages
   */
  export namespace V2PostConceptLanguages2 {
    export type RequestParams = {
      conceptId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostConceptLanguagesBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiConceptLanguageResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2PatchConceptLanguages2
 * @summary Patch the name for a given language names by passing in a list of concepts with the new names
for the languages.
 * @request PATCH:/v2/concepts/{concept_id}/languages
*/
  export namespace V2PatchConceptLanguages2 {
    export type RequestParams = {
      conceptId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchConceptLanguagesBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiConceptLanguageResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetConceptLanguage2
   * @summary Get a specific concept from an app.
   * @request GET:/v2/concepts/{concept_id}/languages/{language}
   */
  export namespace V2GetConceptLanguage2 {
    export type RequestParams = {
      conceptId: string;
      /** This is the language identifier. */
      language: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleConceptLanguageResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListDatasets3
   * @summary List all the datasets.
   * @request GET:/v2/datasets
   */
  export namespace V2ListDatasets3 {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      additional_fields?: string[];
      /**
       * Sorting options:
       * Whether to sort in ascending order. If false, will order in descending order.
       */
      sort_ascending?: boolean;
      /** Whether to order by the created_at time. */
      sort_by_created_at?: boolean;
      /** Whether to order by the number of users stared the app */
      sort_by_star_count?: boolean;
      /** If neither sort option is set to true, will sort by modified_at. */
      sort_by_modified_at?: boolean;
      /** Whether to order by the external id */
      sort_by_id?: boolean;
      /** Filtering options: */
      starred_only?: boolean;
      /** Filter datasets by bookmark. If set, only return bookmarked datasets. Otherwise none bookmarked datasets only. */
      bookmark?: boolean;
      /**
       * Searching options:
       * Specify a search parameter in order to perform keyword search on the
       * following fields of the dataset:
       *   - id
       *   - description
       *   - notes
       *   - user_id (unless user_app_id.user_id is already set)
       *
       * Keywords are both normalized for search (so searching for "satisfy" matches "satisfied")
       * and used for partial prefix-matching (so searching for "clari" matches "clarifai").
       *
       * NOTE: Both the list of fields searched and the exact keyword matching
       * rules are subject to change and not guaranteed to be backwards-compatible.
       */
      search?: string;
      /**
       * Fuzzy filter on dataset ID
       * Deprecated: use search instead.
       */
      id?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiDatasetResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteDatasets2
   * @summary Delete one or more datasets in a single request.
   * @request DELETE:/v2/datasets
   */
  export namespace V2DeleteDatasets2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiDeleteDatasetsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2PostDatasets2
 * @summary Add datasets to an app.
The process is atomic, i.e. either all or no datasets are added.
If there is an error for one dataset,
the process will stop, revert the transaction and return the error.
 * @request POST:/v2/datasets
*/
  export namespace V2PostDatasets2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPostDatasetsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiDatasetResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2PatchDatasets2
 * @summary Patch one or more datasets.
The process is atomic, i.e. either all or no datasets are patched.
If there is an error for one dataset,
the process will stop, revert the transaction and return the error.
 * @request PATCH:/v2/datasets
*/
  export namespace V2PatchDatasets2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPatchDatasetsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiDatasetResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetDataset2
   * @summary Get a specific dataset.
   * @request GET:/v2/datasets/{dataset_id}
   */
  export namespace V2GetDataset2 {
    export type RequestParams = {
      /** Identify dataset by id. */
      datasetId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      additional_fields?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleDatasetResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListDatasetInputs2
   * @summary List all the dataset inputs in a dataset.
   * @request GET:/v2/datasets/{dataset_id}/inputs
   */
  export namespace V2ListDatasetInputs2 {
    export type RequestParams = {
      /** Identify dataset by id. */
      datasetId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiDatasetInputResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteDatasetInputs2
   * @summary Delete one or more dataset inputs in a single request.
   * @request DELETE:/v2/datasets/{dataset_id}/inputs
   */
  export namespace V2DeleteDatasetInputs2 {
    export type RequestParams = {
      /** Identify dataset by id. */
      datasetId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2DeleteDatasetInputsBody;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2PostDatasetInputs2
 * @summary Add dataset inputs to a dataset.
The process is not atomic, i.e. if there are errors with some dataset
inputs, others might still be added. The response reports
  - SUCCESS if all dataset inputs were added,
  - MIXED_STATUS if only some dataset inputs were added, and
  - FAILURE if no dataset inputs were added.
Each individual dataset input in the response has the status set to
indicate if it was successful or if there was an error.
 * @request POST:/v2/datasets/{dataset_id}/inputs
*/
  export namespace V2PostDatasetInputs2 {
    export type RequestParams = {
      /** Identify dataset by id. */
      datasetId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostDatasetInputsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiDatasetInputResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetDatasetInput2
   * @summary Get a specific dataset input.
   * @request GET:/v2/datasets/{dataset_id}/inputs/{input_id}
   */
  export namespace V2GetDatasetInput2 {
    export type RequestParams = {
      /** Identify dataset by id. */
      datasetId: string;
      /** Identify dataset input by id. */
      inputId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleDatasetInputResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListDatasetVersions2
   * @summary List all the dataset versions.
   * @request GET:/v2/datasets/{dataset_id}/versions
   */
  export namespace V2ListDatasetVersions2 {
    export type RequestParams = {
      /** Identify dataset by id. */
      datasetId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      /** (optional URL parameter) Filter by origin of dataset version */
      request_origins?: ('DATASET_VERSION_REQUEST_ORIGIN_NOT_SET' | 'MANUAL' | 'TRAINING' | 'EVAL_GROUND_TRUTH' | 'EVAL_PREDICTIONS')[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiDatasetVersionResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteDatasetVersions2
   * @summary Delete one or more dataset versions in a single request.
   * @request DELETE:/v2/datasets/{dataset_id}/versions
   */
  export namespace V2DeleteDatasetVersions2 {
    export type RequestParams = {
      /** Identify dataset by id. */
      datasetId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2DeleteDatasetVersionsBody;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostDatasetVersions2
   * @summary Add dataset versions to a dataset.
   * @request POST:/v2/datasets/{dataset_id}/versions
   */
  export namespace V2PostDatasetVersions2 {
    export type RequestParams = {
      /** Identify dataset by id. */
      datasetId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostDatasetVersionsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiDatasetVersionResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchDatasetVersions2
   * @summary Patch one or more dataset versions.
   * @request PATCH:/v2/datasets/{dataset_id}/versions
   */
  export namespace V2PatchDatasetVersions2 {
    export type RequestParams = {
      /** Identify dataset by id. */
      datasetId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchDatasetVersionsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiDatasetVersionResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetDatasetVersion2
   * @summary Get a specific dataset version.
   * @request GET:/v2/datasets/{dataset_id}/versions/{dataset_version_id}
   */
  export namespace V2GetDatasetVersion2 {
    export type RequestParams = {
      /** Identify dataset by id. */
      datasetId: string;
      /** Identify dataset version by id. */
      datasetVersionId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleDatasetVersionResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PutDatasetVersionExports2
   * @summary Create export of a dataset version.
   * @request PUT:/v2/datasets/{dataset_id}/versions/{dataset_version_id}/exports
   */
  export namespace V2PutDatasetVersionExports2 {
    export type RequestParams = {
      /** Identify dataset by id. */
      datasetId: string;
      /** Identify dataset version by id. */
      datasetVersionId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PutDatasetVersionExportsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiDatasetVersionExportResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListDatasetVersionMetricsGroups2
   * @request GET:/v2/datasets/{dataset_id}/versions/{dataset_version_id}/metrics
   */
  export namespace V2ListDatasetVersionMetricsGroups2 {
    export type RequestParams = {
      /** Identify dataset by id. */
      datasetId: string;
      /** Identify dataset version by id. */
      datasetVersionId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      /** Filter by parent path. Multiple parent paths are OR-ed. Empty list results in no filter. */
      parent_paths?: string[];
      /**
       * Filter by parent type. Multiple types are OR-ed. Empty list results in no filter.
       *
       *  - INPUT_TYPE: Group data examples by input type.
       * Examples: images, videos, text, audio.
       *  - CONCEPT_ID: Group data examples by concept ID.
       * Examples: inputs with cat concept, inputs with dog concept.
       *  - CONCEPTS_COUNT: Group data examples by concepts count.
       * Examples: inputs with 20 concepts, inputs with 21 concepts.
       *  - BOUNDING_BOXES_COUNT: Group data examples by bounding boxes count.
       * Examples: inputs with 20 bounding boxes, inputs with 21 bounding boxes.
       *  - POLYGONS_COUNT: Group data examples by polygons count.
       * Examples: inputs with 20 polygons, inputs with 21 polygons.
       *  - POINTS_COUNT: Group data examples by points count.
       * Examples: inputs with 20 points, inputs with 21 points.
       *  - MASKS_COUNT: Group data examples by masks count.
       * Examples: inputs with 20 masks, inputs with 21 masks.
       *  - PIXELS_COUNT: Group data examples by pixels count.
       * In order to reduce the number of groups, we use bins.
       * Examples for bin size = 400: inputs with [200000, 200400) pixels, inputs with [200400, 200800) pixels.
       *  - ASPECT_RATIO: Group data examples by aspect ratio.
       * In order to reduce the number of groups, we use bins.
       * Examples for bin size = 0.1: inputs with [0.5, 0.6) aspect ratio, inputs with [0.6, 0.7) aspect ratio.
       */
      types?: (
        | 'DATASET_VERSION_METRICS_GROUP_TYPE_NOT_SET'
        | 'INPUT_TYPE'
        | 'CONCEPT_ID'
        | 'CONCEPTS_COUNT'
        | 'BOUNDING_BOXES_COUNT'
        | 'POLYGONS_COUNT'
        | 'POINTS_COUNT'
        | 'MASKS_COUNT'
        | 'PIXELS_COUNT'
        | 'ASPECT_RATIO'
      )[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiDatasetVersionMetricsGroupResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListEvaluations3
   * @request GET:/v2/evaluations
   */
  export namespace V2ListEvaluations3 {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      /** If true, sort in ascending order, otherwise sort in descending order. */
      sort_ascending?: boolean;
      /** Whether to order by application id */
      sort_by_app_id?: boolean;
      /** Whether to order by eval metric summary.macro_avg_roc_auc */
      sort_by_roc_auc?: boolean;
      /** Whether to order by eval metric summary.f1 */
      sort_by_f1?: boolean;
      /** Whether to order by when the metric was created */
      sort_by_created_at?: boolean;
      /** Whether to order by eval metric summary.mean_avg_precision_iou_50 */
      sort_by_mean_avg_precision?: boolean;
      /** Whether to order by eval metric summary.macro_avg_precision */
      sort_by_precision?: boolean;
      /** Whether to order by eval metric summary.macro_avg_recall */
      sort_by_recall?: boolean;
      sort_by_model_id?: boolean;
      sort_by_eval_dataset_id?: boolean;
      sort_by_train_dataset_id?: boolean;
      /** Filter on model type id */
      model_type_id?: string;
      /** Filter on dataset ID of the dataset version specified in the metric version */
      eval_dataset_ids?: string[];
      /** Filter on dataset ID of the dataset version specified by the model version */
      train_dataset_ids?: string[];
      /** Filter on concept IDs specified in the modele version's output_info */
      concept_ids?: string[];
      /** Whether to show failed metrics, defaults to false */
      show_failed_metrics?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiEvalMetricsResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostEvaluations2
   * @request POST:/v2/evaluations
   */
  export namespace V2PostEvaluations2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPostEvaluationsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiEvalMetricsResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetEvaluation2
   * @request GET:/v2/evaluations/{evaluation_id}
   */
  export namespace V2GetEvaluation2 {
    export type RequestParams = {
      evaluationId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      fieldsConfusionMatrix?: boolean;
      fieldsCooccurrenceMatrix?: boolean;
      fieldsLabelCounts?: boolean;
      fieldsBinaryMetrics?: boolean;
      fieldsTestSet?: boolean;
      fieldsMetricsByArea?: boolean;
      fieldsMetricsByClass?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleEvalMetricsResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListInputs2
   * @summary List all the inputs.
   * @request GET:/v2/inputs
   */
  export namespace V2ListInputs2 {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      /**
       * Status code from internal codes.
       *
       *  - ZERO: to be revised and greatly expanded
       *  - SUCCESS: Generic
       *  - MOVED: Resource moved. Respond with Http status 307 and add new Location header to response
       *  - ACCEPTED: Request has been accepted. Respond with Http status 202.
       *  - CONN_ACCOUNT_ISSUES: Clarifai Connection Codes: 11xxx
       *
       * expired cc, still in trial, feature not supported in your tier
       *  - CONN_TOKEN_INVALID: invalid auth token used. Deprecated: we should return CONN_KEY_INVALID instead now in all cases.
       *  - CONN_CREDENTIALS_INVALID: invalid auth credentials
       *  - CONN_EXCEED_HOURLY_LIMIT: throttle hourly limit exceeded
       *  - CONN_EXCEED_MONTHLY_LIMIT: throttle monthly limit exceeded
       *  - CONN_THROTTLED: throttler and billing stuff
       *  - CONN_EXCEEDS_LIMITS: throttler and billing stuff
       *  - CONN_INSUFFICIENT_SCOPES: api key has insufficient permissions
       *  - CONN_KEY_INVALID: api key is invalid
       *  - CONN_KEY_NOT_FOUND: api key not found
       *  - CONN_BAD_REQUEST_FORMAT: multipart form parsing, broken json, etc
       *  - CONN_DOES_NOT_EXIST: when path is bad
       *  - CONN_INVALID_REQUEST: something wrong with a header
       *  - CONN_METHOD_NOT_ALLOWED: when a request method is not allowed
       *  - CONN_NO_GDPR_CONSENT: lack GDPR consent
       *  - CONN_INVALID_RANGE: when invalid range of a resource is requested
       *  - CONN_AUTH_METHOD_DISABLED: authentication method is disabled
       *  - MODEL_TRAINED: Model/Custom Training related 20xxx
       *
       * Custom model has been already trained.
       *  - MODEL_TRAINING: Custom model is currently training.
       *  - MODEL_UNTRAINED: Custom model has not yet been trained.
       *  - MODEL_QUEUED_FOR_TRAINING: Custom model is currently in queue for training, waiting on assets to process first.
       *  - MODEL_TRAINING_FAILED: generic err msg for any type of model training err.
       *  - MODEL_BUILDING: For new V3 DockerInternalType models which are built images
       *  - MODEL_BUILDING_FAILED: Failed to build image for model.
       *  - MODEL_BUILD_UNEXPECTED_ERROR: Failed to build image for model.
       *  - MODEL_TRAINING_NO_DATA: Custom model training had no data.  FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
       *  - MODEL_TRAINING_NO_POSITIVES: Custom model training had no positive examples. FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
       *  - MODEL_TRAINING_ONE_VS_N_SINGLE_CLASS: Custom model training was ONE_VS_N but with a single class. FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
       *  - MODEL_TRAINING_TIMED_OUT: Training took longer than hard coded timeouts. FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
       *  - MODEL_TRAINING_WAITING_ERROR: Training got error waiting on asset pipeline to finish. FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
       *  - MODEL_TRAINING_UNKNOWN_ERROR: Training threw an unknown exception.
       *  - MODEL_TRAINING_MSG_REDELIVER: Training message was redelivered. FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
       *  - MODEL_TRAINING_INSUFFICIENT_DATA: Training got error due to insufficient labelled data. FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
       *  - MODEL_TRAINING_INVALID_PARAMS: FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
       *  - MODEL_TRAINING_INVALID_DATA_TOLERANCE_EXCEEDED: Training is stopped because too much data was dropped. FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
       *  - MODEL_EVALUATION_TIMED_OUT: Evaluation took longer than hard coded timeouts. FIXME(yang): deprecate this. Use the 21317 + errStatusMsg
       *  - MODEL_EVALUATION_WAITING_ERROR: Evaluation got error waiting on asset pipeline to finish.FIXME(yang): deprecate this. Use the 21317 + errStatusMsg
       *  - MODEL_EVALUATION_UNKNOWN_ERROR: EVALUATION THREW AN UNKNOWN EXCEPTION.
       *  - MODEL_EVALUATION_MSG_REDELIVER: Eval message was redelivered. FIXME(yang): deprecate this. Use the 21317 + errStatusMsg
       *  - MODEL_EVALUATION_NEED_LABELS: Don't have enough concepts labelled to perform evaluation. FIXME(yang): deprecate this. Use the 21317 + errStatusMsg
       *  - MODEL_EVALUATION_NEED_INPUTS: Don't have enough inputs per concept to perform evaluation. FIXME(yang): deprecate this. Use the 21317 + errStatusMsg
       *  - MODEL_EVALUATION_FAILED: Generic err code for eval failure.
       *  - MODEL_DEPLOYMENT_FAILED: Used when inference coordinator failed to deploy spire and throws an error
       *  - MODEL_DEPLOYING: Used when calling the inference coordinator to deploy a spire
       *  - MODEL_QUEUED_FOR_DEPLOYMENT: Used when training is completed
       *  - MODEL_NOT_DEPLOYED: Used when model spire deployment is manually taken down or due to inactivity
       *  - MODEL_LOADING: Used when the model pod is running, but not yet ready to serve requests.
       *  - MODEL_REFERENCE_INVALID_ARGUMENT: Used when a model reference field is not set properly
       *  - MODEL_EXAMPLE_INPUT_INVALID_ARGUMENT: Used when a model example input field is not set properly
       *  - MODEL_EXPORTED: Model Export status codes
       *  - WORKFLOW_NO_MATCHING_INPUT: specified model input not in workflow
       *  - WORKFLOW_REQUIRE_TRAINED_MODEL: specified model must be trained
       *  - WORKFLOW_INVALID_ARGUMENT: error in the request somewhere
       *  - WORKFLOW_INVALID_REQUEST: error in the request somewhere
       *  - CONCEPT_MODIFY_SUCCESS: Concept related 23xxx
       *  - ANNOTATION_SUCCESS: Annotation related 24xxx
       *  - ANNOTATION_AWAITING_REVIEW: Annotation is awaiting review from task REVIEWERS.
       *  - ANNOTATION_AWAITING_CONSENSUS_REVIEW: Annotation is awaiting consensus review from task LABELERS.
       *  - METADATA_INVALID_PATCH_ARGUMENTS: Metadata related 249xx
       *  - TRAINER_JOB_STATE_NONE: Training service related 25xxx
       *  - DATA_DUMP_SUCCESS: Data Dump related 251xx
       *  - DATA_DUMP_NO_DATA: DEPRECATED: Not used anymore. Now for an empty data dump, DATA_DUMP_SUCCESS is returned. To detect an empty data dump, check if the inptus count is 0.
       *  - APP_DUPLICATION_SUCCESS: Duplicate related 252xx
       *  - MODULE_DOES_NOT_EXIST: Module related codes 253xx
       *  - BULK_OPERATION_SUCCESS: Bulk Operation related codes 254xx
       *  - RUNNER_DOES_NOT_EXIST: Runner related codes 256xx
       *  - NODEPOOL_DOES_NOT_EXIST: Nodepool related codes 257xx
       *  - COMPUTE_CLUSTER_DOES_NOT_EXIST: ComputeCluster related codes 258xx
       *  - DEPLOYMENT_DOES_NOT_EXIST: Deployment related codes 259xx
       *  - INSTANCE_TYPE_DOES_NOT_EXIST: InstanceType related codes 260xx
       *  - COMPUTE_PLANE_METRICS_INVALID_REQUEST: Compute plane related codes 261xx
       *  - PIPELINE_STEP_DOES_NOT_EXIST: PipelineStep related codes 262xx
       *  - INPUT_SUCCESS: Input:Image related 30xxx
       *  - INPUT_PENDING: when things are async, this is the default status.
       *  - INPUT_FAILED: any type of error downloading and processing
       *  - INPUT_DOWNLOAD_SUCCESS: use INPUT_SUCCESS, INPUT_PENDING, INPUT_FAILED, INPUT_IN_PROGRESS instead
       * DOWNLOAD is no longer correct, but keep old statuses for backward compatibility
       *  - INPUT_VIDEO_DOWNLOAD_SUCCESS: Input:Video related 31xxx -- Deprecated
       *  - INPUT_WRITES_DISABLED_FOR_MAINTENANCE: deprecate this one. Use REQUEST_DISABLED_FOR_MAINTENANCE
       *  - PREDICT_INVALID_REQUEST: API formatting issues 4000x
       *  - DATABASE_DUPLICATE_KEY: Other related 400xx
       *  - EXTERNAL_CONNECTION_ERROR: could not connect to external services
       *  - QUEUE_CONN_ERROR: Queue related errors 41xxx
       *  - SQS_OVERLIMIT: SQS related errors 411xx
       *  - SEARCH_INTERNAL_FAILURE: Search related errors 43xxxx
       *  - EVALUATION_QUEUED: Workflow evaluation err code
       *  - STRIPE_EVENT_ERROR: Stripe 44xxx
       *  - CACHE_MISS: Redis/Cache 45xxx
       *  - SIGNUP_EVENT_ERROR: Sift Science 46xxx
       *  - APP_COUNT_INVALID_MESSAGE: Application counts related errors 470xx
       *  - MP_DOWNLOAD_ERROR: Media processor related errors 471xx -- DEPRECATED
       *  - DATATIER_CONN_ERROR: DataTier related error 472xx
       *  - USER_CONSENT_FACE: User legal consent stauts related 50xxx
       *  - WORKER_MISSING: Workers 51xxx
       *  - COLLECTOR_MISSING: Collectors 52xxx
       *  - SSO_IDENTITY_PROVIDER_DOES_NOT_EXIST: SSO 53xxx
       *  - TASK_IN_PROGRESS: Tasks 54xxx
       * The task was created.
       *  - TASK_DONE: The task is completed.
       *  - TASK_WONT_DO: The task is marked as abandoned.
       *  - TASK_FAILED: An error occurred during add-task-annotations or add-auto-annotations pipeline.
       *  - TASK_IDLE: When an Auto Annotation task job has finished processing its last batch and is waiting for more dataset assets.
       *  - TASK_CONFLICT: The task operation is in conflict with the current state of the server.
       *  - TASK_NOT_IMPLEMENTED: Certain task-related scenarios are not implemented.
       *  - TASK_MISSING: Task was not found.
       *  - TASK_PERMISSION_DENIED: Not allowed to perform a task-related action.
       *  - TASK_ASSIGNMENT_SUCCESS: Task Assignments 542xx
       *  - TASK_ASSIGNMENT_REVIEW_SUCCESS: Task Assignment Reviews 543xx
       *  - LABEL_ORDER_PENDING: Label Order Related Status Code 55xxx
       *  - LICENSE_ACTIVE: License Related Status Code 600xx
       *  - LICENSE_DELETED: hidden state not reflected to users
       *  - PASSWORD_VALIDATION_SUCCESS: Password Related Status Code
       *  - FEATUREFLAG_CONFIG_NOT_FOUND: Feature flags status code
       *  - MAINTENANCE_SUCCESS: Maintenance status code
       *  - DATASET_VERSION_PENDING: Datasets 64xxx
       * The dataset version is pending to be processed.
       *  - DATASET_VERSION_IN_PROGRESS: The dataset version is currently being processed.
       *  - DATASET_VERSION_READY: The dataset version is ready to be used.
       *  - DATASET_VERSION_FAILURE: An error occurred during the dataset version processing.
       *  - DATASET_VERSION_UNEXPECTED_ERROR: An unexpected error occurred during the dataset version processing.
       *  - DATASET_VERSION_CONFLICT: An alteration to dataset version would create a conflict
       *  - DATASET_INPUT_SUCCESS: The dataset input was successfully added.
       *  - DATASET_INPUT_DUPLICATE: The dataset input is a duplicate.
       * Deprecated: Unused.
       *  - DATASET_VERSION_EXPORT_SUCCESS: The dataset version export is completed.
       *  - DATASET_VERSION_EXPORT_PENDING: The dataset version is pending to be exported.
       *  - DATASET_VERSION_EXPORT_FAILED: An error occurred during the dataset version export.
       *  - DATASET_VERSION_EXPORT_IN_PROGRESS: The dataset version is currently being exported.
       *  - DATASET_VERSION_EXPORT_UNEXPECTED_ERROR: An unexpected error occurred during the dataset version export.
       *  - JOB_QUEUED: Generic Job status codes
       *  - AUTH_MISSING_IDP_ASSOC: auth issues
       *
       * TODO: Knowledge graph related 80xxx
       *  - UPLOAD_IN_PROGRESS: Multipart uploading status codes
       *  - BILLING_INVALID_INFO: Billing related issues: 69xxx
       *  - LOG_ENTRIES_INVALID_REQUEST: Logs related issues: 70000;
       *  - INTERNAL_SERVER_ISSUE: Internal issues: 98xxx
       *  - CONN_UNCATEGORIZED: Uncategorized: 99xxx: move off as soon as known
       *  - BAD_REQUEST: Deprecated: migrate off to one of the internal issues
       *  - SERVER_ERROR: Deprecated: migrate off to one of the internal issues
       * @default "ZERO"
       */
      statusCode?:
        | 'ZERO'
        | 'SUCCESS'
        | 'MIXED_STATUS'
        | 'FAILURE'
        | 'TRY_AGAIN'
        | 'NOT_IMPLEMENTED'
        | 'MOVED'
        | 'TEAPOT'
        | 'ACCEPTED'
        | 'CONN_ACCOUNT_ISSUES'
        | 'CONN_TOKEN_INVALID'
        | 'CONN_CREDENTIALS_INVALID'
        | 'CONN_EXCEED_HOURLY_LIMIT'
        | 'CONN_EXCEED_MONTHLY_LIMIT'
        | 'CONN_THROTTLED'
        | 'CONN_EXCEEDS_LIMITS'
        | 'CONN_INSUFFICIENT_SCOPES'
        | 'CONN_KEY_INVALID'
        | 'CONN_KEY_NOT_FOUND'
        | 'CONN_BAD_REQUEST_FORMAT'
        | 'CONN_DOES_NOT_EXIST'
        | 'CONN_INVALID_REQUEST'
        | 'CONN_METHOD_NOT_ALLOWED'
        | 'CONN_NO_GDPR_CONSENT'
        | 'CONN_INVALID_RANGE'
        | 'CONN_AUTH_METHOD_DISABLED'
        | 'MODEL_TRAINED'
        | 'MODEL_TRAINING'
        | 'MODEL_UNTRAINED'
        | 'MODEL_QUEUED_FOR_TRAINING'
        | 'MODEL_UPLOADING'
        | 'MODEL_UPLOADING_FAILED'
        | 'MODEL_TRAINING_FAILED'
        | 'MODEL_BUILDING'
        | 'MODEL_BUILDING_FAILED'
        | 'MODEL_BUILD_UNEXPECTED_ERROR'
        | 'MODEL_TRAINING_NO_DATA'
        | 'MODEL_TRAINING_NO_POSITIVES'
        | 'MODEL_TRAINING_ONE_VS_N_SINGLE_CLASS'
        | 'MODEL_TRAINING_TIMED_OUT'
        | 'MODEL_TRAINING_WAITING_ERROR'
        | 'MODEL_TRAINING_UNKNOWN_ERROR'
        | 'MODEL_TRAINING_MSG_REDELIVER'
        | 'MODEL_TRAINING_INSUFFICIENT_DATA'
        | 'MODEL_TRAINING_INVALID_PARAMS'
        | 'MODEL_TRAINING_INVALID_DATA_TOLERANCE_EXCEEDED'
        | 'MODEL_MODIFY_SUCCESS'
        | 'MODEL_MODIFY_PENDING'
        | 'MODEL_MODIFY_FAILED'
        | 'MODEL_DOES_NOT_EXIST'
        | 'MODEL_PERMISSION_DENIED'
        | 'MODEL_INVALID_ARGUMENT'
        | 'MODEL_INVALID_REQUEST'
        | 'MODEL_EVALUATED'
        | 'MODEL_EVALUATING'
        | 'MODEL_NOT_EVALUATED'
        | 'MODEL_QUEUED_FOR_EVALUATION'
        | 'MODEL_EVALUATION_TIMED_OUT'
        | 'MODEL_EVALUATION_WAITING_ERROR'
        | 'MODEL_EVALUATION_UNKNOWN_ERROR'
        | 'MODEL_PREDICTION_FAILED'
        | 'MODEL_EVALUATION_MSG_REDELIVER'
        | 'MODEL_EVALUATION_NEED_LABELS'
        | 'MODEL_EVALUATION_NEED_INPUTS'
        | 'MODEL_EVALUATION_FAILED'
        | 'MODEL_DEPLOYMENT_FAILED'
        | 'MODEL_DEPLOYING'
        | 'MODEL_QUEUED_FOR_DEPLOYMENT'
        | 'MODEL_NOT_DEPLOYED'
        | 'MODEL_BUSY_PLEASE_RETRY'
        | 'MODEL_LOADING'
        | 'MODEL_REFERENCE_INVALID_ARGUMENT'
        | 'MODEL_EXAMPLE_INPUT_INVALID_ARGUMENT'
        | 'MODEL_EXPORTED'
        | 'MODEL_EXPORTING'
        | 'MODEL_EXPORTING_FAILED'
        | 'MODEL_EXPORT_PENDING'
        | 'WORKFLOW_NO_MATCHING_INPUT'
        | 'WORKFLOW_REQUIRE_TRAINED_MODEL'
        | 'WORKFLOW_DUPLICATE'
        | 'WORKFLOW_UNSUPPORTED_FORMAT'
        | 'WORKFLOW_DOES_NOT_EXIST'
        | 'WORKFLOW_PERMISSION_DENIED'
        | 'WORKFLOW_INVALID_ARGUMENT'
        | 'WORKFLOW_INVALID_RECIPE'
        | 'WORKFLOW_INVALID_TEMPLATE'
        | 'WORKFLOW_INVALID_GRAPH'
        | 'WORKFLOW_INTERNAL_FAILURE'
        | 'WORKFLOW_INVALID_REQUEST'
        | 'WORKFLOW_MODIFY_SUCCESS'
        | 'WORKFLOW_MODIFY_PENDING'
        | 'WORKFLOW_MODIFY_FAILED'
        | 'WORKFLOW_REINDEX_FAILED'
        | 'CONCEPT_MODIFY_SUCCESS'
        | 'CONCEPT_MODIFY_PENDING'
        | 'CONCEPT_MODIFY_FAILED'
        | 'ANNOTATION_SUCCESS'
        | 'ANNOTATION_PENDING'
        | 'ANNOTATION_FAILED'
        | 'ANNOTATION_UNKNOWN_STATUS'
        | 'ANNOTATION_INVALID_ARGUMENT'
        | 'ANNOTATION_PERMISSION_DENIED'
        | 'ANNOTATION_AWAITING_REVIEW'
        | 'ANNOTATION_AWAITING_CONSENSUS_REVIEW'
        | 'ANNOTATION_REVIEW_DENIED'
        | 'ANNOTATION_MODIFY_SUCCESS'
        | 'ANNOTATION_MODIFY_PENDING'
        | 'ANNOTATION_MODIFY_FAILED'
        | 'METADATA_INVALID_PATCH_ARGUMENTS'
        | 'METADATA_PARSING_ISSUE'
        | 'METADATA_MANIPULATION_ISSUE'
        | 'TRAINER_JOB_STATE_NONE'
        | 'TRAINER_JOB_STATE_QUEUED'
        | 'TRAINER_JOB_STATE_RUNNING'
        | 'TRAINER_JOB_STATE_COMPLETE'
        | 'TRAINER_JOB_STATE_ERROR'
        | 'DATA_DUMP_SUCCESS'
        | 'DATA_DUMP_PENDING'
        | 'DATA_DUMP_FAILED'
        | 'DATA_DUMP_IN_PROGRESS'
        | 'DATA_DUMP_NO_DATA'
        | 'DATA_DUMP_UNEXPECTED_ERROR'
        | 'DATA_DUMP_EXPORT_SUCCESS'
        | 'DATA_DUMP_EXPORT_PENDING'
        | 'DATA_DUMP_EXPORT_FAILED'
        | 'DATA_DUMP_EXPORT_IN_PROGRESS'
        | 'DATA_DUMP_EXPORT_UNEXPECTED_ERROR'
        | 'APP_DUPLICATION_SUCCESS'
        | 'APP_DUPLICATION_FAILED'
        | 'APP_DUPLICATION_PENDING'
        | 'APP_DUPLICATION_IN_PROGRESS'
        | 'APP_DUPLICATION_INVALID_REQUEST'
        | 'MODULE_DOES_NOT_EXIST'
        | 'MODULE_PERMISSION_DENIED'
        | 'MODULE_INVALID_ARGUMENT'
        | 'MODULE_INVALID_REQUEST'
        | 'BULK_OPERATION_SUCCESS'
        | 'BULK_OPERATION_FAILED'
        | 'BULK_OPERATION_PENDING'
        | 'BULK_OPERATION_IN_PROGRESS'
        | 'BULK_OPERATION_INVALID_REQUEST'
        | 'BULK_OPERATION_CANCELLED'
        | 'BULK_OPERATION_UNEXPECTED_ERROR'
        | 'RUNNER_DOES_NOT_EXIST'
        | 'RUNNER_PERMISSION_DENIED'
        | 'RUNNER_INVALID_ARGUMENT'
        | 'RUNNER_INVALID_REQUEST'
        | 'RUNNER_NEEDS_RETRY'
        | 'RUNNER_STREAM_START'
        | 'RUNNER_STREAM_END'
        | 'RUNNER_ITEM_CANCELLED'
        | 'RUNNER_PROCESSING_FAILED'
        | 'NODEPOOL_DOES_NOT_EXIST'
        | 'NODEPOOL_INVALID_ARGUMENT'
        | 'NODEPOOL_INVALID_REQUEST'
        | 'COMPUTE_CLUSTER_DOES_NOT_EXIST'
        | 'COMPUTE_CLUSTER_INVALID_ARGUMENT'
        | 'COMPUTE_CLUSTER_INVALID_REQUEST'
        | 'DEPLOYMENT_DOES_NOT_EXIST'
        | 'DEPLOYMENT_INVALID_ARGUMENT'
        | 'DEPLOYMENT_INVALID_REQUEST'
        | 'INSTANCE_TYPE_DOES_NOT_EXIST'
        | 'INSTANCE_TYPE_INVALID_ARGUMENT'
        | 'INSTANCE_TYPE_INVALID_REQUEST'
        | 'COMPUTE_PLANE_METRICS_INVALID_REQUEST'
        | 'PIPELINE_STEP_DOES_NOT_EXIST'
        | 'PIPELINE_STEP_INVALID_ARGUMENT'
        | 'PIPELINE_STEP_INVALID_REQUEST'
        | 'PIPELINE_STEP_UPLOADING'
        | 'PIPELINE_STEP_UPLOADING_FAILED'
        | 'PIPELINE_STEP_BUILDING'
        | 'PIPELINE_STEP_BUILDING_FAILED'
        | 'PIPELINE_STEP_BUILD_UNEXPECTED_ERROR'
        | 'PIPELINE_STEP_READY'
        | 'PIPELINE_STEP_NOT_READY'
        | 'INPUT_SUCCESS'
        | 'INPUT_PENDING'
        | 'INPUT_FAILED'
        | 'INPUT_IN_PROGRESS'
        | 'INPUT_DOWNLOAD_SUCCESS'
        | 'INPUT_DOWNLOAD_PENDING'
        | 'INPUT_DOWNLOAD_FAILED'
        | 'INPUT_DOWNLOAD_IN_PROGRESS'
        | 'INPUT_STATUS_UPDATE_FAILED'
        | 'INPUT_DELETE_FAILED'
        | 'INPUT_DUPLICATE'
        | 'INPUT_UNSUPPORTED_FORMAT'
        | 'INPUT_DOES_NOT_EXIST'
        | 'INPUT_PERMISSION_DENIED'
        | 'INPUT_INVALID_ARGUMENT'
        | 'INPUT_OVER_LIMIT'
        | 'INPUT_INVALID_URL'
        | 'INPUT_MODIFY_SUCCESS'
        | 'INPUT_MODIFY_PENDING'
        | 'INPUT_MODIFY_FAILED'
        | 'INPUT_STORAGE_HOST_FAILED'
        | 'ALL_INPUT_INVALID_BYTES'
        | 'INPUT_CLUSTER_SUCCESS'
        | 'INPUT_CLUSTER_PENDING'
        | 'INPUT_CLUSTER_FAILED'
        | 'INPUT_CLUSTER_IN_PROGRESS'
        | 'INPUT_REINDEX_SUCCESS'
        | 'INPUT_REINDEX_PENDING'
        | 'INPUT_REINDEX_FAILED'
        | 'INPUT_REINDEX_IN_PROGRESS'
        | 'INPUT_VIDEO_DOWNLOAD_SUCCESS'
        | 'INPUT_VIDEO_DOWNLOAD_PENDING'
        | 'INPUT_VIDEO_DOWNLOAD_FAILED'
        | 'INPUT_VIDEO_DUPLICATE'
        | 'INPUT_VIDEO_UNSUPPORTED_FORMAT'
        | 'INPUT_VIDEO_DOES_NOT_EXIST'
        | 'INPUT_VIDEO_PERMISSION_DENIED'
        | 'INPUT_VIDEO_INVALID_ARGUMENT'
        | 'INPUT_VIDEO_OVER_LIMIT'
        | 'INPUT_VIDEO_INVALID_URL'
        | 'INPUT_VIDEO_MODIFY_SUCCESS'
        | 'INPUT_VIDEO_MODIFY_PENDING'
        | 'INPUT_VIDEO_MODIFY_FAILED'
        | 'INPUT_VIDEO_STORAGE_HOST_FAILED'
        | 'ALL_INPUT_VIDEOS_INVALID_BYTES'
        | 'INPUT_VIDEO_PROCESSING_SUCCESS'
        | 'INPUT_VIDEO_PROCESSING_PENDING'
        | 'INPUT_VIDEO_PROCESSING_FAILED'
        | 'INPUT_VIDEO_STORAGE_INCONSISTENCY'
        | 'INPUT_VIDEO_STORAGE_FAILURE'
        | 'INPUT_VIDEO_URL_GENERATION_FAILURE'
        | 'INPUT_CONNECTION_FAILED'
        | 'REQUEST_DISABLED_FOR_MAINTENANCE'
        | 'INPUT_WRITES_DISABLED_FOR_MAINTENANCE'
        | 'INPUT_INVALID_REQUEST'
        | 'PREDICT_INVALID_REQUEST'
        | 'SEARCH_INVALID_REQUEST'
        | 'CONCEPTS_INVALID_REQUEST'
        | 'STATS_INVALID_REQUEST'
        | 'DATABASE_DUPLICATE_KEY'
        | 'DATABASE_STATEMENT_TIMEOUT'
        | 'DATABASE_INVALID_ROWS_AFFECTED'
        | 'DATABASE_DEADLOCK_DETECTED'
        | 'DATABASE_FAIL_TASK'
        | 'DATABASE_FAIL_TO_GET_CONNECTIONS'
        | 'DATABASE_TOO_MANY_CLIENTS'
        | 'DATABASE_CONSTRAINT_VIOLATED'
        | 'DATABASE_CANCELED'
        | 'ASYNC_WORKER_MULTI_ERRORS'
        | 'RPC_REQUEST_QUEUE_FULL'
        | 'RPC_SERVER_UNAVAILABLE'
        | 'RPC_REQUEST_TIMEOUT'
        | 'RPC_MAX_MESSAGE_SIZE_EXCEEDED'
        | 'RPC_CANCELED'
        | 'RPC_UNKNOWN_METHOD'
        | 'REQUEST_CANCELED_BY_USER'
        | 'CLUSTER_INTERNAL_FAILURE'
        | 'EXTERNAL_CONNECTION_ERROR'
        | 'QUERY_INVALID_SYNTAX'
        | 'QUEUE_CONN_ERROR'
        | 'QUEUE_CLOSE_REQUEST_TIMEOUT'
        | 'QUEUE_CONN_CLOSED'
        | 'QUEUE_PUBLISH_ACK_TIMEOUT'
        | 'QUEUE_PUBLISH_ERROR'
        | 'QUEUE_SUBSCRIPTION_TIMEOUT'
        | 'QUEUE_SUBSCRIPTION_ERROR'
        | 'QUEUE_MARSHALLING_FAILED'
        | 'QUEUE_UNMARSHALLING_FAILED'
        | 'QUEUE_MAX_MSG_REDELIVERY_EXCEEDED'
        | 'QUEUE_ACK_FAILURE'
        | 'SQS_OVERLIMIT'
        | 'SQS_INVALID_RECEIPT_HANDLE'
        | 'SQS_UNKNOWN'
        | 'SEARCH_INTERNAL_FAILURE'
        | 'SEARCH_PROJECTION_FAILURE'
        | 'SEARCH_PREDICTION_FAILURE'
        | 'SEARCH_BY_NOT_FULLY_INDEXED_INPUT'
        | 'SAVED_SEARCH_MODIFY_FAILED'
        | 'SEARCH_COUNTS_UNAVAILABLE'
        | 'EVALUATION_QUEUED'
        | 'EVALUATION_IN_PROGRESS'
        | 'EVALUATION_SUCCESS'
        | 'EVALUATION_FAILED_TO_RETRIEVE_DATA'
        | 'EVALUATION_INVALID_ARGUMENT'
        | 'EVALUATION_FAILED'
        | 'EVALUATION_PENDING'
        | 'EVALUATION_TIMED_OUT'
        | 'EVALUATION_UNEXPECTED_ERROR'
        | 'EVALUATION_MIXED'
        | 'STRIPE_EVENT_ERROR'
        | 'CACHE_MISS'
        | 'REDIS_SCRIPT_EXITED_WITH_FAILURE'
        | 'REDIS_STREAM_ERR'
        | 'REDIS_NO_CONSUMERS'
        | 'REDIS_STREAM_BACKOFF'
        | 'SIGNUP_EVENT_ERROR'
        | 'SIGNUP_FLAGGED'
        | 'FILETYPE_UNSUPPORTED'
        | 'APP_COUNT_INVALID_MESSAGE'
        | 'APP_COUNT_UPDATE_INCREMENT_FAILED'
        | 'APP_COUNT_REBUILD_FAILED'
        | 'APP_COUNT_INTERNAL_FAILURE'
        | 'MP_DOWNLOAD_ERROR'
        | 'MP_RESOLVE_DNS_ERROR'
        | 'MP_DOWNLOAD_MAX_SIZE_EXCEEDED_ERROR'
        | 'MP_IMAGE_DECODE_ERROR'
        | 'MP_INVALID_ARGUMENT'
        | 'MP_IMAGE_PROCESSING_ERROR'
        | 'DATATIER_CONN_ERROR'
        | 'USER_CONSENT_FACE'
        | 'WORKER_MISSING'
        | 'WORKER_ACTIVE'
        | 'WORKER_INACTIVE'
        | 'COLLECTOR_MISSING'
        | 'COLLECTOR_ACTIVE'
        | 'COLLECTOR_INACTIVE'
        | 'COLLECTOR_POST_INPUT_FAILED'
        | 'SSO_IDENTITY_PROVIDER_DOES_NOT_EXIST'
        | 'TASK_IN_PROGRESS'
        | 'TASK_DONE'
        | 'TASK_WONT_DO'
        | 'TASK_FAILED'
        | 'TASK_IDLE'
        | 'TASK_CONFLICT'
        | 'TASK_NOT_IMPLEMENTED'
        | 'TASK_MISSING'
        | 'TASK_PERMISSION_DENIED'
        | 'TASK_ASSIGNMENT_SUCCESS'
        | 'TASK_ASSIGNMENT_PENDING'
        | 'TASK_ASSIGNMENT_AWAITING_REVIEW'
        | 'TASK_ASSIGNMENT_AWAITING_CONSENSUS_REVIEW'
        | 'TASK_ASSIGNMENT_REJECTED'
        | 'TASK_ASSIGNMENT_REVIEW_SUCCESS'
        | 'TASK_ASSIGNMENT_REVIEW_PENDING'
        | 'TASK_ASSIGNMENT_REVIEW_DISMISSED'
        | 'LABEL_ORDER_PENDING'
        | 'LABEL_ORDER_IN_PROGRESS'
        | 'LABEL_ORDER_SUCCESS'
        | 'LABEL_ORDER_CANCELED'
        | 'LICENSE_ACTIVE'
        | 'LICENSE_DOES_NOT_EXIST'
        | 'LICENSE_NEED_UPDATE'
        | 'LICENSE_EXPIRED'
        | 'LICENSE_REVOKED'
        | 'LICENSE_DELETED'
        | 'LICENSE_VOLUME_EXCEEDED'
        | 'PASSWORD_VALIDATION_SUCCESS'
        | 'PASSWORD_VALIDATION_FAILED'
        | 'PASSWORDPOLICY_INVALID_ARGUMENT'
        | 'FEATUREFLAG_CONFIG_NOT_FOUND'
        | 'FEATUREFLAG_INVALID_ARGUMENT'
        | 'FEATUREFLAG_BLOCKED'
        | 'FEATUREFLAG_NOT_FOUND'
        | 'MAINTENANCE_SUCCESS'
        | 'MAINTENANCE_FAILED'
        | 'DATASET_VERSION_PENDING'
        | 'DATASET_VERSION_IN_PROGRESS'
        | 'DATASET_VERSION_READY'
        | 'DATASET_VERSION_FAILURE'
        | 'DATASET_VERSION_UNEXPECTED_ERROR'
        | 'DATASET_VERSION_CONFLICT'
        | 'DATASET_INPUT_SUCCESS'
        | 'DATASET_INPUT_DUPLICATE'
        | 'DATASET_VERSION_EXPORT_SUCCESS'
        | 'DATASET_VERSION_EXPORT_PENDING'
        | 'DATASET_VERSION_EXPORT_FAILED'
        | 'DATASET_VERSION_EXPORT_IN_PROGRESS'
        | 'DATASET_VERSION_EXPORT_UNEXPECTED_ERROR'
        | 'JOB_QUEUED'
        | 'JOB_RUNNING'
        | 'JOB_COMPLETED'
        | 'JOB_FAILED'
        | 'JOB_CANCELLED'
        | 'JOB_UNEXPECTED_ERROR'
        | 'JOB_CONFLICT'
        | 'AUTH_MISSING_IDP_ASSOC'
        | 'LIST_OBJECTS_FAILED'
        | 'ARCHIVE_EXTRACT_FAILED'
        | 'UPLOAD_IN_PROGRESS'
        | 'UPLOAD_DONE'
        | 'UPLOAD_FAILED'
        | 'UPLOAD_UNEXPECTED_ERROR'
        | 'UPLOAD_EXPIRED'
        | 'UPLOAD_CANCELED'
        | 'UPLOAD_CONFLICT'
        | 'BILLING_INVALID_INFO'
        | 'BILLING_MISSING_TOKENS'
        | 'LOG_ENTRIES_INVALID_REQUEST'
        | 'INTERNAL_SERVER_ISSUE'
        | 'INTERNAL_FETCHING_ISSUE'
        | 'INTERNAL_DATABASE_ISSUE'
        | 'INTERNAL_CONTEXT_CANCELED'
        | 'INTERNAL_UNEXPECTED_TIMEOUT'
        | 'INTERNAL_UNEXPECTED_V1'
        | 'INTERNAL_UNEXPECTED_PANIC'
        | 'INTERNAL_UNEXPECTED_SPIRE'
        | 'INTERNAL_REDIS_UNAVAILABLE'
        | 'INTERNAL_RESOURCE_EXHAUSTED'
        | 'INTERNAL_REDIS_UNCATEGORIZED'
        | 'INTERNAL_AWS_UNCATEGORIZED'
        | 'INTERNAL_AZURE_UNCATEGORIZED'
        | 'INTERNAL_VECTORDB_UNCATEGORIZED'
        | 'INTERNAL_ORACLE_UNCATEGORIZED'
        | 'INTERNAL_VULTR_UNCATEGORIZED'
        | 'CONN_UNCATEGORIZED'
        | 'MODEL_UNCATEGORIZED'
        | 'INPUT_UNCATEGORIZED'
        | 'ANNOTATION_UNCATEGORIZED'
        | 'BILLING_UNCATEGORIZED'
        | 'INTERNAL_UNCATEGORIZED'
        | 'BAD_REQUEST'
        | 'SERVER_ERROR';
      /** A short description of the error. */
      statusDescription?: string;
      /**
       * More details of the given error.
       * These details may be exposed to non-technical users.
       * For technical details, try to use developer_notes field.
       */
      statusDetails?: string;
      /**
       * For some environment we may return a stack trace to help debug
       * any issues.
       */
      statusStackTrace?: string[];
      /**
       * specifically for long running jobs
       * @format int64
       */
      statusPercentCompleted?: number;
      /**
       * if status is pending, how much time is remaining (in seconds)
       * @format int64
       */
      statusTimeRemaining?: number;
      /** A request ID may be present, to help monitoring and tracking requests */
      statusReqId?: string;
      /** Internal Annotation (do not set in production, for internal Clarifai use only). */
      statusInternalDetails?: string;
      /** New location for the resource. Used to set response Location header. */
      statusRedirectInfoUrl?: string;
      /** Resource type */
      statusRedirectInfoResourceType?: string;
      /** Old resource id */
      statusRedirectInfoOldResourceId?: string;
      /** New resource id */
      statusRedirectInfoNewResourceId?: string;
      /**
       * Notes for developer.
       * These notes are rather technical details for developers how to interpret the status,
       * e.g. why an error occurred and how to avoid getting the error.
       */
      statusDeveloperNotes?: string;
      ids?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiInputResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2DeleteInputs2
 * @summary Delete multiple inputs in one request.
This call is asynchronous.
 * @request DELETE:/v2/inputs
*/
  export namespace V2DeleteInputs2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiDeleteInputsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2PostInputs2
 * @summary PostInputs adds one or more inputs to the app.
Takes a list of image/video/audio/text URLs, image/video/audio bytes or raw text
Optionally, include concepts or dataset ids to link them
Optionally, include metadata for search
Note that inputs processing is asynchronous process
See ListInputs, StreamInputs or PostInputSearches to list results
 * @request POST:/v2/inputs
*/
  export namespace V2PostInputs2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPostInputsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiInputResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchInputs2
   * @summary Patch one or more inputs.
   * @request PATCH:/v2/inputs
   */
  export namespace V2PatchInputs2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPatchInputsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiInputResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteAnnotations2
   * @summary Delete multiple annotations in one request.
   * @request DELETE:/v2/inputs/annotations
   */
  export namespace V2DeleteAnnotations2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiDeleteAnnotationsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
 * @description The cloud URL will be treated as a filter prefix. For example s3:/bucket/images_folder/abc will process files in the images_folder beginning with abc or in a subfolder beginning with abc. For example: bucket/images_folder/abcImage.png bucket/images_folder/abc-1/Data.zip If given URL is for a private bucket or file, then credentials should be provided to access the bucket. Credentials should include rights to list the objects in the bucket, except when pointed directly at a file archive, in which case it only requires rights to access that particular file.
 * @tags V2
 * @name V2PostInputsDataSources2
 * @summary Initiates retrieval of inputs from cloud storage from a user provided data source.
Will create and return an inputs-add-job for tracking progress.
Archives will be extracted and their contents will be processed as inputs.
 * @request POST:/v2/inputs/data_sources
*/
  export namespace V2PostInputsDataSources2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPostInputsDataSourcesRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiInputsAddJobResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListInputsAddJobs2
   * @summary List all the inputs add jobs
   * @request GET:/v2/inputs/jobs/add
   */
  export namespace V2ListInputsAddJobs2 {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiInputsAddJobResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetInputsAddJob2
   * @summary Get the input add job details by ID
   * @request GET:/v2/inputs/jobs/add/{id}
   */
  export namespace V2GetInputsAddJob2 {
    export type RequestParams = {
      /** id of add inputs job */
      id: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleInputsAddJobResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2CancelInputsAddJob2
   * @summary cancel the input add job by ID
   * @request PATCH:/v2/inputs/jobs/add/{id}
   */
  export namespace V2CancelInputsAddJob2 {
    export type RequestParams = {
      /** id of add inputs job to be cancelled */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2CancelInputsAddJobBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleInputsAddJobResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListInputsExtractionJobs2
   * @summary List all the input extraction jobs
   * @request GET:/v2/inputs/jobs/extraction
   */
  export namespace V2ListInputsExtractionJobs2 {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiInputsExtractionJobResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2CancelInputsExtractionJobs2
   * @request PATCH:/v2/inputs/jobs/extraction
   */
  export namespace V2CancelInputsExtractionJobs2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiCancelInputsExtractionJobsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiInputsExtractionJobResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetInputsExtractionJob2
   * @summary Get the input extraction job details by ID
   * @request GET:/v2/inputs/jobs/extraction/{inputs_extraction_job_id}
   */
  export namespace V2GetInputsExtractionJob2 {
    export type RequestParams = {
      inputsExtractionJobId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleInputsExtractionJobResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostInputsSearches2
   * @summary Execute a search over inputs
   * @request POST:/v2/inputs/searches
   */
  export namespace V2PostInputsSearches2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPostInputsSearchesRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiSearchResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchInputsSearches2
   * @summary Patch saved inputs searches by ids.
   * @request PATCH:/v2/inputs/searches
   */
  export namespace V2PatchInputsSearches2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPatchInputsSearchesRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiSearchResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetInputCount2
   * @summary Get input count per status.
   * @request GET:/v2/inputs/status
   */
  export namespace V2GetInputCount2 {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleInputCountResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2StreamInputs2
   * @summary Streams all the inputs starting from oldest assets.
   * @request GET:/v2/inputs/stream
   */
  export namespace V2StreamInputs2 {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 20.
       * @format int64
       */
      per_page?: number;
      last_id?: string;
      /**
       * By default, the endpoint return inputs by the time when it is added.
       * If this is set to true, we will return inputs by id.
       */
      order_by_id?: boolean;
      descending?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiInputResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2PostInputsUploads2
 * @summary Create new upload job with a file archive containing inputs (images, videos, text, audio)
Actual file upload happens in next steps by calling `PutUploadContentParts` endpoint
and providing the file content in the request body.
This endpoint creates and return an inputs-add-job which contains an upload id needed for upload and further status tracking
Completing the upload will automatically begin unpacking the archive and uploading the contents as inputs.
See also GetInputsAddJob and then GetInputsExtractionJob
 * @request POST:/v2/inputs/uploads
*/
  export namespace V2PostInputsUploads2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPostInputsUploadsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiInputsAddJobResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetInput2
   * @summary Get a specific input from an app.
   * @request GET:/v2/inputs/{input_id}
   */
  export namespace V2GetInput2 {
    export type RequestParams = {
      inputId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleInputResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteInput2
   * @summary Delete a single input asynchronously.
   * @request DELETE:/v2/inputs/{input_id}
   */
  export namespace V2DeleteInput2 {
    export type RequestParams = {
      inputId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetAnnotation2
   * @summary Get a specific annotation from an app.
   * @request GET:/v2/inputs/{input_id}/annotations/{annotation_id}
   */
  export namespace V2GetAnnotation2 {
    export type RequestParams = {
      inputId: string;
      annotationId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleAnnotationResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteAnnotation2
   * @summary Delete a single annotation.
   * @request DELETE:/v2/inputs/{input_id}/annotations/{annotation_id}
   */
  export namespace V2DeleteAnnotation2 {
    export type RequestParams = {
      inputId: string;
      annotationId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2GetInputVideoManifest2
 * @summary Get a MPEG-DASH manifest for video-type inputs that were added via PostInputs and successfully processed
Experimental. Manifest is used by browser and desktop clients that implement an efficient streaming playback
This means client can switch between low-resolution and high-resolution video streams
Depending on network bandwidth or user's preference
This also means that reencoded video streams are reencoded in a uniform way, not relying on original format
Alternative to MPEG-dash is to stream original file with byte-range header
 * @request GET:/v2/inputs/{input_id}/video_manifest
*/
  export namespace V2GetInputVideoManifest2 {
    export type RequestParams = {
      inputId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiGetVideoManifestResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListLabelOrders2
   * @summary List label orders.
   * @request GET:/v2/label_orders
   */
  export namespace V2ListLabelOrders2 {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiLabelOrderResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2DeleteLabelOrders2
 * @summary Delete multiple label orders in one request.
this do not change task status
 * @request DELETE:/v2/label_orders
*/
  export namespace V2DeleteLabelOrders2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiDeleteLabelOrdersRequest;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostLabelOrders2
   * @summary Add Label orders.
   * @request POST:/v2/label_orders
   */
  export namespace V2PostLabelOrders2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPostLabelOrdersRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiLabelOrderResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchLabelOrders2
   * @summary Patch one or more label orders.
   * @request PATCH:/v2/label_orders
   */
  export namespace V2PatchLabelOrders2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPatchLabelOrdersRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiLabelOrderResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetLabelOrder2
   * @summary Get a label order.
   * @request GET:/v2/label_orders/{label_order_id}
   */
  export namespace V2GetLabelOrder2 {
    export type RequestParams = {
      labelOrderId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleLabelOrderResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostLogEntries
   * @request POST:/v2/log_entries
   */
  export namespace V2PostLogEntries {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPostLogEntriesRequest;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListModels3
   * @summary List all the models.
   * @request GET:/v2/models
   */
  export namespace V2ListModels3 {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      /** (optional URL parameter) List of additional fields to be included in the response. Currently supported: all, stars, outputs, presets, counts */
      additional_fields?: string[];
      /**
       * Sorting options:
       * Whether to sort in ascending order. If false, will order in descending order.
       */
      sort_ascending?: boolean;
      /** Whether to order by the name */
      sort_by_name?: boolean;
      /** Whether to order by the number of training inputs */
      sort_by_num_inputs?: boolean;
      /**
       * Whether to order by the modified_at time of the latest model version.
       * If none of the sort options is set to true, will sort by modified_at.
       */
      sort_by_modified_at?: boolean;
      /** Whether to order by the created_at */
      sort_by_created_at?: boolean;
      /** Whether to order by count of stars */
      sort_by_star_count?: boolean;
      /**
       * Filtering options:
       * Filter models by the specific model_type_id. See ListModelTypes for the list of ModelType.Id's
       * supported.
       */
      model_type_id?: string;
      /** If true, we only return models that have the status MODEL_TRAINED, which includes non-trainable model types. */
      trained_only?: boolean;
      /**
       * The list of input fields to the model.
       * For example, you can specify 'image', which will return models that make inferences on images like visual-classifier models.
       */
      input_fields?: string[];
      /**
       * The list of output fields to the model.
       * For example, you can specify 'regions[...].data.concepts', which will return visual-detector models.
       */
      output_fields?: string[];
      /** Filter by the license of the model version */
      license?: string;
      /** If true, we only return models that are handpicked by clarifai staff */
      featured_only?: boolean;
      /** If true, we only return models that are starred by the requesting user */
      starred_only?: boolean;
      /** List of toolkit tags to filter by */
      toolkits?: string[];
      /** List of use_case tags to filter by */
      use_cases?: string[];
      /** List of language tags to filter by */
      languages?: string[];
      /**
       * Old API behavior resulted in returning clarifai main models when calling ListModels while scoped to an app. While we transition
       * away from that, we can use this flag to not always fetch clarifai main models, unless that is the app we are explicitly listing for.
       *
       * @exclude TODO (EAGLE-4447): Remove this field
       */
      dont_fetch_from_main?: boolean;
      /**
       * Filter models by bookmark. If set, only return bookmarked models. Otherwise none bookmarked models only.
       * Note: you can not filter `trained_only` and bookmark at the same time.
       * When filter by bookmark, we will return trained and untrained models.
       */
      bookmark?: boolean;
      /**
       * Searching options:
       * Specify a search parameter in order to perform keyword search on the
       * following fields of the model:
       *   - id
       *   - name
       *   - description
       *   - notes
       *   - user_id (unless user_app_id.user_id is already set)
       *
       * Keywords are both normalized for search (so searching for "satisfy" matches "satisfied")
       * and used for partial prefix-matching (so searching for "clari" matches "clarifai").
       *
       * NOTE: Both the list of fields searched and the exact keyword matching
       * rules are subject to change and not guaranteed to be backwards-compatible.
       */
      search?: string;
      /**
       * Query name, description and id fields, that can contain the words in the query string. Does NOT support wildcards - full words only. Supports operators "OR" and "-" as NOT.
       * Deprecated: use search instead.
       */
      query?: string;
      /**
       * Filter by the description and id of the model. This supports wildcard queries like "gen*" to match "general" as an example.
       * Deprecated: use search instead.
       */
      name?: string;
      /**
       * Extends the name filter to include the user_id of the application owner that the model belongs to.
       * Deprecated: use search instead of name.
       */
      filter_by_user_id?: boolean;
      /** Filter by the model version ids. If set, only return the model of these versions. */
      model_version_ids?: string[];
      /**
       * Filter by LicenseType
       * @default "UNKNOWN_LICENSE_TYPE"
       */
      license_type?: 'UNKNOWN_LICENSE_TYPE' | 'FIRST_PARTY' | 'OPEN_SOURCE' | 'CLOSED_SOURCE';
      /**
       * Filter by Source
       * @format int64
       */
      source?: number;
      /** Filter by Creator */
      creator?: string;
      /**
       * Filter by model versions runners with replicas >= min_replicas.
       * @format int64
       */
      min_replicas?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiModelResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteModels2
   * @summary Delete multiple models in one request.
   * @request DELETE:/v2/models
   */
  export namespace V2DeleteModels2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiDeleteModelsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostModels2
   * @summary Add a models to an app.
   * @request POST:/v2/models
   */
  export namespace V2PostModels2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPostModelsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleModelResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchModels2
   * @summary Patch one or more models.
   * @request PATCH:/v2/models
   */
  export namespace V2PatchModels2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPatchModelsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiModelResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2StreamModelOutputs
   * @summary Stream of requests and stream of responses
   * @request POST:/v2/models/outputs/stream
   */
  export namespace V2StreamModelOutputs {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPostModelOutputsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = {
      result?: ApiMultiOutputResponse;
      error?: GooglerpcStatus;
    };
  }

  /**
 * No description
 * @tags V2
 * @name V2PostModelsSearches2
 * @summary Search over the models to find one or more you're looking for.
This leverage the "body" parameter because we also have page and
per_page as url query param variables in this request.
 * @request POST:/v2/models/searches
*/
  export namespace V2PostModelsSearches2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPostModelsSearchesRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiModelResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2ListModelTypes2
 * @summary List all the model types available in the platform.
This MUST be above ListModels so that the /models/types endpoint takes precedence.
 * @request GET:/v2/models/types
*/
  export namespace V2ListModelTypes2 {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiModelTypeResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetModelType2
   * @summary Get a specific model type.
   * @request GET:/v2/models/types/{model_type_id}
   */
  export namespace V2GetModelType2 {
    export type RequestParams = {
      /** The specific ModelType.Id you want to retrieve. */
      modelTypeId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleModelTypeResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2PostModelVersionsUpload
 * @summary This is a streaming endpoint, the request has a field, upload_data, which can either be the config for the upload or the actual data to upload.
The config must be sent first before the model_bytes can be uploaded.
Once the config has been sent, the server will respond with a confirmation containing the model_version_id.
This is so that if your upload is interrupted, you can resume the upload by sending the config again with the model_version_id specified for your model_version.
The actual upload will be done via a multipart upload, the latest successful part_id will be sent from the server in the response to the model_bytes.
 * @request POST:/v2/models/versions/upload
*/
  export namespace V2PostModelVersionsUpload {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPostModelVersionsUploadRequest;
    export type RequestHeaders = {};
    export type ResponseBody = {
      result?: ApiPostModelVersionsUploadResponse;
      error?: GooglerpcStatus;
    };
  }

  /**
   * No description
   * @tags V2
   * @name V2GetModel2
   * @summary Get a specific model from an app.
   * @request GET:/v2/models/{model_id}
   */
  export namespace V2GetModel2 {
    export type RequestParams = {
      modelId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /**
       * This is included so that we can re-use this request for multiple
       * rpcs with and without the version_id.
       */
      version_id?: string;
      language?: string;
      trained_before?: boolean;
      /** (optional URL parameter) List of additional fields to be included in the response. Currently supported: all, stars, outputs, presets */
      additional_fields?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleModelResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteModel2
   * @summary Delete a single model.
   * @request DELETE:/v2/models/{model_id}
   */
  export namespace V2DeleteModel2 {
    export type RequestParams = {
      modelId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchModelCheckConsents2
   * @summary Update model check consents
   * @request PATCH:/v2/models/{model_id}/check_consents
   */
  export namespace V2PatchModelCheckConsents2 {
    export type RequestParams = {
      /** the model id */
      modelId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchModelCheckConsentsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiModelCheckConsentResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2ListModelInputs2
 * @summary Deprecated: Unmaintained and ideally replaced with usage of datasets
  The server may refuse to accept requests to this endpoint.
 * @request GET:/v2/models/{model_id}/inputs
*/
  export namespace V2ListModelInputs2 {
    export type RequestParams = {
      modelId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      version_id?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiInputResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchModelLanguages2
   * @summary Update model languages tags
   * @request PATCH:/v2/models/{model_id}/languages
   */
  export namespace V2PatchModelLanguages2 {
    export type RequestParams = {
      modelId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchModelLanguagesBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiModelLanguageResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2GetModelOutputInfo2
 * @summary Get a the output info for a given model_id or model_id/version_id
combo.
 * @request GET:/v2/models/{model_id}/output_info
*/
  export namespace V2GetModelOutputInfo2 {
    export type RequestParams = {
      modelId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /**
       * This is included so that we can re-use this request for multiple
       * rpcs with and without the version_id.
       */
      version_id?: string;
      language?: string;
      trained_before?: boolean;
      /** (optional URL parameter) List of additional fields to be included in the response. Currently supported: all, stars, outputs, presets */
      additional_fields?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleModelResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostModelOutputs4
   * @summary Get predicted outputs from the model.
   * @request POST:/v2/models/{model_id}/outputs
   */
  export namespace V2PostModelOutputs4 {
    export type RequestParams = {
      modelId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostModelOutputsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiOutputResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostModelVersionsPublish2
   * @summary PostModelVersionsPublish
   * @request POST:/v2/models/{model_id}/publish
   */
  export namespace V2PostModelVersionsPublish2 {
    export type RequestParams = {
      modelId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostModelVersionsPublishBody;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListModelReferences2
   * @summary Lists model references tied to a particular model id.
   * @request GET:/v2/models/{model_id}/references
   */
  export namespace V2ListModelReferences2 {
    export type RequestParams = {
      modelId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /**
       * Optional, defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * Optional, defaults to 128 references per page.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiModelReferenceResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchModelToolkits2
   * @summary Update model toolkits tags
   * @request PATCH:/v2/models/{model_id}/toolkits
   */
  export namespace V2PatchModelToolkits2 {
    export type RequestParams = {
      modelId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchModelToolkitsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiModelToolkitResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostModelVersionsUnPublish2
   * @summary PostModelVersionsUnPublish
   * @request POST:/v2/models/{model_id}/unpublish
   */
  export namespace V2PostModelVersionsUnPublish2 {
    export type RequestParams = {
      modelId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostModelVersionsUnPublishBody;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchModelUseCases2
   * @summary Update model use_cases tags
   * @request PATCH:/v2/models/{model_id}/usecases
   */
  export namespace V2PatchModelUseCases2 {
    export type RequestParams = {
      modelId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchModelUseCasesBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiModelUseCaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListModelVersions2
   * @summary List all the models.
   * @request GET:/v2/models/{model_id}/versions
   */
  export namespace V2ListModelVersions2 {
    export type RequestParams = {
      modelId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      /**
       * Filtering options:
       * To list only the model versions that have these concept ids present in them.
       */
      concept_ids?: string[];
      /** To list only the model versions that have been trained. */
      trained_only?: boolean;
      /**
       * Sorting options:
       * Whether to sort in ascending order. If false, will order in descending order.
       */
      sort_ascending?: boolean;
      /** Whether to order by the status code */
      sort_by_status_code?: boolean;
      /** Whether to order by the number of training inputs */
      sort_by_num_inputs?: boolean;
      /** Whether to sort by the description */
      sort_by_description?: boolean;
      /**
       * Whether to order by the created_at time
       * If neither sort option is set to true, will sort by created_at.
       */
      sort_by_created_at?: boolean;
      /**
       * Filter by model versions runners with replicas >= min_replicas.
       * @format int64
       */
      min_replicas?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiModelVersionResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostModelVersions2
   * @summary Create a new model version to trigger training of the model.
   * @request POST:/v2/models/{model_id}/versions
   */
  export namespace V2PostModelVersions2 {
    export type RequestParams = {
      modelId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostModelVersionsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleModelResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostModelVersionsTrainingTimeEstimate2
   * @summary Get the training time estimate based off train request and estimated input count.
   * @request POST:/v2/models/{model_id}/versions/time_estimate
   */
  export namespace V2PostModelVersionsTrainingTimeEstimate2 {
    export type RequestParams = {
      modelId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostModelVersionsTrainingTimeEstimateBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiTrainingTimeEstimateResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2ListModelVersionEvaluations2
 * @summary Deprecated, use GetEvaluation instead
List the evaluation metrics for a model version.
 * @request GET:/v2/models/{model_id}/versions/{model_version_id}/evaluations
*/
  export namespace V2ListModelVersionEvaluations2 {
    export type RequestParams = {
      modelId: string;
      modelVersionId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiEvalMetricsResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostModelVersionEvaluations2
   * @summary Deprecated, use PostEvaluations instead
   * @request POST:/v2/models/{model_id}/versions/{model_version_id}/evaluations
   */
  export namespace V2PostModelVersionEvaluations2 {
    export type RequestParams = {
      modelId: string;
      modelVersionId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostModelVersionEvaluationsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiEvalMetricsResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2GetModelVersionEvaluation2
 * @summary Deprecated, use GetEvaluation instead
Get an evaluation metrics for a model version.
 * @request GET:/v2/models/{model_id}/versions/{model_version_id}/evaluations/{evaluation_id}
*/
  export namespace V2GetModelVersionEvaluation2 {
    export type RequestParams = {
      modelId: string;
      modelVersionId: string;
      evaluationId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      fieldsConfusionMatrix?: boolean;
      fieldsCooccurrenceMatrix?: boolean;
      fieldsLabelCounts?: boolean;
      fieldsBinaryMetrics?: boolean;
      fieldsTestSet?: boolean;
      fieldsMetricsByArea?: boolean;
      fieldsMetricsByClass?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleEvalMetricsResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListModelVersionInputExamples2
   * @summary ListModelVersionInputExamples
   * @request GET:/v2/models/{model_id}/versions/{model_version_id}/input_examples
   */
  export namespace V2ListModelVersionInputExamples2 {
    export type RequestParams = {
      /** id of model the example belongs to */
      modelId: string;
      /** specific version the example belongs to */
      modelVersionId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /**
       * Optional, defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * Optional, defaults to 128 references per page.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiModelVersionInputExampleResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetModelVersionInputExample2
   * @summary GetModelVersionInputExample
   * @request GET:/v2/models/{model_id}/versions/{model_version_id}/input_examples/{example_id}
   */
  export namespace V2GetModelVersionInputExample2 {
    export type RequestParams = {
      /** id of model the example belongs to */
      modelId: string;
      /** specific version the example belongs to */
      modelVersionId: string;
      /** Id of example to fetch */
      exampleId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleModelVersionInputExampleResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetModelVersion2
   * @summary Get a specific model from an app.
   * @request GET:/v2/models/{model_id}/versions/{version_id}
   */
  export namespace V2GetModelVersion2 {
    export type RequestParams = {
      modelId: string;
      versionId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleModelVersionResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteModelVersion2
   * @summary Delete a single model.
   * @request DELETE:/v2/models/{model_id}/versions/{version_id}
   */
  export namespace V2DeleteModelVersion2 {
    export type RequestParams = {
      modelId: string;
      versionId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetModelVersionExport2
   * @summary GetModelVersionExport
   * @request GET:/v2/models/{model_id}/versions/{version_id}/exports
   */
  export namespace V2GetModelVersionExport2 {
    export type RequestParams = {
      modelId: string;
      versionId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleModelVersionExportResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PutModelVersionExports2
   * @summary Export a model
   * @request PUT:/v2/models/{model_id}/versions/{version_id}/exports
   */
  export namespace V2PutModelVersionExports2 {
    export type RequestParams = {
      modelId: string;
      versionId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleModelVersionExportResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2ListModelInputs4
 * @summary Deprecated: Unmaintained and ideally replaced with usage of datasets
  The server may refuse to accept requests to this endpoint.
 * @request GET:/v2/models/{model_id}/versions/{version_id}/inputs
*/
  export namespace V2ListModelInputs4 {
    export type RequestParams = {
      modelId: string;
      versionId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiInputResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2GetModelVersionMetrics2
 * @summary Get the evaluation metrics for a model version.
Deprecated: Use GetEvaluation instead
  The server may refuse to accept requests to this endpoint.
 * @request GET:/v2/models/{model_id}/versions/{version_id}/metrics
*/
  export namespace V2GetModelVersionMetrics2 {
    export type RequestParams = {
      modelId: string;
      versionId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      fieldsConfusionMatrix?: boolean;
      fieldsCooccurrenceMatrix?: boolean;
      fieldsLabelCounts?: boolean;
      fieldsBinaryMetrics?: boolean;
      fieldsTestSet?: boolean;
      fieldsMetricsByArea?: boolean;
      fieldsMetricsByClass?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleModelVersionResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2PostModelVersionMetrics2
 * @summary Deprecated, use PostEvaluations instead
Run the evaluation metrics for a model version.
 * @request POST:/v2/models/{model_id}/versions/{version_id}/metrics
*/
  export namespace V2PostModelVersionMetrics2 {
    export type RequestParams = {
      modelId: string;
      versionId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostModelVersionMetricsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleModelVersionResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2GetModelOutputInfo4
 * @summary Get a the output info for a given model_id or model_id/version_id
combo.
 * @request GET:/v2/models/{model_id}/versions/{version_id}/output_info
*/
  export namespace V2GetModelOutputInfo4 {
    export type RequestParams = {
      modelId: string;
      /**
       * This is included so that we can re-use this request for multiple
       * rpcs with and without the version_id.
       */
      versionId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      language?: string;
      trained_before?: boolean;
      /** (optional URL parameter) List of additional fields to be included in the response. Currently supported: all, stars, outputs, presets */
      additional_fields?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleModelResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostModelOutputs2
   * @summary Get predicted outputs from the model.
   * @request POST:/v2/models/{model_id}/versions/{version_id}/outputs
   */
  export namespace V2PostModelOutputs2 {
    export type RequestParams = {
      modelId: string;
      versionId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostModelOutputsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiOutputResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListModules3
   * @summary List all the modules in community, by user or by app.
   * @request GET:/v2/modules
   */
  export namespace V2ListModules3 {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      additional_fields?: string[];
      /**
       * Sorting options:
       * Whether to sort in ascending order. If false, will order in descending order.
       */
      sort_ascending?: boolean;
      /** Whether to order by the created_at time. */
      sort_by_created_at?: boolean;
      /** Whether to order by the number of users stared the app */
      sort_by_star_count?: boolean;
      /** If neither sort option is set to true, will sort by modified_at. */
      sort_by_modified_at?: boolean;
      /** Whether to order by the external id */
      sort_by_id?: boolean;
      /** Filtering options: */
      starred_only?: boolean;
      /** Filter modules by bookmark. If set, only return bookmarked modules. Otherwise none bookmarked modules only. */
      bookmark?: boolean;
      /**
       * Searching options:
       * Specify a search parameter in order to perform keyword search on the
       * following fields of the module:
       *   - id
       *   - description
       *   - user_id (unless user_app_id.user_id is already set)
       *
       * Keywords are both normalized for search (so searching for "satisfy" matches "satisfied")
       * and used for partial prefix-matching (so searching for "clari" matches "clarifai").
       *
       * NOTE: Both the list of fields searched and the exact keyword matching
       * rules are subject to change and not guaranteed to be backwards-compatible.
       */
      search?: string;
      /**
       * Filter by the id and description of the module. This supports wildcard queries like "gen*" to match "general" as an example.
       * Deprecated: use search instead.
       */
      name?: string;
      /**
       * Filter by the application owner whose this module belongs to
       * Deprecated: use search instead of name.
       */
      filter_by_user_id?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiModuleResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2MyScopes3
 * @summary API Keys in the public API -- request is itself Key authorized, and will tell
the user the scopes/access of the key/credential they're providing, as computed by
our authorizer:
 * @request GET:/v2/my_scopes
*/
  export namespace V2MyScopes3 {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiScopeResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2MyScopes2
 * @summary API Keys in the public API -- request is itself Key authorized, and will tell
the user the scopes/access of the key/credential they're providing, as computed by
our authorizer:
 * @request GET:/v2/myscopes
*/
  export namespace V2MyScopes2 {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiScopeResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2MyScopesRoot
   * @request GET:/v2/myscopesroot
   */
  export namespace V2MyScopesRoot {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiScopeRootResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListOpenSourceLicenses
   * @summary List all the supported open source licenses in the platform.
   * @request GET:/v2/open_source_licenses
   */
  export namespace V2ListOpenSourceLicenses {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiListOpenSourceLicensesResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2PostPipelineStepVersionsUpload
 * @summary This is a streaming endpoint, the request has a field, upload_data, which can either be the config for the upload or the actual data to upload.
The config must be sent first before the pipeline_step_bytes can be uploaded.
Once the config has been sent, the server will respond with a confirmation containing the pipeline_step_version_id.
This is so that if your upload is interrupted, you can resume the upload by sending the config again with the pipeline_step_version_id specified for your pipeline_step_version.
The actual upload will be done via a multipart upload, the latest successful part_id will be sent from the server in the response to the pipeline_step_bytes.
 * @request POST:/v2/pipeline_step_versions/upload
*/
  export namespace V2PostPipelineStepVersionsUpload {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPostPipelineStepVersionsUploadRequest;
    export type RequestHeaders = {};
    export type ResponseBody = {
      result?: ApiPostPipelineStepVersionsUploadResponse;
      error?: GooglerpcStatus;
    };
  }

  /**
   * No description
   * @tags V2
   * @name V2GetResourceCounts2
   * @summary List the resource counts for the app.
   * @request GET:/v2/resource_counts
   */
  export namespace V2GetResourceCounts2 {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiGetResourceCountsResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2ProcessRunnerItems
 * @summary This maintains a single request for asking the API if there is any work to be done, processing
it and streaming back results.
To do that first handshake the MultiRunnerItemOutputResponse will have RUNNER_STREAM_START
status filled in so that the API knows to respond with a MultiRunnerItemResponse.
For now there will only be one of those if the model prediction only has one request.
NOTE(zeiler): downside of this is you can't use HTTP REST requests to do runner work.
 * @request POST:/v2/runners/items/process
*/
  export namespace V2ProcessRunnerItems {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPostRunnerItemOutputsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = {
      result?: ApiMultiRunnerItemResponse;
      error?: GooglerpcStatus;
    };
  }

  /**
   * No description
   * @tags V2
   * @name V2ListSearches2
   * @summary List all saved legacy searches.
   * @request GET:/v2/searches
   */
  export namespace V2ListSearches2 {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiSearchResponse;
  }

  /**
   * @description Deprecated: Use PostInputsSearches or PostAnnotationsSearches instead. The server may refuse to accept requests to this endpoint.
   * @tags V2
   * @name V2PostSearches2
   * @summary Execute a new search and optionally save it.
   * @request POST:/v2/searches
   */
  export namespace V2PostSearches2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPostSearchesRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiSearchResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchSearches2
   * @summary Patch saved legacy searches by ids.
   * @request PATCH:/v2/searches
   */
  export namespace V2PatchSearches2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPatchSearchesRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiSearchResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetSearch2
   * @summary Get a saved legacy search.
   * @request GET:/v2/searches/{id}
   */
  export namespace V2GetSearch2 {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleSearchResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteSearch2
   * @summary Delete a saved search.
   * @request DELETE:/v2/searches/{id}
   */
  export namespace V2DeleteSearch2 {
    export type RequestParams = {
      id: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostSearchesById2
   * @summary Execute a previously saved legacy search.
   * @request POST:/v2/searches/{id}
   */
  export namespace V2PostSearchesById2 {
    export type RequestParams = {
      /** ID for saves search to be executed */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostSearchesByIDBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiSearchResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostStatValues2
   * @summary PostStatValues
   * @request POST:/v2/stats/values
   */
  export namespace V2PostStatValues2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPostStatValuesRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiStatValueResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostStatValuesAggregate2
   * @summary PostStatValuesAggregate
   * @request POST:/v2/stats/values/aggregate
   */
  export namespace V2PostStatValuesAggregate2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPostStatValuesAggregateRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiStatValueAggregateResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListStatusCodes
   * @summary List all status codes.
   * @request GET:/v2/status_codes
   */
  export namespace V2ListStatusCodes {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiStatusCodeResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetStatusCode
   * @summary Get more details for a status code.
   * @request GET:/v2/status_codes/{status_code_id}
   */
  export namespace V2GetStatusCode {
    export type RequestParams = {
      statusCodeId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleStatusCodeResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListTasks2
   * @summary List tasks from an app.
   * @request GET:/v2/tasks
   */
  export namespace V2ListTasks2 {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      /** Get tasks that have ANY user from this list assigned as worker. */
      worker_user_ids?: string[];
      /** Get tasks that have ANY user from this list assigned as reviewer. */
      review_user_ids?: string[];
      /** Get tasks that are associated to ANY label order from this list. */
      label_order_ids?: string[];
      /**
       * Get label order tasks as well
       * It is automatically set to true if label_order_ids is set.
       */
      including_label_order_tasks?: boolean;
      /**
       * (optional URL parameter) List of additional fields to be included in the response.
       * Currently supported additional fields:
       * - all
       * - worker.users
       * - review.users
       * - metrics.input_source.inputs_count_estimated
       * - metrics.work.inputs_count_estimated
       * - metrics.work.inputs_percent_estimated
       * - metrics.review.inputs_count_estimated
       * - metrics.review.inputs_count_estimated_per_reviewer
       * - metrics.review.inputs_percent_estimated
       * - metrics.review.inputs_percent_estimated_per_reviewer
       * - metrics.review.inputs_reviewable_count_estimated_per_reviewer
       */
      additional_fields?: string[];
      /** (optional) task IDs to filter on */
      ids?: string[];
      /**
       * (optional) input source type to filter
       *
       *  - ALL_INPUTS: Use all inputs in the app.
       *  - SAVED_SEARCH: Use the inputs from a saved search.
       *  - DATASET: Inputs from a dataset.
       * @default "INPUT_SOURCE_TYPE_NOT_SET"
       */
      input_source_type?: 'INPUT_SOURCE_TYPE_NOT_SET' | 'ALL_INPUTS' | 'SAVED_SEARCH' | 'DATASET';
      /** (optional) ids of input source to be filtered */
      input_source_ids?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiTaskResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteTasks2
   * @summary Delete multiple tasks in one request.
   * @request DELETE:/v2/tasks
   */
  export namespace V2DeleteTasks2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiDeleteTasksRequest;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostTasks2
   * @summary Add tasks to an app.
   * @request POST:/v2/tasks
   */
  export namespace V2PostTasks2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPostTasksRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiTaskResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchTasks2
   * @summary Patch one or more tasks.
   * @request PATCH:/v2/tasks
   */
  export namespace V2PatchTasks2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPatchTasksRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiTaskResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetTask2
   * @summary Get a specific task from an app.
   * @request GET:/v2/tasks/{task_id}
   */
  export namespace V2GetTask2 {
    export type RequestParams = {
      taskId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) List of additional fields to be included in the response.
       * Currently supported additional fields:
       * - all
       * - worker.users
       * - review.users
       * - metrics.input_source.inputs_count_estimated
       * - metrics.work.inputs_count_estimated
       * - metrics.work.inputs_percent_estimated
       * - metrics.review.inputs_count_estimated
       * - metrics.review.inputs_count_estimated_per_reviewer
       * - metrics.review.inputs_percent_estimated
       * - metrics.review.inputs_percent_estimated_per_reviewer
       * - metrics.review.inputs_reviewable_count_estimated_per_reviewer
       */
      additional_fields?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleTaskResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetTaskAnnotationCount2
   * @summary Task annotation count
   * @request GET:/v2/tasks/{task_id}/annotations/count
   */
  export namespace V2GetTaskAnnotationCount2 {
    export type RequestParams = {
      /** task_id for which count per user per status is needed */
      taskId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /**
       * Only return counts for these user IDs, effectively operating as an
       * OR among them to filter down the results.
       * If model_version_ids or workflow_version_ids are also provided, these user_ids are OR'd with them as well because
       * we want the union of all worker (user, model or workflow) counts in the results.
       */
      user_ids?: string[];
      /**
       * Only return counts for these model version IDs, effectively operating as an
       * OR among them to filter down the results.
       * If user_ids or workflow_version_ids are also provided, these model_version_ids are OR'd with them as well because
       * we want the union of all worker (user, model or workflow) counts in the results.
       */
      model_version_ids?: string[];
      /**
       * Only return counts for these workflow version IDs, effectively operating as an
       * OR among them to filter down the results.
       * If user_ids or model_version_ids are also provided, these workflow_version_ids are OR'd with them as well because
       * we want the union of all worker (user, model or workflow) counts in the results.
       */
      workflow_version_ids?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleTaskCountResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2ListNextTaskAssignments2
 * @summary Deprecated: Use PutTaskAssignments with action=LABEL_START.
  This endpoint has initially been designed as a GET request,
  but has been re-designed to serve a PUT logic.
  In order to clearly highlight that this endpoint serves a PUT request,
  this endpoint has been deprecated and replaced by PutTaskAssignments with action=LABEL_START.
 * @request GET:/v2/tasks/{task_id}/assignments
*/
  export namespace V2ListNextTaskAssignments2 {
    export type RequestParams = {
      taskId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiInputResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetTaskInputCount2
   * @summary Task Input count
   * @request GET:/v2/tasks/{task_id}/inputs/count
   */
  export namespace V2GetTaskInputCount2 {
    export type RequestParams = {
      /** task_id for which count per user per status is needed */
      taskId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /**
       * Only return counts for these user IDs, effectively operating as an
       * OR among them to filter down the results.
       * If model_version_ids or workflow_version_ids are also provided, these user_ids are OR'd with them as well because
       * we want the union of all worker (user, model or workflow) counts in the results.
       */
      user_ids?: string[];
      /**
       * Only return counts for these model version IDs, effectively operating as an
       * OR among them to filter down the results.
       * If user_ids or workflow_version_ids are also provided, these model_version_ids are OR'd with them as well because
       * we want the union of all worker (user, model or workflow) counts in the results.
       */
      model_version_ids?: string[];
      /**
       * Only return counts for these workflow version IDs, effectively operating as an
       * OR among them to filter down the results.
       * If user_ids or model_version_ids are also provided, these workflow_version_ids are OR'd with them as well because
       * we want the union of all worker (user, model or workflow) counts in the results.
       */
      workflow_version_ids?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleTaskCountResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetInputSamples2
   * @request GET:/v2/tasks/{task_id}/inputs/samples
   */
  export namespace V2GetInputSamples2 {
    export type RequestParams = {
      taskId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /** URL param. If zero ids provided, returns for all task labelers */
      user_ids?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiInputAnnotationResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListUploads2
   * @request GET:/v2/uploads
   */
  export namespace V2ListUploads2 {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiUploadResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteUploads2
   * @request DELETE:/v2/uploads
   */
  export namespace V2DeleteUploads2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiDeleteUploadsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2PostUploads2
 * @summary PostUploads is used to upload files. Note that this does not create inputs.
returns job with uploadID, job has UPLOAD_IN_PROGRESS status
Actual upload content can be done in multiple calls with PutUploadContentParts
You can get status of upload with GetUpload or ListUploads endpoints
See also PostInputsUploads
 * @request POST:/v2/uploads
*/
  export namespace V2PostUploads2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPostUploadsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiUploadResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetUpload2
   * @request GET:/v2/uploads/{upload_id}
   */
  export namespace V2GetUpload2 {
    export type RequestParams = {
      /** Upload ID */
      uploadId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleUploadResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2PutUploadContentParts2
 * @summary Upload a part of a multipart upload.
Behaviour on completion depends on the endpoint that was used to initiate the upload.
 * @request PUT:/v2/uploads/{upload_id}/content_parts
*/
  export namespace V2PutUploadContentParts2 {
    export type RequestParams = {
      uploadId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleUploadResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostModelOutputs5
   * @summary Get predicted outputs from the model.
   * @request POST:/v2/users/{runner_selector.deployment.user_id}/deployments/{runner_selector.deployment.id}/outputs
   */
  export namespace V2PostModelOutputs5 {
    export type RequestParams = {
      /** The user who owns the deployment. These live in the user/org account. */
      runnerSelectorDeploymentUserId: string;
      /** An id for this configured deployment. */
      runnerSelectorDeploymentId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostModelOutputsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiOutputResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2StreamLogEntries2
   * @request GET:/v2/users/{user_app_id.user_id_1}/apps/{user_app_id.app_id}/models/{model_id}/versions/{model_version_id}/compute_clusters/{compute_cluster_id}/nodepools/{nodepool_id}/{log_type}/logs
   */
  export namespace V2StreamLogEntries2 {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId1: string;
      userAppIdAppId: string;
      /** The Model ID, if a model produced the logs. */
      modelId: string;
      /** The Version ID, if a model version produced the logs. */
      modelVersionId: string;
      /** Where the logs came from. */
      computeClusterId: string;
      nodepoolId: string;
      /** The type of log entry. Examples: model, agent, build, training. */
      logType: string;
    };
    export type RequestQuery = {
      /** Workflow Id, if a workflow produced the logs. */
      workflow_id?: string;
      runner_id?: string;
      /** Pipelines that produced the logs. */
      pipeline_id?: string;
      pipeline_version_id?: string;
      pipeline_version_run_id?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = {
      result?: ApiMultiLogEntryResponse;
      error?: GooglerpcStatus;
    };
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchRunners
   * @summary Patch runners of a user.
   * @request POST:/v2/users/{user_app_id.user_id_1}/compute_clusters/{compute_cluster_id}/nodepools/{nodepool_id}/runners
   */
  export namespace V2PatchRunners {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId1: string;
      computeClusterId: string;
      nodepoolId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchRunnersBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiRunnerResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2StreamLogEntries
   * @request GET:/v2/users/{user_app_id.user_id_1}/compute_clusters/{compute_cluster_id}/nodepools/{nodepool_id}/runners/{runner_id}/{log_type}/logs
   */
  export namespace V2StreamLogEntries {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId1: string;
      /** Where the logs came from. */
      computeClusterId: string;
      nodepoolId: string;
      runnerId: string;
      /** The type of log entry. Examples: model, agent, build, training. */
      logType: string;
    };
    export type RequestQuery = {
      userAppIdAppId?: string;
      /** The Model ID, if a model produced the logs. */
      model_id?: string;
      /** The Version ID, if a model version produced the logs. */
      model_version_id?: string;
      /** Workflow Id, if a workflow produced the logs. */
      workflow_id?: string;
      /** Pipelines that produced the logs. */
      pipeline_id?: string;
      pipeline_version_id?: string;
      pipeline_version_run_id?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = {
      result?: ApiMultiLogEntryResponse;
      error?: GooglerpcStatus;
    };
  }

  /**
   * No description
   * @tags V2
   * @name V2GetUser
   * @summary Get user information
   * @request GET:/v2/users/{user_app_id.user_id}
   */
  export namespace V2GetUser {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
    };
    export type RequestQuery = {
      userAppIdAppId?: string;
      /** (optional URL parameter) List of additional fields to be included in the response. Currently supported: all, stars */
      additional_fields?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleUserResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListApps
   * @summary List all the apps.
   * @request GET:/v2/users/{user_app_id.user_id}/apps
   */
  export namespace V2ListApps {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
    };
    export type RequestQuery = {
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      /** (optional URL parameter) List of additional fields to be included in the response. Currently supported: all, stars, counts */
      additional_fields?: string[];
      /**
       * Sorting options:
       * Whether to sort in ascending order. If false, will order in descending order.
       */
      sort_ascending?: boolean;
      /** Whether to order by the name. */
      sort_by_name?: boolean;
      /**
       * Whether to order by the modified_at time.
       * If none of the sort options is set to true, will sort by modified_at.
       */
      sort_by_modified_at?: boolean;
      /** Whether to order by the created_at time. */
      sort_by_created_at?: boolean;
      /** Whether to order by the number of users stared the app */
      sort_by_star_count?: boolean;
      /** Whether to order by the id */
      sort_by_id?: boolean;
      /**
       * Filtering options:
       * If true, we only return apps that are handpicked by clarifai staff
       */
      featured_only?: boolean;
      /** If true, we only return apps that are starred by the requesting user */
      starred_only?: boolean;
      /** If true, we only return apps that are marked as a template by the app owner. */
      template_only?: boolean;
      /**
       * Searching options:
       * Specify a search parameter in order to perform keyword search on the
       * following fields of the application:
       *   - id
       *   - name
       *   - description
       *   - notes
       *   - user_id (unless user_app_id.user_id is already set)
       *
       * Keywords are both normalized for search (so searching for "satisfy" matches "satisfied")
       * and used for partial prefix-matching (so searching for "clari" matches "clarifai").
       *
       * NOTE: Both the list of fields searched and the exact keyword matching
       * rules are subject to change and not guaranteed to be backwards-compatible.
       */
      search?: string;
      /**
       * Query various text fields (id, name, description, and notes) that can contain the words in the query string
       * Deprecated: use search instead.
       */
      query?: string;
      /**
       * Filter by the id, name and notes of the app. This supports wilcard queries like "gen*" to match "general" as an example.
       * Deprecated: use search instead.
       */
      name?: string;
      /**
       * Filter by the user-unique-id of the app. This supports wilcard queries like "gen*" to match "general" as an example.
       * Deprecated: use search instead.
       */
      id?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiAppResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2PostApps
 * @summary Add a app to an app.
This needs to load the default workflow to make a copy, validating all the models in it, and
then writing the new workflow back to this new app.
 * @request POST:/v2/users/{user_app_id.user_id}/apps
*/
  export namespace V2PostApps {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostAppsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiAppResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchApps
   * @summary Patch one or more apps.
   * @request PATCH:/v2/users/{user_app_id.user_id}/apps
   */
  export namespace V2PatchApps {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchAppsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiAppResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchAppsIds
   * @summary Patch apps ids.
   * @request PATCH:/v2/users/{user_app_id.user_id}/apps/ids
   */
  export namespace V2PatchAppsIds {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchAppsIdsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiAppResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostAppsSearches
   * @summary Search over the applications to find one or more you're looking for.
   * @request POST:/v2/users/{user_app_id.user_id}/apps/searches
   */
  export namespace V2PostAppsSearches {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostAppsSearchesBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiAppResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetApp
   * @summary Get a specific app from an app.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}
   */
  export namespace V2GetApp {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {
      /** (optional URL parameter) List of additional fields to be included in the response. Currently supported: all, stars, counts */
      additional_fields?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleAppResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2DeleteApp
 * @summary Search over the apps to find one or more you're looking for.
This leverage the "body" parameter because we also have page and
per_page as url query param variables in this request.
 * @request DELETE:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}
*/
  export namespace V2DeleteApp {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchApp
   * @summary Patch one app.
   * @request PATCH:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}
   */
  export namespace V2PatchApp {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchAppBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleAppResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListAnnotationFilters
   * @summary List all the annotation filters.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/annotation_filters
   */
  export namespace V2ListAnnotationFilters {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiAnnotationFilterResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteAnnotationFilters
   * @summary Delete one or more annotation filters in a single request.
   * @request DELETE:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/annotation_filters
   */
  export namespace V2DeleteAnnotationFilters {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2DeleteAnnotationFiltersBody;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostAnnotationFilters
   * @summary Add annotation filters.
   * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/annotation_filters
   */
  export namespace V2PostAnnotationFilters {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostAnnotationFiltersBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiAnnotationFilterResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchAnnotationFilters
   * @summary Patch one or more annotation filters.
   * @request PATCH:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/annotation_filters
   */
  export namespace V2PatchAnnotationFilters {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchAnnotationFiltersBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiAnnotationFilterResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetAnnotationFilter
   * @summary Get a specific annotation filter.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/annotation_filters/{annotation_filter_id}
   */
  export namespace V2GetAnnotationFilter {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** Identify annotation filter by id. */
      annotationFilterId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleAnnotationFilterResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListAnnotations
   * @summary List all the annotation.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/annotations
   */
  export namespace V2ListAnnotations {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {
      /** List annotations for these IDs */
      ids?: string[];
      /**
       * List annotations for these Input IDs
       * Note that 'ids' are optional but if the are provided the number and order in
       * 'ids' and 'input_ids' should match
       * If you do not specify 'ids' all the annotations for 'input_ids' are returned
       * If a you do not specify both 'input_ids' and 'ids' all the annotations in the app are returned
       */
      input_ids?: string[];
      /**
       * Only return the annotations that has one of these user IDs, effectively operating as an
       * OR among them to filter down the results.
       * If model_version_ids or workflow_version_ids are also provided, these user_ids are OR'd with them as well because
       * we want the union of all worker (user, model or workflow) annotations in the results of ListAnnotations request.
       * Setting user_ids does also set list_all_annotations=True.
       */
      user_ids?: string[];
      /**
       * Only return the annotations that has one of these model version IDs, effectively operating as an
       * OR among them to filter down the results.
       * If user_ids or workflow_version_ids are also provided, these model_version_ids are OR'd with them as well because
       * we want the union of all worker (user, model or workflow) annotations in the results of ListAnnotations request.
       * Setting model_version_ids does also set list_all_annotations=True.
       */
      model_version_ids?: string[];
      /**
       * Only return the annotations that has one of these workflow version IDs, effectively operating as an
       * OR among them to filter down the results.
       * If user_ids or model_version_ids are also provided, these workflow_version_ids are OR'd with them as well because
       * we want the union of all worker (user, model or workflow) annotations in the results of ListAnnotations request.
       * Setting workflow_version_ids does also set list_all_annotations=True.
       */
      workflow_version_ids?: string[];
      /**
       * Set this flag to list both trusted and not trusted annotations
       * by default it's listing only trusted annotations
       */
      list_all_annotations?: boolean;
      /** Set this flag to return the model output for model annotations in the response. */
      return_model_output?: boolean;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      /** Flag to filter annotations by task_id */
      task_id?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiAnnotationResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteAnnotations3
   * @summary Delete multiple annotations in one request.
   * @request DELETE:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/annotations
   */
  export namespace V2DeleteAnnotations3 {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = ApiV2DeleteAnnotationsBody;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostAnnotations
   * @summary Post annotations.
   * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/annotations
   */
  export namespace V2PostAnnotations {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostAnnotationsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiAnnotationResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchAnnotations
   * @summary Patch one or more annotations.
   * @request PATCH:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/annotations
   */
  export namespace V2PatchAnnotations {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchAnnotationsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiAnnotationResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostAnnotationsSearches
   * @summary Execute a search over annotations
   * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/annotations/searches
   */
  export namespace V2PostAnnotationsSearches {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostAnnotationsSearchesBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiSearchResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchAnnotationsSearches
   * @summary Patch saved annotations searches by ids.
   * @request PATCH:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/annotations/searches
   */
  export namespace V2PatchAnnotationsSearches {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchAnnotationsSearchesBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiSearchResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListAnnotationSearchMetrics
   * @summary List the evaluation results between two search requests
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/annotations/searches/metrics
   */
  export namespace V2ListAnnotationSearchMetrics {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiAnnotationSearchMetricsResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostAnnotationSearchMetrics
   * @summary Evaluate the results of two search requests
   * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/annotations/searches/metrics
   */
  export namespace V2PostAnnotationSearchMetrics {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostAnnotationSearchMetricsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiAnnotationSearchMetricsResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetAnnotationSearchMetrics
   * @summary Get the evaluation results between two search requests
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/annotations/searches/metrics/{id}
   */
  export namespace V2GetAnnotationSearchMetrics {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** Unique custom facing id that identifies the eval to get */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiAnnotationSearchMetricsResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteAnnotationSearchMetrics
   * @summary DeleteAnnotationSearchMetrics
   * @request DELETE:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/annotations/searches/metrics/{id}
   */
  export namespace V2DeleteAnnotationSearchMetrics {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2ListAnnotationWorkers
 * @summary ListAnnotationWorkers lists users, models, and workflows (collectively
known as "workers") that have added annotations to the application.
 * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/annotations/workers
*/
  export namespace V2ListAnnotationWorkers {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      /**
       * (optional URL parameter) List of additional fields to be included in the response.
       * Currently supported: all, names
       */
      additional_fields?: string[];
      /** (optional URL parameter) Only list workers that have created trusted annotations. */
      trusted_only?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiWorkerResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListBulkOperations
   * @summary List all the bulk operations
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/bulk_operations
   */
  export namespace V2ListBulkOperations {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiBulkOperationsResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteBulkOperations
   * @summary delete one or more terminated bulk operations
   * @request DELETE:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/bulk_operations
   */
  export namespace V2DeleteBulkOperations {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2DeleteBulkOperationsBody;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2PostBulkOperations
 * @summary Perform bulk operations on a list of inputs based on input source.
Operation include add, update, delete of concepts, metadata and geo data.
This is an Asynchronous process. Use ListBulkOperations or GetBulkOperation to check the status.
 * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/bulk_operations
*/
  export namespace V2PostBulkOperations {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostBulkOperationsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiBulkOperationsResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2CancelBulkOperations
   * @summary Cancel one or more bulk operations
   * @request PATCH:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/bulk_operations
   */
  export namespace V2CancelBulkOperations {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2CancelBulkOperationsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiBulkOperationsResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetBulkOperation
   * @summary Get the bulk operation details by ID
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/bulk_operations/{id}
   */
  export namespace V2GetBulkOperation {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** The bulk operation id */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleBulkOperationsResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListCollaborators
   * @summary owner list users who the app is shared with
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/collaborators
   */
  export namespace V2ListCollaborators {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {
      /**
       * Set this flag to list both deleted and not deleted collaborators
       * by default it's listing only not deleted collaborators
       */
      list_all_collaborators?: boolean;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiCollaboratorsResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteCollaborators
   * @summary Delete existing collaborators.
   * @request DELETE:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/collaborators
   */
  export namespace V2DeleteCollaborators {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2DeleteCollaboratorsBody;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostCollaborators
   * @summary add collaborators to an app.
   * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/collaborators
   */
  export namespace V2PostCollaborators {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostCollaboratorsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiCollaboratorsResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchCollaborators
   * @summary Patch existing collaborators.
   * @request PATCH:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/collaborators
   */
  export namespace V2PatchCollaborators {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchCollaboratorsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiCollaboratorsResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListCollectors
   * @summary List all the collectors.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/collectors
   */
  export namespace V2ListCollectors {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiCollectorResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2DeleteCollectors
 * @summary Delete multiple collectors in one request.
This call is asynchronous. Use DeleteCollector if you want a synchronous version.
 * @request DELETE:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/collectors
*/
  export namespace V2DeleteCollectors {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2DeleteCollectorsBody;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2PostCollectors
 * @summary Add a list of Collectors to an app.
In the handler of this endpoint we also check for all the scopes of the  POST /inputs
endpoint.
Those current scopes are listed here as a hard requirement.
They are needed when adding the collectors just so we now that you have permission with
that key at least to do the writing to this app with POST /inputs.
 * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/collectors
*/
  export namespace V2PostCollectors {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostCollectorsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiCollectorResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchCollectors
   * @summary Patch one or more collectors.
   * @request PATCH:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/collectors
   */
  export namespace V2PatchCollectors {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchCollectorsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiCollectorResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetCollector
   * @summary Get a specific collector from an app.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/collectors/{collector_id}
   */
  export namespace V2GetCollector {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      collectorId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleCollectorResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListConcepts
   * @summary List all the concepts.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/concepts
   */
  export namespace V2ListConcepts {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      /** Fuzzy match on concept ID */
      id?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiConceptResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostConcepts
   * @summary Add a concept to an app.
   * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/concepts
   */
  export namespace V2PostConcepts {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostConceptsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiConceptResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchConcepts
   * @summary Patch one or more concepts.
   * @request PATCH:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/concepts
   */
  export namespace V2PatchConcepts {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchConceptsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiConceptResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListKnowledgeGraphs
   * @summary List all domain graphs.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/concepts/knowledge_graphs
   */
  export namespace V2ListKnowledgeGraphs {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiKnowledgeGraphResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostKnowledgeGraphs
   * @summary Post domain graphs.
   * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/concepts/knowledge_graphs
   */
  export namespace V2PostKnowledgeGraphs {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostKnowledgeGraphsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiKnowledgeGraphResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2ListConceptRelations2
 * @summary List concept relations between concepts in the platform.
MUST be above ListConcepts so that if concept_id is empty this will still match
/concepts/relations to list all the concept relations in the app.
 * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/concepts/relations
*/
  export namespace V2ListConceptRelations2 {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {
      /**
       * The subject concept id in your app to get all the relationships for.
       * Leave as an empty string (GET /concepts/relations) to list ALL the relations in the app.
       *
       * When listing all the relations it will only return one direction of the relationship
       * with the predicate acting on the subject and not the inverse like is done when providing a
       * concept_id so that we can return a reliable page size always.
       *
       * When providing a concept_id, if a hyponym is present in the DB such as:
       * 'honey' (subject), 'hyponym' (predicate for "is a kind of"), 'food' (object)
       * then you can list the concept relations for 'honey' and get hyponym predicate with 'food'
       * object.
       * But you can also list the concept relations for 'food' and it will return the same hyponym
       * relationship with 'honey' as object and 'hypernym' as predicate.
       * Synonyms by nature are symmetrical relationships so either side can be the concept_id (subject)
       * when listing the relations.
       */
      concept_id?: string;
      /**
       * If predicate is provided then only list relations with that predicate.
       *
       * Note that if no subject is set in concept_id and predicate is set to
       * 'hypernym', then it will return any stored hyponyms as hypernyms with
       * just the subject and object swapped since they are reversed relations.
       *
       * Valid predicates are:
       * - 'hypernym'
       * - 'hyponym'
       * - 'synonym'
       */
      predicate?: string;
      /**
       * If knowledge_graph_id is provided then just list relations from that knowledge graph.
       * If not provided then list relations from all knowledge graphs including the global one for this
       * app one (ie. knowledge_graph "") and any specific ones in the app.
       */
      knowledge_graph_id?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiConceptRelationResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2PostConceptsSearches
 * @summary Search over the concepts to find one or more you're looking for.
This leverage the "body" parameter because we also have page and
per_page as url query param variables in this request.
 * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/concepts/searches
*/
  export namespace V2PostConceptsSearches {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostConceptsSearchesBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiConceptResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetConceptCounts
   * @summary List all the concepts with their positive and negative counts
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/concepts/status
   */
  export namespace V2GetConceptCounts {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiConceptCountResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetConcept
   * @summary Get a specific concept from an app.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/concepts/{concept_id}
   */
  export namespace V2GetConcept {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** The concept's id. */
      conceptId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleConceptResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListConceptLanguages
   * @summary List the concept in all the translated languages.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/concepts/{concept_id}/languages
   */
  export namespace V2ListConceptLanguages {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      conceptId: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiConceptLanguageResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostConceptLanguages
   * @summary Add a new translation for this concept.
   * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/concepts/{concept_id}/languages
   */
  export namespace V2PostConceptLanguages {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      conceptId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostConceptLanguagesBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiConceptLanguageResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2PatchConceptLanguages
 * @summary Patch the name for a given language names by passing in a list of concepts with the new names
for the languages.
 * @request PATCH:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/concepts/{concept_id}/languages
*/
  export namespace V2PatchConceptLanguages {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      conceptId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchConceptLanguagesBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiConceptLanguageResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetConceptLanguage
   * @summary Get a specific concept from an app.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/concepts/{concept_id}/languages/{language}
   */
  export namespace V2GetConceptLanguage {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      conceptId: string;
      /** This is the language identifier. */
      language: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleConceptLanguageResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2ListConceptRelations
 * @summary List concept relations between concepts in the platform.
MUST be above ListConcepts so that if concept_id is empty this will still match
/concepts/relations to list all the concept relations in the app.
 * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/concepts/{concept_id}/relations
*/
  export namespace V2ListConceptRelations {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /**
       * The subject concept id in your app to get all the relationships for.
       * Leave as an empty string (GET /concepts/relations) to list ALL the relations in the app.
       *
       * When listing all the relations it will only return one direction of the relationship
       * with the predicate acting on the subject and not the inverse like is done when providing a
       * concept_id so that we can return a reliable page size always.
       *
       * When providing a concept_id, if a hyponym is present in the DB such as:
       * 'honey' (subject), 'hyponym' (predicate for "is a kind of"), 'food' (object)
       * then you can list the concept relations for 'honey' and get hyponym predicate with 'food'
       * object.
       * But you can also list the concept relations for 'food' and it will return the same hyponym
       * relationship with 'honey' as object and 'hypernym' as predicate.
       * Synonyms by nature are symmetrical relationships so either side can be the concept_id (subject)
       * when listing the relations.
       */
      conceptId: string;
    };
    export type RequestQuery = {
      /**
       * If predicate is provided then only list relations with that predicate.
       *
       * Note that if no subject is set in concept_id and predicate is set to
       * 'hypernym', then it will return any stored hyponyms as hypernyms with
       * just the subject and object swapped since they are reversed relations.
       *
       * Valid predicates are:
       * - 'hypernym'
       * - 'hyponym'
       * - 'synonym'
       */
      predicate?: string;
      /**
       * If knowledge_graph_id is provided then just list relations from that knowledge graph.
       * If not provided then list relations from all knowledge graphs including the global one for this
       * app one (ie. knowledge_graph "") and any specific ones in the app.
       */
      knowledge_graph_id?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiConceptRelationResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteConceptRelations
   * @summary Post concept relations to create relations between concepts in the platform.
   * @request DELETE:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/concepts/{concept_id}/relations
   */
  export namespace V2DeleteConceptRelations {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** The concept to delete relationship for. */
      conceptId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2DeleteConceptRelationsBody;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostConceptRelations
   * @summary Post concept relations to create relations between concepts in the platform.
   * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/concepts/{concept_id}/relations
   */
  export namespace V2PostConceptRelations {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** The subject concept id you're going to add relations for. */
      conceptId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostConceptRelationsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiConceptRelationResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListDatasets
   * @summary List all the datasets.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/datasets
   */
  export namespace V2ListDatasets {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      additional_fields?: string[];
      /**
       * Sorting options:
       * Whether to sort in ascending order. If false, will order in descending order.
       */
      sort_ascending?: boolean;
      /** Whether to order by the created_at time. */
      sort_by_created_at?: boolean;
      /** Whether to order by the number of users stared the app */
      sort_by_star_count?: boolean;
      /** If neither sort option is set to true, will sort by modified_at. */
      sort_by_modified_at?: boolean;
      /** Whether to order by the external id */
      sort_by_id?: boolean;
      /** Filtering options: */
      starred_only?: boolean;
      /** Filter datasets by bookmark. If set, only return bookmarked datasets. Otherwise none bookmarked datasets only. */
      bookmark?: boolean;
      /**
       * Searching options:
       * Specify a search parameter in order to perform keyword search on the
       * following fields of the dataset:
       *   - id
       *   - description
       *   - notes
       *   - user_id (unless user_app_id.user_id is already set)
       *
       * Keywords are both normalized for search (so searching for "satisfy" matches "satisfied")
       * and used for partial prefix-matching (so searching for "clari" matches "clarifai").
       *
       * NOTE: Both the list of fields searched and the exact keyword matching
       * rules are subject to change and not guaranteed to be backwards-compatible.
       */
      search?: string;
      /**
       * Fuzzy filter on dataset ID
       * Deprecated: use search instead.
       */
      id?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiDatasetResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteDatasets
   * @summary Delete one or more datasets in a single request.
   * @request DELETE:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/datasets
   */
  export namespace V2DeleteDatasets {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2DeleteDatasetsBody;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2PostDatasets
 * @summary Add datasets to an app.
The process is atomic, i.e. either all or no datasets are added.
If there is an error for one dataset,
the process will stop, revert the transaction and return the error.
 * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/datasets
*/
  export namespace V2PostDatasets {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostDatasetsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiDatasetResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2PatchDatasets
 * @summary Patch one or more datasets.
The process is atomic, i.e. either all or no datasets are patched.
If there is an error for one dataset,
the process will stop, revert the transaction and return the error.
 * @request PATCH:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/datasets
*/
  export namespace V2PatchDatasets {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchDatasetsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiDatasetResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetDataset
   * @summary Get a specific dataset.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/datasets/{dataset_id}
   */
  export namespace V2GetDataset {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** Identify dataset by id. */
      datasetId: string;
    };
    export type RequestQuery = {
      additional_fields?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleDatasetResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListDatasetInputs
   * @summary List all the dataset inputs in a dataset.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/datasets/{dataset_id}/inputs
   */
  export namespace V2ListDatasetInputs {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** Identify dataset by id. */
      datasetId: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiDatasetInputResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteDatasetInputs
   * @summary Delete one or more dataset inputs in a single request.
   * @request DELETE:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/datasets/{dataset_id}/inputs
   */
  export namespace V2DeleteDatasetInputs {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** Identify dataset by id. */
      datasetId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2DeleteDatasetInputsBody;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2PostDatasetInputs
 * @summary Add dataset inputs to a dataset.
The process is not atomic, i.e. if there are errors with some dataset
inputs, others might still be added. The response reports
  - SUCCESS if all dataset inputs were added,
  - MIXED_STATUS if only some dataset inputs were added, and
  - FAILURE if no dataset inputs were added.
Each individual dataset input in the response has the status set to
indicate if it was successful or if there was an error.
 * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/datasets/{dataset_id}/inputs
*/
  export namespace V2PostDatasetInputs {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** Identify dataset by id. */
      datasetId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostDatasetInputsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiDatasetInputResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetDatasetInput
   * @summary Get a specific dataset input.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/datasets/{dataset_id}/inputs/{input_id}
   */
  export namespace V2GetDatasetInput {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** Identify dataset by id. */
      datasetId: string;
      /** Identify dataset input by id. */
      inputId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleDatasetInputResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListDatasetVersions
   * @summary List all the dataset versions.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/datasets/{dataset_id}/versions
   */
  export namespace V2ListDatasetVersions {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** Identify dataset by id. */
      datasetId: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      /** (optional URL parameter) Filter by origin of dataset version */
      request_origins?: ('DATASET_VERSION_REQUEST_ORIGIN_NOT_SET' | 'MANUAL' | 'TRAINING' | 'EVAL_GROUND_TRUTH' | 'EVAL_PREDICTIONS')[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiDatasetVersionResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteDatasetVersions
   * @summary Delete one or more dataset versions in a single request.
   * @request DELETE:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/datasets/{dataset_id}/versions
   */
  export namespace V2DeleteDatasetVersions {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** Identify dataset by id. */
      datasetId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2DeleteDatasetVersionsBody;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostDatasetVersions
   * @summary Add dataset versions to a dataset.
   * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/datasets/{dataset_id}/versions
   */
  export namespace V2PostDatasetVersions {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** Identify dataset by id. */
      datasetId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostDatasetVersionsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiDatasetVersionResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchDatasetVersions
   * @summary Patch one or more dataset versions.
   * @request PATCH:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/datasets/{dataset_id}/versions
   */
  export namespace V2PatchDatasetVersions {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** Identify dataset by id. */
      datasetId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchDatasetVersionsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiDatasetVersionResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetDatasetVersion
   * @summary Get a specific dataset version.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/datasets/{dataset_id}/versions/{dataset_version_id}
   */
  export namespace V2GetDatasetVersion {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** Identify dataset by id. */
      datasetId: string;
      /** Identify dataset version by id. */
      datasetVersionId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleDatasetVersionResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PutDatasetVersionExports
   * @summary Create export of a dataset version.
   * @request PUT:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/datasets/{dataset_id}/versions/{dataset_version_id}/exports
   */
  export namespace V2PutDatasetVersionExports {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** Identify dataset by id. */
      datasetId: string;
      /** Identify dataset version by id. */
      datasetVersionId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PutDatasetVersionExportsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiDatasetVersionExportResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListDatasetVersionMetricsGroups
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/datasets/{dataset_id}/versions/{dataset_version_id}/metrics
   */
  export namespace V2ListDatasetVersionMetricsGroups {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** Identify dataset by id. */
      datasetId: string;
      /** Identify dataset version by id. */
      datasetVersionId: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      /** Filter by parent path. Multiple parent paths are OR-ed. Empty list results in no filter. */
      parent_paths?: string[];
      /**
       * Filter by parent type. Multiple types are OR-ed. Empty list results in no filter.
       *
       *  - INPUT_TYPE: Group data examples by input type.
       * Examples: images, videos, text, audio.
       *  - CONCEPT_ID: Group data examples by concept ID.
       * Examples: inputs with cat concept, inputs with dog concept.
       *  - CONCEPTS_COUNT: Group data examples by concepts count.
       * Examples: inputs with 20 concepts, inputs with 21 concepts.
       *  - BOUNDING_BOXES_COUNT: Group data examples by bounding boxes count.
       * Examples: inputs with 20 bounding boxes, inputs with 21 bounding boxes.
       *  - POLYGONS_COUNT: Group data examples by polygons count.
       * Examples: inputs with 20 polygons, inputs with 21 polygons.
       *  - POINTS_COUNT: Group data examples by points count.
       * Examples: inputs with 20 points, inputs with 21 points.
       *  - MASKS_COUNT: Group data examples by masks count.
       * Examples: inputs with 20 masks, inputs with 21 masks.
       *  - PIXELS_COUNT: Group data examples by pixels count.
       * In order to reduce the number of groups, we use bins.
       * Examples for bin size = 400: inputs with [200000, 200400) pixels, inputs with [200400, 200800) pixels.
       *  - ASPECT_RATIO: Group data examples by aspect ratio.
       * In order to reduce the number of groups, we use bins.
       * Examples for bin size = 0.1: inputs with [0.5, 0.6) aspect ratio, inputs with [0.6, 0.7) aspect ratio.
       */
      types?: (
        | 'DATASET_VERSION_METRICS_GROUP_TYPE_NOT_SET'
        | 'INPUT_TYPE'
        | 'CONCEPT_ID'
        | 'CONCEPTS_COUNT'
        | 'BOUNDING_BOXES_COUNT'
        | 'POLYGONS_COUNT'
        | 'POINTS_COUNT'
        | 'MASKS_COUNT'
        | 'PIXELS_COUNT'
        | 'ASPECT_RATIO'
      )[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiDatasetVersionMetricsGroupResponse;
  }

  /**
 * @description A duplication job can be started by any user that can read from the source application (the target of this call) and can create and write to the destination application. The duplication is associated with the user that created it, so in order to read the status and progress of the job, that user's ID has to be used in the call to GetAppDuplication, which might be different to the source application owner ID in this call.
 * @tags V2
 * @name V2PostAppDuplications
 * @summary PostAppDuplications starts async app duplication jobs which copy resources
(inputs, annotations, models etc) from one application to another. It can
also create the destination application if it does not exist, with fields
(description, metadata etc) copied from the source application.
 * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/duplications
*/
  export namespace V2PostAppDuplications {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostAppDuplicationsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiAppDuplicationsResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListEvaluations
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/evaluations
   */
  export namespace V2ListEvaluations {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      /** If true, sort in ascending order, otherwise sort in descending order. */
      sort_ascending?: boolean;
      /** Whether to order by application id */
      sort_by_app_id?: boolean;
      /** Whether to order by eval metric summary.macro_avg_roc_auc */
      sort_by_roc_auc?: boolean;
      /** Whether to order by eval metric summary.f1 */
      sort_by_f1?: boolean;
      /** Whether to order by when the metric was created */
      sort_by_created_at?: boolean;
      /** Whether to order by eval metric summary.mean_avg_precision_iou_50 */
      sort_by_mean_avg_precision?: boolean;
      /** Whether to order by eval metric summary.macro_avg_precision */
      sort_by_precision?: boolean;
      /** Whether to order by eval metric summary.macro_avg_recall */
      sort_by_recall?: boolean;
      sort_by_model_id?: boolean;
      sort_by_eval_dataset_id?: boolean;
      sort_by_train_dataset_id?: boolean;
      /** Filter on model type id */
      model_type_id?: string;
      /** Filter on dataset ID of the dataset version specified in the metric version */
      eval_dataset_ids?: string[];
      /** Filter on dataset ID of the dataset version specified by the model version */
      train_dataset_ids?: string[];
      /** Filter on concept IDs specified in the modele version's output_info */
      concept_ids?: string[];
      /** Whether to show failed metrics, defaults to false */
      show_failed_metrics?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiEvalMetricsResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostEvaluations
   * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/evaluations
   */
  export namespace V2PostEvaluations {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostEvaluationsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiEvalMetricsResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetEvaluation
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/evaluations/{evaluation_id}
   */
  export namespace V2GetEvaluation {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      evaluationId: string;
    };
    export type RequestQuery = {
      fieldsConfusionMatrix?: boolean;
      fieldsCooccurrenceMatrix?: boolean;
      fieldsLabelCounts?: boolean;
      fieldsBinaryMetrics?: boolean;
      fieldsTestSet?: boolean;
      fieldsMetricsByArea?: boolean;
      fieldsMetricsByClass?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleEvalMetricsResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListInputs
   * @summary List all the inputs.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/inputs
   */
  export namespace V2ListInputs {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      /**
       * Status code from internal codes.
       *
       *  - ZERO: to be revised and greatly expanded
       *  - SUCCESS: Generic
       *  - MOVED: Resource moved. Respond with Http status 307 and add new Location header to response
       *  - ACCEPTED: Request has been accepted. Respond with Http status 202.
       *  - CONN_ACCOUNT_ISSUES: Clarifai Connection Codes: 11xxx
       *
       * expired cc, still in trial, feature not supported in your tier
       *  - CONN_TOKEN_INVALID: invalid auth token used. Deprecated: we should return CONN_KEY_INVALID instead now in all cases.
       *  - CONN_CREDENTIALS_INVALID: invalid auth credentials
       *  - CONN_EXCEED_HOURLY_LIMIT: throttle hourly limit exceeded
       *  - CONN_EXCEED_MONTHLY_LIMIT: throttle monthly limit exceeded
       *  - CONN_THROTTLED: throttler and billing stuff
       *  - CONN_EXCEEDS_LIMITS: throttler and billing stuff
       *  - CONN_INSUFFICIENT_SCOPES: api key has insufficient permissions
       *  - CONN_KEY_INVALID: api key is invalid
       *  - CONN_KEY_NOT_FOUND: api key not found
       *  - CONN_BAD_REQUEST_FORMAT: multipart form parsing, broken json, etc
       *  - CONN_DOES_NOT_EXIST: when path is bad
       *  - CONN_INVALID_REQUEST: something wrong with a header
       *  - CONN_METHOD_NOT_ALLOWED: when a request method is not allowed
       *  - CONN_NO_GDPR_CONSENT: lack GDPR consent
       *  - CONN_INVALID_RANGE: when invalid range of a resource is requested
       *  - CONN_AUTH_METHOD_DISABLED: authentication method is disabled
       *  - MODEL_TRAINED: Model/Custom Training related 20xxx
       *
       * Custom model has been already trained.
       *  - MODEL_TRAINING: Custom model is currently training.
       *  - MODEL_UNTRAINED: Custom model has not yet been trained.
       *  - MODEL_QUEUED_FOR_TRAINING: Custom model is currently in queue for training, waiting on assets to process first.
       *  - MODEL_TRAINING_FAILED: generic err msg for any type of model training err.
       *  - MODEL_BUILDING: For new V3 DockerInternalType models which are built images
       *  - MODEL_BUILDING_FAILED: Failed to build image for model.
       *  - MODEL_BUILD_UNEXPECTED_ERROR: Failed to build image for model.
       *  - MODEL_TRAINING_NO_DATA: Custom model training had no data.  FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
       *  - MODEL_TRAINING_NO_POSITIVES: Custom model training had no positive examples. FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
       *  - MODEL_TRAINING_ONE_VS_N_SINGLE_CLASS: Custom model training was ONE_VS_N but with a single class. FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
       *  - MODEL_TRAINING_TIMED_OUT: Training took longer than hard coded timeouts. FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
       *  - MODEL_TRAINING_WAITING_ERROR: Training got error waiting on asset pipeline to finish. FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
       *  - MODEL_TRAINING_UNKNOWN_ERROR: Training threw an unknown exception.
       *  - MODEL_TRAINING_MSG_REDELIVER: Training message was redelivered. FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
       *  - MODEL_TRAINING_INSUFFICIENT_DATA: Training got error due to insufficient labelled data. FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
       *  - MODEL_TRAINING_INVALID_PARAMS: FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
       *  - MODEL_TRAINING_INVALID_DATA_TOLERANCE_EXCEEDED: Training is stopped because too much data was dropped. FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
       *  - MODEL_EVALUATION_TIMED_OUT: Evaluation took longer than hard coded timeouts. FIXME(yang): deprecate this. Use the 21317 + errStatusMsg
       *  - MODEL_EVALUATION_WAITING_ERROR: Evaluation got error waiting on asset pipeline to finish.FIXME(yang): deprecate this. Use the 21317 + errStatusMsg
       *  - MODEL_EVALUATION_UNKNOWN_ERROR: EVALUATION THREW AN UNKNOWN EXCEPTION.
       *  - MODEL_EVALUATION_MSG_REDELIVER: Eval message was redelivered. FIXME(yang): deprecate this. Use the 21317 + errStatusMsg
       *  - MODEL_EVALUATION_NEED_LABELS: Don't have enough concepts labelled to perform evaluation. FIXME(yang): deprecate this. Use the 21317 + errStatusMsg
       *  - MODEL_EVALUATION_NEED_INPUTS: Don't have enough inputs per concept to perform evaluation. FIXME(yang): deprecate this. Use the 21317 + errStatusMsg
       *  - MODEL_EVALUATION_FAILED: Generic err code for eval failure.
       *  - MODEL_DEPLOYMENT_FAILED: Used when inference coordinator failed to deploy spire and throws an error
       *  - MODEL_DEPLOYING: Used when calling the inference coordinator to deploy a spire
       *  - MODEL_QUEUED_FOR_DEPLOYMENT: Used when training is completed
       *  - MODEL_NOT_DEPLOYED: Used when model spire deployment is manually taken down or due to inactivity
       *  - MODEL_LOADING: Used when the model pod is running, but not yet ready to serve requests.
       *  - MODEL_REFERENCE_INVALID_ARGUMENT: Used when a model reference field is not set properly
       *  - MODEL_EXAMPLE_INPUT_INVALID_ARGUMENT: Used when a model example input field is not set properly
       *  - MODEL_EXPORTED: Model Export status codes
       *  - WORKFLOW_NO_MATCHING_INPUT: specified model input not in workflow
       *  - WORKFLOW_REQUIRE_TRAINED_MODEL: specified model must be trained
       *  - WORKFLOW_INVALID_ARGUMENT: error in the request somewhere
       *  - WORKFLOW_INVALID_REQUEST: error in the request somewhere
       *  - CONCEPT_MODIFY_SUCCESS: Concept related 23xxx
       *  - ANNOTATION_SUCCESS: Annotation related 24xxx
       *  - ANNOTATION_AWAITING_REVIEW: Annotation is awaiting review from task REVIEWERS.
       *  - ANNOTATION_AWAITING_CONSENSUS_REVIEW: Annotation is awaiting consensus review from task LABELERS.
       *  - METADATA_INVALID_PATCH_ARGUMENTS: Metadata related 249xx
       *  - TRAINER_JOB_STATE_NONE: Training service related 25xxx
       *  - DATA_DUMP_SUCCESS: Data Dump related 251xx
       *  - DATA_DUMP_NO_DATA: DEPRECATED: Not used anymore. Now for an empty data dump, DATA_DUMP_SUCCESS is returned. To detect an empty data dump, check if the inptus count is 0.
       *  - APP_DUPLICATION_SUCCESS: Duplicate related 252xx
       *  - MODULE_DOES_NOT_EXIST: Module related codes 253xx
       *  - BULK_OPERATION_SUCCESS: Bulk Operation related codes 254xx
       *  - RUNNER_DOES_NOT_EXIST: Runner related codes 256xx
       *  - NODEPOOL_DOES_NOT_EXIST: Nodepool related codes 257xx
       *  - COMPUTE_CLUSTER_DOES_NOT_EXIST: ComputeCluster related codes 258xx
       *  - DEPLOYMENT_DOES_NOT_EXIST: Deployment related codes 259xx
       *  - INSTANCE_TYPE_DOES_NOT_EXIST: InstanceType related codes 260xx
       *  - COMPUTE_PLANE_METRICS_INVALID_REQUEST: Compute plane related codes 261xx
       *  - PIPELINE_STEP_DOES_NOT_EXIST: PipelineStep related codes 262xx
       *  - INPUT_SUCCESS: Input:Image related 30xxx
       *  - INPUT_PENDING: when things are async, this is the default status.
       *  - INPUT_FAILED: any type of error downloading and processing
       *  - INPUT_DOWNLOAD_SUCCESS: use INPUT_SUCCESS, INPUT_PENDING, INPUT_FAILED, INPUT_IN_PROGRESS instead
       * DOWNLOAD is no longer correct, but keep old statuses for backward compatibility
       *  - INPUT_VIDEO_DOWNLOAD_SUCCESS: Input:Video related 31xxx -- Deprecated
       *  - INPUT_WRITES_DISABLED_FOR_MAINTENANCE: deprecate this one. Use REQUEST_DISABLED_FOR_MAINTENANCE
       *  - PREDICT_INVALID_REQUEST: API formatting issues 4000x
       *  - DATABASE_DUPLICATE_KEY: Other related 400xx
       *  - EXTERNAL_CONNECTION_ERROR: could not connect to external services
       *  - QUEUE_CONN_ERROR: Queue related errors 41xxx
       *  - SQS_OVERLIMIT: SQS related errors 411xx
       *  - SEARCH_INTERNAL_FAILURE: Search related errors 43xxxx
       *  - EVALUATION_QUEUED: Workflow evaluation err code
       *  - STRIPE_EVENT_ERROR: Stripe 44xxx
       *  - CACHE_MISS: Redis/Cache 45xxx
       *  - SIGNUP_EVENT_ERROR: Sift Science 46xxx
       *  - APP_COUNT_INVALID_MESSAGE: Application counts related errors 470xx
       *  - MP_DOWNLOAD_ERROR: Media processor related errors 471xx -- DEPRECATED
       *  - DATATIER_CONN_ERROR: DataTier related error 472xx
       *  - USER_CONSENT_FACE: User legal consent stauts related 50xxx
       *  - WORKER_MISSING: Workers 51xxx
       *  - COLLECTOR_MISSING: Collectors 52xxx
       *  - SSO_IDENTITY_PROVIDER_DOES_NOT_EXIST: SSO 53xxx
       *  - TASK_IN_PROGRESS: Tasks 54xxx
       * The task was created.
       *  - TASK_DONE: The task is completed.
       *  - TASK_WONT_DO: The task is marked as abandoned.
       *  - TASK_FAILED: An error occurred during add-task-annotations or add-auto-annotations pipeline.
       *  - TASK_IDLE: When an Auto Annotation task job has finished processing its last batch and is waiting for more dataset assets.
       *  - TASK_CONFLICT: The task operation is in conflict with the current state of the server.
       *  - TASK_NOT_IMPLEMENTED: Certain task-related scenarios are not implemented.
       *  - TASK_MISSING: Task was not found.
       *  - TASK_PERMISSION_DENIED: Not allowed to perform a task-related action.
       *  - TASK_ASSIGNMENT_SUCCESS: Task Assignments 542xx
       *  - TASK_ASSIGNMENT_REVIEW_SUCCESS: Task Assignment Reviews 543xx
       *  - LABEL_ORDER_PENDING: Label Order Related Status Code 55xxx
       *  - LICENSE_ACTIVE: License Related Status Code 600xx
       *  - LICENSE_DELETED: hidden state not reflected to users
       *  - PASSWORD_VALIDATION_SUCCESS: Password Related Status Code
       *  - FEATUREFLAG_CONFIG_NOT_FOUND: Feature flags status code
       *  - MAINTENANCE_SUCCESS: Maintenance status code
       *  - DATASET_VERSION_PENDING: Datasets 64xxx
       * The dataset version is pending to be processed.
       *  - DATASET_VERSION_IN_PROGRESS: The dataset version is currently being processed.
       *  - DATASET_VERSION_READY: The dataset version is ready to be used.
       *  - DATASET_VERSION_FAILURE: An error occurred during the dataset version processing.
       *  - DATASET_VERSION_UNEXPECTED_ERROR: An unexpected error occurred during the dataset version processing.
       *  - DATASET_VERSION_CONFLICT: An alteration to dataset version would create a conflict
       *  - DATASET_INPUT_SUCCESS: The dataset input was successfully added.
       *  - DATASET_INPUT_DUPLICATE: The dataset input is a duplicate.
       * Deprecated: Unused.
       *  - DATASET_VERSION_EXPORT_SUCCESS: The dataset version export is completed.
       *  - DATASET_VERSION_EXPORT_PENDING: The dataset version is pending to be exported.
       *  - DATASET_VERSION_EXPORT_FAILED: An error occurred during the dataset version export.
       *  - DATASET_VERSION_EXPORT_IN_PROGRESS: The dataset version is currently being exported.
       *  - DATASET_VERSION_EXPORT_UNEXPECTED_ERROR: An unexpected error occurred during the dataset version export.
       *  - JOB_QUEUED: Generic Job status codes
       *  - AUTH_MISSING_IDP_ASSOC: auth issues
       *
       * TODO: Knowledge graph related 80xxx
       *  - UPLOAD_IN_PROGRESS: Multipart uploading status codes
       *  - BILLING_INVALID_INFO: Billing related issues: 69xxx
       *  - LOG_ENTRIES_INVALID_REQUEST: Logs related issues: 70000;
       *  - INTERNAL_SERVER_ISSUE: Internal issues: 98xxx
       *  - CONN_UNCATEGORIZED: Uncategorized: 99xxx: move off as soon as known
       *  - BAD_REQUEST: Deprecated: migrate off to one of the internal issues
       *  - SERVER_ERROR: Deprecated: migrate off to one of the internal issues
       * @default "ZERO"
       */
      statusCode?:
        | 'ZERO'
        | 'SUCCESS'
        | 'MIXED_STATUS'
        | 'FAILURE'
        | 'TRY_AGAIN'
        | 'NOT_IMPLEMENTED'
        | 'MOVED'
        | 'TEAPOT'
        | 'ACCEPTED'
        | 'CONN_ACCOUNT_ISSUES'
        | 'CONN_TOKEN_INVALID'
        | 'CONN_CREDENTIALS_INVALID'
        | 'CONN_EXCEED_HOURLY_LIMIT'
        | 'CONN_EXCEED_MONTHLY_LIMIT'
        | 'CONN_THROTTLED'
        | 'CONN_EXCEEDS_LIMITS'
        | 'CONN_INSUFFICIENT_SCOPES'
        | 'CONN_KEY_INVALID'
        | 'CONN_KEY_NOT_FOUND'
        | 'CONN_BAD_REQUEST_FORMAT'
        | 'CONN_DOES_NOT_EXIST'
        | 'CONN_INVALID_REQUEST'
        | 'CONN_METHOD_NOT_ALLOWED'
        | 'CONN_NO_GDPR_CONSENT'
        | 'CONN_INVALID_RANGE'
        | 'CONN_AUTH_METHOD_DISABLED'
        | 'MODEL_TRAINED'
        | 'MODEL_TRAINING'
        | 'MODEL_UNTRAINED'
        | 'MODEL_QUEUED_FOR_TRAINING'
        | 'MODEL_UPLOADING'
        | 'MODEL_UPLOADING_FAILED'
        | 'MODEL_TRAINING_FAILED'
        | 'MODEL_BUILDING'
        | 'MODEL_BUILDING_FAILED'
        | 'MODEL_BUILD_UNEXPECTED_ERROR'
        | 'MODEL_TRAINING_NO_DATA'
        | 'MODEL_TRAINING_NO_POSITIVES'
        | 'MODEL_TRAINING_ONE_VS_N_SINGLE_CLASS'
        | 'MODEL_TRAINING_TIMED_OUT'
        | 'MODEL_TRAINING_WAITING_ERROR'
        | 'MODEL_TRAINING_UNKNOWN_ERROR'
        | 'MODEL_TRAINING_MSG_REDELIVER'
        | 'MODEL_TRAINING_INSUFFICIENT_DATA'
        | 'MODEL_TRAINING_INVALID_PARAMS'
        | 'MODEL_TRAINING_INVALID_DATA_TOLERANCE_EXCEEDED'
        | 'MODEL_MODIFY_SUCCESS'
        | 'MODEL_MODIFY_PENDING'
        | 'MODEL_MODIFY_FAILED'
        | 'MODEL_DOES_NOT_EXIST'
        | 'MODEL_PERMISSION_DENIED'
        | 'MODEL_INVALID_ARGUMENT'
        | 'MODEL_INVALID_REQUEST'
        | 'MODEL_EVALUATED'
        | 'MODEL_EVALUATING'
        | 'MODEL_NOT_EVALUATED'
        | 'MODEL_QUEUED_FOR_EVALUATION'
        | 'MODEL_EVALUATION_TIMED_OUT'
        | 'MODEL_EVALUATION_WAITING_ERROR'
        | 'MODEL_EVALUATION_UNKNOWN_ERROR'
        | 'MODEL_PREDICTION_FAILED'
        | 'MODEL_EVALUATION_MSG_REDELIVER'
        | 'MODEL_EVALUATION_NEED_LABELS'
        | 'MODEL_EVALUATION_NEED_INPUTS'
        | 'MODEL_EVALUATION_FAILED'
        | 'MODEL_DEPLOYMENT_FAILED'
        | 'MODEL_DEPLOYING'
        | 'MODEL_QUEUED_FOR_DEPLOYMENT'
        | 'MODEL_NOT_DEPLOYED'
        | 'MODEL_BUSY_PLEASE_RETRY'
        | 'MODEL_LOADING'
        | 'MODEL_REFERENCE_INVALID_ARGUMENT'
        | 'MODEL_EXAMPLE_INPUT_INVALID_ARGUMENT'
        | 'MODEL_EXPORTED'
        | 'MODEL_EXPORTING'
        | 'MODEL_EXPORTING_FAILED'
        | 'MODEL_EXPORT_PENDING'
        | 'WORKFLOW_NO_MATCHING_INPUT'
        | 'WORKFLOW_REQUIRE_TRAINED_MODEL'
        | 'WORKFLOW_DUPLICATE'
        | 'WORKFLOW_UNSUPPORTED_FORMAT'
        | 'WORKFLOW_DOES_NOT_EXIST'
        | 'WORKFLOW_PERMISSION_DENIED'
        | 'WORKFLOW_INVALID_ARGUMENT'
        | 'WORKFLOW_INVALID_RECIPE'
        | 'WORKFLOW_INVALID_TEMPLATE'
        | 'WORKFLOW_INVALID_GRAPH'
        | 'WORKFLOW_INTERNAL_FAILURE'
        | 'WORKFLOW_INVALID_REQUEST'
        | 'WORKFLOW_MODIFY_SUCCESS'
        | 'WORKFLOW_MODIFY_PENDING'
        | 'WORKFLOW_MODIFY_FAILED'
        | 'WORKFLOW_REINDEX_FAILED'
        | 'CONCEPT_MODIFY_SUCCESS'
        | 'CONCEPT_MODIFY_PENDING'
        | 'CONCEPT_MODIFY_FAILED'
        | 'ANNOTATION_SUCCESS'
        | 'ANNOTATION_PENDING'
        | 'ANNOTATION_FAILED'
        | 'ANNOTATION_UNKNOWN_STATUS'
        | 'ANNOTATION_INVALID_ARGUMENT'
        | 'ANNOTATION_PERMISSION_DENIED'
        | 'ANNOTATION_AWAITING_REVIEW'
        | 'ANNOTATION_AWAITING_CONSENSUS_REVIEW'
        | 'ANNOTATION_REVIEW_DENIED'
        | 'ANNOTATION_MODIFY_SUCCESS'
        | 'ANNOTATION_MODIFY_PENDING'
        | 'ANNOTATION_MODIFY_FAILED'
        | 'METADATA_INVALID_PATCH_ARGUMENTS'
        | 'METADATA_PARSING_ISSUE'
        | 'METADATA_MANIPULATION_ISSUE'
        | 'TRAINER_JOB_STATE_NONE'
        | 'TRAINER_JOB_STATE_QUEUED'
        | 'TRAINER_JOB_STATE_RUNNING'
        | 'TRAINER_JOB_STATE_COMPLETE'
        | 'TRAINER_JOB_STATE_ERROR'
        | 'DATA_DUMP_SUCCESS'
        | 'DATA_DUMP_PENDING'
        | 'DATA_DUMP_FAILED'
        | 'DATA_DUMP_IN_PROGRESS'
        | 'DATA_DUMP_NO_DATA'
        | 'DATA_DUMP_UNEXPECTED_ERROR'
        | 'DATA_DUMP_EXPORT_SUCCESS'
        | 'DATA_DUMP_EXPORT_PENDING'
        | 'DATA_DUMP_EXPORT_FAILED'
        | 'DATA_DUMP_EXPORT_IN_PROGRESS'
        | 'DATA_DUMP_EXPORT_UNEXPECTED_ERROR'
        | 'APP_DUPLICATION_SUCCESS'
        | 'APP_DUPLICATION_FAILED'
        | 'APP_DUPLICATION_PENDING'
        | 'APP_DUPLICATION_IN_PROGRESS'
        | 'APP_DUPLICATION_INVALID_REQUEST'
        | 'MODULE_DOES_NOT_EXIST'
        | 'MODULE_PERMISSION_DENIED'
        | 'MODULE_INVALID_ARGUMENT'
        | 'MODULE_INVALID_REQUEST'
        | 'BULK_OPERATION_SUCCESS'
        | 'BULK_OPERATION_FAILED'
        | 'BULK_OPERATION_PENDING'
        | 'BULK_OPERATION_IN_PROGRESS'
        | 'BULK_OPERATION_INVALID_REQUEST'
        | 'BULK_OPERATION_CANCELLED'
        | 'BULK_OPERATION_UNEXPECTED_ERROR'
        | 'RUNNER_DOES_NOT_EXIST'
        | 'RUNNER_PERMISSION_DENIED'
        | 'RUNNER_INVALID_ARGUMENT'
        | 'RUNNER_INVALID_REQUEST'
        | 'RUNNER_NEEDS_RETRY'
        | 'RUNNER_STREAM_START'
        | 'RUNNER_STREAM_END'
        | 'RUNNER_ITEM_CANCELLED'
        | 'RUNNER_PROCESSING_FAILED'
        | 'NODEPOOL_DOES_NOT_EXIST'
        | 'NODEPOOL_INVALID_ARGUMENT'
        | 'NODEPOOL_INVALID_REQUEST'
        | 'COMPUTE_CLUSTER_DOES_NOT_EXIST'
        | 'COMPUTE_CLUSTER_INVALID_ARGUMENT'
        | 'COMPUTE_CLUSTER_INVALID_REQUEST'
        | 'DEPLOYMENT_DOES_NOT_EXIST'
        | 'DEPLOYMENT_INVALID_ARGUMENT'
        | 'DEPLOYMENT_INVALID_REQUEST'
        | 'INSTANCE_TYPE_DOES_NOT_EXIST'
        | 'INSTANCE_TYPE_INVALID_ARGUMENT'
        | 'INSTANCE_TYPE_INVALID_REQUEST'
        | 'COMPUTE_PLANE_METRICS_INVALID_REQUEST'
        | 'PIPELINE_STEP_DOES_NOT_EXIST'
        | 'PIPELINE_STEP_INVALID_ARGUMENT'
        | 'PIPELINE_STEP_INVALID_REQUEST'
        | 'PIPELINE_STEP_UPLOADING'
        | 'PIPELINE_STEP_UPLOADING_FAILED'
        | 'PIPELINE_STEP_BUILDING'
        | 'PIPELINE_STEP_BUILDING_FAILED'
        | 'PIPELINE_STEP_BUILD_UNEXPECTED_ERROR'
        | 'PIPELINE_STEP_READY'
        | 'PIPELINE_STEP_NOT_READY'
        | 'INPUT_SUCCESS'
        | 'INPUT_PENDING'
        | 'INPUT_FAILED'
        | 'INPUT_IN_PROGRESS'
        | 'INPUT_DOWNLOAD_SUCCESS'
        | 'INPUT_DOWNLOAD_PENDING'
        | 'INPUT_DOWNLOAD_FAILED'
        | 'INPUT_DOWNLOAD_IN_PROGRESS'
        | 'INPUT_STATUS_UPDATE_FAILED'
        | 'INPUT_DELETE_FAILED'
        | 'INPUT_DUPLICATE'
        | 'INPUT_UNSUPPORTED_FORMAT'
        | 'INPUT_DOES_NOT_EXIST'
        | 'INPUT_PERMISSION_DENIED'
        | 'INPUT_INVALID_ARGUMENT'
        | 'INPUT_OVER_LIMIT'
        | 'INPUT_INVALID_URL'
        | 'INPUT_MODIFY_SUCCESS'
        | 'INPUT_MODIFY_PENDING'
        | 'INPUT_MODIFY_FAILED'
        | 'INPUT_STORAGE_HOST_FAILED'
        | 'ALL_INPUT_INVALID_BYTES'
        | 'INPUT_CLUSTER_SUCCESS'
        | 'INPUT_CLUSTER_PENDING'
        | 'INPUT_CLUSTER_FAILED'
        | 'INPUT_CLUSTER_IN_PROGRESS'
        | 'INPUT_REINDEX_SUCCESS'
        | 'INPUT_REINDEX_PENDING'
        | 'INPUT_REINDEX_FAILED'
        | 'INPUT_REINDEX_IN_PROGRESS'
        | 'INPUT_VIDEO_DOWNLOAD_SUCCESS'
        | 'INPUT_VIDEO_DOWNLOAD_PENDING'
        | 'INPUT_VIDEO_DOWNLOAD_FAILED'
        | 'INPUT_VIDEO_DUPLICATE'
        | 'INPUT_VIDEO_UNSUPPORTED_FORMAT'
        | 'INPUT_VIDEO_DOES_NOT_EXIST'
        | 'INPUT_VIDEO_PERMISSION_DENIED'
        | 'INPUT_VIDEO_INVALID_ARGUMENT'
        | 'INPUT_VIDEO_OVER_LIMIT'
        | 'INPUT_VIDEO_INVALID_URL'
        | 'INPUT_VIDEO_MODIFY_SUCCESS'
        | 'INPUT_VIDEO_MODIFY_PENDING'
        | 'INPUT_VIDEO_MODIFY_FAILED'
        | 'INPUT_VIDEO_STORAGE_HOST_FAILED'
        | 'ALL_INPUT_VIDEOS_INVALID_BYTES'
        | 'INPUT_VIDEO_PROCESSING_SUCCESS'
        | 'INPUT_VIDEO_PROCESSING_PENDING'
        | 'INPUT_VIDEO_PROCESSING_FAILED'
        | 'INPUT_VIDEO_STORAGE_INCONSISTENCY'
        | 'INPUT_VIDEO_STORAGE_FAILURE'
        | 'INPUT_VIDEO_URL_GENERATION_FAILURE'
        | 'INPUT_CONNECTION_FAILED'
        | 'REQUEST_DISABLED_FOR_MAINTENANCE'
        | 'INPUT_WRITES_DISABLED_FOR_MAINTENANCE'
        | 'INPUT_INVALID_REQUEST'
        | 'PREDICT_INVALID_REQUEST'
        | 'SEARCH_INVALID_REQUEST'
        | 'CONCEPTS_INVALID_REQUEST'
        | 'STATS_INVALID_REQUEST'
        | 'DATABASE_DUPLICATE_KEY'
        | 'DATABASE_STATEMENT_TIMEOUT'
        | 'DATABASE_INVALID_ROWS_AFFECTED'
        | 'DATABASE_DEADLOCK_DETECTED'
        | 'DATABASE_FAIL_TASK'
        | 'DATABASE_FAIL_TO_GET_CONNECTIONS'
        | 'DATABASE_TOO_MANY_CLIENTS'
        | 'DATABASE_CONSTRAINT_VIOLATED'
        | 'DATABASE_CANCELED'
        | 'ASYNC_WORKER_MULTI_ERRORS'
        | 'RPC_REQUEST_QUEUE_FULL'
        | 'RPC_SERVER_UNAVAILABLE'
        | 'RPC_REQUEST_TIMEOUT'
        | 'RPC_MAX_MESSAGE_SIZE_EXCEEDED'
        | 'RPC_CANCELED'
        | 'RPC_UNKNOWN_METHOD'
        | 'REQUEST_CANCELED_BY_USER'
        | 'CLUSTER_INTERNAL_FAILURE'
        | 'EXTERNAL_CONNECTION_ERROR'
        | 'QUERY_INVALID_SYNTAX'
        | 'QUEUE_CONN_ERROR'
        | 'QUEUE_CLOSE_REQUEST_TIMEOUT'
        | 'QUEUE_CONN_CLOSED'
        | 'QUEUE_PUBLISH_ACK_TIMEOUT'
        | 'QUEUE_PUBLISH_ERROR'
        | 'QUEUE_SUBSCRIPTION_TIMEOUT'
        | 'QUEUE_SUBSCRIPTION_ERROR'
        | 'QUEUE_MARSHALLING_FAILED'
        | 'QUEUE_UNMARSHALLING_FAILED'
        | 'QUEUE_MAX_MSG_REDELIVERY_EXCEEDED'
        | 'QUEUE_ACK_FAILURE'
        | 'SQS_OVERLIMIT'
        | 'SQS_INVALID_RECEIPT_HANDLE'
        | 'SQS_UNKNOWN'
        | 'SEARCH_INTERNAL_FAILURE'
        | 'SEARCH_PROJECTION_FAILURE'
        | 'SEARCH_PREDICTION_FAILURE'
        | 'SEARCH_BY_NOT_FULLY_INDEXED_INPUT'
        | 'SAVED_SEARCH_MODIFY_FAILED'
        | 'SEARCH_COUNTS_UNAVAILABLE'
        | 'EVALUATION_QUEUED'
        | 'EVALUATION_IN_PROGRESS'
        | 'EVALUATION_SUCCESS'
        | 'EVALUATION_FAILED_TO_RETRIEVE_DATA'
        | 'EVALUATION_INVALID_ARGUMENT'
        | 'EVALUATION_FAILED'
        | 'EVALUATION_PENDING'
        | 'EVALUATION_TIMED_OUT'
        | 'EVALUATION_UNEXPECTED_ERROR'
        | 'EVALUATION_MIXED'
        | 'STRIPE_EVENT_ERROR'
        | 'CACHE_MISS'
        | 'REDIS_SCRIPT_EXITED_WITH_FAILURE'
        | 'REDIS_STREAM_ERR'
        | 'REDIS_NO_CONSUMERS'
        | 'REDIS_STREAM_BACKOFF'
        | 'SIGNUP_EVENT_ERROR'
        | 'SIGNUP_FLAGGED'
        | 'FILETYPE_UNSUPPORTED'
        | 'APP_COUNT_INVALID_MESSAGE'
        | 'APP_COUNT_UPDATE_INCREMENT_FAILED'
        | 'APP_COUNT_REBUILD_FAILED'
        | 'APP_COUNT_INTERNAL_FAILURE'
        | 'MP_DOWNLOAD_ERROR'
        | 'MP_RESOLVE_DNS_ERROR'
        | 'MP_DOWNLOAD_MAX_SIZE_EXCEEDED_ERROR'
        | 'MP_IMAGE_DECODE_ERROR'
        | 'MP_INVALID_ARGUMENT'
        | 'MP_IMAGE_PROCESSING_ERROR'
        | 'DATATIER_CONN_ERROR'
        | 'USER_CONSENT_FACE'
        | 'WORKER_MISSING'
        | 'WORKER_ACTIVE'
        | 'WORKER_INACTIVE'
        | 'COLLECTOR_MISSING'
        | 'COLLECTOR_ACTIVE'
        | 'COLLECTOR_INACTIVE'
        | 'COLLECTOR_POST_INPUT_FAILED'
        | 'SSO_IDENTITY_PROVIDER_DOES_NOT_EXIST'
        | 'TASK_IN_PROGRESS'
        | 'TASK_DONE'
        | 'TASK_WONT_DO'
        | 'TASK_FAILED'
        | 'TASK_IDLE'
        | 'TASK_CONFLICT'
        | 'TASK_NOT_IMPLEMENTED'
        | 'TASK_MISSING'
        | 'TASK_PERMISSION_DENIED'
        | 'TASK_ASSIGNMENT_SUCCESS'
        | 'TASK_ASSIGNMENT_PENDING'
        | 'TASK_ASSIGNMENT_AWAITING_REVIEW'
        | 'TASK_ASSIGNMENT_AWAITING_CONSENSUS_REVIEW'
        | 'TASK_ASSIGNMENT_REJECTED'
        | 'TASK_ASSIGNMENT_REVIEW_SUCCESS'
        | 'TASK_ASSIGNMENT_REVIEW_PENDING'
        | 'TASK_ASSIGNMENT_REVIEW_DISMISSED'
        | 'LABEL_ORDER_PENDING'
        | 'LABEL_ORDER_IN_PROGRESS'
        | 'LABEL_ORDER_SUCCESS'
        | 'LABEL_ORDER_CANCELED'
        | 'LICENSE_ACTIVE'
        | 'LICENSE_DOES_NOT_EXIST'
        | 'LICENSE_NEED_UPDATE'
        | 'LICENSE_EXPIRED'
        | 'LICENSE_REVOKED'
        | 'LICENSE_DELETED'
        | 'LICENSE_VOLUME_EXCEEDED'
        | 'PASSWORD_VALIDATION_SUCCESS'
        | 'PASSWORD_VALIDATION_FAILED'
        | 'PASSWORDPOLICY_INVALID_ARGUMENT'
        | 'FEATUREFLAG_CONFIG_NOT_FOUND'
        | 'FEATUREFLAG_INVALID_ARGUMENT'
        | 'FEATUREFLAG_BLOCKED'
        | 'FEATUREFLAG_NOT_FOUND'
        | 'MAINTENANCE_SUCCESS'
        | 'MAINTENANCE_FAILED'
        | 'DATASET_VERSION_PENDING'
        | 'DATASET_VERSION_IN_PROGRESS'
        | 'DATASET_VERSION_READY'
        | 'DATASET_VERSION_FAILURE'
        | 'DATASET_VERSION_UNEXPECTED_ERROR'
        | 'DATASET_VERSION_CONFLICT'
        | 'DATASET_INPUT_SUCCESS'
        | 'DATASET_INPUT_DUPLICATE'
        | 'DATASET_VERSION_EXPORT_SUCCESS'
        | 'DATASET_VERSION_EXPORT_PENDING'
        | 'DATASET_VERSION_EXPORT_FAILED'
        | 'DATASET_VERSION_EXPORT_IN_PROGRESS'
        | 'DATASET_VERSION_EXPORT_UNEXPECTED_ERROR'
        | 'JOB_QUEUED'
        | 'JOB_RUNNING'
        | 'JOB_COMPLETED'
        | 'JOB_FAILED'
        | 'JOB_CANCELLED'
        | 'JOB_UNEXPECTED_ERROR'
        | 'JOB_CONFLICT'
        | 'AUTH_MISSING_IDP_ASSOC'
        | 'LIST_OBJECTS_FAILED'
        | 'ARCHIVE_EXTRACT_FAILED'
        | 'UPLOAD_IN_PROGRESS'
        | 'UPLOAD_DONE'
        | 'UPLOAD_FAILED'
        | 'UPLOAD_UNEXPECTED_ERROR'
        | 'UPLOAD_EXPIRED'
        | 'UPLOAD_CANCELED'
        | 'UPLOAD_CONFLICT'
        | 'BILLING_INVALID_INFO'
        | 'BILLING_MISSING_TOKENS'
        | 'LOG_ENTRIES_INVALID_REQUEST'
        | 'INTERNAL_SERVER_ISSUE'
        | 'INTERNAL_FETCHING_ISSUE'
        | 'INTERNAL_DATABASE_ISSUE'
        | 'INTERNAL_CONTEXT_CANCELED'
        | 'INTERNAL_UNEXPECTED_TIMEOUT'
        | 'INTERNAL_UNEXPECTED_V1'
        | 'INTERNAL_UNEXPECTED_PANIC'
        | 'INTERNAL_UNEXPECTED_SPIRE'
        | 'INTERNAL_REDIS_UNAVAILABLE'
        | 'INTERNAL_RESOURCE_EXHAUSTED'
        | 'INTERNAL_REDIS_UNCATEGORIZED'
        | 'INTERNAL_AWS_UNCATEGORIZED'
        | 'INTERNAL_AZURE_UNCATEGORIZED'
        | 'INTERNAL_VECTORDB_UNCATEGORIZED'
        | 'INTERNAL_ORACLE_UNCATEGORIZED'
        | 'INTERNAL_VULTR_UNCATEGORIZED'
        | 'CONN_UNCATEGORIZED'
        | 'MODEL_UNCATEGORIZED'
        | 'INPUT_UNCATEGORIZED'
        | 'ANNOTATION_UNCATEGORIZED'
        | 'BILLING_UNCATEGORIZED'
        | 'INTERNAL_UNCATEGORIZED'
        | 'BAD_REQUEST'
        | 'SERVER_ERROR';
      /** A short description of the error. */
      statusDescription?: string;
      /**
       * More details of the given error.
       * These details may be exposed to non-technical users.
       * For technical details, try to use developer_notes field.
       */
      statusDetails?: string;
      /**
       * For some environment we may return a stack trace to help debug
       * any issues.
       */
      statusStackTrace?: string[];
      /**
       * specifically for long running jobs
       * @format int64
       */
      statusPercentCompleted?: number;
      /**
       * if status is pending, how much time is remaining (in seconds)
       * @format int64
       */
      statusTimeRemaining?: number;
      /** A request ID may be present, to help monitoring and tracking requests */
      statusReqId?: string;
      /** Internal Annotation (do not set in production, for internal Clarifai use only). */
      statusInternalDetails?: string;
      /** New location for the resource. Used to set response Location header. */
      statusRedirectInfoUrl?: string;
      /** Resource type */
      statusRedirectInfoResourceType?: string;
      /** Old resource id */
      statusRedirectInfoOldResourceId?: string;
      /** New resource id */
      statusRedirectInfoNewResourceId?: string;
      /**
       * Notes for developer.
       * These notes are rather technical details for developers how to interpret the status,
       * e.g. why an error occurred and how to avoid getting the error.
       */
      statusDeveloperNotes?: string;
      ids?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiInputResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2DeleteInputs
 * @summary Delete multiple inputs in one request.
This call is asynchronous.
 * @request DELETE:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/inputs
*/
  export namespace V2DeleteInputs {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2DeleteInputsBody;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2PostInputs
 * @summary PostInputs adds one or more inputs to the app.
Takes a list of image/video/audio/text URLs, image/video/audio bytes or raw text
Optionally, include concepts or dataset ids to link them
Optionally, include metadata for search
Note that inputs processing is asynchronous process
See ListInputs, StreamInputs or PostInputSearches to list results
 * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/inputs
*/
  export namespace V2PostInputs {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostInputsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiInputResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchInputs
   * @summary Patch one or more inputs.
   * @request PATCH:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/inputs
   */
  export namespace V2PatchInputs {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchInputsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiInputResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteAnnotations
   * @summary Delete multiple annotations in one request.
   * @request DELETE:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/inputs/annotations
   */
  export namespace V2DeleteAnnotations {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = ApiV2DeleteAnnotationsBody;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
 * @description The cloud URL will be treated as a filter prefix. For example s3:/bucket/images_folder/abc will process files in the images_folder beginning with abc or in a subfolder beginning with abc. For example: bucket/images_folder/abcImage.png bucket/images_folder/abc-1/Data.zip If given URL is for a private bucket or file, then credentials should be provided to access the bucket. Credentials should include rights to list the objects in the bucket, except when pointed directly at a file archive, in which case it only requires rights to access that particular file.
 * @tags V2
 * @name V2PostInputsDataSources
 * @summary Initiates retrieval of inputs from cloud storage from a user provided data source.
Will create and return an inputs-add-job for tracking progress.
Archives will be extracted and their contents will be processed as inputs.
 * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/inputs/data_sources
*/
  export namespace V2PostInputsDataSources {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostInputsDataSourcesBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiInputsAddJobResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListInputsAddJobs
   * @summary List all the inputs add jobs
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/inputs/jobs/add
   */
  export namespace V2ListInputsAddJobs {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiInputsAddJobResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetInputsAddJob
   * @summary Get the input add job details by ID
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/inputs/jobs/add/{id}
   */
  export namespace V2GetInputsAddJob {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** id of add inputs job */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleInputsAddJobResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2CancelInputsAddJob
   * @summary cancel the input add job by ID
   * @request PATCH:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/inputs/jobs/add/{id}
   */
  export namespace V2CancelInputsAddJob {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** id of add inputs job to be cancelled */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2CancelInputsAddJobBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleInputsAddJobResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListInputsExtractionJobs
   * @summary List all the input extraction jobs
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/inputs/jobs/extraction
   */
  export namespace V2ListInputsExtractionJobs {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiInputsExtractionJobResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2CancelInputsExtractionJobs
   * @request PATCH:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/inputs/jobs/extraction
   */
  export namespace V2CancelInputsExtractionJobs {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2CancelInputsExtractionJobsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiInputsExtractionJobResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetInputsExtractionJob
   * @summary Get the input extraction job details by ID
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/inputs/jobs/extraction/{inputs_extraction_job_id}
   */
  export namespace V2GetInputsExtractionJob {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      inputsExtractionJobId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleInputsExtractionJobResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostInputsSearches
   * @summary Execute a search over inputs
   * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/inputs/searches
   */
  export namespace V2PostInputsSearches {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostInputsSearchesBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiSearchResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchInputsSearches
   * @summary Patch saved inputs searches by ids.
   * @request PATCH:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/inputs/searches
   */
  export namespace V2PatchInputsSearches {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchInputsSearchesBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiSearchResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetInputCount
   * @summary Get input count per status.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/inputs/status
   */
  export namespace V2GetInputCount {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleInputCountResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2StreamInputs
   * @summary Streams all the inputs starting from oldest assets.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/inputs/stream
   */
  export namespace V2StreamInputs {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 20.
       * @format int64
       */
      per_page?: number;
      last_id?: string;
      /**
       * By default, the endpoint return inputs by the time when it is added.
       * If this is set to true, we will return inputs by id.
       */
      order_by_id?: boolean;
      descending?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiInputResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2PostInputsUploads
 * @summary Create new upload job with a file archive containing inputs (images, videos, text, audio)
Actual file upload happens in next steps by calling `PutUploadContentParts` endpoint
and providing the file content in the request body.
This endpoint creates and return an inputs-add-job which contains an upload id needed for upload and further status tracking
Completing the upload will automatically begin unpacking the archive and uploading the contents as inputs.
See also GetInputsAddJob and then GetInputsExtractionJob
 * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/inputs/uploads
*/
  export namespace V2PostInputsUploads {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostInputsUploadsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiInputsAddJobResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetInput
   * @summary Get a specific input from an app.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/inputs/{input_id}
   */
  export namespace V2GetInput {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      inputId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleInputResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteInput
   * @summary Delete a single input asynchronously.
   * @request DELETE:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/inputs/{input_id}
   */
  export namespace V2DeleteInput {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      inputId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetAnnotation
   * @summary Get a specific annotation from an app.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/inputs/{input_id}/annotations/{annotation_id}
   */
  export namespace V2GetAnnotation {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      inputId: string;
      annotationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleAnnotationResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteAnnotation
   * @summary Delete a single annotation.
   * @request DELETE:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/inputs/{input_id}/annotations/{annotation_id}
   */
  export namespace V2DeleteAnnotation {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      inputId: string;
      annotationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2GetInputVideoManifest
 * @summary Get a MPEG-DASH manifest for video-type inputs that were added via PostInputs and successfully processed
Experimental. Manifest is used by browser and desktop clients that implement an efficient streaming playback
This means client can switch between low-resolution and high-resolution video streams
Depending on network bandwidth or user's preference
This also means that reencoded video streams are reencoded in a uniform way, not relying on original format
Alternative to MPEG-dash is to stream original file with byte-range header
 * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/inputs/{input_id}/video_manifest
*/
  export namespace V2GetInputVideoManifest {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      inputId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiGetVideoManifestResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListInstalledModuleVersions
   * @summary List installed modules vesrions for an app.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/installed_module_versions
   */
  export namespace V2ListInstalledModuleVersions {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiInstalledModuleVersionResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2DeleteInstalledModuleVersions
 * @summary Uninstall an installed module version which will deploy the specific ModuleVersion to the app
in the url.
This cleaned up any associated caller keys so needs the Keys_Delete scope.
 * @request DELETE:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/installed_module_versions
*/
  export namespace V2DeleteInstalledModuleVersions {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2DeleteInstalledModuleVersionsBody;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostInstalledModuleVersions
   * @summary Install a new module version which will deploy the specific ModuleVersion to the app in the url.
   * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/installed_module_versions
   */
  export namespace V2PostInstalledModuleVersions {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostInstalledModuleVersionsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiInstalledModuleVersionResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetInstalledModuleVersion
   * @summary Get installed modules vesrions for an app.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/installed_module_versions/{installed_module_version_id}
   */
  export namespace V2GetInstalledModuleVersion {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** the ID to get of the install module version. */
      installedModuleVersionId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleInstalledModuleVersionResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2PostInstalledModuleVersionsKey
 * @summary Assign a key that the caller owns to be used when accessing this installed module version
If this endpoint is called with a different key then it overwrites what is there.
 * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/installed_module_versions/{installed_module_version_id}/key
*/
  export namespace V2PostInstalledModuleVersionsKey {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /**
       * the ID to get of the install module version.
       *
       * Note(zeiler): we don't provide a key to create since it's always deterministic.
       *  we'll create a PAT, owned by the caller with the scopes that the module requests.
       *  in the future if we want we can pass in a Key key = 3; field so that the caller
       *  can adjust the scopes, but for now that doesn't seem necessary.
       */
      installedModuleVersionId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostInstalledModuleVersionsKeyBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleKeyResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListAppKeys
   * @summary List keys by app_id
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/keys
   */
  export namespace V2ListAppKeys {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiKeyResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListLabelOrders
   * @summary List label orders.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/label_orders
   */
  export namespace V2ListLabelOrders {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiLabelOrderResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2DeleteLabelOrders
 * @summary Delete multiple label orders in one request.
this do not change task status
 * @request DELETE:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/label_orders
*/
  export namespace V2DeleteLabelOrders {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2DeleteLabelOrdersBody;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostLabelOrders
   * @summary Add Label orders.
   * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/label_orders
   */
  export namespace V2PostLabelOrders {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostLabelOrdersBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiLabelOrderResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchLabelOrders
   * @summary Patch one or more label orders.
   * @request PATCH:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/label_orders
   */
  export namespace V2PatchLabelOrders {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchLabelOrdersBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiLabelOrderResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetLabelOrder
   * @summary Get a label order.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/label_orders/{label_order_id}
   */
  export namespace V2GetLabelOrder {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      labelOrderId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleLabelOrderResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListModels
   * @summary List all the models.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models
   */
  export namespace V2ListModels {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      /** (optional URL parameter) List of additional fields to be included in the response. Currently supported: all, stars, outputs, presets, counts */
      additional_fields?: string[];
      /**
       * Sorting options:
       * Whether to sort in ascending order. If false, will order in descending order.
       */
      sort_ascending?: boolean;
      /** Whether to order by the name */
      sort_by_name?: boolean;
      /** Whether to order by the number of training inputs */
      sort_by_num_inputs?: boolean;
      /**
       * Whether to order by the modified_at time of the latest model version.
       * If none of the sort options is set to true, will sort by modified_at.
       */
      sort_by_modified_at?: boolean;
      /** Whether to order by the created_at */
      sort_by_created_at?: boolean;
      /** Whether to order by count of stars */
      sort_by_star_count?: boolean;
      /**
       * Filtering options:
       * Filter models by the specific model_type_id. See ListModelTypes for the list of ModelType.Id's
       * supported.
       */
      model_type_id?: string;
      /** If true, we only return models that have the status MODEL_TRAINED, which includes non-trainable model types. */
      trained_only?: boolean;
      /**
       * The list of input fields to the model.
       * For example, you can specify 'image', which will return models that make inferences on images like visual-classifier models.
       */
      input_fields?: string[];
      /**
       * The list of output fields to the model.
       * For example, you can specify 'regions[...].data.concepts', which will return visual-detector models.
       */
      output_fields?: string[];
      /** Filter by the license of the model version */
      license?: string;
      /** If true, we only return models that are handpicked by clarifai staff */
      featured_only?: boolean;
      /** If true, we only return models that are starred by the requesting user */
      starred_only?: boolean;
      /** List of toolkit tags to filter by */
      toolkits?: string[];
      /** List of use_case tags to filter by */
      use_cases?: string[];
      /** List of language tags to filter by */
      languages?: string[];
      /**
       * Old API behavior resulted in returning clarifai main models when calling ListModels while scoped to an app. While we transition
       * away from that, we can use this flag to not always fetch clarifai main models, unless that is the app we are explicitly listing for.
       *
       * @exclude TODO (EAGLE-4447): Remove this field
       */
      dont_fetch_from_main?: boolean;
      /**
       * Filter models by bookmark. If set, only return bookmarked models. Otherwise none bookmarked models only.
       * Note: you can not filter `trained_only` and bookmark at the same time.
       * When filter by bookmark, we will return trained and untrained models.
       */
      bookmark?: boolean;
      /**
       * Searching options:
       * Specify a search parameter in order to perform keyword search on the
       * following fields of the model:
       *   - id
       *   - name
       *   - description
       *   - notes
       *   - user_id (unless user_app_id.user_id is already set)
       *
       * Keywords are both normalized for search (so searching for "satisfy" matches "satisfied")
       * and used for partial prefix-matching (so searching for "clari" matches "clarifai").
       *
       * NOTE: Both the list of fields searched and the exact keyword matching
       * rules are subject to change and not guaranteed to be backwards-compatible.
       */
      search?: string;
      /**
       * Query name, description and id fields, that can contain the words in the query string. Does NOT support wildcards - full words only. Supports operators "OR" and "-" as NOT.
       * Deprecated: use search instead.
       */
      query?: string;
      /**
       * Filter by the description and id of the model. This supports wildcard queries like "gen*" to match "general" as an example.
       * Deprecated: use search instead.
       */
      name?: string;
      /**
       * Extends the name filter to include the user_id of the application owner that the model belongs to.
       * Deprecated: use search instead of name.
       */
      filter_by_user_id?: boolean;
      /** Filter by the model version ids. If set, only return the model of these versions. */
      model_version_ids?: string[];
      /**
       * Filter by LicenseType
       * @default "UNKNOWN_LICENSE_TYPE"
       */
      license_type?: 'UNKNOWN_LICENSE_TYPE' | 'FIRST_PARTY' | 'OPEN_SOURCE' | 'CLOSED_SOURCE';
      /**
       * Filter by Source
       * @format int64
       */
      source?: number;
      /** Filter by Creator */
      creator?: string;
      /**
       * Filter by model versions runners with replicas >= min_replicas.
       * @format int64
       */
      min_replicas?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiModelResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteModels
   * @summary Delete multiple models in one request.
   * @request DELETE:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models
   */
  export namespace V2DeleteModels {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2DeleteModelsBody;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostModels
   * @summary Add a models to an app.
   * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models
   */
  export namespace V2PostModels {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostModelsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleModelResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchModels
   * @summary Patch one or more models.
   * @request PATCH:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models
   */
  export namespace V2PatchModels {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchModelsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiModelResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchModelIds
   * @summary Patch one or more models ids.
   * @request PATCH:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/ids
   */
  export namespace V2PatchModelIds {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchModelIdsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiModelResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2PostModelsSearches
 * @summary Search over the models to find one or more you're looking for.
This leverage the "body" parameter because we also have page and
per_page as url query param variables in this request.
 * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/searches
*/
  export namespace V2PostModelsSearches {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostModelsSearchesBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiModelResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2ListModelTypes
 * @summary List all the model types available in the platform.
This MUST be above ListModels so that the /models/types endpoint takes precedence.
 * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/types
*/
  export namespace V2ListModelTypes {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiModelTypeResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetModelType
   * @summary Get a specific model type.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/types/{model_type_id}
   */
  export namespace V2GetModelType {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** The specific ModelType.Id you want to retrieve. */
      modelTypeId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleModelTypeResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetModel
   * @summary Get a specific model from an app.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/{model_id}
   */
  export namespace V2GetModel {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      modelId: string;
    };
    export type RequestQuery = {
      /**
       * This is included so that we can re-use this request for multiple
       * rpcs with and without the version_id.
       */
      version_id?: string;
      language?: string;
      trained_before?: boolean;
      /** (optional URL parameter) List of additional fields to be included in the response. Currently supported: all, stars, outputs, presets */
      additional_fields?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleModelResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteModel
   * @summary Delete a single model.
   * @request DELETE:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/{model_id}
   */
  export namespace V2DeleteModel {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      modelId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchModelCheckConsents
   * @summary Update model check consents
   * @request PATCH:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/{model_id}/check_consents
   */
  export namespace V2PatchModelCheckConsents {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** the model id */
      modelId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchModelCheckConsentsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiModelCheckConsentResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListModelConcepts
   * @summary List models concepts.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/{model_id}/concepts
   */
  export namespace V2ListModelConcepts {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** Model id */
      modelId: string;
    };
    export type RequestQuery = {
      /** Model version Id. Optional, if not provided latest model version is used. */
      version_id?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      /**
       * Searching options:
       * Specify a search parameter in order to perform keyword search on the
       * following fields of the concept:
       *   - id
       *   - name
       *
       * Keywords are used for partial prefix-matching (so searching for "larif" matches "clarifai").
       *
       * NOTE: Both the list of fields searched and the exact keyword matching
       * rules are subject to change and not guaranteed to be backwards-compatible.
       */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiConceptResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2ListModelInputs
 * @summary Deprecated: Unmaintained and ideally replaced with usage of datasets
  The server may refuse to accept requests to this endpoint.
 * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/{model_id}/inputs
*/
  export namespace V2ListModelInputs {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      modelId: string;
    };
    export type RequestQuery = {
      version_id?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiInputResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchModelLanguages
   * @summary Update model languages tags
   * @request PATCH:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/{model_id}/languages
   */
  export namespace V2PatchModelLanguages {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      modelId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchModelLanguagesBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiModelLanguageResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostModelMigration
   * @summary Kicks off conversion from the old Triton model format to the new Docker model format.
   * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/{model_id}/migration
   */
  export namespace V2PostModelMigration {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      modelId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostModelMigrationBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleModelResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2GetModelOutputInfo
 * @summary Get a the output info for a given model_id or model_id/version_id
combo.
 * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/{model_id}/output_info
*/
  export namespace V2GetModelOutputInfo {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      modelId: string;
    };
    export type RequestQuery = {
      /**
       * This is included so that we can re-use this request for multiple
       * rpcs with and without the version_id.
       */
      version_id?: string;
      language?: string;
      trained_before?: boolean;
      /** (optional URL parameter) List of additional fields to be included in the response. Currently supported: all, stars, outputs, presets */
      additional_fields?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleModelResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostModelOutputs3
   * @summary Get predicted outputs from the model.
   * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/{model_id}/outputs
   */
  export namespace V2PostModelOutputs3 {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      modelId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostModelOutputsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiOutputResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2GenerateModelOutputs2
 * @summary TODO(zeiler): will need to
Single request but streaming responses.
 * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/{model_id}/outputs/generate
*/
  export namespace V2GenerateModelOutputs2 {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      modelId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2GenerateModelOutputsBody;
    export type RequestHeaders = {};
    export type ResponseBody = {
      result?: ApiMultiOutputResponse;
      error?: GooglerpcStatus;
    };
  }

  /**
   * No description
   * @tags V2
   * @name V2PostModelVersionsPublish
   * @summary PostModelVersionsPublish
   * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/{model_id}/publish
   */
  export namespace V2PostModelVersionsPublish {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      modelId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostModelVersionsPublishBody;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListModelReferences
   * @summary Lists model references tied to a particular model id.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/{model_id}/references
   */
  export namespace V2ListModelReferences {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      modelId: string;
    };
    export type RequestQuery = {
      /**
       * Optional, defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * Optional, defaults to 128 references per page.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiModelReferenceResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchModelToolkits
   * @summary Update model toolkits tags
   * @request PATCH:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/{model_id}/toolkits
   */
  export namespace V2PatchModelToolkits {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      modelId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchModelToolkitsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiModelToolkitResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostModelVersionsUnPublish
   * @summary PostModelVersionsUnPublish
   * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/{model_id}/unpublish
   */
  export namespace V2PostModelVersionsUnPublish {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      modelId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostModelVersionsUnPublishBody;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchModelUseCases
   * @summary Update model use_cases tags
   * @request PATCH:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/{model_id}/usecases
   */
  export namespace V2PatchModelUseCases {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      modelId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchModelUseCasesBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiModelUseCaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListModelVersions
   * @summary List all the models.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/{model_id}/versions
   */
  export namespace V2ListModelVersions {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      modelId: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      /**
       * Filtering options:
       * To list only the model versions that have these concept ids present in them.
       */
      concept_ids?: string[];
      /** To list only the model versions that have been trained. */
      trained_only?: boolean;
      /**
       * Sorting options:
       * Whether to sort in ascending order. If false, will order in descending order.
       */
      sort_ascending?: boolean;
      /** Whether to order by the status code */
      sort_by_status_code?: boolean;
      /** Whether to order by the number of training inputs */
      sort_by_num_inputs?: boolean;
      /** Whether to sort by the description */
      sort_by_description?: boolean;
      /**
       * Whether to order by the created_at time
       * If neither sort option is set to true, will sort by created_at.
       */
      sort_by_created_at?: boolean;
      /**
       * Filter by model versions runners with replicas >= min_replicas.
       * @format int64
       */
      min_replicas?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiModelVersionResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostModelVersions
   * @summary Create a new model version to trigger training of the model.
   * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/{model_id}/versions
   */
  export namespace V2PostModelVersions {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      modelId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostModelVersionsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleModelResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchModelVersions
   * @summary PatchModelVersions
   * @request PATCH:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/{model_id}/versions
   */
  export namespace V2PatchModelVersions {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      modelId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchModelVersionsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiModelVersionResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostModelVersionsTrainingTimeEstimate
   * @summary Get the training time estimate based off train request and estimated input count.
   * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/{model_id}/versions/time_estimate
   */
  export namespace V2PostModelVersionsTrainingTimeEstimate {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      modelId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostModelVersionsTrainingTimeEstimateBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiTrainingTimeEstimateResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListLogEntries2
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/{model_id}/versions/{model_version_id}/compute_clusters/{compute_cluster_id}/nodepools/{nodepool_id}/{log_type}/logs
   */
  export namespace V2ListLogEntries2 {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** The Model ID, if a model produced the logs. */
      modelId: string;
      /** The Version ID, if a model version produced the logs. */
      modelVersionId: string;
      /** Where the logs came from. */
      computeClusterId: string;
      nodepoolId: string;
      /** The type of log entry. Examples: model, agent, build, training. */
      logType: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to last page.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 32.
       * @format int64
       */
      per_page?: number;
      /** Workflow Id, if a workflow produced the logs. */
      workflow_id?: string;
      runner_id?: string;
      /** Pipelines that produced the logs. */
      pipeline_id?: string;
      pipeline_version_id?: string;
      pipeline_version_run_id?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiLogEntryResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2ListModelVersionEvaluations
 * @summary Deprecated, use GetEvaluation instead
List the evaluation metrics for a model version.
 * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/{model_id}/versions/{model_version_id}/evaluations
*/
  export namespace V2ListModelVersionEvaluations {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      modelId: string;
      modelVersionId: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiEvalMetricsResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostModelVersionEvaluations
   * @summary Deprecated, use PostEvaluations instead
   * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/{model_id}/versions/{model_version_id}/evaluations
   */
  export namespace V2PostModelVersionEvaluations {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      modelId: string;
      modelVersionId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostModelVersionEvaluationsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiEvalMetricsResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2GetModelVersionEvaluation
 * @summary Deprecated, use GetEvaluation instead
Get an evaluation metrics for a model version.
 * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/{model_id}/versions/{model_version_id}/evaluations/{evaluation_id}
*/
  export namespace V2GetModelVersionEvaluation {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      modelId: string;
      modelVersionId: string;
      evaluationId: string;
    };
    export type RequestQuery = {
      fieldsConfusionMatrix?: boolean;
      fieldsCooccurrenceMatrix?: boolean;
      fieldsLabelCounts?: boolean;
      fieldsBinaryMetrics?: boolean;
      fieldsTestSet?: boolean;
      fieldsMetricsByArea?: boolean;
      fieldsMetricsByClass?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleEvalMetricsResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListModelVersionInputExamples
   * @summary ListModelVersionInputExamples
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/{model_id}/versions/{model_version_id}/input_examples
   */
  export namespace V2ListModelVersionInputExamples {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** id of model the example belongs to */
      modelId: string;
      /** specific version the example belongs to */
      modelVersionId: string;
    };
    export type RequestQuery = {
      /**
       * Optional, defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * Optional, defaults to 128 references per page.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiModelVersionInputExampleResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetModelVersionInputExample
   * @summary GetModelVersionInputExample
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/{model_id}/versions/{model_version_id}/input_examples/{example_id}
   */
  export namespace V2GetModelVersionInputExample {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** id of model the example belongs to */
      modelId: string;
      /** specific version the example belongs to */
      modelVersionId: string;
      /** Id of example to fetch */
      exampleId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleModelVersionInputExampleResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListLogEntries4
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/{model_id}/versions/{model_version_id}/{log_type}/logs
   */
  export namespace V2ListLogEntries4 {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** The Model ID, if a model produced the logs. */
      modelId: string;
      /** The Version ID, if a model version produced the logs. */
      modelVersionId: string;
      /** The type of log entry. Examples: model, agent, build, training. */
      logType: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to last page.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 32.
       * @format int64
       */
      per_page?: number;
      /** Workflow Id, if a workflow produced the logs. */
      workflow_id?: string;
      /** Where the logs came from. */
      compute_cluster_id?: string;
      nodepool_id?: string;
      runner_id?: string;
      /** Pipelines that produced the logs. */
      pipeline_id?: string;
      pipeline_version_id?: string;
      pipeline_version_run_id?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiLogEntryResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetModelVersion
   * @summary Get a specific model from an app.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/{model_id}/versions/{version_id}
   */
  export namespace V2GetModelVersion {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      modelId: string;
      versionId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleModelVersionResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteModelVersion
   * @summary Delete a single model.
   * @request DELETE:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/{model_id}/versions/{version_id}
   */
  export namespace V2DeleteModelVersion {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      modelId: string;
      versionId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListModelConcepts2
   * @summary List models concepts.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/{model_id}/versions/{version_id}/concepts
   */
  export namespace V2ListModelConcepts2 {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** Model id */
      modelId: string;
      /** Model version Id. Optional, if not provided latest model version is used. */
      versionId: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      /**
       * Searching options:
       * Specify a search parameter in order to perform keyword search on the
       * following fields of the concept:
       *   - id
       *   - name
       *
       * Keywords are used for partial prefix-matching (so searching for "larif" matches "clarifai").
       *
       * NOTE: Both the list of fields searched and the exact keyword matching
       * rules are subject to change and not guaranteed to be backwards-compatible.
       */
      search?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiConceptResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetModelVersionExport
   * @summary GetModelVersionExport
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/{model_id}/versions/{version_id}/exports
   */
  export namespace V2GetModelVersionExport {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      modelId: string;
      versionId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleModelVersionExportResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PutModelVersionExports
   * @summary Export a model
   * @request PUT:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/{model_id}/versions/{version_id}/exports
   */
  export namespace V2PutModelVersionExports {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      modelId: string;
      versionId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleModelVersionExportResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2ListModelInputs3
 * @summary Deprecated: Unmaintained and ideally replaced with usage of datasets
  The server may refuse to accept requests to this endpoint.
 * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/{model_id}/versions/{version_id}/inputs
*/
  export namespace V2ListModelInputs3 {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      modelId: string;
      versionId: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiInputResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2GetModelVersionMetrics
 * @summary Get the evaluation metrics for a model version.
Deprecated: Use GetEvaluation instead
  The server may refuse to accept requests to this endpoint.
 * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/{model_id}/versions/{version_id}/metrics
*/
  export namespace V2GetModelVersionMetrics {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      modelId: string;
      versionId: string;
    };
    export type RequestQuery = {
      fieldsConfusionMatrix?: boolean;
      fieldsCooccurrenceMatrix?: boolean;
      fieldsLabelCounts?: boolean;
      fieldsBinaryMetrics?: boolean;
      fieldsTestSet?: boolean;
      fieldsMetricsByArea?: boolean;
      fieldsMetricsByClass?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleModelVersionResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2PostModelVersionMetrics
 * @summary Deprecated, use PostEvaluations instead
Run the evaluation metrics for a model version.
 * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/{model_id}/versions/{version_id}/metrics
*/
  export namespace V2PostModelVersionMetrics {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      modelId: string;
      versionId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostModelVersionMetricsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleModelVersionResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2GetModelOutputInfo3
 * @summary Get a the output info for a given model_id or model_id/version_id
combo.
 * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/{model_id}/versions/{version_id}/output_info
*/
  export namespace V2GetModelOutputInfo3 {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      modelId: string;
      /**
       * This is included so that we can re-use this request for multiple
       * rpcs with and without the version_id.
       */
      versionId: string;
    };
    export type RequestQuery = {
      language?: string;
      trained_before?: boolean;
      /** (optional URL parameter) List of additional fields to be included in the response. Currently supported: all, stars, outputs, presets */
      additional_fields?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleModelResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostModelOutputs
   * @summary Get predicted outputs from the model.
   * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/{model_id}/versions/{version_id}/outputs
   */
  export namespace V2PostModelOutputs {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      modelId: string;
      versionId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostModelOutputsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiOutputResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2GenerateModelOutputs
 * @summary TODO(zeiler): will need to
Single request but streaming responses.
 * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/models/{model_id}/versions/{version_id}/outputs/generate
*/
  export namespace V2GenerateModelOutputs {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      modelId: string;
      versionId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2GenerateModelOutputsBody;
    export type RequestHeaders = {};
    export type ResponseBody = {
      result?: ApiMultiOutputResponse;
      error?: GooglerpcStatus;
    };
  }

  /**
   * No description
   * @tags V2
   * @name V2ListModules
   * @summary List all the modules in community, by user or by app.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/modules
   */
  export namespace V2ListModules {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      additional_fields?: string[];
      /**
       * Sorting options:
       * Whether to sort in ascending order. If false, will order in descending order.
       */
      sort_ascending?: boolean;
      /** Whether to order by the created_at time. */
      sort_by_created_at?: boolean;
      /** Whether to order by the number of users stared the app */
      sort_by_star_count?: boolean;
      /** If neither sort option is set to true, will sort by modified_at. */
      sort_by_modified_at?: boolean;
      /** Whether to order by the external id */
      sort_by_id?: boolean;
      /** Filtering options: */
      starred_only?: boolean;
      /** Filter modules by bookmark. If set, only return bookmarked modules. Otherwise none bookmarked modules only. */
      bookmark?: boolean;
      /**
       * Searching options:
       * Specify a search parameter in order to perform keyword search on the
       * following fields of the module:
       *   - id
       *   - description
       *   - user_id (unless user_app_id.user_id is already set)
       *
       * Keywords are both normalized for search (so searching for "satisfy" matches "satisfied")
       * and used for partial prefix-matching (so searching for "clari" matches "clarifai").
       *
       * NOTE: Both the list of fields searched and the exact keyword matching
       * rules are subject to change and not guaranteed to be backwards-compatible.
       */
      search?: string;
      /**
       * Filter by the id and description of the module. This supports wildcard queries like "gen*" to match "general" as an example.
       * Deprecated: use search instead.
       */
      name?: string;
      /**
       * Filter by the application owner whose this module belongs to
       * Deprecated: use search instead of name.
       */
      filter_by_user_id?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiModuleResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteModules
   * @summary Delete multiple modules in one request.
   * @request DELETE:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/modules
   */
  export namespace V2DeleteModules {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2DeleteModulesBody;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostModules
   * @summary Add a modules to an app.
   * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/modules
   */
  export namespace V2PostModules {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostModulesBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiModuleResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchModules
   * @summary Patch one or more modules.
   * @request PATCH:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/modules
   */
  export namespace V2PatchModules {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchModulesBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiModuleResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetModule
   * @summary Get a specific module from an app.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/modules/{module_id}
   */
  export namespace V2GetModule {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      moduleId: string;
    };
    export type RequestQuery = {
      additional_fields?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleModuleResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListModuleVersions
   * @summary List all the modules versions for a given module.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/modules/{module_id}/versions
   */
  export namespace V2ListModuleVersions {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      moduleId: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiModuleVersionResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteModuleVersions
   * @summary Delete a multiple module version.
   * @request DELETE:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/modules/{module_id}/versions
   */
  export namespace V2DeleteModuleVersions {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      moduleId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2DeleteModuleVersionsBody;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostModuleVersions
   * @summary Create a new module version to trigger training of the module.
   * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/modules/{module_id}/versions
   */
  export namespace V2PostModuleVersions {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      moduleId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostModuleVersionsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiModuleVersionResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchModuleVersions
   * @summary Modify details of an existing module version.
   * @request PATCH:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/modules/{module_id}/versions
   */
  export namespace V2PatchModuleVersions {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      moduleId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchModuleVersionsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiModuleVersionResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetModuleVersion
   * @summary Get a specific module version for a module.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/modules/{module_id}/versions/{module_version_id}
   */
  export namespace V2GetModuleVersion {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      moduleId: string;
      moduleVersionId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleModuleVersionResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetModuleVersionUsageCount
   * @summary Get usage count for specific module version.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/modules/{module_id}/versions/{module_version_id}/usage_count
   */
  export namespace V2GetModuleVersionUsageCount {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      moduleId: string;
      moduleVersionId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleModuleVersionUsageCountResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2MyScopes
 * @summary API Keys in the public API -- request is itself Key authorized, and will tell
the user the scopes/access of the key/credential they're providing, as computed by
our authorizer:
 * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/myscopes
*/
  export namespace V2MyScopes {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiScopeResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2PatchAppsDetails
 * @summary Allows to Patch only the below fields in one or more apps.
Allowed fields are notes, description and image
 * @request PATCH:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/partial
*/
  export namespace V2PatchAppsDetails {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchAppsDetailsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiAppResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListPipelineSteps
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/pipeline_steps
   */
  export namespace V2ListPipelineSteps {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiPipelineStepResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostPipelineSteps
   * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/pipeline_steps
   */
  export namespace V2PostPipelineSteps {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostPipelineStepsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiPipelineStepResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetPipelineStep
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/pipeline_steps/{pipeline_step_id}
   */
  export namespace V2GetPipelineStep {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** The id of the pipeline step that has the requested version. */
      pipelineStepId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSinglePipelineStepResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListPipelineStepVersions
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/pipeline_steps/{pipeline_step_id}/versions
   */
  export namespace V2ListPipelineStepVersions {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** List versions for the pipeline step identified by this id */
      pipelineStepId: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      /**
       * Filter based on status
       *
       *  - ZERO: to be revised and greatly expanded
       *  - SUCCESS: Generic
       *  - MOVED: Resource moved. Respond with Http status 307 and add new Location header to response
       *  - ACCEPTED: Request has been accepted. Respond with Http status 202.
       *  - CONN_ACCOUNT_ISSUES: Clarifai Connection Codes: 11xxx
       *
       * expired cc, still in trial, feature not supported in your tier
       *  - CONN_TOKEN_INVALID: invalid auth token used. Deprecated: we should return CONN_KEY_INVALID instead now in all cases.
       *  - CONN_CREDENTIALS_INVALID: invalid auth credentials
       *  - CONN_EXCEED_HOURLY_LIMIT: throttle hourly limit exceeded
       *  - CONN_EXCEED_MONTHLY_LIMIT: throttle monthly limit exceeded
       *  - CONN_THROTTLED: throttler and billing stuff
       *  - CONN_EXCEEDS_LIMITS: throttler and billing stuff
       *  - CONN_INSUFFICIENT_SCOPES: api key has insufficient permissions
       *  - CONN_KEY_INVALID: api key is invalid
       *  - CONN_KEY_NOT_FOUND: api key not found
       *  - CONN_BAD_REQUEST_FORMAT: multipart form parsing, broken json, etc
       *  - CONN_DOES_NOT_EXIST: when path is bad
       *  - CONN_INVALID_REQUEST: something wrong with a header
       *  - CONN_METHOD_NOT_ALLOWED: when a request method is not allowed
       *  - CONN_NO_GDPR_CONSENT: lack GDPR consent
       *  - CONN_INVALID_RANGE: when invalid range of a resource is requested
       *  - CONN_AUTH_METHOD_DISABLED: authentication method is disabled
       *  - MODEL_TRAINED: Model/Custom Training related 20xxx
       *
       * Custom model has been already trained.
       *  - MODEL_TRAINING: Custom model is currently training.
       *  - MODEL_UNTRAINED: Custom model has not yet been trained.
       *  - MODEL_QUEUED_FOR_TRAINING: Custom model is currently in queue for training, waiting on assets to process first.
       *  - MODEL_TRAINING_FAILED: generic err msg for any type of model training err.
       *  - MODEL_BUILDING: For new V3 DockerInternalType models which are built images
       *  - MODEL_BUILDING_FAILED: Failed to build image for model.
       *  - MODEL_BUILD_UNEXPECTED_ERROR: Failed to build image for model.
       *  - MODEL_TRAINING_NO_DATA: Custom model training had no data.  FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
       *  - MODEL_TRAINING_NO_POSITIVES: Custom model training had no positive examples. FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
       *  - MODEL_TRAINING_ONE_VS_N_SINGLE_CLASS: Custom model training was ONE_VS_N but with a single class. FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
       *  - MODEL_TRAINING_TIMED_OUT: Training took longer than hard coded timeouts. FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
       *  - MODEL_TRAINING_WAITING_ERROR: Training got error waiting on asset pipeline to finish. FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
       *  - MODEL_TRAINING_UNKNOWN_ERROR: Training threw an unknown exception.
       *  - MODEL_TRAINING_MSG_REDELIVER: Training message was redelivered. FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
       *  - MODEL_TRAINING_INSUFFICIENT_DATA: Training got error due to insufficient labelled data. FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
       *  - MODEL_TRAINING_INVALID_PARAMS: FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
       *  - MODEL_TRAINING_INVALID_DATA_TOLERANCE_EXCEEDED: Training is stopped because too much data was dropped. FIXME(yang): deprecate this. Use the 21106 + errStatusMsg
       *  - MODEL_EVALUATION_TIMED_OUT: Evaluation took longer than hard coded timeouts. FIXME(yang): deprecate this. Use the 21317 + errStatusMsg
       *  - MODEL_EVALUATION_WAITING_ERROR: Evaluation got error waiting on asset pipeline to finish.FIXME(yang): deprecate this. Use the 21317 + errStatusMsg
       *  - MODEL_EVALUATION_UNKNOWN_ERROR: EVALUATION THREW AN UNKNOWN EXCEPTION.
       *  - MODEL_EVALUATION_MSG_REDELIVER: Eval message was redelivered. FIXME(yang): deprecate this. Use the 21317 + errStatusMsg
       *  - MODEL_EVALUATION_NEED_LABELS: Don't have enough concepts labelled to perform evaluation. FIXME(yang): deprecate this. Use the 21317 + errStatusMsg
       *  - MODEL_EVALUATION_NEED_INPUTS: Don't have enough inputs per concept to perform evaluation. FIXME(yang): deprecate this. Use the 21317 + errStatusMsg
       *  - MODEL_EVALUATION_FAILED: Generic err code for eval failure.
       *  - MODEL_DEPLOYMENT_FAILED: Used when inference coordinator failed to deploy spire and throws an error
       *  - MODEL_DEPLOYING: Used when calling the inference coordinator to deploy a spire
       *  - MODEL_QUEUED_FOR_DEPLOYMENT: Used when training is completed
       *  - MODEL_NOT_DEPLOYED: Used when model spire deployment is manually taken down or due to inactivity
       *  - MODEL_LOADING: Used when the model pod is running, but not yet ready to serve requests.
       *  - MODEL_REFERENCE_INVALID_ARGUMENT: Used when a model reference field is not set properly
       *  - MODEL_EXAMPLE_INPUT_INVALID_ARGUMENT: Used when a model example input field is not set properly
       *  - MODEL_EXPORTED: Model Export status codes
       *  - WORKFLOW_NO_MATCHING_INPUT: specified model input not in workflow
       *  - WORKFLOW_REQUIRE_TRAINED_MODEL: specified model must be trained
       *  - WORKFLOW_INVALID_ARGUMENT: error in the request somewhere
       *  - WORKFLOW_INVALID_REQUEST: error in the request somewhere
       *  - CONCEPT_MODIFY_SUCCESS: Concept related 23xxx
       *  - ANNOTATION_SUCCESS: Annotation related 24xxx
       *  - ANNOTATION_AWAITING_REVIEW: Annotation is awaiting review from task REVIEWERS.
       *  - ANNOTATION_AWAITING_CONSENSUS_REVIEW: Annotation is awaiting consensus review from task LABELERS.
       *  - METADATA_INVALID_PATCH_ARGUMENTS: Metadata related 249xx
       *  - TRAINER_JOB_STATE_NONE: Training service related 25xxx
       *  - DATA_DUMP_SUCCESS: Data Dump related 251xx
       *  - DATA_DUMP_NO_DATA: DEPRECATED: Not used anymore. Now for an empty data dump, DATA_DUMP_SUCCESS is returned. To detect an empty data dump, check if the inptus count is 0.
       *  - APP_DUPLICATION_SUCCESS: Duplicate related 252xx
       *  - MODULE_DOES_NOT_EXIST: Module related codes 253xx
       *  - BULK_OPERATION_SUCCESS: Bulk Operation related codes 254xx
       *  - RUNNER_DOES_NOT_EXIST: Runner related codes 256xx
       *  - NODEPOOL_DOES_NOT_EXIST: Nodepool related codes 257xx
       *  - COMPUTE_CLUSTER_DOES_NOT_EXIST: ComputeCluster related codes 258xx
       *  - DEPLOYMENT_DOES_NOT_EXIST: Deployment related codes 259xx
       *  - INSTANCE_TYPE_DOES_NOT_EXIST: InstanceType related codes 260xx
       *  - COMPUTE_PLANE_METRICS_INVALID_REQUEST: Compute plane related codes 261xx
       *  - PIPELINE_STEP_DOES_NOT_EXIST: PipelineStep related codes 262xx
       *  - INPUT_SUCCESS: Input:Image related 30xxx
       *  - INPUT_PENDING: when things are async, this is the default status.
       *  - INPUT_FAILED: any type of error downloading and processing
       *  - INPUT_DOWNLOAD_SUCCESS: use INPUT_SUCCESS, INPUT_PENDING, INPUT_FAILED, INPUT_IN_PROGRESS instead
       * DOWNLOAD is no longer correct, but keep old statuses for backward compatibility
       *  - INPUT_VIDEO_DOWNLOAD_SUCCESS: Input:Video related 31xxx -- Deprecated
       *  - INPUT_WRITES_DISABLED_FOR_MAINTENANCE: deprecate this one. Use REQUEST_DISABLED_FOR_MAINTENANCE
       *  - PREDICT_INVALID_REQUEST: API formatting issues 4000x
       *  - DATABASE_DUPLICATE_KEY: Other related 400xx
       *  - EXTERNAL_CONNECTION_ERROR: could not connect to external services
       *  - QUEUE_CONN_ERROR: Queue related errors 41xxx
       *  - SQS_OVERLIMIT: SQS related errors 411xx
       *  - SEARCH_INTERNAL_FAILURE: Search related errors 43xxxx
       *  - EVALUATION_QUEUED: Workflow evaluation err code
       *  - STRIPE_EVENT_ERROR: Stripe 44xxx
       *  - CACHE_MISS: Redis/Cache 45xxx
       *  - SIGNUP_EVENT_ERROR: Sift Science 46xxx
       *  - APP_COUNT_INVALID_MESSAGE: Application counts related errors 470xx
       *  - MP_DOWNLOAD_ERROR: Media processor related errors 471xx -- DEPRECATED
       *  - DATATIER_CONN_ERROR: DataTier related error 472xx
       *  - USER_CONSENT_FACE: User legal consent stauts related 50xxx
       *  - WORKER_MISSING: Workers 51xxx
       *  - COLLECTOR_MISSING: Collectors 52xxx
       *  - SSO_IDENTITY_PROVIDER_DOES_NOT_EXIST: SSO 53xxx
       *  - TASK_IN_PROGRESS: Tasks 54xxx
       * The task was created.
       *  - TASK_DONE: The task is completed.
       *  - TASK_WONT_DO: The task is marked as abandoned.
       *  - TASK_FAILED: An error occurred during add-task-annotations or add-auto-annotations pipeline.
       *  - TASK_IDLE: When an Auto Annotation task job has finished processing its last batch and is waiting for more dataset assets.
       *  - TASK_CONFLICT: The task operation is in conflict with the current state of the server.
       *  - TASK_NOT_IMPLEMENTED: Certain task-related scenarios are not implemented.
       *  - TASK_MISSING: Task was not found.
       *  - TASK_PERMISSION_DENIED: Not allowed to perform a task-related action.
       *  - TASK_ASSIGNMENT_SUCCESS: Task Assignments 542xx
       *  - TASK_ASSIGNMENT_REVIEW_SUCCESS: Task Assignment Reviews 543xx
       *  - LABEL_ORDER_PENDING: Label Order Related Status Code 55xxx
       *  - LICENSE_ACTIVE: License Related Status Code 600xx
       *  - LICENSE_DELETED: hidden state not reflected to users
       *  - PASSWORD_VALIDATION_SUCCESS: Password Related Status Code
       *  - FEATUREFLAG_CONFIG_NOT_FOUND: Feature flags status code
       *  - MAINTENANCE_SUCCESS: Maintenance status code
       *  - DATASET_VERSION_PENDING: Datasets 64xxx
       * The dataset version is pending to be processed.
       *  - DATASET_VERSION_IN_PROGRESS: The dataset version is currently being processed.
       *  - DATASET_VERSION_READY: The dataset version is ready to be used.
       *  - DATASET_VERSION_FAILURE: An error occurred during the dataset version processing.
       *  - DATASET_VERSION_UNEXPECTED_ERROR: An unexpected error occurred during the dataset version processing.
       *  - DATASET_VERSION_CONFLICT: An alteration to dataset version would create a conflict
       *  - DATASET_INPUT_SUCCESS: The dataset input was successfully added.
       *  - DATASET_INPUT_DUPLICATE: The dataset input is a duplicate.
       * Deprecated: Unused.
       *  - DATASET_VERSION_EXPORT_SUCCESS: The dataset version export is completed.
       *  - DATASET_VERSION_EXPORT_PENDING: The dataset version is pending to be exported.
       *  - DATASET_VERSION_EXPORT_FAILED: An error occurred during the dataset version export.
       *  - DATASET_VERSION_EXPORT_IN_PROGRESS: The dataset version is currently being exported.
       *  - DATASET_VERSION_EXPORT_UNEXPECTED_ERROR: An unexpected error occurred during the dataset version export.
       *  - JOB_QUEUED: Generic Job status codes
       *  - AUTH_MISSING_IDP_ASSOC: auth issues
       *
       * TODO: Knowledge graph related 80xxx
       *  - UPLOAD_IN_PROGRESS: Multipart uploading status codes
       *  - BILLING_INVALID_INFO: Billing related issues: 69xxx
       *  - LOG_ENTRIES_INVALID_REQUEST: Logs related issues: 70000;
       *  - INTERNAL_SERVER_ISSUE: Internal issues: 98xxx
       *  - CONN_UNCATEGORIZED: Uncategorized: 99xxx: move off as soon as known
       *  - BAD_REQUEST: Deprecated: migrate off to one of the internal issues
       *  - SERVER_ERROR: Deprecated: migrate off to one of the internal issues
       */
      status_codes?: (
        | 'ZERO'
        | 'SUCCESS'
        | 'MIXED_STATUS'
        | 'FAILURE'
        | 'TRY_AGAIN'
        | 'NOT_IMPLEMENTED'
        | 'MOVED'
        | 'TEAPOT'
        | 'ACCEPTED'
        | 'CONN_ACCOUNT_ISSUES'
        | 'CONN_TOKEN_INVALID'
        | 'CONN_CREDENTIALS_INVALID'
        | 'CONN_EXCEED_HOURLY_LIMIT'
        | 'CONN_EXCEED_MONTHLY_LIMIT'
        | 'CONN_THROTTLED'
        | 'CONN_EXCEEDS_LIMITS'
        | 'CONN_INSUFFICIENT_SCOPES'
        | 'CONN_KEY_INVALID'
        | 'CONN_KEY_NOT_FOUND'
        | 'CONN_BAD_REQUEST_FORMAT'
        | 'CONN_DOES_NOT_EXIST'
        | 'CONN_INVALID_REQUEST'
        | 'CONN_METHOD_NOT_ALLOWED'
        | 'CONN_NO_GDPR_CONSENT'
        | 'CONN_INVALID_RANGE'
        | 'CONN_AUTH_METHOD_DISABLED'
        | 'MODEL_TRAINED'
        | 'MODEL_TRAINING'
        | 'MODEL_UNTRAINED'
        | 'MODEL_QUEUED_FOR_TRAINING'
        | 'MODEL_UPLOADING'
        | 'MODEL_UPLOADING_FAILED'
        | 'MODEL_TRAINING_FAILED'
        | 'MODEL_BUILDING'
        | 'MODEL_BUILDING_FAILED'
        | 'MODEL_BUILD_UNEXPECTED_ERROR'
        | 'MODEL_TRAINING_NO_DATA'
        | 'MODEL_TRAINING_NO_POSITIVES'
        | 'MODEL_TRAINING_ONE_VS_N_SINGLE_CLASS'
        | 'MODEL_TRAINING_TIMED_OUT'
        | 'MODEL_TRAINING_WAITING_ERROR'
        | 'MODEL_TRAINING_UNKNOWN_ERROR'
        | 'MODEL_TRAINING_MSG_REDELIVER'
        | 'MODEL_TRAINING_INSUFFICIENT_DATA'
        | 'MODEL_TRAINING_INVALID_PARAMS'
        | 'MODEL_TRAINING_INVALID_DATA_TOLERANCE_EXCEEDED'
        | 'MODEL_MODIFY_SUCCESS'
        | 'MODEL_MODIFY_PENDING'
        | 'MODEL_MODIFY_FAILED'
        | 'MODEL_DOES_NOT_EXIST'
        | 'MODEL_PERMISSION_DENIED'
        | 'MODEL_INVALID_ARGUMENT'
        | 'MODEL_INVALID_REQUEST'
        | 'MODEL_EVALUATED'
        | 'MODEL_EVALUATING'
        | 'MODEL_NOT_EVALUATED'
        | 'MODEL_QUEUED_FOR_EVALUATION'
        | 'MODEL_EVALUATION_TIMED_OUT'
        | 'MODEL_EVALUATION_WAITING_ERROR'
        | 'MODEL_EVALUATION_UNKNOWN_ERROR'
        | 'MODEL_PREDICTION_FAILED'
        | 'MODEL_EVALUATION_MSG_REDELIVER'
        | 'MODEL_EVALUATION_NEED_LABELS'
        | 'MODEL_EVALUATION_NEED_INPUTS'
        | 'MODEL_EVALUATION_FAILED'
        | 'MODEL_DEPLOYMENT_FAILED'
        | 'MODEL_DEPLOYING'
        | 'MODEL_QUEUED_FOR_DEPLOYMENT'
        | 'MODEL_NOT_DEPLOYED'
        | 'MODEL_BUSY_PLEASE_RETRY'
        | 'MODEL_LOADING'
        | 'MODEL_REFERENCE_INVALID_ARGUMENT'
        | 'MODEL_EXAMPLE_INPUT_INVALID_ARGUMENT'
        | 'MODEL_EXPORTED'
        | 'MODEL_EXPORTING'
        | 'MODEL_EXPORTING_FAILED'
        | 'MODEL_EXPORT_PENDING'
        | 'WORKFLOW_NO_MATCHING_INPUT'
        | 'WORKFLOW_REQUIRE_TRAINED_MODEL'
        | 'WORKFLOW_DUPLICATE'
        | 'WORKFLOW_UNSUPPORTED_FORMAT'
        | 'WORKFLOW_DOES_NOT_EXIST'
        | 'WORKFLOW_PERMISSION_DENIED'
        | 'WORKFLOW_INVALID_ARGUMENT'
        | 'WORKFLOW_INVALID_RECIPE'
        | 'WORKFLOW_INVALID_TEMPLATE'
        | 'WORKFLOW_INVALID_GRAPH'
        | 'WORKFLOW_INTERNAL_FAILURE'
        | 'WORKFLOW_INVALID_REQUEST'
        | 'WORKFLOW_MODIFY_SUCCESS'
        | 'WORKFLOW_MODIFY_PENDING'
        | 'WORKFLOW_MODIFY_FAILED'
        | 'WORKFLOW_REINDEX_FAILED'
        | 'CONCEPT_MODIFY_SUCCESS'
        | 'CONCEPT_MODIFY_PENDING'
        | 'CONCEPT_MODIFY_FAILED'
        | 'ANNOTATION_SUCCESS'
        | 'ANNOTATION_PENDING'
        | 'ANNOTATION_FAILED'
        | 'ANNOTATION_UNKNOWN_STATUS'
        | 'ANNOTATION_INVALID_ARGUMENT'
        | 'ANNOTATION_PERMISSION_DENIED'
        | 'ANNOTATION_AWAITING_REVIEW'
        | 'ANNOTATION_AWAITING_CONSENSUS_REVIEW'
        | 'ANNOTATION_REVIEW_DENIED'
        | 'ANNOTATION_MODIFY_SUCCESS'
        | 'ANNOTATION_MODIFY_PENDING'
        | 'ANNOTATION_MODIFY_FAILED'
        | 'METADATA_INVALID_PATCH_ARGUMENTS'
        | 'METADATA_PARSING_ISSUE'
        | 'METADATA_MANIPULATION_ISSUE'
        | 'TRAINER_JOB_STATE_NONE'
        | 'TRAINER_JOB_STATE_QUEUED'
        | 'TRAINER_JOB_STATE_RUNNING'
        | 'TRAINER_JOB_STATE_COMPLETE'
        | 'TRAINER_JOB_STATE_ERROR'
        | 'DATA_DUMP_SUCCESS'
        | 'DATA_DUMP_PENDING'
        | 'DATA_DUMP_FAILED'
        | 'DATA_DUMP_IN_PROGRESS'
        | 'DATA_DUMP_NO_DATA'
        | 'DATA_DUMP_UNEXPECTED_ERROR'
        | 'DATA_DUMP_EXPORT_SUCCESS'
        | 'DATA_DUMP_EXPORT_PENDING'
        | 'DATA_DUMP_EXPORT_FAILED'
        | 'DATA_DUMP_EXPORT_IN_PROGRESS'
        | 'DATA_DUMP_EXPORT_UNEXPECTED_ERROR'
        | 'APP_DUPLICATION_SUCCESS'
        | 'APP_DUPLICATION_FAILED'
        | 'APP_DUPLICATION_PENDING'
        | 'APP_DUPLICATION_IN_PROGRESS'
        | 'APP_DUPLICATION_INVALID_REQUEST'
        | 'MODULE_DOES_NOT_EXIST'
        | 'MODULE_PERMISSION_DENIED'
        | 'MODULE_INVALID_ARGUMENT'
        | 'MODULE_INVALID_REQUEST'
        | 'BULK_OPERATION_SUCCESS'
        | 'BULK_OPERATION_FAILED'
        | 'BULK_OPERATION_PENDING'
        | 'BULK_OPERATION_IN_PROGRESS'
        | 'BULK_OPERATION_INVALID_REQUEST'
        | 'BULK_OPERATION_CANCELLED'
        | 'BULK_OPERATION_UNEXPECTED_ERROR'
        | 'RUNNER_DOES_NOT_EXIST'
        | 'RUNNER_PERMISSION_DENIED'
        | 'RUNNER_INVALID_ARGUMENT'
        | 'RUNNER_INVALID_REQUEST'
        | 'RUNNER_NEEDS_RETRY'
        | 'RUNNER_STREAM_START'
        | 'RUNNER_STREAM_END'
        | 'RUNNER_ITEM_CANCELLED'
        | 'RUNNER_PROCESSING_FAILED'
        | 'NODEPOOL_DOES_NOT_EXIST'
        | 'NODEPOOL_INVALID_ARGUMENT'
        | 'NODEPOOL_INVALID_REQUEST'
        | 'COMPUTE_CLUSTER_DOES_NOT_EXIST'
        | 'COMPUTE_CLUSTER_INVALID_ARGUMENT'
        | 'COMPUTE_CLUSTER_INVALID_REQUEST'
        | 'DEPLOYMENT_DOES_NOT_EXIST'
        | 'DEPLOYMENT_INVALID_ARGUMENT'
        | 'DEPLOYMENT_INVALID_REQUEST'
        | 'INSTANCE_TYPE_DOES_NOT_EXIST'
        | 'INSTANCE_TYPE_INVALID_ARGUMENT'
        | 'INSTANCE_TYPE_INVALID_REQUEST'
        | 'COMPUTE_PLANE_METRICS_INVALID_REQUEST'
        | 'PIPELINE_STEP_DOES_NOT_EXIST'
        | 'PIPELINE_STEP_INVALID_ARGUMENT'
        | 'PIPELINE_STEP_INVALID_REQUEST'
        | 'PIPELINE_STEP_UPLOADING'
        | 'PIPELINE_STEP_UPLOADING_FAILED'
        | 'PIPELINE_STEP_BUILDING'
        | 'PIPELINE_STEP_BUILDING_FAILED'
        | 'PIPELINE_STEP_BUILD_UNEXPECTED_ERROR'
        | 'PIPELINE_STEP_READY'
        | 'PIPELINE_STEP_NOT_READY'
        | 'INPUT_SUCCESS'
        | 'INPUT_PENDING'
        | 'INPUT_FAILED'
        | 'INPUT_IN_PROGRESS'
        | 'INPUT_DOWNLOAD_SUCCESS'
        | 'INPUT_DOWNLOAD_PENDING'
        | 'INPUT_DOWNLOAD_FAILED'
        | 'INPUT_DOWNLOAD_IN_PROGRESS'
        | 'INPUT_STATUS_UPDATE_FAILED'
        | 'INPUT_DELETE_FAILED'
        | 'INPUT_DUPLICATE'
        | 'INPUT_UNSUPPORTED_FORMAT'
        | 'INPUT_DOES_NOT_EXIST'
        | 'INPUT_PERMISSION_DENIED'
        | 'INPUT_INVALID_ARGUMENT'
        | 'INPUT_OVER_LIMIT'
        | 'INPUT_INVALID_URL'
        | 'INPUT_MODIFY_SUCCESS'
        | 'INPUT_MODIFY_PENDING'
        | 'INPUT_MODIFY_FAILED'
        | 'INPUT_STORAGE_HOST_FAILED'
        | 'ALL_INPUT_INVALID_BYTES'
        | 'INPUT_CLUSTER_SUCCESS'
        | 'INPUT_CLUSTER_PENDING'
        | 'INPUT_CLUSTER_FAILED'
        | 'INPUT_CLUSTER_IN_PROGRESS'
        | 'INPUT_REINDEX_SUCCESS'
        | 'INPUT_REINDEX_PENDING'
        | 'INPUT_REINDEX_FAILED'
        | 'INPUT_REINDEX_IN_PROGRESS'
        | 'INPUT_VIDEO_DOWNLOAD_SUCCESS'
        | 'INPUT_VIDEO_DOWNLOAD_PENDING'
        | 'INPUT_VIDEO_DOWNLOAD_FAILED'
        | 'INPUT_VIDEO_DUPLICATE'
        | 'INPUT_VIDEO_UNSUPPORTED_FORMAT'
        | 'INPUT_VIDEO_DOES_NOT_EXIST'
        | 'INPUT_VIDEO_PERMISSION_DENIED'
        | 'INPUT_VIDEO_INVALID_ARGUMENT'
        | 'INPUT_VIDEO_OVER_LIMIT'
        | 'INPUT_VIDEO_INVALID_URL'
        | 'INPUT_VIDEO_MODIFY_SUCCESS'
        | 'INPUT_VIDEO_MODIFY_PENDING'
        | 'INPUT_VIDEO_MODIFY_FAILED'
        | 'INPUT_VIDEO_STORAGE_HOST_FAILED'
        | 'ALL_INPUT_VIDEOS_INVALID_BYTES'
        | 'INPUT_VIDEO_PROCESSING_SUCCESS'
        | 'INPUT_VIDEO_PROCESSING_PENDING'
        | 'INPUT_VIDEO_PROCESSING_FAILED'
        | 'INPUT_VIDEO_STORAGE_INCONSISTENCY'
        | 'INPUT_VIDEO_STORAGE_FAILURE'
        | 'INPUT_VIDEO_URL_GENERATION_FAILURE'
        | 'INPUT_CONNECTION_FAILED'
        | 'REQUEST_DISABLED_FOR_MAINTENANCE'
        | 'INPUT_WRITES_DISABLED_FOR_MAINTENANCE'
        | 'INPUT_INVALID_REQUEST'
        | 'PREDICT_INVALID_REQUEST'
        | 'SEARCH_INVALID_REQUEST'
        | 'CONCEPTS_INVALID_REQUEST'
        | 'STATS_INVALID_REQUEST'
        | 'DATABASE_DUPLICATE_KEY'
        | 'DATABASE_STATEMENT_TIMEOUT'
        | 'DATABASE_INVALID_ROWS_AFFECTED'
        | 'DATABASE_DEADLOCK_DETECTED'
        | 'DATABASE_FAIL_TASK'
        | 'DATABASE_FAIL_TO_GET_CONNECTIONS'
        | 'DATABASE_TOO_MANY_CLIENTS'
        | 'DATABASE_CONSTRAINT_VIOLATED'
        | 'DATABASE_CANCELED'
        | 'ASYNC_WORKER_MULTI_ERRORS'
        | 'RPC_REQUEST_QUEUE_FULL'
        | 'RPC_SERVER_UNAVAILABLE'
        | 'RPC_REQUEST_TIMEOUT'
        | 'RPC_MAX_MESSAGE_SIZE_EXCEEDED'
        | 'RPC_CANCELED'
        | 'RPC_UNKNOWN_METHOD'
        | 'REQUEST_CANCELED_BY_USER'
        | 'CLUSTER_INTERNAL_FAILURE'
        | 'EXTERNAL_CONNECTION_ERROR'
        | 'QUERY_INVALID_SYNTAX'
        | 'QUEUE_CONN_ERROR'
        | 'QUEUE_CLOSE_REQUEST_TIMEOUT'
        | 'QUEUE_CONN_CLOSED'
        | 'QUEUE_PUBLISH_ACK_TIMEOUT'
        | 'QUEUE_PUBLISH_ERROR'
        | 'QUEUE_SUBSCRIPTION_TIMEOUT'
        | 'QUEUE_SUBSCRIPTION_ERROR'
        | 'QUEUE_MARSHALLING_FAILED'
        | 'QUEUE_UNMARSHALLING_FAILED'
        | 'QUEUE_MAX_MSG_REDELIVERY_EXCEEDED'
        | 'QUEUE_ACK_FAILURE'
        | 'SQS_OVERLIMIT'
        | 'SQS_INVALID_RECEIPT_HANDLE'
        | 'SQS_UNKNOWN'
        | 'SEARCH_INTERNAL_FAILURE'
        | 'SEARCH_PROJECTION_FAILURE'
        | 'SEARCH_PREDICTION_FAILURE'
        | 'SEARCH_BY_NOT_FULLY_INDEXED_INPUT'
        | 'SAVED_SEARCH_MODIFY_FAILED'
        | 'SEARCH_COUNTS_UNAVAILABLE'
        | 'EVALUATION_QUEUED'
        | 'EVALUATION_IN_PROGRESS'
        | 'EVALUATION_SUCCESS'
        | 'EVALUATION_FAILED_TO_RETRIEVE_DATA'
        | 'EVALUATION_INVALID_ARGUMENT'
        | 'EVALUATION_FAILED'
        | 'EVALUATION_PENDING'
        | 'EVALUATION_TIMED_OUT'
        | 'EVALUATION_UNEXPECTED_ERROR'
        | 'EVALUATION_MIXED'
        | 'STRIPE_EVENT_ERROR'
        | 'CACHE_MISS'
        | 'REDIS_SCRIPT_EXITED_WITH_FAILURE'
        | 'REDIS_STREAM_ERR'
        | 'REDIS_NO_CONSUMERS'
        | 'REDIS_STREAM_BACKOFF'
        | 'SIGNUP_EVENT_ERROR'
        | 'SIGNUP_FLAGGED'
        | 'FILETYPE_UNSUPPORTED'
        | 'APP_COUNT_INVALID_MESSAGE'
        | 'APP_COUNT_UPDATE_INCREMENT_FAILED'
        | 'APP_COUNT_REBUILD_FAILED'
        | 'APP_COUNT_INTERNAL_FAILURE'
        | 'MP_DOWNLOAD_ERROR'
        | 'MP_RESOLVE_DNS_ERROR'
        | 'MP_DOWNLOAD_MAX_SIZE_EXCEEDED_ERROR'
        | 'MP_IMAGE_DECODE_ERROR'
        | 'MP_INVALID_ARGUMENT'
        | 'MP_IMAGE_PROCESSING_ERROR'
        | 'DATATIER_CONN_ERROR'
        | 'USER_CONSENT_FACE'
        | 'WORKER_MISSING'
        | 'WORKER_ACTIVE'
        | 'WORKER_INACTIVE'
        | 'COLLECTOR_MISSING'
        | 'COLLECTOR_ACTIVE'
        | 'COLLECTOR_INACTIVE'
        | 'COLLECTOR_POST_INPUT_FAILED'
        | 'SSO_IDENTITY_PROVIDER_DOES_NOT_EXIST'
        | 'TASK_IN_PROGRESS'
        | 'TASK_DONE'
        | 'TASK_WONT_DO'
        | 'TASK_FAILED'
        | 'TASK_IDLE'
        | 'TASK_CONFLICT'
        | 'TASK_NOT_IMPLEMENTED'
        | 'TASK_MISSING'
        | 'TASK_PERMISSION_DENIED'
        | 'TASK_ASSIGNMENT_SUCCESS'
        | 'TASK_ASSIGNMENT_PENDING'
        | 'TASK_ASSIGNMENT_AWAITING_REVIEW'
        | 'TASK_ASSIGNMENT_AWAITING_CONSENSUS_REVIEW'
        | 'TASK_ASSIGNMENT_REJECTED'
        | 'TASK_ASSIGNMENT_REVIEW_SUCCESS'
        | 'TASK_ASSIGNMENT_REVIEW_PENDING'
        | 'TASK_ASSIGNMENT_REVIEW_DISMISSED'
        | 'LABEL_ORDER_PENDING'
        | 'LABEL_ORDER_IN_PROGRESS'
        | 'LABEL_ORDER_SUCCESS'
        | 'LABEL_ORDER_CANCELED'
        | 'LICENSE_ACTIVE'
        | 'LICENSE_DOES_NOT_EXIST'
        | 'LICENSE_NEED_UPDATE'
        | 'LICENSE_EXPIRED'
        | 'LICENSE_REVOKED'
        | 'LICENSE_DELETED'
        | 'LICENSE_VOLUME_EXCEEDED'
        | 'PASSWORD_VALIDATION_SUCCESS'
        | 'PASSWORD_VALIDATION_FAILED'
        | 'PASSWORDPOLICY_INVALID_ARGUMENT'
        | 'FEATUREFLAG_CONFIG_NOT_FOUND'
        | 'FEATUREFLAG_INVALID_ARGUMENT'
        | 'FEATUREFLAG_BLOCKED'
        | 'FEATUREFLAG_NOT_FOUND'
        | 'MAINTENANCE_SUCCESS'
        | 'MAINTENANCE_FAILED'
        | 'DATASET_VERSION_PENDING'
        | 'DATASET_VERSION_IN_PROGRESS'
        | 'DATASET_VERSION_READY'
        | 'DATASET_VERSION_FAILURE'
        | 'DATASET_VERSION_UNEXPECTED_ERROR'
        | 'DATASET_VERSION_CONFLICT'
        | 'DATASET_INPUT_SUCCESS'
        | 'DATASET_INPUT_DUPLICATE'
        | 'DATASET_VERSION_EXPORT_SUCCESS'
        | 'DATASET_VERSION_EXPORT_PENDING'
        | 'DATASET_VERSION_EXPORT_FAILED'
        | 'DATASET_VERSION_EXPORT_IN_PROGRESS'
        | 'DATASET_VERSION_EXPORT_UNEXPECTED_ERROR'
        | 'JOB_QUEUED'
        | 'JOB_RUNNING'
        | 'JOB_COMPLETED'
        | 'JOB_FAILED'
        | 'JOB_CANCELLED'
        | 'JOB_UNEXPECTED_ERROR'
        | 'JOB_CONFLICT'
        | 'AUTH_MISSING_IDP_ASSOC'
        | 'LIST_OBJECTS_FAILED'
        | 'ARCHIVE_EXTRACT_FAILED'
        | 'UPLOAD_IN_PROGRESS'
        | 'UPLOAD_DONE'
        | 'UPLOAD_FAILED'
        | 'UPLOAD_UNEXPECTED_ERROR'
        | 'UPLOAD_EXPIRED'
        | 'UPLOAD_CANCELED'
        | 'UPLOAD_CONFLICT'
        | 'BILLING_INVALID_INFO'
        | 'BILLING_MISSING_TOKENS'
        | 'LOG_ENTRIES_INVALID_REQUEST'
        | 'INTERNAL_SERVER_ISSUE'
        | 'INTERNAL_FETCHING_ISSUE'
        | 'INTERNAL_DATABASE_ISSUE'
        | 'INTERNAL_CONTEXT_CANCELED'
        | 'INTERNAL_UNEXPECTED_TIMEOUT'
        | 'INTERNAL_UNEXPECTED_V1'
        | 'INTERNAL_UNEXPECTED_PANIC'
        | 'INTERNAL_UNEXPECTED_SPIRE'
        | 'INTERNAL_REDIS_UNAVAILABLE'
        | 'INTERNAL_RESOURCE_EXHAUSTED'
        | 'INTERNAL_REDIS_UNCATEGORIZED'
        | 'INTERNAL_AWS_UNCATEGORIZED'
        | 'INTERNAL_AZURE_UNCATEGORIZED'
        | 'INTERNAL_VECTORDB_UNCATEGORIZED'
        | 'INTERNAL_ORACLE_UNCATEGORIZED'
        | 'INTERNAL_VULTR_UNCATEGORIZED'
        | 'CONN_UNCATEGORIZED'
        | 'MODEL_UNCATEGORIZED'
        | 'INPUT_UNCATEGORIZED'
        | 'ANNOTATION_UNCATEGORIZED'
        | 'BILLING_UNCATEGORIZED'
        | 'INTERNAL_UNCATEGORIZED'
        | 'BAD_REQUEST'
        | 'SERVER_ERROR'
      )[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiPipelineStepVersionResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetPipelineStepVersion
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/pipeline_steps/{pipeline_step_id}/versions/{pipeline_step_version_id}
   */
  export namespace V2GetPipelineStepVersion {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** The id of the pipeline step that has the requested version. */
      pipelineStepId: string;
      /** Get the identified by this id */
      pipelineStepVersionId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSinglePipelineStepVersionResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListLogEntries5
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/pipelines/{pipeline_id}/versions/{pipeline_version_id}/runs/{pipeline_version_run_id}/{log_type}/logs
   */
  export namespace V2ListLogEntries5 {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** Pipelines that produced the logs. */
      pipelineId: string;
      pipelineVersionId: string;
      pipelineVersionRunId: string;
      /** The type of log entry. Examples: model, agent, build, training. */
      logType: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to last page.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 32.
       * @format int64
       */
      per_page?: number;
      /** The Model ID, if a model produced the logs. */
      model_id?: string;
      /** The Version ID, if a model version produced the logs. */
      model_version_id?: string;
      /** Workflow Id, if a workflow produced the logs. */
      workflow_id?: string;
      /** Where the logs came from. */
      compute_cluster_id?: string;
      nodepool_id?: string;
      runner_id?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiLogEntryResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2StreamLogEntries3
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/pipelines/{pipeline_id}/versions/{pipeline_version_id}/runs/{pipeline_version_run_id}/{log_type}/stream/logs
   */
  export namespace V2StreamLogEntries3 {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** Pipelines that produced the logs. */
      pipelineId: string;
      pipelineVersionId: string;
      pipelineVersionRunId: string;
      /** The type of log entry. Examples: model, agent, build, training. */
      logType: string;
    };
    export type RequestQuery = {
      /** The Model ID, if a model produced the logs. */
      model_id?: string;
      /** The Version ID, if a model version produced the logs. */
      model_version_id?: string;
      /** Workflow Id, if a workflow produced the logs. */
      workflow_id?: string;
      /** Where the logs came from. */
      compute_cluster_id?: string;
      nodepool_id?: string;
      runner_id?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = {
      result?: ApiMultiLogEntryResponse;
      error?: GooglerpcStatus;
    };
  }

  /**
   * No description
   * @tags V2
   * @name V2GetResourceCounts
   * @summary List the resource counts for the app.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/resource_counts
   */
  export namespace V2GetResourceCounts {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiGetResourceCountsResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListSearches
   * @summary List all saved legacy searches.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/searches
   */
  export namespace V2ListSearches {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiSearchResponse;
  }

  /**
   * @description Deprecated: Use PostInputsSearches or PostAnnotationsSearches instead. The server may refuse to accept requests to this endpoint.
   * @tags V2
   * @name V2PostSearches
   * @summary Execute a new search and optionally save it.
   * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/searches
   */
  export namespace V2PostSearches {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostSearchesBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiSearchResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchSearches
   * @summary Patch saved legacy searches by ids.
   * @request PATCH:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/searches
   */
  export namespace V2PatchSearches {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchSearchesBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiSearchResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetSearch
   * @summary Get a saved legacy search.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/searches/{id}
   */
  export namespace V2GetSearch {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleSearchResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteSearch
   * @summary Delete a saved search.
   * @request DELETE:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/searches/{id}
   */
  export namespace V2DeleteSearch {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostSearchesById
   * @summary Execute a previously saved legacy search.
   * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/searches/{id}
   */
  export namespace V2PostSearchesById {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** ID for saves search to be executed */
      id: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostSearchesByIDBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiSearchResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostStatValues
   * @summary PostStatValues
   * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/stats/values
   */
  export namespace V2PostStatValues {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostStatValuesBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiStatValueResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostStatValuesAggregate
   * @summary PostStatValuesAggregate
   * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/stats/values/aggregate
   */
  export namespace V2PostStatValuesAggregate {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostStatValuesAggregateBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiStatValueAggregateResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2PatchAnnotationsStatus
 * @summary Patch annotations status by worker id and task id.
Deprecated: Use PutTaskAssignments to update task annotations.
  For example, you can use PutTaskAssignments with action REVIEW_APPROVE
  to approve task assignments and associated annotations in bulk.
 * @request PATCH:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/task/{task_id}/annotations/status
*/
  export namespace V2PatchAnnotationsStatus {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** Filter by task ID */
      taskId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchAnnotationsStatusBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiPatchAnnotationsStatusResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListTasks
   * @summary List tasks from an app.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/tasks
   */
  export namespace V2ListTasks {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      /** Get tasks that have ANY user from this list assigned as worker. */
      worker_user_ids?: string[];
      /** Get tasks that have ANY user from this list assigned as reviewer. */
      review_user_ids?: string[];
      /** Get tasks that are associated to ANY label order from this list. */
      label_order_ids?: string[];
      /**
       * Get label order tasks as well
       * It is automatically set to true if label_order_ids is set.
       */
      including_label_order_tasks?: boolean;
      /**
       * (optional URL parameter) List of additional fields to be included in the response.
       * Currently supported additional fields:
       * - all
       * - worker.users
       * - review.users
       * - metrics.input_source.inputs_count_estimated
       * - metrics.work.inputs_count_estimated
       * - metrics.work.inputs_percent_estimated
       * - metrics.review.inputs_count_estimated
       * - metrics.review.inputs_count_estimated_per_reviewer
       * - metrics.review.inputs_percent_estimated
       * - metrics.review.inputs_percent_estimated_per_reviewer
       * - metrics.review.inputs_reviewable_count_estimated_per_reviewer
       */
      additional_fields?: string[];
      /** (optional) task IDs to filter on */
      ids?: string[];
      /**
       * (optional) input source type to filter
       *
       *  - ALL_INPUTS: Use all inputs in the app.
       *  - SAVED_SEARCH: Use the inputs from a saved search.
       *  - DATASET: Inputs from a dataset.
       * @default "INPUT_SOURCE_TYPE_NOT_SET"
       */
      input_source_type?: 'INPUT_SOURCE_TYPE_NOT_SET' | 'ALL_INPUTS' | 'SAVED_SEARCH' | 'DATASET';
      /** (optional) ids of input source to be filtered */
      input_source_ids?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiTaskResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteTasks
   * @summary Delete multiple tasks in one request.
   * @request DELETE:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/tasks
   */
  export namespace V2DeleteTasks {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2DeleteTasksBody;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostTasks
   * @summary Add tasks to an app.
   * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/tasks
   */
  export namespace V2PostTasks {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostTasksBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiTaskResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchTasks
   * @summary Patch one or more tasks.
   * @request PATCH:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/tasks
   */
  export namespace V2PatchTasks {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchTasksBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiTaskResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetTask
   * @summary Get a specific task from an app.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/tasks/{task_id}
   */
  export namespace V2GetTask {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      taskId: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) List of additional fields to be included in the response.
       * Currently supported additional fields:
       * - all
       * - worker.users
       * - review.users
       * - metrics.input_source.inputs_count_estimated
       * - metrics.work.inputs_count_estimated
       * - metrics.work.inputs_percent_estimated
       * - metrics.review.inputs_count_estimated
       * - metrics.review.inputs_count_estimated_per_reviewer
       * - metrics.review.inputs_percent_estimated
       * - metrics.review.inputs_percent_estimated_per_reviewer
       * - metrics.review.inputs_reviewable_count_estimated_per_reviewer
       */
      additional_fields?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleTaskResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetTaskAnnotationCount
   * @summary Task annotation count
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/tasks/{task_id}/annotations/count
   */
  export namespace V2GetTaskAnnotationCount {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** task_id for which count per user per status is needed */
      taskId: string;
    };
    export type RequestQuery = {
      /**
       * Only return counts for these user IDs, effectively operating as an
       * OR among them to filter down the results.
       * If model_version_ids or workflow_version_ids are also provided, these user_ids are OR'd with them as well because
       * we want the union of all worker (user, model or workflow) counts in the results.
       */
      user_ids?: string[];
      /**
       * Only return counts for these model version IDs, effectively operating as an
       * OR among them to filter down the results.
       * If user_ids or workflow_version_ids are also provided, these model_version_ids are OR'd with them as well because
       * we want the union of all worker (user, model or workflow) counts in the results.
       */
      model_version_ids?: string[];
      /**
       * Only return counts for these workflow version IDs, effectively operating as an
       * OR among them to filter down the results.
       * If user_ids or model_version_ids are also provided, these workflow_version_ids are OR'd with them as well because
       * we want the union of all worker (user, model or workflow) counts in the results.
       */
      workflow_version_ids?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleTaskCountResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2ListNextTaskAssignments
 * @summary Deprecated: Use PutTaskAssignments with action=LABEL_START.
  This endpoint has initially been designed as a GET request,
  but has been re-designed to serve a PUT logic.
  In order to clearly highlight that this endpoint serves a PUT request,
  this endpoint has been deprecated and replaced by PutTaskAssignments with action=LABEL_START.
 * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/tasks/{task_id}/assignments
*/
  export namespace V2ListNextTaskAssignments {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      taskId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiInputResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2PutTaskAssignments
 * @summary PutTaskAssignments performs an idempotent action for the task assignments in given task.
See PutTaskAssignmentsRequestAction for more details about possible actions.
 * @request PUT:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/tasks/{task_id}/assignments
*/
  export namespace V2PutTaskAssignments {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      taskId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PutTaskAssignmentsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiTaskAssignmentResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetTaskInputCount
   * @summary Task Input count
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/tasks/{task_id}/inputs/count
   */
  export namespace V2GetTaskInputCount {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** task_id for which count per user per status is needed */
      taskId: string;
    };
    export type RequestQuery = {
      /**
       * Only return counts for these user IDs, effectively operating as an
       * OR among them to filter down the results.
       * If model_version_ids or workflow_version_ids are also provided, these user_ids are OR'd with them as well because
       * we want the union of all worker (user, model or workflow) counts in the results.
       */
      user_ids?: string[];
      /**
       * Only return counts for these model version IDs, effectively operating as an
       * OR among them to filter down the results.
       * If user_ids or workflow_version_ids are also provided, these model_version_ids are OR'd with them as well because
       * we want the union of all worker (user, model or workflow) counts in the results.
       */
      model_version_ids?: string[];
      /**
       * Only return counts for these workflow version IDs, effectively operating as an
       * OR among them to filter down the results.
       * If user_ids or model_version_ids are also provided, these workflow_version_ids are OR'd with them as well because
       * we want the union of all worker (user, model or workflow) counts in the results.
       */
      workflow_version_ids?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleTaskCountResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetInputSamples
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/tasks/{task_id}/inputs/samples
   */
  export namespace V2GetInputSamples {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      taskId: string;
    };
    export type RequestQuery = {
      /** URL param. If zero ids provided, returns for all task labelers */
      user_ids?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiInputAnnotationResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListUploads
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/uploads
   */
  export namespace V2ListUploads {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiUploadResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteUploads
   * @request DELETE:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/uploads
   */
  export namespace V2DeleteUploads {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2DeleteUploadsBody;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2PostUploads
 * @summary PostUploads is used to upload files. Note that this does not create inputs.
returns job with uploadID, job has UPLOAD_IN_PROGRESS status
Actual upload content can be done in multiple calls with PutUploadContentParts
You can get status of upload with GetUpload or ListUploads endpoints
See also PostInputsUploads
 * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/uploads
*/
  export namespace V2PostUploads {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostUploadsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiUploadResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetUpload
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/uploads/{upload_id}
   */
  export namespace V2GetUpload {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** Upload ID */
      uploadId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleUploadResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2PutUploadContentParts
 * @summary Upload a part of a multipart upload.
Behaviour on completion depends on the endpoint that was used to initiate the upload.
 * @request PUT:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/uploads/{upload_id}/content_parts
*/
  export namespace V2PutUploadContentParts {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      uploadId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PutUploadContentPartsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleUploadResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListWorkflows
   * @summary List all the workflows.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/workflows
   */
  export namespace V2ListWorkflows {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      /** (optional URL parameter) List of additional fields to be included in the response. Currently supported: all, stars */
      additional_fields?: string[];
      /**
       * Sorting options:
       * Whether to sort in ascending order. If false, will order in descending order.
       */
      sort_ascending?: boolean;
      /** Whether to order by the name */
      sort_by_id?: boolean;
      /**
       * Whether to order by the modified_at time.
       * If none of the sort options is set to true, will sort by modified_at.
       */
      sort_by_modified_at?: boolean;
      /** Whether to order by the created_at time. */
      sort_by_created_at?: boolean;
      /** Whether to order by the number of users stared the workflow */
      sort_by_star_count?: boolean;
      /**
       * Filtering options:
       * If true, we only return workflows that are handpicked by clarifai staff
       */
      featured_only?: boolean;
      /** If true, we only return workflows that are starred by the requesting user */
      starred_only?: boolean;
      /** Filter workflows by bookmark. If set, only return bookmarked workflows. Otherwise none bookmarked workflows only. */
      bookmark?: boolean;
      /**
       * Searching options:
       * Specify a search parameter in order to perform keyword search on the
       * following fields of the workflow:
       *   - id
       *   - description
       *   - notes
       *   - user_id (unless user_app_id.user_id is already set)
       *
       * Keywords are both normalized for search (so searching for "satisfy" matches "satisfied")
       * and used for partial prefix-matching (so searching for "clari" matches "clarifai").
       *
       * NOTE: Both the list of fields searched and the exact keyword matching
       * rules are subject to change and not guaranteed to be backwards-compatible.
       */
      search?: string;
      /**
       * Query various text fields (id, description and notes) that can contain the words in the query string.
       * Deprecated: use search instead.
       */
      query?: string;
      /**
       * Filter by the id of the workflow. This supports wilcard queries like "gen*" to match "general" as an example.
       * Deprecated: use search instead.
       */
      id?: string;
      /**
       * Full text and prefix matching on id, owner id, description and notes. Searchable fields may be added
       * Deprecated: use search instead.
       */
      search_term?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiWorkflowResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteWorkflows
   * @summary Delete multiple workflows in one request.
   * @request DELETE:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/workflows
   */
  export namespace V2DeleteWorkflows {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2DeleteWorkflowsBody;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2PostWorkflows
 * @summary Add a workflow to an app.
Note(zeiler): the order of the workflows that are returned from this endpoint
may be different than the order in which the user provides them. This is because
we reorder by a sort that optimizes for performance of the graph and its dependencies.
When using the workflow in any future call the order returned by this endpoint
will be used.
 * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/workflows
*/
  export namespace V2PostWorkflows {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostWorkflowsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiWorkflowResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchWorkflows
   * @summary Patch one or more workflows.
   * @request PATCH:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/workflows
   */
  export namespace V2PatchWorkflows {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchWorkflowsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiWorkflowResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchWorkflowIds
   * @summary Patch one or more workflows ids.
   * @request PATCH:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/workflows/ids
   */
  export namespace V2PatchWorkflowIds {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchWorkflowIdsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiWorkflowResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetWorkflow
   * @summary Get a specific workflow from an app.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/workflows/{workflow_id}
   */
  export namespace V2GetWorkflow {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /**
       * Workflow ID to retrieve
       * If no ID is specified we return default workflow of the application
       * If an ID is specified by default we first looks into Clarifai workflows for a Workflow ID
       */
      workflowId: string;
    };
    export type RequestQuery = {
      /** (optional URL parameter) List of additional fields to be included in the response. Currently supported: all, stars */
      additional_fields?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleWorkflowResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteWorkflow
   * @summary Delete a single workflow.
   * @request DELETE:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/workflows/{workflow_id}
   */
  export namespace V2DeleteWorkflow {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      workflowId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostWorkflowVersionsPublish
   * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/workflows/{workflow_id}/publish
   */
  export namespace V2PostWorkflowVersionsPublish {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      workflowId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostWorkflowVersionsPublishBody;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostWorkflowResults2
   * @summary Predict using a workflow.
   * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/workflows/{workflow_id}/results
   */
  export namespace V2PostWorkflowResults2 {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /**
       * Workflow ID to retrieve
       * If no ID is specified we return default workflow of the application
       * If an ID is specified by default we first looks into Clarifai workflows for a Workflow ID
       */
      workflowId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostWorkflowResultsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiPostWorkflowResultsResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostWorkflowVersionsUnPublish
   * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/workflows/{workflow_id}/unpublish
   */
  export namespace V2PostWorkflowVersionsUnPublish {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      workflowId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostWorkflowVersionsUnPublishBody;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListWorkflowVersions
   * @summary List workflow versions.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/workflows/{workflow_id}/versions
   */
  export namespace V2ListWorkflowVersions {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** List versions for the workflow identified by this id */
      workflowId: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiWorkflowVersionResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteWorkflowVersions
   * @summary Delete workflow versions.
   * @request DELETE:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/workflows/{workflow_id}/versions
   */
  export namespace V2DeleteWorkflowVersions {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** The id of the workflow that has the requested versions to delete. */
      workflowId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2DeleteWorkflowVersionsBody;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchWorkflowVersions
   * @summary Patch workflow versions.
   * @request PATCH:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/workflows/{workflow_id}/versions
   */
  export namespace V2PatchWorkflowVersions {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** The id of the workflow that has the requested versions to patch. */
      workflowId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchWorkflowVersionsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiWorkflowVersionResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostWorkflowResults
   * @summary Predict using a workflow.
   * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/workflows/{workflow_id}/versions/{version_id}/results
   */
  export namespace V2PostWorkflowResults {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /**
       * Workflow ID to retrieve
       * If no ID is specified we return default workflow of the application
       * If an ID is specified by default we first looks into Clarifai workflows for a Workflow ID
       */
      workflowId: string;
      /**
       * Workflow version ID to retrieve
       * If no ID is specified, latest workflow version is used
       */
      versionId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostWorkflowResultsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiPostWorkflowResultsResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetWorkflowVersion
   * @summary Get single workflow version.
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/workflows/{workflow_id}/versions/{workflow_version_id}
   */
  export namespace V2GetWorkflowVersion {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      /** The id of the workflow that has the requested version. */
      workflowId: string;
      /** Get the identified by this id */
      workflowVersionId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleWorkflowVersionResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListWorkflowVersionEvaluations
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/workflows/{workflow_id}/versions/{workflow_version_id}/evaluations
   */
  export namespace V2ListWorkflowVersionEvaluations {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      workflowId: string;
      workflowVersionId: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiWorkflowVersionEvaluationResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostWorkflowVersionEvaluations
   * @request POST:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/workflows/{workflow_id}/versions/{workflow_version_id}/evaluations
   */
  export namespace V2PostWorkflowVersionEvaluations {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      workflowId: string;
      workflowVersionId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostWorkflowVersionEvaluationsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiWorkflowVersionEvaluationResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchWorkflowVersionEvaluations
   * @request PATCH:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/workflows/{workflow_id}/versions/{workflow_version_id}/evaluations
   */
  export namespace V2PatchWorkflowVersionEvaluations {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      workflowId: string;
      workflowVersionId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchWorkflowVersionEvaluationsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiWorkflowVersionEvaluationResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetWorkflowVersionEvaluation
   * @request GET:/v2/users/{user_app_id.user_id}/apps/{user_app_id.app_id}/workflows/{workflow_id}/versions/{workflow_version_id}/evaluations/{workflow_version_evaluation_id}
   */
  export namespace V2GetWorkflowVersionEvaluation {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      userAppIdAppId: string;
      workflowId: string;
      workflowVersionId: string;
      workflowVersionEvaluationId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleWorkflowVersionEvaluationResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostAuditLogSearches
   * @request POST:/v2/users/{user_app_id.user_id}/audit_log/searches
   */
  export namespace V2PostAuditLogSearches {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostAuditLogSearchesBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiAuditLogEntryResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListCollaborations
   * @summary Collaboration includes the app user are invitied to work on
   * @request GET:/v2/users/{user_app_id.user_id}/collaborations
   */
  export namespace V2ListCollaborations {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
    };
    export type RequestQuery = {
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      /**
       * Filtering options:
       * If true, we only return collaborations on apps that are marked as a template by the app owner.
       */
      template_only?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiCollaborationsResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListComputeClusters
   * @request GET:/v2/users/{user_app_id.user_id}/compute_clusters
   */
  export namespace V2ListComputeClusters {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
    };
    export type RequestQuery = {
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiComputeClusterResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteComputeClusters
   * @summary Delete multiple compute_clusters in one request.
   * @request DELETE:/v2/users/{user_app_id.user_id}/compute_clusters
   */
  export namespace V2DeleteComputeClusters {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2DeleteComputeClustersBody;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostComputeClusters
   * @request POST:/v2/users/{user_app_id.user_id}/compute_clusters
   */
  export namespace V2PostComputeClusters {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostComputeClustersBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiComputeClusterResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetComputeCluster
   * @summary ComputeCluster CRUD
   * @request GET:/v2/users/{user_app_id.user_id}/compute_clusters/{compute_cluster_id}
   */
  export namespace V2GetComputeCluster {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      computeClusterId: string;
    };
    export type RequestQuery = {
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleComputeClusterResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListNodepools
   * @request GET:/v2/users/{user_app_id.user_id}/compute_clusters/{compute_cluster_id}/nodepools
   */
  export namespace V2ListNodepools {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      computeClusterId: string;
    };
    export type RequestQuery = {
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      /**
       * Only return nodepools that are actively being used (having runners with
       * replicas >= threshold and pipeline versions scheduled to run)
       */
      active_usage?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiNodepoolResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteNodepools
   * @summary Delete multiple nodepools in one request.
   * @request DELETE:/v2/users/{user_app_id.user_id}/compute_clusters/{compute_cluster_id}/nodepools
   */
  export namespace V2DeleteNodepools {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      computeClusterId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2DeleteNodepoolsBody;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostNodepools
   * @request POST:/v2/users/{user_app_id.user_id}/compute_clusters/{compute_cluster_id}/nodepools
   */
  export namespace V2PostNodepools {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      computeClusterId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostNodepoolsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiNodepoolResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchNodepools
   * @request PATCH:/v2/users/{user_app_id.user_id}/compute_clusters/{compute_cluster_id}/nodepools
   */
  export namespace V2PatchNodepools {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      computeClusterId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchNodepoolsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiNodepoolResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetNodepool
   * @summary Nodepools CRUD
   * @request GET:/v2/users/{user_app_id.user_id}/compute_clusters/{compute_cluster_id}/nodepools/{nodepool_id}
   */
  export namespace V2GetNodepool {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      computeClusterId: string;
      nodepoolId: string;
    };
    export type RequestQuery = {
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleNodepoolResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListRunners
   * @summary List all the runners for the user.
   * @request GET:/v2/users/{user_app_id.user_id}/compute_clusters/{compute_cluster_id}/nodepools/{nodepool_id}/runners
   */
  export namespace V2ListRunners {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      computeClusterId: string;
      nodepoolId: string;
    };
    export type RequestQuery = {
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      /**
       * Only return runners whose replicas are >= min_replicas.
       * @format int64
       */
      min_replicas?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiRunnerResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteRunners
   * @summary Delete multiple runners in one request.
   * @request DELETE:/v2/users/{user_app_id.user_id}/compute_clusters/{compute_cluster_id}/nodepools/{nodepool_id}/runners
   */
  export namespace V2DeleteRunners {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      computeClusterId: string;
      nodepoolId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2DeleteRunnersBody;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostRunners
   * @summary Add a runners to a user.
   * @request POST:/v2/users/{user_app_id.user_id}/compute_clusters/{compute_cluster_id}/nodepools/{nodepool_id}/runners
   */
  export namespace V2PostRunners {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      computeClusterId: string;
      nodepoolId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostRunnersBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiRunnerResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2GetRunner
 * @summary Get a specific runner.
TODO(zeiler): runner_id is a UUID so can list globally as well.
 * @request GET:/v2/users/{user_app_id.user_id}/compute_clusters/{compute_cluster_id}/nodepools/{nodepool_id}/runners/{runner_id}
*/
  export namespace V2GetRunner {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      computeClusterId: string;
      nodepoolId: string;
      runnerId: string;
    };
    export type RequestQuery = {
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleRunnerResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2ListRunnerItems
 * @summary List items for the remote runner to work on.
since the runner_id is a UUID we can access it directly too.
 * @request GET:/v2/users/{user_app_id.user_id}/compute_clusters/{compute_cluster_id}/nodepools/{nodepool_id}/runners/{runner_id}/items
*/
  export namespace V2ListRunnerItems {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      computeClusterId: string;
      nodepoolId: string;
      runnerId: string;
    };
    export type RequestQuery = {
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiRunnerItemResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2PostRunnerItemOutputs
 * @summary Post back outputs from remote runners
since the runner_id is a UUID we can access it directly too.
 * @request POST:/v2/users/{user_app_id.user_id}/compute_clusters/{compute_cluster_id}/nodepools/{nodepool_id}/runners/{runner_id}/items/{runner_item_id}/outputs
*/
  export namespace V2PostRunnerItemOutputs {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      computeClusterId: string;
      /** The particular nodepool that runner belongs to */
      nodepoolId: string;
      /** The particular runner that processed the work. */
      runnerId: string;
      /** The particular item of work processed. */
      runnerItemId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostRunnerItemOutputsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiRunnerItemOutputResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListLogEntries
   * @request GET:/v2/users/{user_app_id.user_id}/compute_clusters/{compute_cluster_id}/nodepools/{nodepool_id}/runners/{runner_id}/{log_type}/logs
   */
  export namespace V2ListLogEntries {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      /** Where the logs came from. */
      computeClusterId: string;
      nodepoolId: string;
      runnerId: string;
      /** The type of log entry. Examples: model, agent, build, training. */
      logType: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to last page.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 32.
       * @format int64
       */
      per_page?: number;
      userAppIdAppId?: string;
      /** The Model ID, if a model produced the logs. */
      model_id?: string;
      /** The Version ID, if a model version produced the logs. */
      model_version_id?: string;
      /** Workflow Id, if a workflow produced the logs. */
      workflow_id?: string;
      /** Pipelines that produced the logs. */
      pipeline_id?: string;
      pipeline_version_id?: string;
      pipeline_version_run_id?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiLogEntryResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListLogEntries3
   * @request GET:/v2/users/{user_app_id.user_id}/compute_clusters/{compute_cluster_id}/{log_type}/logs
   */
  export namespace V2ListLogEntries3 {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      /** Where the logs came from. */
      computeClusterId: string;
      /** The type of log entry. Examples: model, agent, build, training. */
      logType: string;
    };
    export type RequestQuery = {
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to last page.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 32.
       * @format int64
       */
      per_page?: number;
      userAppIdAppId?: string;
      /** The Model ID, if a model produced the logs. */
      model_id?: string;
      /** The Version ID, if a model version produced the logs. */
      model_version_id?: string;
      /** Workflow Id, if a workflow produced the logs. */
      workflow_id?: string;
      nodepool_id?: string;
      runner_id?: string;
      /** Pipelines that produced the logs. */
      pipeline_id?: string;
      pipeline_version_id?: string;
      pipeline_version_run_id?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiLogEntryResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListDatasets2
   * @summary List all the datasets.
   * @request GET:/v2/users/{user_app_id.user_id}/datasets
   */
  export namespace V2ListDatasets2 {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
    };
    export type RequestQuery = {
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      additional_fields?: string[];
      /**
       * Sorting options:
       * Whether to sort in ascending order. If false, will order in descending order.
       */
      sort_ascending?: boolean;
      /** Whether to order by the created_at time. */
      sort_by_created_at?: boolean;
      /** Whether to order by the number of users stared the app */
      sort_by_star_count?: boolean;
      /** If neither sort option is set to true, will sort by modified_at. */
      sort_by_modified_at?: boolean;
      /** Whether to order by the external id */
      sort_by_id?: boolean;
      /** Filtering options: */
      starred_only?: boolean;
      /** Filter datasets by bookmark. If set, only return bookmarked datasets. Otherwise none bookmarked datasets only. */
      bookmark?: boolean;
      /**
       * Searching options:
       * Specify a search parameter in order to perform keyword search on the
       * following fields of the dataset:
       *   - id
       *   - description
       *   - notes
       *   - user_id (unless user_app_id.user_id is already set)
       *
       * Keywords are both normalized for search (so searching for "satisfy" matches "satisfied")
       * and used for partial prefix-matching (so searching for "clari" matches "clarifai").
       *
       * NOTE: Both the list of fields searched and the exact keyword matching
       * rules are subject to change and not guaranteed to be backwards-compatible.
       */
      search?: string;
      /**
       * Fuzzy filter on dataset ID
       * Deprecated: use search instead.
       */
      id?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiDatasetResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListDeployments
   * @request GET:/v2/users/{user_app_id.user_id}/deployments
   */
  export namespace V2ListDeployments {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
    };
    export type RequestQuery = {
      userAppIdAppId?: string;
      /** (optional URL parameter) Nodepool ID. To list all deployed workers in a Nodepool */
      nodepool_id?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      /** (optional URL parameter) ModelVersion IDs. To list all deployments for the model version */
      model_version_ids?: string[];
      /** (optional URL parameter) WorkflowVersion IDs. To list all deployments for the workflow version */
      workflow_version_ids?: string[];
      /** (optional URL parameter) ComputeCluster ID. To list all deployed workers in a ComputeCluster */
      compute_cluster_id?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiDeploymentResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteDeployments
   * @summary Delete multiple deployments in one request.
   * @request DELETE:/v2/users/{user_app_id.user_id}/deployments
   */
  export namespace V2DeleteDeployments {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2DeleteDeploymentsBody;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostDeployments
   * @request POST:/v2/users/{user_app_id.user_id}/deployments
   */
  export namespace V2PostDeployments {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostDeploymentsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiDeploymentResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchDeployments
   * @request PATCH:/v2/users/{user_app_id.user_id}/deployments
   */
  export namespace V2PatchDeployments {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchDeploymentsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiDeploymentResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetDeployment
   * @summary Deployments CRUD
   * @request GET:/v2/users/{user_app_id.user_id}/deployments/{deployment_id}
   */
  export namespace V2GetDeployment {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      deploymentId: string;
    };
    export type RequestQuery = {
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleDeploymentResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListAppDuplications
   * @summary ListAppDuplications lists all app duplication jobs created by the user.
   * @request GET:/v2/users/{user_app_id.user_id}/duplications
   */
  export namespace V2ListAppDuplications {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
    };
    export type RequestQuery = {
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiAppDuplicationsResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetAppDuplication
   * @summary GetAppDuplication returns an app duplication job created by the user.
   * @request GET:/v2/users/{user_app_id.user_id}/duplications/{app_duplication_id}
   */
  export namespace V2GetAppDuplication {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      appDuplicationId: string;
    };
    export type RequestQuery = {
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleAppDuplicationResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListEvaluations2
   * @request GET:/v2/users/{user_app_id.user_id}/evaluations
   */
  export namespace V2ListEvaluations2 {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
    };
    export type RequestQuery = {
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      /** If true, sort in ascending order, otherwise sort in descending order. */
      sort_ascending?: boolean;
      /** Whether to order by application id */
      sort_by_app_id?: boolean;
      /** Whether to order by eval metric summary.macro_avg_roc_auc */
      sort_by_roc_auc?: boolean;
      /** Whether to order by eval metric summary.f1 */
      sort_by_f1?: boolean;
      /** Whether to order by when the metric was created */
      sort_by_created_at?: boolean;
      /** Whether to order by eval metric summary.mean_avg_precision_iou_50 */
      sort_by_mean_avg_precision?: boolean;
      /** Whether to order by eval metric summary.macro_avg_precision */
      sort_by_precision?: boolean;
      /** Whether to order by eval metric summary.macro_avg_recall */
      sort_by_recall?: boolean;
      sort_by_model_id?: boolean;
      sort_by_eval_dataset_id?: boolean;
      sort_by_train_dataset_id?: boolean;
      /** Filter on model type id */
      model_type_id?: string;
      /** Filter on dataset ID of the dataset version specified in the metric version */
      eval_dataset_ids?: string[];
      /** Filter on dataset ID of the dataset version specified by the model version */
      train_dataset_ids?: string[];
      /** Filter on concept IDs specified in the modele version's output_info */
      concept_ids?: string[];
      /** Whether to show failed metrics, defaults to false */
      show_failed_metrics?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiEvalMetricsResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListKeys
   * @summary List all the keys.
   * @request GET:/v2/users/{user_app_id.user_id}/keys
   */
  export namespace V2ListKeys {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
    };
    export type RequestQuery = {
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      /**
       * Filtering options:
       * If true, only return keys that have not expired.
       */
      not_expired?: boolean;
      /** Only return keys that have the listed scopes. */
      scopes?: string[];
      /** Only return keys that have the listed endpoints. */
      endpoints?: string[];
      /** Only return keys with the listed type. */
      type?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiKeyResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostKeys
   * @summary Add a key to an app.
   * @request POST:/v2/users/{user_app_id.user_id}/keys
   */
  export namespace V2PostKeys {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostKeysBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiKeyResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchKeys
   * @summary Patch one or more keys.
   * @request PATCH:/v2/users/{user_app_id.user_id}/keys
   */
  export namespace V2PatchKeys {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchKeysBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiKeyResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetKey
   * @summary Get a specific key from an app.
   * @request GET:/v2/users/{user_app_id.user_id}/keys/{key_id}
   */
  export namespace V2GetKey {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      keyId: string;
    };
    export type RequestQuery = {
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleKeyResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2DeleteKey
 * @summary Search over the keys to find one or more you're looking for.
This leverage the "body" parameter because we also have page and
per_page as url query param variables in this request.
 * @request DELETE:/v2/users/{user_app_id.user_id}/keys/{key_id}
*/
  export namespace V2DeleteKey {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      keyId: string;
    };
    export type RequestQuery = {
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListModels2
   * @summary List all the models.
   * @request GET:/v2/users/{user_app_id.user_id}/models
   */
  export namespace V2ListModels2 {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
    };
    export type RequestQuery = {
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      /** (optional URL parameter) List of additional fields to be included in the response. Currently supported: all, stars, outputs, presets, counts */
      additional_fields?: string[];
      /**
       * Sorting options:
       * Whether to sort in ascending order. If false, will order in descending order.
       */
      sort_ascending?: boolean;
      /** Whether to order by the name */
      sort_by_name?: boolean;
      /** Whether to order by the number of training inputs */
      sort_by_num_inputs?: boolean;
      /**
       * Whether to order by the modified_at time of the latest model version.
       * If none of the sort options is set to true, will sort by modified_at.
       */
      sort_by_modified_at?: boolean;
      /** Whether to order by the created_at */
      sort_by_created_at?: boolean;
      /** Whether to order by count of stars */
      sort_by_star_count?: boolean;
      /**
       * Filtering options:
       * Filter models by the specific model_type_id. See ListModelTypes for the list of ModelType.Id's
       * supported.
       */
      model_type_id?: string;
      /** If true, we only return models that have the status MODEL_TRAINED, which includes non-trainable model types. */
      trained_only?: boolean;
      /**
       * The list of input fields to the model.
       * For example, you can specify 'image', which will return models that make inferences on images like visual-classifier models.
       */
      input_fields?: string[];
      /**
       * The list of output fields to the model.
       * For example, you can specify 'regions[...].data.concepts', which will return visual-detector models.
       */
      output_fields?: string[];
      /** Filter by the license of the model version */
      license?: string;
      /** If true, we only return models that are handpicked by clarifai staff */
      featured_only?: boolean;
      /** If true, we only return models that are starred by the requesting user */
      starred_only?: boolean;
      /** List of toolkit tags to filter by */
      toolkits?: string[];
      /** List of use_case tags to filter by */
      use_cases?: string[];
      /** List of language tags to filter by */
      languages?: string[];
      /**
       * Old API behavior resulted in returning clarifai main models when calling ListModels while scoped to an app. While we transition
       * away from that, we can use this flag to not always fetch clarifai main models, unless that is the app we are explicitly listing for.
       *
       * @exclude TODO (EAGLE-4447): Remove this field
       */
      dont_fetch_from_main?: boolean;
      /**
       * Filter models by bookmark. If set, only return bookmarked models. Otherwise none bookmarked models only.
       * Note: you can not filter `trained_only` and bookmark at the same time.
       * When filter by bookmark, we will return trained and untrained models.
       */
      bookmark?: boolean;
      /**
       * Searching options:
       * Specify a search parameter in order to perform keyword search on the
       * following fields of the model:
       *   - id
       *   - name
       *   - description
       *   - notes
       *   - user_id (unless user_app_id.user_id is already set)
       *
       * Keywords are both normalized for search (so searching for "satisfy" matches "satisfied")
       * and used for partial prefix-matching (so searching for "clari" matches "clarifai").
       *
       * NOTE: Both the list of fields searched and the exact keyword matching
       * rules are subject to change and not guaranteed to be backwards-compatible.
       */
      search?: string;
      /**
       * Query name, description and id fields, that can contain the words in the query string. Does NOT support wildcards - full words only. Supports operators "OR" and "-" as NOT.
       * Deprecated: use search instead.
       */
      query?: string;
      /**
       * Filter by the description and id of the model. This supports wildcard queries like "gen*" to match "general" as an example.
       * Deprecated: use search instead.
       */
      name?: string;
      /**
       * Extends the name filter to include the user_id of the application owner that the model belongs to.
       * Deprecated: use search instead of name.
       */
      filter_by_user_id?: boolean;
      /** Filter by the model version ids. If set, only return the model of these versions. */
      model_version_ids?: string[];
      /**
       * Filter by LicenseType
       * @default "UNKNOWN_LICENSE_TYPE"
       */
      license_type?: 'UNKNOWN_LICENSE_TYPE' | 'FIRST_PARTY' | 'OPEN_SOURCE' | 'CLOSED_SOURCE';
      /**
       * Filter by Source
       * @format int64
       */
      source?: number;
      /** Filter by Creator */
      creator?: string;
      /**
       * Filter by model versions runners with replicas >= min_replicas.
       * @format int64
       */
      min_replicas?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiModelResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListModules2
   * @summary List all the modules in community, by user or by app.
   * @request GET:/v2/users/{user_app_id.user_id}/modules
   */
  export namespace V2ListModules2 {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
    };
    export type RequestQuery = {
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      additional_fields?: string[];
      /**
       * Sorting options:
       * Whether to sort in ascending order. If false, will order in descending order.
       */
      sort_ascending?: boolean;
      /** Whether to order by the created_at time. */
      sort_by_created_at?: boolean;
      /** Whether to order by the number of users stared the app */
      sort_by_star_count?: boolean;
      /** If neither sort option is set to true, will sort by modified_at. */
      sort_by_modified_at?: boolean;
      /** Whether to order by the external id */
      sort_by_id?: boolean;
      /** Filtering options: */
      starred_only?: boolean;
      /** Filter modules by bookmark. If set, only return bookmarked modules. Otherwise none bookmarked modules only. */
      bookmark?: boolean;
      /**
       * Searching options:
       * Specify a search parameter in order to perform keyword search on the
       * following fields of the module:
       *   - id
       *   - description
       *   - user_id (unless user_app_id.user_id is already set)
       *
       * Keywords are both normalized for search (so searching for "satisfy" matches "satisfied")
       * and used for partial prefix-matching (so searching for "clari" matches "clarifai").
       *
       * NOTE: Both the list of fields searched and the exact keyword matching
       * rules are subject to change and not guaranteed to be backwards-compatible.
       */
      search?: string;
      /**
       * Filter by the id and description of the module. This supports wildcard queries like "gen*" to match "general" as an example.
       * Deprecated: use search instead.
       */
      name?: string;
      /**
       * Filter by the application owner whose this module belongs to
       * Deprecated: use search instead of name.
       */
      filter_by_user_id?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiModuleResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2MyScopesUser
   * @request GET:/v2/users/{user_app_id.user_id}/myscopes
   */
  export namespace V2MyScopesUser {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
    };
    export type RequestQuery = {
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiScopeUserResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListNodepools2
   * @request GET:/v2/users/{user_app_id.user_id}/nodepools
   */
  export namespace V2ListNodepools2 {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
    };
    export type RequestQuery = {
      userAppIdAppId?: string;
      compute_cluster_id?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      /**
       * Only return nodepools that are actively being used (having runners with
       * replicas >= threshold and pipeline versions scheduled to run)
       */
      active_usage?: boolean;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiNodepoolResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2GetRunner2
 * @summary Get a specific runner.
TODO(zeiler): runner_id is a UUID so can list globally as well.
 * @request GET:/v2/users/{user_app_id.user_id}/runners/{runner_id}
*/
  export namespace V2GetRunner2 {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
      runnerId: string;
    };
    export type RequestQuery = {
      userAppIdAppId?: string;
      nodepool_id?: string;
      compute_cluster_id?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleRunnerResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListScopes
   * @summary List all auth scopes available to me as a user.
   * @request GET:/v2/users/{user_app_id.user_id}/scopes
   */
  export namespace V2ListScopes {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
    };
    export type RequestQuery = {
      /**
       * If "personal_access_token" include scopes and endpoints available to personal access tokens.
       * If "app_specific_key" include scopes and endpoints available to app-specific keys. (default)
       */
      key_type?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiScopeDepsResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostValidatePassword
   * @summary Validate new password in real-time for a user
   * @request POST:/v2/users/{user_app_id.user_id}/validate_password
   */
  export namespace V2PostValidatePassword {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostValidatePasswordBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSinglePasswordValidationResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListWorkflows2
   * @summary List all the workflows.
   * @request GET:/v2/users/{user_app_id.user_id}/workflows
   */
  export namespace V2ListWorkflows2 {
    export type RequestParams = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId: string;
    };
    export type RequestQuery = {
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      /** (optional URL parameter) List of additional fields to be included in the response. Currently supported: all, stars */
      additional_fields?: string[];
      /**
       * Sorting options:
       * Whether to sort in ascending order. If false, will order in descending order.
       */
      sort_ascending?: boolean;
      /** Whether to order by the name */
      sort_by_id?: boolean;
      /**
       * Whether to order by the modified_at time.
       * If none of the sort options is set to true, will sort by modified_at.
       */
      sort_by_modified_at?: boolean;
      /** Whether to order by the created_at time. */
      sort_by_created_at?: boolean;
      /** Whether to order by the number of users stared the workflow */
      sort_by_star_count?: boolean;
      /**
       * Filtering options:
       * If true, we only return workflows that are handpicked by clarifai staff
       */
      featured_only?: boolean;
      /** If true, we only return workflows that are starred by the requesting user */
      starred_only?: boolean;
      /** Filter workflows by bookmark. If set, only return bookmarked workflows. Otherwise none bookmarked workflows only. */
      bookmark?: boolean;
      /**
       * Searching options:
       * Specify a search parameter in order to perform keyword search on the
       * following fields of the workflow:
       *   - id
       *   - description
       *   - notes
       *   - user_id (unless user_app_id.user_id is already set)
       *
       * Keywords are both normalized for search (so searching for "satisfy" matches "satisfied")
       * and used for partial prefix-matching (so searching for "clari" matches "clarifai").
       *
       * NOTE: Both the list of fields searched and the exact keyword matching
       * rules are subject to change and not guaranteed to be backwards-compatible.
       */
      search?: string;
      /**
       * Query various text fields (id, description and notes) that can contain the words in the query string.
       * Deprecated: use search instead.
       */
      query?: string;
      /**
       * Filter by the id of the workflow. This supports wilcard queries like "gen*" to match "general" as an example.
       * Deprecated: use search instead.
       */
      id?: string;
      /**
       * Full text and prefix matching on id, owner id, description and notes. Searchable fields may be added
       * Deprecated: use search instead.
       */
      search_term?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiWorkflowResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostValidatePassword2
   * @summary Validate new password in real-time for a user
   * @request POST:/v2/validate_password
   */
  export namespace V2PostValidatePassword2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPostValidatePasswordRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSinglePasswordValidationResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListWorkflowEvaluationTemplates
   * @request GET:/v2/workflow-version-evaluation-templates
   */
  export namespace V2ListWorkflowEvaluationTemplates {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiWorkflowEvaluationTemplateResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListWorkflowVersionEvaluations2
   * @request GET:/v2/workflow-version-evaluations
   */
  export namespace V2ListWorkflowVersionEvaluations2 {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      workflow_id?: string;
      workflow_version_id?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiWorkflowVersionEvaluationResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetWorkflowVersionEvaluation2
   * @request GET:/v2/workflow-version-evaluations/{workflow_version_evaluation_id}
   */
  export namespace V2GetWorkflowVersionEvaluation2 {
    export type RequestParams = {
      workflowVersionEvaluationId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      workflow_id?: string;
      workflow_version_id?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleWorkflowVersionEvaluationResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListWorkflows3
   * @summary List all the workflows.
   * @request GET:/v2/workflows
   */
  export namespace V2ListWorkflows3 {
    export type RequestParams = {};
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
      /** (optional URL parameter) List of additional fields to be included in the response. Currently supported: all, stars */
      additional_fields?: string[];
      /**
       * Sorting options:
       * Whether to sort in ascending order. If false, will order in descending order.
       */
      sort_ascending?: boolean;
      /** Whether to order by the name */
      sort_by_id?: boolean;
      /**
       * Whether to order by the modified_at time.
       * If none of the sort options is set to true, will sort by modified_at.
       */
      sort_by_modified_at?: boolean;
      /** Whether to order by the created_at time. */
      sort_by_created_at?: boolean;
      /** Whether to order by the number of users stared the workflow */
      sort_by_star_count?: boolean;
      /**
       * Filtering options:
       * If true, we only return workflows that are handpicked by clarifai staff
       */
      featured_only?: boolean;
      /** If true, we only return workflows that are starred by the requesting user */
      starred_only?: boolean;
      /** Filter workflows by bookmark. If set, only return bookmarked workflows. Otherwise none bookmarked workflows only. */
      bookmark?: boolean;
      /**
       * Searching options:
       * Specify a search parameter in order to perform keyword search on the
       * following fields of the workflow:
       *   - id
       *   - description
       *   - notes
       *   - user_id (unless user_app_id.user_id is already set)
       *
       * Keywords are both normalized for search (so searching for "satisfy" matches "satisfied")
       * and used for partial prefix-matching (so searching for "clari" matches "clarifai").
       *
       * NOTE: Both the list of fields searched and the exact keyword matching
       * rules are subject to change and not guaranteed to be backwards-compatible.
       */
      search?: string;
      /**
       * Query various text fields (id, description and notes) that can contain the words in the query string.
       * Deprecated: use search instead.
       */
      query?: string;
      /**
       * Filter by the id of the workflow. This supports wilcard queries like "gen*" to match "general" as an example.
       * Deprecated: use search instead.
       */
      id?: string;
      /**
       * Full text and prefix matching on id, owner id, description and notes. Searchable fields may be added
       * Deprecated: use search instead.
       */
      search_term?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiWorkflowResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteWorkflows2
   * @summary Delete multiple workflows in one request.
   * @request DELETE:/v2/workflows
   */
  export namespace V2DeleteWorkflows2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiDeleteWorkflowsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
 * No description
 * @tags V2
 * @name V2PostWorkflows2
 * @summary Add a workflow to an app.
Note(zeiler): the order of the workflows that are returned from this endpoint
may be different than the order in which the user provides them. This is because
we reorder by a sort that optimizes for performance of the graph and its dependencies.
When using the workflow in any future call the order returned by this endpoint
will be used.
 * @request POST:/v2/workflows
*/
  export namespace V2PostWorkflows2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPostWorkflowsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiWorkflowResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchWorkflows2
   * @summary Patch one or more workflows.
   * @request PATCH:/v2/workflows
   */
  export namespace V2PatchWorkflows2 {
    export type RequestParams = {};
    export type RequestQuery = {};
    export type RequestBody = ApiPatchWorkflowsRequest;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiWorkflowResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetWorkflow2
   * @summary Get a specific workflow from an app.
   * @request GET:/v2/workflows/{workflow_id}
   */
  export namespace V2GetWorkflow2 {
    export type RequestParams = {
      /**
       * Workflow ID to retrieve
       * If no ID is specified we return default workflow of the application
       * If an ID is specified by default we first looks into Clarifai workflows for a Workflow ID
       */
      workflowId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /** (optional URL parameter) List of additional fields to be included in the response. Currently supported: all, stars */
      additional_fields?: string[];
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleWorkflowResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteWorkflow2
   * @summary Delete a single workflow.
   * @request DELETE:/v2/workflows/{workflow_id}
   */
  export namespace V2DeleteWorkflow2 {
    export type RequestParams = {
      workflowId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostWorkflowVersionsPublish2
   * @request POST:/v2/workflows/{workflow_id}/publish
   */
  export namespace V2PostWorkflowVersionsPublish2 {
    export type RequestParams = {
      workflowId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostWorkflowVersionsPublishBody;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostWorkflowResults3
   * @summary Predict using a workflow.
   * @request POST:/v2/workflows/{workflow_id}/results
   */
  export namespace V2PostWorkflowResults3 {
    export type RequestParams = {
      /**
       * Workflow ID to retrieve
       * If no ID is specified we return default workflow of the application
       * If an ID is specified by default we first looks into Clarifai workflows for a Workflow ID
       */
      workflowId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostWorkflowResultsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiPostWorkflowResultsResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PostWorkflowVersionsUnPublish2
   * @request POST:/v2/workflows/{workflow_id}/unpublish
   */
  export namespace V2PostWorkflowVersionsUnPublish2 {
    export type RequestParams = {
      workflowId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PostWorkflowVersionsUnPublishBody;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2ListWorkflowVersions2
   * @summary List workflow versions.
   * @request GET:/v2/workflows/{workflow_id}/versions
   */
  export namespace V2ListWorkflowVersions2 {
    export type RequestParams = {
      /** List versions for the workflow identified by this id */
      workflowId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
      /**
       * (optional URL parameter) The page number. Pagination is used to split the results into chunks.
       * Defaults to 1.
       * @format int64
       */
      page?: number;
      /**
       * (optional URL parameter) The number of results that will be contained in each page. Defaults
       * to 128.
       * @format int64
       */
      per_page?: number;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiWorkflowVersionResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2DeleteWorkflowVersions2
   * @summary Delete workflow versions.
   * @request DELETE:/v2/workflows/{workflow_id}/versions
   */
  export namespace V2DeleteWorkflowVersions2 {
    export type RequestParams = {
      /** The id of the workflow that has the requested versions to delete. */
      workflowId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2DeleteWorkflowVersionsBody;
    export type RequestHeaders = {};
    export type ResponseBody = StatusBaseResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2PatchWorkflowVersions2
   * @summary Patch workflow versions.
   * @request PATCH:/v2/workflows/{workflow_id}/versions
   */
  export namespace V2PatchWorkflowVersions2 {
    export type RequestParams = {
      /** The id of the workflow that has the requested versions to patch. */
      workflowId: string;
    };
    export type RequestQuery = {};
    export type RequestBody = V2PatchWorkflowVersionsBody;
    export type RequestHeaders = {};
    export type ResponseBody = ApiMultiWorkflowVersionResponse;
  }

  /**
   * No description
   * @tags V2
   * @name V2GetWorkflowVersion2
   * @summary Get single workflow version.
   * @request GET:/v2/workflows/{workflow_id}/versions/{workflow_version_id}
   */
  export namespace V2GetWorkflowVersion2 {
    export type RequestParams = {
      /** The id of the workflow that has the requested version. */
      workflowId: string;
      /** Get the identified by this id */
      workflowVersionId: string;
    };
    export type RequestQuery = {
      /** Note user_id 'me' is reserved - it is the alias for the id of authorized user */
      userAppIdUserId?: string;
      userAppIdAppId?: string;
    };
    export type RequestBody = never;
    export type RequestHeaders = {};
    export type ResponseBody = ApiSingleWorkflowVersionResponse;
  }
}
